function gj(n, i) {
  for (var l = 0; l < i.length; l++) {
    const o = i[l];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const d in o)
        if (d !== "default" && !(d in n)) {
          const f = Object.getOwnPropertyDescriptor(o, d);
          f && Object.defineProperty(n, d, f.get ? f : {
            enumerable: !0,
            get: () => o[d]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
function ll(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ld = { exports: {} }, Fr = {};
var Yx;
function xj() {
  if (Yx) return Fr;
  Yx = 1;
  var n = /* @__PURE__ */ Symbol.for("react.transitional.element"), i = /* @__PURE__ */ Symbol.for("react.fragment");
  function l(o, d, f) {
    var h = null;
    if (f !== void 0 && (h = "" + f), d.key !== void 0 && (h = "" + d.key), "key" in d) {
      f = {};
      for (var p in d)
        p !== "key" && (f[p] = d[p]);
    } else f = d;
    return d = f.ref, {
      $$typeof: n,
      type: o,
      key: h,
      ref: d !== void 0 ? d : null,
      props: f
    };
  }
  return Fr.Fragment = i, Fr.jsx = l, Fr.jsxs = l, Fr;
}
var Qx;
function yj() {
  return Qx || (Qx = 1, Ld.exports = xj()), Ld.exports;
}
var s = yj(), Pd = { exports: {} }, Br = {}, qd = { exports: {} }, Id = {};
var Zx;
function bj() {
  return Zx || (Zx = 1, (function(n) {
    function i(O, X) {
      var te = O.length;
      O.push(X);
      e: for (; 0 < te; ) {
        var me = te - 1 >>> 1, $ = O[me];
        if (0 < d($, X))
          O[me] = X, O[te] = $, te = me;
        else break e;
      }
    }
    function l(O) {
      return O.length === 0 ? null : O[0];
    }
    function o(O) {
      if (O.length === 0) return null;
      var X = O[0], te = O.pop();
      if (te !== X) {
        O[0] = te;
        e: for (var me = 0, $ = O.length, N = $ >>> 1; me < N; ) {
          var P = 2 * (me + 1) - 1, G = O[P], W = P + 1, J = O[W];
          if (0 > d(G, te))
            W < $ && 0 > d(J, G) ? (O[me] = J, O[W] = te, me = W) : (O[me] = G, O[P] = te, me = P);
          else if (W < $ && 0 > d(J, te))
            O[me] = J, O[W] = te, me = W;
          else break e;
        }
      }
      return X;
    }
    function d(O, X) {
      var te = O.sortIndex - X.sortIndex;
      return te !== 0 ? te : O.id - X.id;
    }
    if (n.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var f = performance;
      n.unstable_now = function() {
        return f.now();
      };
    } else {
      var h = Date, p = h.now();
      n.unstable_now = function() {
        return h.now() - p;
      };
    }
    var g = [], m = [], b = 1, y = null, w = 3, S = !1, T = !1, _ = !1, R = !1, z = typeof setTimeout == "function" ? setTimeout : null, Q = typeof clearTimeout == "function" ? clearTimeout : null, L = typeof setImmediate < "u" ? setImmediate : null;
    function Y(O) {
      for (var X = l(m); X !== null; ) {
        if (X.callback === null) o(m);
        else if (X.startTime <= O)
          o(m), X.sortIndex = X.expirationTime, i(g, X);
        else break;
        X = l(m);
      }
    }
    function ae(O) {
      if (_ = !1, Y(O), !T)
        if (l(g) !== null)
          T = !0, ee || (ee = !0, he());
        else {
          var X = l(m);
          X !== null && Se(ae, X.startTime - O);
        }
    }
    var ee = !1, Z = -1, k = 5, ne = -1;
    function V() {
      return R ? !0 : !(n.unstable_now() - ne < k);
    }
    function ie() {
      if (R = !1, ee) {
        var O = n.unstable_now();
        ne = O;
        var X = !0;
        try {
          e: {
            T = !1, _ && (_ = !1, Q(Z), Z = -1), S = !0;
            var te = w;
            try {
              t: {
                for (Y(O), y = l(g); y !== null && !(y.expirationTime > O && V()); ) {
                  var me = y.callback;
                  if (typeof me == "function") {
                    y.callback = null, w = y.priorityLevel;
                    var $ = me(
                      y.expirationTime <= O
                    );
                    if (O = n.unstable_now(), typeof $ == "function") {
                      y.callback = $, Y(O), X = !0;
                      break t;
                    }
                    y === l(g) && o(g), Y(O);
                  } else o(g);
                  y = l(g);
                }
                if (y !== null) X = !0;
                else {
                  var N = l(m);
                  N !== null && Se(
                    ae,
                    N.startTime - O
                  ), X = !1;
                }
              }
              break e;
            } finally {
              y = null, w = te, S = !1;
            }
            X = void 0;
          }
        } finally {
          X ? he() : ee = !1;
        }
      }
    }
    var he;
    if (typeof L == "function")
      he = function() {
        L(ie);
      };
    else if (typeof MessageChannel < "u") {
      var je = new MessageChannel(), ke = je.port2;
      je.port1.onmessage = ie, he = function() {
        ke.postMessage(null);
      };
    } else
      he = function() {
        z(ie, 0);
      };
    function Se(O, X) {
      Z = z(function() {
        O(n.unstable_now());
      }, X);
    }
    n.unstable_IdlePriority = 5, n.unstable_ImmediatePriority = 1, n.unstable_LowPriority = 4, n.unstable_NormalPriority = 3, n.unstable_Profiling = null, n.unstable_UserBlockingPriority = 2, n.unstable_cancelCallback = function(O) {
      O.callback = null;
    }, n.unstable_forceFrameRate = function(O) {
      0 > O || 125 < O ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : k = 0 < O ? Math.floor(1e3 / O) : 5;
    }, n.unstable_getCurrentPriorityLevel = function() {
      return w;
    }, n.unstable_next = function(O) {
      switch (w) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = w;
      }
      var te = w;
      w = X;
      try {
        return O();
      } finally {
        w = te;
      }
    }, n.unstable_requestPaint = function() {
      R = !0;
    }, n.unstable_runWithPriority = function(O, X) {
      switch (O) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          O = 3;
      }
      var te = w;
      w = O;
      try {
        return X();
      } finally {
        w = te;
      }
    }, n.unstable_scheduleCallback = function(O, X, te) {
      var me = n.unstable_now();
      switch (typeof te == "object" && te !== null ? (te = te.delay, te = typeof te == "number" && 0 < te ? me + te : me) : te = me, O) {
        case 1:
          var $ = -1;
          break;
        case 2:
          $ = 250;
          break;
        case 5:
          $ = 1073741823;
          break;
        case 4:
          $ = 1e4;
          break;
        default:
          $ = 5e3;
      }
      return $ = te + $, O = {
        id: b++,
        callback: X,
        priorityLevel: O,
        startTime: te,
        expirationTime: $,
        sortIndex: -1
      }, te > me ? (O.sortIndex = te, i(m, O), l(g) === null && O === l(m) && (_ ? (Q(Z), Z = -1) : _ = !0, Se(ae, te - me))) : (O.sortIndex = $, i(g, O), T || S || (T = !0, ee || (ee = !0, he()))), O;
    }, n.unstable_shouldYield = V, n.unstable_wrapCallback = function(O) {
      var X = w;
      return function() {
        var te = w;
        w = X;
        try {
          return O.apply(this, arguments);
        } finally {
          w = te;
        }
      };
    };
  })(Id)), Id;
}
var Xx;
function vj() {
  return Xx || (Xx = 1, qd.exports = bj()), qd.exports;
}
var Gd = { exports: {} }, ye = {};
var Kx;
function wj() {
  if (Kx) return ye;
  Kx = 1;
  var n = /* @__PURE__ */ Symbol.for("react.transitional.element"), i = /* @__PURE__ */ Symbol.for("react.portal"), l = /* @__PURE__ */ Symbol.for("react.fragment"), o = /* @__PURE__ */ Symbol.for("react.strict_mode"), d = /* @__PURE__ */ Symbol.for("react.profiler"), f = /* @__PURE__ */ Symbol.for("react.consumer"), h = /* @__PURE__ */ Symbol.for("react.context"), p = /* @__PURE__ */ Symbol.for("react.forward_ref"), g = /* @__PURE__ */ Symbol.for("react.suspense"), m = /* @__PURE__ */ Symbol.for("react.memo"), b = /* @__PURE__ */ Symbol.for("react.lazy"), y = /* @__PURE__ */ Symbol.for("react.activity"), w = Symbol.iterator;
  function S(N) {
    return N === null || typeof N != "object" ? null : (N = w && N[w] || N["@@iterator"], typeof N == "function" ? N : null);
  }
  var T = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, _ = Object.assign, R = {};
  function z(N, P, G) {
    this.props = N, this.context = P, this.refs = R, this.updater = G || T;
  }
  z.prototype.isReactComponent = {}, z.prototype.setState = function(N, P) {
    if (typeof N != "object" && typeof N != "function" && N != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, N, P, "setState");
  }, z.prototype.forceUpdate = function(N) {
    this.updater.enqueueForceUpdate(this, N, "forceUpdate");
  };
  function Q() {
  }
  Q.prototype = z.prototype;
  function L(N, P, G) {
    this.props = N, this.context = P, this.refs = R, this.updater = G || T;
  }
  var Y = L.prototype = new Q();
  Y.constructor = L, _(Y, z.prototype), Y.isPureReactComponent = !0;
  var ae = Array.isArray;
  function ee() {
  }
  var Z = { H: null, A: null, T: null, S: null }, k = Object.prototype.hasOwnProperty;
  function ne(N, P, G) {
    var W = G.ref;
    return {
      $$typeof: n,
      type: N,
      key: P,
      ref: W !== void 0 ? W : null,
      props: G
    };
  }
  function V(N, P) {
    return ne(N.type, P, N.props);
  }
  function ie(N) {
    return typeof N == "object" && N !== null && N.$$typeof === n;
  }
  function he(N) {
    var P = { "=": "=0", ":": "=2" };
    return "$" + N.replace(/[=:]/g, function(G) {
      return P[G];
    });
  }
  var je = /\/+/g;
  function ke(N, P) {
    return typeof N == "object" && N !== null && N.key != null ? he("" + N.key) : P.toString(36);
  }
  function Se(N) {
    switch (N.status) {
      case "fulfilled":
        return N.value;
      case "rejected":
        throw N.reason;
      default:
        switch (typeof N.status == "string" ? N.then(ee, ee) : (N.status = "pending", N.then(
          function(P) {
            N.status === "pending" && (N.status = "fulfilled", N.value = P);
          },
          function(P) {
            N.status === "pending" && (N.status = "rejected", N.reason = P);
          }
        )), N.status) {
          case "fulfilled":
            return N.value;
          case "rejected":
            throw N.reason;
        }
    }
    throw N;
  }
  function O(N, P, G, W, J) {
    var le = typeof N;
    (le === "undefined" || le === "boolean") && (N = null);
    var ve = !1;
    if (N === null) ve = !0;
    else
      switch (le) {
        case "bigint":
        case "string":
        case "number":
          ve = !0;
          break;
        case "object":
          switch (N.$$typeof) {
            case n:
            case i:
              ve = !0;
              break;
            case b:
              return ve = N._init, O(
                ve(N._payload),
                P,
                G,
                W,
                J
              );
          }
      }
    if (ve)
      return J = J(N), ve = W === "" ? "." + ke(N, 0) : W, ae(J) ? (G = "", ve != null && (G = ve.replace(je, "$&/") + "/"), O(J, P, G, "", function(Qt) {
        return Qt;
      })) : J != null && (ie(J) && (J = V(
        J,
        G + (J.key == null || N && N.key === J.key ? "" : ("" + J.key).replace(
          je,
          "$&/"
        ) + "/") + ve
      )), P.push(J)), 1;
    ve = 0;
    var be = W === "" ? "." : W + ":";
    if (ae(N))
      for (var ge = 0; ge < N.length; ge++)
        W = N[ge], le = be + ke(W, ge), ve += O(
          W,
          P,
          G,
          le,
          J
        );
    else if (ge = S(N), typeof ge == "function")
      for (N = ge.call(N), ge = 0; !(W = N.next()).done; )
        W = W.value, le = be + ke(W, ge++), ve += O(
          W,
          P,
          G,
          le,
          J
        );
    else if (le === "object") {
      if (typeof N.then == "function")
        return O(
          Se(N),
          P,
          G,
          W,
          J
        );
      throw P = String(N), Error(
        "Objects are not valid as a React child (found: " + (P === "[object Object]" ? "object with keys {" + Object.keys(N).join(", ") + "}" : P) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return ve;
  }
  function X(N, P, G) {
    if (N == null) return N;
    var W = [], J = 0;
    return O(N, W, "", "", function(le) {
      return P.call(G, le, J++);
    }), W;
  }
  function te(N) {
    if (N._status === -1) {
      var P = N._result;
      P = P(), P.then(
        function(G) {
          (N._status === 0 || N._status === -1) && (N._status = 1, N._result = G);
        },
        function(G) {
          (N._status === 0 || N._status === -1) && (N._status = 2, N._result = G);
        }
      ), N._status === -1 && (N._status = 0, N._result = P);
    }
    if (N._status === 1) return N._result.default;
    throw N._result;
  }
  var me = typeof reportError == "function" ? reportError : function(N) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var P = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof N == "object" && N !== null && typeof N.message == "string" ? String(N.message) : String(N),
        error: N
      });
      if (!window.dispatchEvent(P)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", N);
      return;
    }
    console.error(N);
  }, $ = {
    map: X,
    forEach: function(N, P, G) {
      X(
        N,
        function() {
          P.apply(this, arguments);
        },
        G
      );
    },
    count: function(N) {
      var P = 0;
      return X(N, function() {
        P++;
      }), P;
    },
    toArray: function(N) {
      return X(N, function(P) {
        return P;
      }) || [];
    },
    only: function(N) {
      if (!ie(N))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return N;
    }
  };
  return ye.Activity = y, ye.Children = $, ye.Component = z, ye.Fragment = l, ye.Profiler = d, ye.PureComponent = L, ye.StrictMode = o, ye.Suspense = g, ye.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Z, ye.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(N) {
      return Z.H.useMemoCache(N);
    }
  }, ye.cache = function(N) {
    return function() {
      return N.apply(null, arguments);
    };
  }, ye.cacheSignal = function() {
    return null;
  }, ye.cloneElement = function(N, P, G) {
    if (N == null)
      throw Error(
        "The argument must be a React element, but you passed " + N + "."
      );
    var W = _({}, N.props), J = N.key;
    if (P != null)
      for (le in P.key !== void 0 && (J = "" + P.key), P)
        !k.call(P, le) || le === "key" || le === "__self" || le === "__source" || le === "ref" && P.ref === void 0 || (W[le] = P[le]);
    var le = arguments.length - 2;
    if (le === 1) W.children = G;
    else if (1 < le) {
      for (var ve = Array(le), be = 0; be < le; be++)
        ve[be] = arguments[be + 2];
      W.children = ve;
    }
    return ne(N.type, J, W);
  }, ye.createContext = function(N) {
    return N = {
      $$typeof: h,
      _currentValue: N,
      _currentValue2: N,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, N.Provider = N, N.Consumer = {
      $$typeof: f,
      _context: N
    }, N;
  }, ye.createElement = function(N, P, G) {
    var W, J = {}, le = null;
    if (P != null)
      for (W in P.key !== void 0 && (le = "" + P.key), P)
        k.call(P, W) && W !== "key" && W !== "__self" && W !== "__source" && (J[W] = P[W]);
    var ve = arguments.length - 2;
    if (ve === 1) J.children = G;
    else if (1 < ve) {
      for (var be = Array(ve), ge = 0; ge < ve; ge++)
        be[ge] = arguments[ge + 2];
      J.children = be;
    }
    if (N && N.defaultProps)
      for (W in ve = N.defaultProps, ve)
        J[W] === void 0 && (J[W] = ve[W]);
    return ne(N, le, J);
  }, ye.createRef = function() {
    return { current: null };
  }, ye.forwardRef = function(N) {
    return { $$typeof: p, render: N };
  }, ye.isValidElement = ie, ye.lazy = function(N) {
    return {
      $$typeof: b,
      _payload: { _status: -1, _result: N },
      _init: te
    };
  }, ye.memo = function(N, P) {
    return {
      $$typeof: m,
      type: N,
      compare: P === void 0 ? null : P
    };
  }, ye.startTransition = function(N) {
    var P = Z.T, G = {};
    Z.T = G;
    try {
      var W = N(), J = Z.S;
      J !== null && J(G, W), typeof W == "object" && W !== null && typeof W.then == "function" && W.then(ee, me);
    } catch (le) {
      me(le);
    } finally {
      P !== null && G.types !== null && (P.types = G.types), Z.T = P;
    }
  }, ye.unstable_useCacheRefresh = function() {
    return Z.H.useCacheRefresh();
  }, ye.use = function(N) {
    return Z.H.use(N);
  }, ye.useActionState = function(N, P, G) {
    return Z.H.useActionState(N, P, G);
  }, ye.useCallback = function(N, P) {
    return Z.H.useCallback(N, P);
  }, ye.useContext = function(N) {
    return Z.H.useContext(N);
  }, ye.useDebugValue = function() {
  }, ye.useDeferredValue = function(N, P) {
    return Z.H.useDeferredValue(N, P);
  }, ye.useEffect = function(N, P) {
    return Z.H.useEffect(N, P);
  }, ye.useEffectEvent = function(N) {
    return Z.H.useEffectEvent(N);
  }, ye.useId = function() {
    return Z.H.useId();
  }, ye.useImperativeHandle = function(N, P, G) {
    return Z.H.useImperativeHandle(N, P, G);
  }, ye.useInsertionEffect = function(N, P) {
    return Z.H.useInsertionEffect(N, P);
  }, ye.useLayoutEffect = function(N, P) {
    return Z.H.useLayoutEffect(N, P);
  }, ye.useMemo = function(N, P) {
    return Z.H.useMemo(N, P);
  }, ye.useOptimistic = function(N, P) {
    return Z.H.useOptimistic(N, P);
  }, ye.useReducer = function(N, P, G) {
    return Z.H.useReducer(N, P, G);
  }, ye.useRef = function(N) {
    return Z.H.useRef(N);
  }, ye.useState = function(N) {
    return Z.H.useState(N);
  }, ye.useSyncExternalStore = function(N, P, G) {
    return Z.H.useSyncExternalStore(
      N,
      P,
      G
    );
  }, ye.useTransition = function() {
    return Z.H.useTransition();
  }, ye.version = "19.2.8", ye;
}
var $x;
function xc() {
  return $x || ($x = 1, Gd.exports = wj()), Gd.exports;
}
var Yd = { exports: {} }, Nt = {};
var Wx;
function jj() {
  if (Wx) return Nt;
  Wx = 1;
  var n = xc();
  function i(g) {
    var m = "https://react.dev/errors/" + g;
    if (1 < arguments.length) {
      m += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var b = 2; b < arguments.length; b++)
        m += "&args[]=" + encodeURIComponent(arguments[b]);
    }
    return "Minified React error #" + g + "; visit " + m + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function l() {
  }
  var o = {
    d: {
      f: l,
      r: function() {
        throw Error(i(522));
      },
      D: l,
      C: l,
      L: l,
      m: l,
      X: l,
      S: l,
      M: l
    },
    p: 0,
    findDOMNode: null
  }, d = /* @__PURE__ */ Symbol.for("react.portal");
  function f(g, m, b) {
    var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: d,
      key: y == null ? null : "" + y,
      children: g,
      containerInfo: m,
      implementation: b
    };
  }
  var h = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function p(g, m) {
    if (g === "font") return "";
    if (typeof m == "string")
      return m === "use-credentials" ? m : "";
  }
  return Nt.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = o, Nt.createPortal = function(g, m) {
    var b = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!m || m.nodeType !== 1 && m.nodeType !== 9 && m.nodeType !== 11)
      throw Error(i(299));
    return f(g, m, null, b);
  }, Nt.flushSync = function(g) {
    var m = h.T, b = o.p;
    try {
      if (h.T = null, o.p = 2, g) return g();
    } finally {
      h.T = m, o.p = b, o.d.f();
    }
  }, Nt.preconnect = function(g, m) {
    typeof g == "string" && (m ? (m = m.crossOrigin, m = typeof m == "string" ? m === "use-credentials" ? m : "" : void 0) : m = null, o.d.C(g, m));
  }, Nt.prefetchDNS = function(g) {
    typeof g == "string" && o.d.D(g);
  }, Nt.preinit = function(g, m) {
    if (typeof g == "string" && m && typeof m.as == "string") {
      var b = m.as, y = p(b, m.crossOrigin), w = typeof m.integrity == "string" ? m.integrity : void 0, S = typeof m.fetchPriority == "string" ? m.fetchPriority : void 0;
      b === "style" ? o.d.S(
        g,
        typeof m.precedence == "string" ? m.precedence : void 0,
        {
          crossOrigin: y,
          integrity: w,
          fetchPriority: S
        }
      ) : b === "script" && o.d.X(g, {
        crossOrigin: y,
        integrity: w,
        fetchPriority: S,
        nonce: typeof m.nonce == "string" ? m.nonce : void 0
      });
    }
  }, Nt.preinitModule = function(g, m) {
    if (typeof g == "string")
      if (typeof m == "object" && m !== null) {
        if (m.as == null || m.as === "script") {
          var b = p(
            m.as,
            m.crossOrigin
          );
          o.d.M(g, {
            crossOrigin: b,
            integrity: typeof m.integrity == "string" ? m.integrity : void 0,
            nonce: typeof m.nonce == "string" ? m.nonce : void 0
          });
        }
      } else m == null && o.d.M(g);
  }, Nt.preload = function(g, m) {
    if (typeof g == "string" && typeof m == "object" && m !== null && typeof m.as == "string") {
      var b = m.as, y = p(b, m.crossOrigin);
      o.d.L(g, b, {
        crossOrigin: y,
        integrity: typeof m.integrity == "string" ? m.integrity : void 0,
        nonce: typeof m.nonce == "string" ? m.nonce : void 0,
        type: typeof m.type == "string" ? m.type : void 0,
        fetchPriority: typeof m.fetchPriority == "string" ? m.fetchPriority : void 0,
        referrerPolicy: typeof m.referrerPolicy == "string" ? m.referrerPolicy : void 0,
        imageSrcSet: typeof m.imageSrcSet == "string" ? m.imageSrcSet : void 0,
        imageSizes: typeof m.imageSizes == "string" ? m.imageSizes : void 0,
        media: typeof m.media == "string" ? m.media : void 0
      });
    }
  }, Nt.preloadModule = function(g, m) {
    if (typeof g == "string")
      if (m) {
        var b = p(m.as, m.crossOrigin);
        o.d.m(g, {
          as: typeof m.as == "string" && m.as !== "script" ? m.as : void 0,
          crossOrigin: b,
          integrity: typeof m.integrity == "string" ? m.integrity : void 0
        });
      } else o.d.m(g);
  }, Nt.requestFormReset = function(g) {
    o.d.r(g);
  }, Nt.unstable_batchedUpdates = function(g, m) {
    return g(m);
  }, Nt.useFormState = function(g, m, b) {
    return h.H.useFormState(g, m, b);
  }, Nt.useFormStatus = function() {
    return h.H.useHostTransitionStatus();
  }, Nt.version = "19.2.8", Nt;
}
var Jx;
function fv() {
  if (Jx) return Yd.exports;
  Jx = 1;
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (i) {
        console.error(i);
      }
  }
  return n(), Yd.exports = jj(), Yd.exports;
}
var ey;
function Sj() {
  if (ey) return Br;
  ey = 1;
  var n = vj(), i = xc(), l = fv();
  function o(e) {
    var t = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var a = 2; a < arguments.length; a++)
        t += "&args[]=" + encodeURIComponent(arguments[a]);
    }
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function d(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function f(e) {
    var t = e, a = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, (t.flags & 4098) !== 0 && (a = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? a : null;
  }
  function h(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function p(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function g(e) {
    if (f(e) !== e)
      throw Error(o(188));
  }
  function m(e) {
    var t = e.alternate;
    if (!t) {
      if (t = f(e), t === null) throw Error(o(188));
      return t !== e ? null : e;
    }
    for (var a = e, r = t; ; ) {
      var c = a.return;
      if (c === null) break;
      var u = c.alternate;
      if (u === null) {
        if (r = c.return, r !== null) {
          a = r;
          continue;
        }
        break;
      }
      if (c.child === u.child) {
        for (u = c.child; u; ) {
          if (u === a) return g(c), e;
          if (u === r) return g(c), t;
          u = u.sibling;
        }
        throw Error(o(188));
      }
      if (a.return !== r.return) a = c, r = u;
      else {
        for (var x = !1, v = c.child; v; ) {
          if (v === a) {
            x = !0, a = c, r = u;
            break;
          }
          if (v === r) {
            x = !0, r = c, a = u;
            break;
          }
          v = v.sibling;
        }
        if (!x) {
          for (v = u.child; v; ) {
            if (v === a) {
              x = !0, a = u, r = c;
              break;
            }
            if (v === r) {
              x = !0, r = u, a = c;
              break;
            }
            v = v.sibling;
          }
          if (!x) throw Error(o(189));
        }
      }
      if (a.alternate !== r) throw Error(o(190));
    }
    if (a.tag !== 3) throw Error(o(188));
    return a.stateNode.current === a ? e : t;
  }
  function b(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null; ) {
      if (t = b(e), t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var y = Object.assign, w = /* @__PURE__ */ Symbol.for("react.element"), S = /* @__PURE__ */ Symbol.for("react.transitional.element"), T = /* @__PURE__ */ Symbol.for("react.portal"), _ = /* @__PURE__ */ Symbol.for("react.fragment"), R = /* @__PURE__ */ Symbol.for("react.strict_mode"), z = /* @__PURE__ */ Symbol.for("react.profiler"), Q = /* @__PURE__ */ Symbol.for("react.consumer"), L = /* @__PURE__ */ Symbol.for("react.context"), Y = /* @__PURE__ */ Symbol.for("react.forward_ref"), ae = /* @__PURE__ */ Symbol.for("react.suspense"), ee = /* @__PURE__ */ Symbol.for("react.suspense_list"), Z = /* @__PURE__ */ Symbol.for("react.memo"), k = /* @__PURE__ */ Symbol.for("react.lazy"), ne = /* @__PURE__ */ Symbol.for("react.activity"), V = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), ie = Symbol.iterator;
  function he(e) {
    return e === null || typeof e != "object" ? null : (e = ie && e[ie] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var je = /* @__PURE__ */ Symbol.for("react.client.reference");
  function ke(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === je ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case _:
        return "Fragment";
      case z:
        return "Profiler";
      case R:
        return "StrictMode";
      case ae:
        return "Suspense";
      case ee:
        return "SuspenseList";
      case ne:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case T:
          return "Portal";
        case L:
          return e.displayName || "Context";
        case Q:
          return (e._context.displayName || "Context") + ".Consumer";
        case Y:
          var t = e.render;
          return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case Z:
          return t = e.displayName || null, t !== null ? t : ke(e.type) || "Memo";
        case k:
          t = e._payload, e = e._init;
          try {
            return ke(e(t));
          } catch {
          }
      }
    return null;
  }
  var Se = Array.isArray, O = i.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = l.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, te = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, me = [], $ = -1;
  function N(e) {
    return { current: e };
  }
  function P(e) {
    0 > $ || (e.current = me[$], me[$] = null, $--);
  }
  function G(e, t) {
    $++, me[$] = e.current, e.current = t;
  }
  var W = N(null), J = N(null), le = N(null), ve = N(null);
  function be(e, t) {
    switch (G(le, t), G(J, e), G(W, null), t.nodeType) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? px(e) : 0;
        break;
      default:
        if (e = t.tagName, t = t.namespaceURI)
          t = px(t), e = gx(t, e);
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    P(W), G(W, e);
  }
  function ge() {
    P(W), P(J), P(le);
  }
  function Qt(e) {
    e.memoizedState !== null && G(ve, e);
    var t = W.current, a = gx(t, e.type);
    t !== a && (G(J, e), G(W, a));
  }
  function Rt(e) {
    J.current === e && (P(W), P(J)), ve.current === e && (P(ve), Or._currentValue = te);
  }
  var At, ma;
  function wt(e) {
    if (At === void 0)
      try {
        throw Error();
      } catch (a) {
        var t = a.stack.trim().match(/\n( *(at )?)/);
        At = t && t[1] || "", ma = -1 < a.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < a.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + At + e + ma;
  }
  var Ls = !1;
  function Fi(e, t) {
    if (!e || Ls) return "";
    Ls = !0;
    var a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var r = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var I = function() {
                throw Error();
              };
              if (Object.defineProperty(I.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(I, []);
                } catch (H) {
                  var B = H;
                }
                Reflect.construct(e, [], I);
              } else {
                try {
                  I.call();
                } catch (H) {
                  B = H;
                }
                e.call(I.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (H) {
                B = H;
              }
              (I = e()) && typeof I.catch == "function" && I.catch(function() {
              });
            }
          } catch (H) {
            if (H && B && typeof H.stack == "string")
              return [H.stack, B.stack];
          }
          return [null, null];
        }
      };
      r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var c = Object.getOwnPropertyDescriptor(
        r.DetermineComponentFrameRoot,
        "name"
      );
      c && c.configurable && Object.defineProperty(
        r.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var u = r.DetermineComponentFrameRoot(), x = u[0], v = u[1];
      if (x && v) {
        var j = x.split(`
`), F = v.split(`
`);
        for (c = r = 0; r < j.length && !j[r].includes("DetermineComponentFrameRoot"); )
          r++;
        for (; c < F.length && !F[c].includes(
          "DetermineComponentFrameRoot"
        ); )
          c++;
        if (r === j.length || c === F.length)
          for (r = j.length - 1, c = F.length - 1; 1 <= r && 0 <= c && j[r] !== F[c]; )
            c--;
        for (; 1 <= r && 0 <= c; r--, c--)
          if (j[r] !== F[c]) {
            if (r !== 1 || c !== 1)
              do
                if (r--, c--, 0 > c || j[r] !== F[c]) {
                  var U = `
` + j[r].replace(" at new ", " at ");
                  return e.displayName && U.includes("<anonymous>") && (U = U.replace("<anonymous>", e.displayName)), U;
                }
              while (1 <= r && 0 <= c);
            break;
          }
      }
    } finally {
      Ls = !1, Error.prepareStackTrace = a;
    }
    return (a = e ? e.displayName || e.name : "") ? wt(a) : "";
  }
  function Wa(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return wt(e.type);
      case 16:
        return wt("Lazy");
      case 13:
        return e.child !== t && t !== null ? wt("Suspense Fallback") : wt("Suspense");
      case 19:
        return wt("SuspenseList");
      case 0:
      case 15:
        return Fi(e.type, !1);
      case 11:
        return Fi(e.type.render, !1);
      case 1:
        return Fi(e.type, !0);
      case 31:
        return wt("Activity");
      default:
        return "";
    }
  }
  function Ps(e) {
    try {
      var t = "", a = null;
      do
        t += Wa(e, a), a = e, e = e.return;
      while (e);
      return t;
    } catch (r) {
      return `
Error generating stack: ` + r.message + `
` + r.stack;
    }
  }
  var Zt = Object.prototype.hasOwnProperty, qs = n.unstable_scheduleCallback, Is = n.unstable_cancelCallback, Ct = n.unstable_shouldYield, pa = n.unstable_requestPaint, Et = n.unstable_now, kc = n.unstable_getCurrentPriorityLevel, Ja = n.unstable_ImmediatePriority, pl = n.unstable_UserBlockingPriority, ei = n.unstable_NormalPriority, Gs = n.unstable_LowPriority, Qn = n.unstable_IdlePriority, gl = n.log, ga = n.unstable_setDisableYieldValue, ti = null, kt = null;
  function Nn(e) {
    if (typeof gl == "function" && ga(e), kt && typeof kt.setStrictMode == "function")
      try {
        kt.setStrictMode(ti, e);
      } catch {
      }
  }
  var jt = Math.clz32 ? Math.clz32 : _n, Mc = Math.log, Ys = Math.LN2;
  function _n(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (Mc(e) / Ys | 0) | 0;
  }
  var Bi = 256, Vi = 262144, ni = 4194304;
  function Dn(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function xe(e, t, a) {
    var r = e.pendingLanes;
    if (r === 0) return 0;
    var c = 0, u = e.suspendedLanes, x = e.pingedLanes;
    e = e.warmLanes;
    var v = r & 134217727;
    return v !== 0 ? (r = v & ~u, r !== 0 ? c = Dn(r) : (x &= v, x !== 0 ? c = Dn(x) : a || (a = v & ~e, a !== 0 && (c = Dn(a))))) : (v = r & ~u, v !== 0 ? c = Dn(v) : x !== 0 ? c = Dn(x) : a || (a = r & ~e, a !== 0 && (c = Dn(a)))), c === 0 ? 0 : t !== 0 && t !== c && (t & u) === 0 && (u = c & -c, a = t & -t, u >= a || u === 32 && (a & 4194048) !== 0) ? t : c;
  }
  function Ze(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function ut(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function St() {
    var e = ni;
    return ni <<= 1, (ni & 62914560) === 0 && (ni = 4194304), e;
  }
  function xa(e) {
    for (var t = [], a = 0; 31 > a; a++) t.push(e);
    return t;
  }
  function Ke(e, t) {
    e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
  }
  function _t(e, t, a, r, c, u) {
    var x = e.pendingLanes;
    e.pendingLanes = a, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= a, e.entangledLanes &= a, e.errorRecoveryDisabledLanes &= a, e.shellSuspendCounter = 0;
    var v = e.entanglements, j = e.expirationTimes, F = e.hiddenUpdates;
    for (a = x & ~a; 0 < a; ) {
      var U = 31 - jt(a), I = 1 << U;
      v[U] = 0, j[U] = -1;
      var B = F[U];
      if (B !== null)
        for (F[U] = null, U = 0; U < B.length; U++) {
          var H = B[U];
          H !== null && (H.lane &= -536870913);
        }
      a &= ~I;
    }
    r !== 0 && ai(e, r, 0), u !== 0 && c === 0 && e.tag !== 0 && (e.suspendedLanes |= u & ~(x & ~t));
  }
  function ai(e, t, a) {
    e.pendingLanes |= t, e.suspendedLanes &= ~t;
    var r = 31 - jt(t);
    e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | a & 261930;
  }
  function Dt(e, t) {
    var a = e.entangledLanes |= t;
    for (e = e.entanglements; a; ) {
      var r = 31 - jt(a), c = 1 << r;
      c & t | e[r] & t && (e[r] |= t), a &= ~c;
    }
  }
  function Ft(e, t) {
    var a = t & -t;
    return a = (a & 42) !== 0 ? 1 : Hi(a), (a & (e.suspendedLanes | t)) !== 0 ? 0 : a;
  }
  function Hi(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function Tn(e) {
    return e &= -e, 2 < e ? 8 < e ? (e & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function zc() {
    var e = X.p;
    return e !== 0 ? e : (e = window.event, e === void 0 ? 32 : Hx(e.type));
  }
  function tm(e, t) {
    var a = X.p;
    try {
      return X.p = e, t();
    } finally {
      X.p = a;
    }
  }
  var ya = Math.random().toString(36).slice(2), mt = "__reactFiber$" + ya, Bt = "__reactProps$" + ya, Ui = "__reactContainer$" + ya, Oc = "__reactEvents$" + ya, sw = "__reactListeners$" + ya, rw = "__reactHandles$" + ya, nm = "__reactResources$" + ya, Qs = "__reactMarker$" + ya;
  function Rc(e) {
    delete e[mt], delete e[Bt], delete e[Oc], delete e[sw], delete e[rw];
  }
  function Li(e) {
    var t = e[mt];
    if (t) return t;
    for (var a = e.parentNode; a; ) {
      if (t = a[Ui] || a[mt]) {
        if (a = t.alternate, t.child !== null || a !== null && a.child !== null)
          for (e = Sx(e); e !== null; ) {
            if (a = e[mt]) return a;
            e = Sx(e);
          }
        return t;
      }
      e = a, a = e.parentNode;
    }
    return null;
  }
  function Pi(e) {
    if (e = e[mt] || e[Ui]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return e;
    }
    return null;
  }
  function Zs(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(o(33));
  }
  function qi(e) {
    var t = e[nm];
    return t || (t = e[nm] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function dt(e) {
    e[Qs] = !0;
  }
  var am = /* @__PURE__ */ new Set(), im = {};
  function ii(e, t) {
    Ii(e, t), Ii(e + "Capture", t);
  }
  function Ii(e, t) {
    for (im[e] = t, e = 0; e < t.length; e++)
      am.add(t[e]);
  }
  var lw = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), sm = {}, rm = {};
  function ow(e) {
    return Zt.call(rm, e) ? !0 : Zt.call(sm, e) ? !1 : lw.test(e) ? rm[e] = !0 : (sm[e] = !0, !1);
  }
  function xl(e, t, a) {
    if (ow(t))
      if (a === null) e.removeAttribute(t);
      else {
        switch (typeof a) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(t);
            return;
          case "boolean":
            var r = t.toLowerCase().slice(0, 5);
            if (r !== "data-" && r !== "aria-") {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, "" + a);
      }
  }
  function yl(e, t, a) {
    if (a === null) e.removeAttribute(t);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, "" + a);
    }
  }
  function Zn(e, t, a, r) {
    if (r === null) e.removeAttribute(a);
    else {
      switch (typeof r) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(a);
          return;
      }
      e.setAttributeNS(t, a, "" + r);
    }
  }
  function on(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function lm(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function cw(e, t, a) {
    var r = Object.getOwnPropertyDescriptor(
      e.constructor.prototype,
      t
    );
    if (!e.hasOwnProperty(t) && typeof r < "u" && typeof r.get == "function" && typeof r.set == "function") {
      var c = r.get, u = r.set;
      return Object.defineProperty(e, t, {
        configurable: !0,
        get: function() {
          return c.call(this);
        },
        set: function(x) {
          a = "" + x, u.call(this, x);
        }
      }), Object.defineProperty(e, t, {
        enumerable: r.enumerable
      }), {
        getValue: function() {
          return a;
        },
        setValue: function(x) {
          a = "" + x;
        },
        stopTracking: function() {
          e._valueTracker = null, delete e[t];
        }
      };
    }
  }
  function _c(e) {
    if (!e._valueTracker) {
      var t = lm(e) ? "checked" : "value";
      e._valueTracker = cw(
        e,
        t,
        "" + e[t]
      );
    }
  }
  function om(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var a = t.getValue(), r = "";
    return e && (r = lm(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== a ? (t.setValue(e), !0) : !1;
  }
  function bl(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var uw = /[\n"\\]/g;
  function cn(e) {
    return e.replace(
      uw,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Dc(e, t, a, r, c, u, x, v) {
    e.name = "", x != null && typeof x != "function" && typeof x != "symbol" && typeof x != "boolean" ? e.type = x : e.removeAttribute("type"), t != null ? x === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + on(t)) : e.value !== "" + on(t) && (e.value = "" + on(t)) : x !== "submit" && x !== "reset" || e.removeAttribute("value"), t != null ? Fc(e, x, on(t)) : a != null ? Fc(e, x, on(a)) : r != null && e.removeAttribute("value"), c == null && u != null && (e.defaultChecked = !!u), c != null && (e.checked = c && typeof c != "function" && typeof c != "symbol"), v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" ? e.name = "" + on(v) : e.removeAttribute("name");
  }
  function cm(e, t, a, r, c, u, x, v) {
    if (u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (e.type = u), t != null || a != null) {
      if (!(u !== "submit" && u !== "reset" || t != null)) {
        _c(e);
        return;
      }
      a = a != null ? "" + on(a) : "", t = t != null ? "" + on(t) : a, v || t === e.value || (e.value = t), e.defaultValue = t;
    }
    r = r ?? c, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = v ? e.checked : !!r, e.defaultChecked = !!r, x != null && typeof x != "function" && typeof x != "symbol" && typeof x != "boolean" && (e.name = x), _c(e);
  }
  function Fc(e, t, a) {
    t === "number" && bl(e.ownerDocument) === e || e.defaultValue === "" + a || (e.defaultValue = "" + a);
  }
  function Gi(e, t, a, r) {
    if (e = e.options, t) {
      t = {};
      for (var c = 0; c < a.length; c++)
        t["$" + a[c]] = !0;
      for (a = 0; a < e.length; a++)
        c = t.hasOwnProperty("$" + e[a].value), e[a].selected !== c && (e[a].selected = c), c && r && (e[a].defaultSelected = !0);
    } else {
      for (a = "" + on(a), t = null, c = 0; c < e.length; c++) {
        if (e[c].value === a) {
          e[c].selected = !0, r && (e[c].defaultSelected = !0);
          return;
        }
        t !== null || e[c].disabled || (t = e[c]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function um(e, t, a) {
    if (t != null && (t = "" + on(t), t !== e.value && (e.value = t), a == null)) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = a != null ? "" + on(a) : "";
  }
  function dm(e, t, a, r) {
    if (t == null) {
      if (r != null) {
        if (a != null) throw Error(o(92));
        if (Se(r)) {
          if (1 < r.length) throw Error(o(93));
          r = r[0];
        }
        a = r;
      }
      a == null && (a = ""), t = a;
    }
    a = on(t), e.defaultValue = a, r = e.textContent, r === a && r !== "" && r !== null && (e.value = r), _c(e);
  }
  function Yi(e, t) {
    if (t) {
      var a = e.firstChild;
      if (a && a === e.lastChild && a.nodeType === 3) {
        a.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var dw = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function hm(e, t, a) {
    var r = t.indexOf("--") === 0;
    a == null || typeof a == "boolean" || a === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, a) : typeof a != "number" || a === 0 || dw.has(t) ? t === "float" ? e.cssFloat = a : e[t] = ("" + a).trim() : e[t] = a + "px";
  }
  function fm(e, t, a) {
    if (t != null && typeof t != "object")
      throw Error(o(62));
    if (e = e.style, a != null) {
      for (var r in a)
        !a.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
      for (var c in t)
        r = t[c], t.hasOwnProperty(c) && a[c] !== r && hm(e, c, r);
    } else
      for (var u in t)
        t.hasOwnProperty(u) && hm(e, u, t[u]);
  }
  function Bc(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var hw = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), fw = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function vl(e) {
    return fw.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  function Xn() {
  }
  var Vc = null;
  function Hc(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var Qi = null, Zi = null;
  function mm(e) {
    var t = Pi(e);
    if (t && (e = t.stateNode)) {
      var a = e[Bt] || null;
      e: switch (e = t.stateNode, t.type) {
        case "input":
          if (Dc(
            e,
            a.value,
            a.defaultValue,
            a.defaultValue,
            a.checked,
            a.defaultChecked,
            a.type,
            a.name
          ), t = a.name, a.type === "radio" && t != null) {
            for (a = e; a.parentNode; ) a = a.parentNode;
            for (a = a.querySelectorAll(
              'input[name="' + cn(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < a.length; t++) {
              var r = a[t];
              if (r !== e && r.form === e.form) {
                var c = r[Bt] || null;
                if (!c) throw Error(o(90));
                Dc(
                  r,
                  c.value,
                  c.defaultValue,
                  c.defaultValue,
                  c.checked,
                  c.defaultChecked,
                  c.type,
                  c.name
                );
              }
            }
            for (t = 0; t < a.length; t++)
              r = a[t], r.form === e.form && om(r);
          }
          break e;
        case "textarea":
          um(e, a.value, a.defaultValue);
          break e;
        case "select":
          t = a.value, t != null && Gi(e, !!a.multiple, t, !1);
      }
    }
  }
  var Uc = !1;
  function pm(e, t, a) {
    if (Uc) return e(t, a);
    Uc = !0;
    try {
      var r = e(t);
      return r;
    } finally {
      if (Uc = !1, (Qi !== null || Zi !== null) && (lo(), Qi && (t = Qi, e = Zi, Zi = Qi = null, mm(t), e)))
        for (t = 0; t < e.length; t++) mm(e[t]);
    }
  }
  function Xs(e, t) {
    var a = e.stateNode;
    if (a === null) return null;
    var r = a[Bt] || null;
    if (r === null) return null;
    a = r[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (a && typeof a != "function")
      throw Error(
        o(231, t, typeof a)
      );
    return a;
  }
  var Kn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Lc = !1;
  if (Kn)
    try {
      var Ks = {};
      Object.defineProperty(Ks, "passive", {
        get: function() {
          Lc = !0;
        }
      }), window.addEventListener("test", Ks, Ks), window.removeEventListener("test", Ks, Ks);
    } catch {
      Lc = !1;
    }
  var ba = null, Pc = null, wl = null;
  function gm() {
    if (wl) return wl;
    var e, t = Pc, a = t.length, r, c = "value" in ba ? ba.value : ba.textContent, u = c.length;
    for (e = 0; e < a && t[e] === c[e]; e++) ;
    var x = a - e;
    for (r = 1; r <= x && t[a - r] === c[u - r]; r++) ;
    return wl = c.slice(e, 1 < r ? 1 - r : void 0);
  }
  function jl(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function Sl() {
    return !0;
  }
  function xm() {
    return !1;
  }
  function Vt(e) {
    function t(a, r, c, u, x) {
      this._reactName = a, this._targetInst = c, this.type = r, this.nativeEvent = u, this.target = x, this.currentTarget = null;
      for (var v in e)
        e.hasOwnProperty(v) && (a = e[v], this[v] = a ? a(u) : u[v]);
      return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? Sl : xm, this.isPropagationStopped = xm, this;
    }
    return y(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = Sl);
      },
      stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = Sl);
      },
      persist: function() {
      },
      isPersistent: Sl
    }), t;
  }
  var si = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Nl = Vt(si), $s = y({}, si, { view: 0, detail: 0 }), mw = Vt($s), qc, Ic, Ws, Tl = y({}, $s, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Yc,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== Ws && (Ws && e.type === "mousemove" ? (qc = e.screenX - Ws.screenX, Ic = e.screenY - Ws.screenY) : Ic = qc = 0, Ws = e), qc);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : Ic;
    }
  }), ym = Vt(Tl), pw = y({}, Tl, { dataTransfer: 0 }), gw = Vt(pw), xw = y({}, $s, { relatedTarget: 0 }), Gc = Vt(xw), yw = y({}, si, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), bw = Vt(yw), vw = y({}, si, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), ww = Vt(vw), jw = y({}, si, { data: 0 }), bm = Vt(jw), Sw = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Nw = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Tw = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Aw(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = Tw[e]) ? !!t[e] : !1;
  }
  function Yc() {
    return Aw;
  }
  var Cw = y({}, $s, {
    key: function(e) {
      if (e.key) {
        var t = Sw[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress" ? (e = jl(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Nw[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Yc,
    charCode: function(e) {
      return e.type === "keypress" ? jl(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? jl(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), Ew = Vt(Cw), kw = y({}, Tl, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), vm = Vt(kw), Mw = y({}, $s, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Yc
  }), zw = Vt(Mw), Ow = y({}, si, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Rw = Vt(Ow), _w = y({}, Tl, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Dw = Vt(_w), Fw = y({}, si, {
    newState: 0,
    oldState: 0
  }), Bw = Vt(Fw), Vw = [9, 13, 27, 32], Qc = Kn && "CompositionEvent" in window, Js = null;
  Kn && "documentMode" in document && (Js = document.documentMode);
  var Hw = Kn && "TextEvent" in window && !Js, wm = Kn && (!Qc || Js && 8 < Js && 11 >= Js), jm = " ", Sm = !1;
  function Nm(e, t) {
    switch (e) {
      case "keyup":
        return Vw.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Tm(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var Xi = !1;
  function Uw(e, t) {
    switch (e) {
      case "compositionend":
        return Tm(t);
      case "keypress":
        return t.which !== 32 ? null : (Sm = !0, jm);
      case "textInput":
        return e = t.data, e === jm && Sm ? null : e;
      default:
        return null;
    }
  }
  function Lw(e, t) {
    if (Xi)
      return e === "compositionend" || !Qc && Nm(e, t) ? (e = gm(), wl = Pc = ba = null, Xi = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return wm && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Pw = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Am(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!Pw[e.type] : t === "textarea";
  }
  function Cm(e, t, a, r) {
    Qi ? Zi ? Zi.push(r) : Zi = [r] : Qi = r, t = po(t, "onChange"), 0 < t.length && (a = new Nl(
      "onChange",
      "change",
      null,
      a,
      r
    ), e.push({ event: a, listeners: t }));
  }
  var er = null, tr = null;
  function qw(e) {
    cx(e, 0);
  }
  function Al(e) {
    var t = Zs(e);
    if (om(t)) return e;
  }
  function Em(e, t) {
    if (e === "change") return t;
  }
  var km = !1;
  if (Kn) {
    var Zc;
    if (Kn) {
      var Xc = "oninput" in document;
      if (!Xc) {
        var Mm = document.createElement("div");
        Mm.setAttribute("oninput", "return;"), Xc = typeof Mm.oninput == "function";
      }
      Zc = Xc;
    } else Zc = !1;
    km = Zc && (!document.documentMode || 9 < document.documentMode);
  }
  function zm() {
    er && (er.detachEvent("onpropertychange", Om), tr = er = null);
  }
  function Om(e) {
    if (e.propertyName === "value" && Al(tr)) {
      var t = [];
      Cm(
        t,
        tr,
        e,
        Hc(e)
      ), pm(qw, t);
    }
  }
  function Iw(e, t, a) {
    e === "focusin" ? (zm(), er = t, tr = a, er.attachEvent("onpropertychange", Om)) : e === "focusout" && zm();
  }
  function Gw(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return Al(tr);
  }
  function Yw(e, t) {
    if (e === "click") return Al(t);
  }
  function Qw(e, t) {
    if (e === "input" || e === "change")
      return Al(t);
  }
  function Zw(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var Xt = typeof Object.is == "function" ? Object.is : Zw;
  function nr(e, t) {
    if (Xt(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null)
      return !1;
    var a = Object.keys(e), r = Object.keys(t);
    if (a.length !== r.length) return !1;
    for (r = 0; r < a.length; r++) {
      var c = a[r];
      if (!Zt.call(t, c) || !Xt(e[c], t[c]))
        return !1;
    }
    return !0;
  }
  function Rm(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function _m(e, t) {
    var a = Rm(e);
    e = 0;
    for (var r; a; ) {
      if (a.nodeType === 3) {
        if (r = e + a.textContent.length, e <= t && r >= t)
          return { node: a, offset: t - e };
        e = r;
      }
      e: {
        for (; a; ) {
          if (a.nextSibling) {
            a = a.nextSibling;
            break e;
          }
          a = a.parentNode;
        }
        a = void 0;
      }
      a = Rm(a);
    }
  }
  function Dm(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Dm(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function Fm(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = bl(e.document); t instanceof e.HTMLIFrameElement; ) {
      try {
        var a = typeof t.contentWindow.location.href == "string";
      } catch {
        a = !1;
      }
      if (a) e = t.contentWindow;
      else break;
      t = bl(e.document);
    }
    return t;
  }
  function Kc(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  var Xw = Kn && "documentMode" in document && 11 >= document.documentMode, Ki = null, $c = null, ar = null, Wc = !1;
  function Bm(e, t, a) {
    var r = a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
    Wc || Ki == null || Ki !== bl(r) || (r = Ki, "selectionStart" in r && Kc(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
      anchorNode: r.anchorNode,
      anchorOffset: r.anchorOffset,
      focusNode: r.focusNode,
      focusOffset: r.focusOffset
    }), ar && nr(ar, r) || (ar = r, r = po($c, "onSelect"), 0 < r.length && (t = new Nl(
      "onSelect",
      "select",
      null,
      t,
      a
    ), e.push({ event: t, listeners: r }), t.target = Ki)));
  }
  function ri(e, t) {
    var a = {};
    return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
  }
  var $i = {
    animationend: ri("Animation", "AnimationEnd"),
    animationiteration: ri("Animation", "AnimationIteration"),
    animationstart: ri("Animation", "AnimationStart"),
    transitionrun: ri("Transition", "TransitionRun"),
    transitionstart: ri("Transition", "TransitionStart"),
    transitioncancel: ri("Transition", "TransitionCancel"),
    transitionend: ri("Transition", "TransitionEnd")
  }, Jc = {}, Vm = {};
  Kn && (Vm = document.createElement("div").style, "AnimationEvent" in window || (delete $i.animationend.animation, delete $i.animationiteration.animation, delete $i.animationstart.animation), "TransitionEvent" in window || delete $i.transitionend.transition);
  function li(e) {
    if (Jc[e]) return Jc[e];
    if (!$i[e]) return e;
    var t = $i[e], a;
    for (a in t)
      if (t.hasOwnProperty(a) && a in Vm)
        return Jc[e] = t[a];
    return e;
  }
  var Hm = li("animationend"), Um = li("animationiteration"), Lm = li("animationstart"), Kw = li("transitionrun"), $w = li("transitionstart"), Ww = li("transitioncancel"), Pm = li("transitionend"), qm = /* @__PURE__ */ new Map(), eu = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  eu.push("scrollEnd");
  function An(e, t) {
    qm.set(e, t), ii(t, [e]);
  }
  var Cl = typeof reportError == "function" ? reportError : function(e) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", e);
      return;
    }
    console.error(e);
  }, un = [], Wi = 0, tu = 0;
  function El() {
    for (var e = Wi, t = tu = Wi = 0; t < e; ) {
      var a = un[t];
      un[t++] = null;
      var r = un[t];
      un[t++] = null;
      var c = un[t];
      un[t++] = null;
      var u = un[t];
      if (un[t++] = null, r !== null && c !== null) {
        var x = r.pending;
        x === null ? c.next = c : (c.next = x.next, x.next = c), r.pending = c;
      }
      u !== 0 && Im(a, c, u);
    }
  }
  function kl(e, t, a, r) {
    un[Wi++] = e, un[Wi++] = t, un[Wi++] = a, un[Wi++] = r, tu |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
  }
  function nu(e, t, a, r) {
    return kl(e, t, a, r), Ml(e);
  }
  function oi(e, t) {
    return kl(e, null, null, t), Ml(e);
  }
  function Im(e, t, a) {
    e.lanes |= a;
    var r = e.alternate;
    r !== null && (r.lanes |= a);
    for (var c = !1, u = e.return; u !== null; )
      u.childLanes |= a, r = u.alternate, r !== null && (r.childLanes |= a), u.tag === 22 && (e = u.stateNode, e === null || e._visibility & 1 || (c = !0)), e = u, u = u.return;
    return e.tag === 3 ? (u = e.stateNode, c && t !== null && (c = 31 - jt(a), e = u.hiddenUpdates, r = e[c], r === null ? e[c] = [t] : r.push(t), t.lane = a | 536870912), u) : null;
  }
  function Ml(e) {
    if (50 < Tr)
      throw Tr = 0, dd = null, Error(o(185));
    for (var t = e.return; t !== null; )
      e = t, t = e.return;
    return e.tag === 3 ? e.stateNode : null;
  }
  var Ji = {};
  function Jw(e, t, a, r) {
    this.tag = e, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Kt(e, t, a, r) {
    return new Jw(e, t, a, r);
  }
  function au(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function $n(e, t) {
    var a = e.alternate;
    return a === null ? (a = Kt(
      e.tag,
      t,
      e.key,
      e.mode
    ), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = 0, a.subtreeFlags = 0, a.deletions = null), a.flags = e.flags & 65011712, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue, t = e.dependencies, a.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.refCleanup = e.refCleanup, a;
  }
  function Gm(e, t) {
    e.flags &= 65011714;
    var a = e.alternate;
    return a === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type, t = a.dependencies, e.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), e;
  }
  function zl(e, t, a, r, c, u) {
    var x = 0;
    if (r = e, typeof e == "function") au(e) && (x = 1);
    else if (typeof e == "string")
      x = ij(
        e,
        a,
        W.current
      ) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
    else
      e: switch (e) {
        case ne:
          return e = Kt(31, a, t, c), e.elementType = ne, e.lanes = u, e;
        case _:
          return ci(a.children, c, u, t);
        case R:
          x = 8, c |= 24;
          break;
        case z:
          return e = Kt(12, a, t, c | 2), e.elementType = z, e.lanes = u, e;
        case ae:
          return e = Kt(13, a, t, c), e.elementType = ae, e.lanes = u, e;
        case ee:
          return e = Kt(19, a, t, c), e.elementType = ee, e.lanes = u, e;
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case L:
                x = 10;
                break e;
              case Q:
                x = 9;
                break e;
              case Y:
                x = 11;
                break e;
              case Z:
                x = 14;
                break e;
              case k:
                x = 16, r = null;
                break e;
            }
          x = 29, a = Error(
            o(130, e === null ? "null" : typeof e, "")
          ), r = null;
      }
    return t = Kt(x, a, t, c), t.elementType = e, t.type = r, t.lanes = u, t;
  }
  function ci(e, t, a, r) {
    return e = Kt(7, e, r, t), e.lanes = a, e;
  }
  function iu(e, t, a) {
    return e = Kt(6, e, null, t), e.lanes = a, e;
  }
  function Ym(e) {
    var t = Kt(18, null, null, 0);
    return t.stateNode = e, t;
  }
  function su(e, t, a) {
    return t = Kt(
      4,
      e.children !== null ? e.children : [],
      e.key,
      t
    ), t.lanes = a, t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, t;
  }
  var Qm = /* @__PURE__ */ new WeakMap();
  function dn(e, t) {
    if (typeof e == "object" && e !== null) {
      var a = Qm.get(e);
      return a !== void 0 ? a : (t = {
        value: e,
        source: t,
        stack: Ps(t)
      }, Qm.set(e, t), t);
    }
    return {
      value: e,
      source: t,
      stack: Ps(t)
    };
  }
  var es = [], ts = 0, Ol = null, ir = 0, hn = [], fn = 0, va = null, Fn = 1, Bn = "";
  function Wn(e, t) {
    es[ts++] = ir, es[ts++] = Ol, Ol = e, ir = t;
  }
  function Zm(e, t, a) {
    hn[fn++] = Fn, hn[fn++] = Bn, hn[fn++] = va, va = e;
    var r = Fn;
    e = Bn;
    var c = 32 - jt(r) - 1;
    r &= ~(1 << c), a += 1;
    var u = 32 - jt(t) + c;
    if (30 < u) {
      var x = c - c % 5;
      u = (r & (1 << x) - 1).toString(32), r >>= x, c -= x, Fn = 1 << 32 - jt(t) + c | a << c | r, Bn = u + e;
    } else
      Fn = 1 << u | a << c | r, Bn = e;
  }
  function ru(e) {
    e.return !== null && (Wn(e, 1), Zm(e, 1, 0));
  }
  function lu(e) {
    for (; e === Ol; )
      Ol = es[--ts], es[ts] = null, ir = es[--ts], es[ts] = null;
    for (; e === va; )
      va = hn[--fn], hn[fn] = null, Bn = hn[--fn], hn[fn] = null, Fn = hn[--fn], hn[fn] = null;
  }
  function Xm(e, t) {
    hn[fn++] = Fn, hn[fn++] = Bn, hn[fn++] = va, Fn = t.id, Bn = t.overflow, va = e;
  }
  var pt = null, Ye = null, Re = !1, wa = null, mn = !1, ou = Error(o(519));
  function ja(e) {
    var t = Error(
      o(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw sr(dn(t, e)), ou;
  }
  function Km(e) {
    var t = e.stateNode, a = e.type, r = e.memoizedProps;
    switch (t[mt] = e, t[Bt] = r, a) {
      case "dialog":
        Ee("cancel", t), Ee("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ee("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Cr.length; a++)
          Ee(Cr[a], t);
        break;
      case "source":
        Ee("error", t);
        break;
      case "img":
      case "image":
      case "link":
        Ee("error", t), Ee("load", t);
        break;
      case "details":
        Ee("toggle", t);
        break;
      case "input":
        Ee("invalid", t), cm(
          t,
          r.value,
          r.defaultValue,
          r.checked,
          r.defaultChecked,
          r.type,
          r.name,
          !0
        );
        break;
      case "select":
        Ee("invalid", t);
        break;
      case "textarea":
        Ee("invalid", t), dm(t, r.value, r.defaultValue, r.children);
    }
    a = r.children, typeof a != "string" && typeof a != "number" && typeof a != "bigint" || t.textContent === "" + a || r.suppressHydrationWarning === !0 || fx(t.textContent, a) ? (r.popover != null && (Ee("beforetoggle", t), Ee("toggle", t)), r.onScroll != null && Ee("scroll", t), r.onScrollEnd != null && Ee("scrollend", t), r.onClick != null && (t.onclick = Xn), t = !0) : t = !1, t || ja(e, !0);
  }
  function $m(e) {
    for (pt = e.return; pt; )
      switch (pt.tag) {
        case 5:
        case 31:
        case 13:
          mn = !1;
          return;
        case 27:
        case 3:
          mn = !0;
          return;
        default:
          pt = pt.return;
      }
  }
  function ns(e) {
    if (e !== pt) return !1;
    if (!Re) return $m(e), Re = !0, !1;
    var t = e.tag, a;
    if ((a = t !== 3 && t !== 27) && ((a = t === 5) && (a = e.type, a = !(a !== "form" && a !== "button") || Ad(e.type, e.memoizedProps)), a = !a), a && Ye && ja(e), $m(e), t === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      Ye = jx(e);
    } else if (t === 31) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      Ye = jx(e);
    } else
      t === 27 ? (t = Ye, Fa(e.type) ? (e = zd, zd = null, Ye = e) : Ye = t) : Ye = pt ? gn(e.stateNode.nextSibling) : null;
    return !0;
  }
  function ui() {
    Ye = pt = null, Re = !1;
  }
  function cu() {
    var e = wa;
    return e !== null && (Pt === null ? Pt = e : Pt.push.apply(
      Pt,
      e
    ), wa = null), e;
  }
  function sr(e) {
    wa === null ? wa = [e] : wa.push(e);
  }
  var uu = N(null), di = null, Jn = null;
  function Sa(e, t, a) {
    G(uu, t._currentValue), t._currentValue = a;
  }
  function ea(e) {
    e._currentValue = uu.current, P(uu);
  }
  function du(e, t, a) {
    for (; e !== null; ) {
      var r = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === a) break;
      e = e.return;
    }
  }
  function hu(e, t, a, r) {
    var c = e.child;
    for (c !== null && (c.return = e); c !== null; ) {
      var u = c.dependencies;
      if (u !== null) {
        var x = c.child;
        u = u.firstContext;
        e: for (; u !== null; ) {
          var v = u;
          u = c;
          for (var j = 0; j < t.length; j++)
            if (v.context === t[j]) {
              u.lanes |= a, v = u.alternate, v !== null && (v.lanes |= a), du(
                u.return,
                a,
                e
              ), r || (x = null);
              break e;
            }
          u = v.next;
        }
      } else if (c.tag === 18) {
        if (x = c.return, x === null) throw Error(o(341));
        x.lanes |= a, u = x.alternate, u !== null && (u.lanes |= a), du(x, a, e), x = null;
      } else x = c.child;
      if (x !== null) x.return = c;
      else
        for (x = c; x !== null; ) {
          if (x === e) {
            x = null;
            break;
          }
          if (c = x.sibling, c !== null) {
            c.return = x.return, x = c;
            break;
          }
          x = x.return;
        }
      c = x;
    }
  }
  function as(e, t, a, r) {
    e = null;
    for (var c = t, u = !1; c !== null; ) {
      if (!u) {
        if ((c.flags & 524288) !== 0) u = !0;
        else if ((c.flags & 262144) !== 0) break;
      }
      if (c.tag === 10) {
        var x = c.alternate;
        if (x === null) throw Error(o(387));
        if (x = x.memoizedProps, x !== null) {
          var v = c.type;
          Xt(c.pendingProps.value, x.value) || (e !== null ? e.push(v) : e = [v]);
        }
      } else if (c === ve.current) {
        if (x = c.alternate, x === null) throw Error(o(387));
        x.memoizedState.memoizedState !== c.memoizedState.memoizedState && (e !== null ? e.push(Or) : e = [Or]);
      }
      c = c.return;
    }
    e !== null && hu(
      t,
      e,
      a,
      r
    ), t.flags |= 262144;
  }
  function Rl(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!Xt(
        e.context._currentValue,
        e.memoizedValue
      ))
        return !0;
      e = e.next;
    }
    return !1;
  }
  function hi(e) {
    di = e, Jn = null, e = e.dependencies, e !== null && (e.firstContext = null);
  }
  function gt(e) {
    return Wm(di, e);
  }
  function _l(e, t) {
    return di === null && hi(e), Wm(e, t);
  }
  function Wm(e, t) {
    var a = t._currentValue;
    if (t = { context: t, memoizedValue: a, next: null }, Jn === null) {
      if (e === null) throw Error(o(308));
      Jn = t, e.dependencies = { lanes: 0, firstContext: t }, e.flags |= 524288;
    } else Jn = Jn.next = t;
    return a;
  }
  var e2 = typeof AbortController < "u" ? AbortController : function() {
    var e = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(a, r) {
        e.push(r);
      }
    };
    this.abort = function() {
      t.aborted = !0, e.forEach(function(a) {
        return a();
      });
    };
  }, t2 = n.unstable_scheduleCallback, n2 = n.unstable_NormalPriority, nt = {
    $$typeof: L,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function fu() {
    return {
      controller: new e2(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function rr(e) {
    e.refCount--, e.refCount === 0 && t2(n2, function() {
      e.controller.abort();
    });
  }
  var lr = null, mu = 0, is = 0, ss = null;
  function a2(e, t) {
    if (lr === null) {
      var a = lr = [];
      mu = 0, is = xd(), ss = {
        status: "pending",
        value: void 0,
        then: function(r) {
          a.push(r);
        }
      };
    }
    return mu++, t.then(Jm, Jm), t;
  }
  function Jm() {
    if (--mu === 0 && lr !== null) {
      ss !== null && (ss.status = "fulfilled");
      var e = lr;
      lr = null, is = 0, ss = null;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function i2(e, t) {
    var a = [], r = {
      status: "pending",
      value: null,
      reason: null,
      then: function(c) {
        a.push(c);
      }
    };
    return e.then(
      function() {
        r.status = "fulfilled", r.value = t;
        for (var c = 0; c < a.length; c++) (0, a[c])(t);
      },
      function(c) {
        for (r.status = "rejected", r.reason = c, c = 0; c < a.length; c++)
          (0, a[c])(void 0);
      }
    ), r;
  }
  var ep = O.S;
  O.S = function(e, t) {
    Bg = Et(), typeof t == "object" && t !== null && typeof t.then == "function" && a2(e, t), ep !== null && ep(e, t);
  };
  var fi = N(null);
  function pu() {
    var e = fi.current;
    return e !== null ? e : qe.pooledCache;
  }
  function Dl(e, t) {
    t === null ? G(fi, fi.current) : G(fi, t.pool);
  }
  function tp() {
    var e = pu();
    return e === null ? null : { parent: nt._currentValue, pool: e };
  }
  var rs = Error(o(460)), gu = Error(o(474)), Fl = Error(o(542)), Bl = { then: function() {
  } };
  function np(e) {
    return e = e.status, e === "fulfilled" || e === "rejected";
  }
  function ap(e, t, a) {
    switch (a = e[a], a === void 0 ? e.push(t) : a !== t && (t.then(Xn, Xn), t = a), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw e = t.reason, sp(e), e;
      default:
        if (typeof t.status == "string") t.then(Xn, Xn);
        else {
          if (e = qe, e !== null && 100 < e.shellSuspendCounter)
            throw Error(o(482));
          e = t, e.status = "pending", e.then(
            function(r) {
              if (t.status === "pending") {
                var c = t;
                c.status = "fulfilled", c.value = r;
              }
            },
            function(r) {
              if (t.status === "pending") {
                var c = t;
                c.status = "rejected", c.reason = r;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw e = t.reason, sp(e), e;
        }
        throw pi = t, rs;
    }
  }
  function mi(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (a) {
      throw a !== null && typeof a == "object" && typeof a.then == "function" ? (pi = a, rs) : a;
    }
  }
  var pi = null;
  function ip() {
    if (pi === null) throw Error(o(459));
    var e = pi;
    return pi = null, e;
  }
  function sp(e) {
    if (e === rs || e === Fl)
      throw Error(o(483));
  }
  var ls = null, or = 0;
  function Vl(e) {
    var t = or;
    return or += 1, ls === null && (ls = []), ap(ls, e, t);
  }
  function cr(e, t) {
    t = t.props.ref, e.ref = t !== void 0 ? t : null;
  }
  function Hl(e, t) {
    throw t.$$typeof === w ? Error(o(525)) : (e = Object.prototype.toString.call(t), Error(
      o(
        31,
        e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e
      )
    ));
  }
  function rp(e) {
    function t(M, A) {
      if (e) {
        var D = M.deletions;
        D === null ? (M.deletions = [A], M.flags |= 16) : D.push(A);
      }
    }
    function a(M, A) {
      if (!e) return null;
      for (; A !== null; )
        t(M, A), A = A.sibling;
      return null;
    }
    function r(M) {
      for (var A = /* @__PURE__ */ new Map(); M !== null; )
        M.key !== null ? A.set(M.key, M) : A.set(M.index, M), M = M.sibling;
      return A;
    }
    function c(M, A) {
      return M = $n(M, A), M.index = 0, M.sibling = null, M;
    }
    function u(M, A, D) {
      return M.index = D, e ? (D = M.alternate, D !== null ? (D = D.index, D < A ? (M.flags |= 67108866, A) : D) : (M.flags |= 67108866, A)) : (M.flags |= 1048576, A);
    }
    function x(M) {
      return e && M.alternate === null && (M.flags |= 67108866), M;
    }
    function v(M, A, D, q) {
      return A === null || A.tag !== 6 ? (A = iu(D, M.mode, q), A.return = M, A) : (A = c(A, D), A.return = M, A);
    }
    function j(M, A, D, q) {
      var fe = D.type;
      return fe === _ ? U(
        M,
        A,
        D.props.children,
        q,
        D.key
      ) : A !== null && (A.elementType === fe || typeof fe == "object" && fe !== null && fe.$$typeof === k && mi(fe) === A.type) ? (A = c(A, D.props), cr(A, D), A.return = M, A) : (A = zl(
        D.type,
        D.key,
        D.props,
        null,
        M.mode,
        q
      ), cr(A, D), A.return = M, A);
    }
    function F(M, A, D, q) {
      return A === null || A.tag !== 4 || A.stateNode.containerInfo !== D.containerInfo || A.stateNode.implementation !== D.implementation ? (A = su(D, M.mode, q), A.return = M, A) : (A = c(A, D.children || []), A.return = M, A);
    }
    function U(M, A, D, q, fe) {
      return A === null || A.tag !== 7 ? (A = ci(
        D,
        M.mode,
        q,
        fe
      ), A.return = M, A) : (A = c(A, D), A.return = M, A);
    }
    function I(M, A, D) {
      if (typeof A == "string" && A !== "" || typeof A == "number" || typeof A == "bigint")
        return A = iu(
          "" + A,
          M.mode,
          D
        ), A.return = M, A;
      if (typeof A == "object" && A !== null) {
        switch (A.$$typeof) {
          case S:
            return D = zl(
              A.type,
              A.key,
              A.props,
              null,
              M.mode,
              D
            ), cr(D, A), D.return = M, D;
          case T:
            return A = su(
              A,
              M.mode,
              D
            ), A.return = M, A;
          case k:
            return A = mi(A), I(M, A, D);
        }
        if (Se(A) || he(A))
          return A = ci(
            A,
            M.mode,
            D,
            null
          ), A.return = M, A;
        if (typeof A.then == "function")
          return I(M, Vl(A), D);
        if (A.$$typeof === L)
          return I(
            M,
            _l(M, A),
            D
          );
        Hl(M, A);
      }
      return null;
    }
    function B(M, A, D, q) {
      var fe = A !== null ? A.key : null;
      if (typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint")
        return fe !== null ? null : v(M, A, "" + D, q);
      if (typeof D == "object" && D !== null) {
        switch (D.$$typeof) {
          case S:
            return D.key === fe ? j(M, A, D, q) : null;
          case T:
            return D.key === fe ? F(M, A, D, q) : null;
          case k:
            return D = mi(D), B(M, A, D, q);
        }
        if (Se(D) || he(D))
          return fe !== null ? null : U(M, A, D, q, null);
        if (typeof D.then == "function")
          return B(
            M,
            A,
            Vl(D),
            q
          );
        if (D.$$typeof === L)
          return B(
            M,
            A,
            _l(M, D),
            q
          );
        Hl(M, D);
      }
      return null;
    }
    function H(M, A, D, q, fe) {
      if (typeof q == "string" && q !== "" || typeof q == "number" || typeof q == "bigint")
        return M = M.get(D) || null, v(A, M, "" + q, fe);
      if (typeof q == "object" && q !== null) {
        switch (q.$$typeof) {
          case S:
            return M = M.get(
              q.key === null ? D : q.key
            ) || null, j(A, M, q, fe);
          case T:
            return M = M.get(
              q.key === null ? D : q.key
            ) || null, F(A, M, q, fe);
          case k:
            return q = mi(q), H(
              M,
              A,
              D,
              q,
              fe
            );
        }
        if (Se(q) || he(q))
          return M = M.get(D) || null, U(A, M, q, fe, null);
        if (typeof q.then == "function")
          return H(
            M,
            A,
            D,
            Vl(q),
            fe
          );
        if (q.$$typeof === L)
          return H(
            M,
            A,
            D,
            _l(A, q),
            fe
          );
        Hl(A, q);
      }
      return null;
    }
    function ce(M, A, D, q) {
      for (var fe = null, _e = null, de = A, Ne = A = 0, ze = null; de !== null && Ne < D.length; Ne++) {
        de.index > Ne ? (ze = de, de = null) : ze = de.sibling;
        var De = B(
          M,
          de,
          D[Ne],
          q
        );
        if (De === null) {
          de === null && (de = ze);
          break;
        }
        e && de && De.alternate === null && t(M, de), A = u(De, A, Ne), _e === null ? fe = De : _e.sibling = De, _e = De, de = ze;
      }
      if (Ne === D.length)
        return a(M, de), Re && Wn(M, Ne), fe;
      if (de === null) {
        for (; Ne < D.length; Ne++)
          de = I(M, D[Ne], q), de !== null && (A = u(
            de,
            A,
            Ne
          ), _e === null ? fe = de : _e.sibling = de, _e = de);
        return Re && Wn(M, Ne), fe;
      }
      for (de = r(de); Ne < D.length; Ne++)
        ze = H(
          de,
          M,
          Ne,
          D[Ne],
          q
        ), ze !== null && (e && ze.alternate !== null && de.delete(
          ze.key === null ? Ne : ze.key
        ), A = u(
          ze,
          A,
          Ne
        ), _e === null ? fe = ze : _e.sibling = ze, _e = ze);
      return e && de.forEach(function(La) {
        return t(M, La);
      }), Re && Wn(M, Ne), fe;
    }
    function pe(M, A, D, q) {
      if (D == null) throw Error(o(151));
      for (var fe = null, _e = null, de = A, Ne = A = 0, ze = null, De = D.next(); de !== null && !De.done; Ne++, De = D.next()) {
        de.index > Ne ? (ze = de, de = null) : ze = de.sibling;
        var La = B(M, de, De.value, q);
        if (La === null) {
          de === null && (de = ze);
          break;
        }
        e && de && La.alternate === null && t(M, de), A = u(La, A, Ne), _e === null ? fe = La : _e.sibling = La, _e = La, de = ze;
      }
      if (De.done)
        return a(M, de), Re && Wn(M, Ne), fe;
      if (de === null) {
        for (; !De.done; Ne++, De = D.next())
          De = I(M, De.value, q), De !== null && (A = u(De, A, Ne), _e === null ? fe = De : _e.sibling = De, _e = De);
        return Re && Wn(M, Ne), fe;
      }
      for (de = r(de); !De.done; Ne++, De = D.next())
        De = H(de, M, Ne, De.value, q), De !== null && (e && De.alternate !== null && de.delete(De.key === null ? Ne : De.key), A = u(De, A, Ne), _e === null ? fe = De : _e.sibling = De, _e = De);
      return e && de.forEach(function(pj) {
        return t(M, pj);
      }), Re && Wn(M, Ne), fe;
    }
    function Pe(M, A, D, q) {
      if (typeof D == "object" && D !== null && D.type === _ && D.key === null && (D = D.props.children), typeof D == "object" && D !== null) {
        switch (D.$$typeof) {
          case S:
            e: {
              for (var fe = D.key; A !== null; ) {
                if (A.key === fe) {
                  if (fe = D.type, fe === _) {
                    if (A.tag === 7) {
                      a(
                        M,
                        A.sibling
                      ), q = c(
                        A,
                        D.props.children
                      ), q.return = M, M = q;
                      break e;
                    }
                  } else if (A.elementType === fe || typeof fe == "object" && fe !== null && fe.$$typeof === k && mi(fe) === A.type) {
                    a(
                      M,
                      A.sibling
                    ), q = c(A, D.props), cr(q, D), q.return = M, M = q;
                    break e;
                  }
                  a(M, A);
                  break;
                } else t(M, A);
                A = A.sibling;
              }
              D.type === _ ? (q = ci(
                D.props.children,
                M.mode,
                q,
                D.key
              ), q.return = M, M = q) : (q = zl(
                D.type,
                D.key,
                D.props,
                null,
                M.mode,
                q
              ), cr(q, D), q.return = M, M = q);
            }
            return x(M);
          case T:
            e: {
              for (fe = D.key; A !== null; ) {
                if (A.key === fe)
                  if (A.tag === 4 && A.stateNode.containerInfo === D.containerInfo && A.stateNode.implementation === D.implementation) {
                    a(
                      M,
                      A.sibling
                    ), q = c(A, D.children || []), q.return = M, M = q;
                    break e;
                  } else {
                    a(M, A);
                    break;
                  }
                else t(M, A);
                A = A.sibling;
              }
              q = su(D, M.mode, q), q.return = M, M = q;
            }
            return x(M);
          case k:
            return D = mi(D), Pe(
              M,
              A,
              D,
              q
            );
        }
        if (Se(D))
          return ce(
            M,
            A,
            D,
            q
          );
        if (he(D)) {
          if (fe = he(D), typeof fe != "function") throw Error(o(150));
          return D = fe.call(D), pe(
            M,
            A,
            D,
            q
          );
        }
        if (typeof D.then == "function")
          return Pe(
            M,
            A,
            Vl(D),
            q
          );
        if (D.$$typeof === L)
          return Pe(
            M,
            A,
            _l(M, D),
            q
          );
        Hl(M, D);
      }
      return typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint" ? (D = "" + D, A !== null && A.tag === 6 ? (a(M, A.sibling), q = c(A, D), q.return = M, M = q) : (a(M, A), q = iu(D, M.mode, q), q.return = M, M = q), x(M)) : a(M, A);
    }
    return function(M, A, D, q) {
      try {
        or = 0;
        var fe = Pe(
          M,
          A,
          D,
          q
        );
        return ls = null, fe;
      } catch (de) {
        if (de === rs || de === Fl) throw de;
        var _e = Kt(29, de, null, M.mode);
        return _e.lanes = q, _e.return = M, _e;
      }
    };
  }
  var gi = rp(!0), lp = rp(!1), Na = !1;
  function xu(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function yu(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function Ta(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function Aa(e, t, a) {
    var r = e.updateQueue;
    if (r === null) return null;
    if (r = r.shared, (Fe & 2) !== 0) {
      var c = r.pending;
      return c === null ? t.next = t : (t.next = c.next, c.next = t), r.pending = t, t = Ml(e), Im(e, null, a), t;
    }
    return kl(e, r, t, a), Ml(e);
  }
  function ur(e, t, a) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (a & 4194048) !== 0)) {
      var r = t.lanes;
      r &= e.pendingLanes, a |= r, t.lanes = a, Dt(e, a);
    }
  }
  function bu(e, t) {
    var a = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, a === r)) {
      var c = null, u = null;
      if (a = a.firstBaseUpdate, a !== null) {
        do {
          var x = {
            lane: a.lane,
            tag: a.tag,
            payload: a.payload,
            callback: null,
            next: null
          };
          u === null ? c = u = x : u = u.next = x, a = a.next;
        } while (a !== null);
        u === null ? c = u = t : u = u.next = t;
      } else c = u = t;
      a = {
        baseState: r.baseState,
        firstBaseUpdate: c,
        lastBaseUpdate: u,
        shared: r.shared,
        callbacks: r.callbacks
      }, e.updateQueue = a;
      return;
    }
    e = a.lastBaseUpdate, e === null ? a.firstBaseUpdate = t : e.next = t, a.lastBaseUpdate = t;
  }
  var vu = !1;
  function dr() {
    if (vu) {
      var e = ss;
      if (e !== null) throw e;
    }
  }
  function hr(e, t, a, r) {
    vu = !1;
    var c = e.updateQueue;
    Na = !1;
    var u = c.firstBaseUpdate, x = c.lastBaseUpdate, v = c.shared.pending;
    if (v !== null) {
      c.shared.pending = null;
      var j = v, F = j.next;
      j.next = null, x === null ? u = F : x.next = F, x = j;
      var U = e.alternate;
      U !== null && (U = U.updateQueue, v = U.lastBaseUpdate, v !== x && (v === null ? U.firstBaseUpdate = F : v.next = F, U.lastBaseUpdate = j));
    }
    if (u !== null) {
      var I = c.baseState;
      x = 0, U = F = j = null, v = u;
      do {
        var B = v.lane & -536870913, H = B !== v.lane;
        if (H ? (Me & B) === B : (r & B) === B) {
          B !== 0 && B === is && (vu = !0), U !== null && (U = U.next = {
            lane: 0,
            tag: v.tag,
            payload: v.payload,
            callback: null,
            next: null
          });
          e: {
            var ce = e, pe = v;
            B = t;
            var Pe = a;
            switch (pe.tag) {
              case 1:
                if (ce = pe.payload, typeof ce == "function") {
                  I = ce.call(Pe, I, B);
                  break e;
                }
                I = ce;
                break e;
              case 3:
                ce.flags = ce.flags & -65537 | 128;
              case 0:
                if (ce = pe.payload, B = typeof ce == "function" ? ce.call(Pe, I, B) : ce, B == null) break e;
                I = y({}, I, B);
                break e;
              case 2:
                Na = !0;
            }
          }
          B = v.callback, B !== null && (e.flags |= 64, H && (e.flags |= 8192), H = c.callbacks, H === null ? c.callbacks = [B] : H.push(B));
        } else
          H = {
            lane: B,
            tag: v.tag,
            payload: v.payload,
            callback: v.callback,
            next: null
          }, U === null ? (F = U = H, j = I) : U = U.next = H, x |= B;
        if (v = v.next, v === null) {
          if (v = c.shared.pending, v === null)
            break;
          H = v, v = H.next, H.next = null, c.lastBaseUpdate = H, c.shared.pending = null;
        }
      } while (!0);
      U === null && (j = I), c.baseState = j, c.firstBaseUpdate = F, c.lastBaseUpdate = U, u === null && (c.shared.lanes = 0), za |= x, e.lanes = x, e.memoizedState = I;
    }
  }
  function op(e, t) {
    if (typeof e != "function")
      throw Error(o(191, e));
    e.call(t);
  }
  function cp(e, t) {
    var a = e.callbacks;
    if (a !== null)
      for (e.callbacks = null, e = 0; e < a.length; e++)
        op(a[e], t);
  }
  var os = N(null), Ul = N(0);
  function up(e, t) {
    e = ca, G(Ul, e), G(os, t), ca = e | t.baseLanes;
  }
  function wu() {
    G(Ul, ca), G(os, os.current);
  }
  function ju() {
    ca = Ul.current, P(os), P(Ul);
  }
  var $t = N(null), pn = null;
  function Ca(e) {
    var t = e.alternate;
    G(et, et.current & 1), G($t, e), pn === null && (t === null || os.current !== null || t.memoizedState !== null) && (pn = e);
  }
  function Su(e) {
    G(et, et.current), G($t, e), pn === null && (pn = e);
  }
  function dp(e) {
    e.tag === 22 ? (G(et, et.current), G($t, e), pn === null && (pn = e)) : Ea();
  }
  function Ea() {
    G(et, et.current), G($t, $t.current);
  }
  function Wt(e) {
    P($t), pn === e && (pn = null), P(et);
  }
  var et = N(0);
  function Ll(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var a = t.memoizedState;
        if (a !== null && (a = a.dehydrated, a === null || kd(a) || Md(a)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var ta = 0, we = null, Ue = null, at = null, Pl = !1, cs = !1, xi = !1, ql = 0, fr = 0, us = null, s2 = 0;
  function $e() {
    throw Error(o(321));
  }
  function Nu(e, t) {
    if (t === null) return !1;
    for (var a = 0; a < t.length && a < e.length; a++)
      if (!Xt(e[a], t[a])) return !1;
    return !0;
  }
  function Tu(e, t, a, r, c, u) {
    return ta = u, we = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, O.H = e === null || e.memoizedState === null ? Zp : Uu, xi = !1, u = a(r, c), xi = !1, cs && (u = fp(
      t,
      a,
      r,
      c
    )), hp(e), u;
  }
  function hp(e) {
    O.H = gr;
    var t = Ue !== null && Ue.next !== null;
    if (ta = 0, at = Ue = we = null, Pl = !1, fr = 0, us = null, t) throw Error(o(300));
    e === null || it || (e = e.dependencies, e !== null && Rl(e) && (it = !0));
  }
  function fp(e, t, a, r) {
    we = e;
    var c = 0;
    do {
      if (cs && (us = null), fr = 0, cs = !1, 25 <= c) throw Error(o(301));
      if (c += 1, at = Ue = null, e.updateQueue != null) {
        var u = e.updateQueue;
        u.lastEffect = null, u.events = null, u.stores = null, u.memoCache != null && (u.memoCache.index = 0);
      }
      O.H = Xp, u = t(a, r);
    } while (cs);
    return u;
  }
  function r2() {
    var e = O.H, t = e.useState()[0];
    return t = typeof t.then == "function" ? mr(t) : t, e = e.useState()[0], (Ue !== null ? Ue.memoizedState : null) !== e && (we.flags |= 1024), t;
  }
  function Au() {
    var e = ql !== 0;
    return ql = 0, e;
  }
  function Cu(e, t, a) {
    t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~a;
  }
  function Eu(e) {
    if (Pl) {
      for (e = e.memoizedState; e !== null; ) {
        var t = e.queue;
        t !== null && (t.pending = null), e = e.next;
      }
      Pl = !1;
    }
    ta = 0, at = Ue = we = null, cs = !1, fr = ql = 0, us = null;
  }
  function Mt() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return at === null ? we.memoizedState = at = e : at = at.next = e, at;
  }
  function tt() {
    if (Ue === null) {
      var e = we.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Ue.next;
    var t = at === null ? we.memoizedState : at.next;
    if (t !== null)
      at = t, Ue = e;
    else {
      if (e === null)
        throw we.alternate === null ? Error(o(467)) : Error(o(310));
      Ue = e, e = {
        memoizedState: Ue.memoizedState,
        baseState: Ue.baseState,
        baseQueue: Ue.baseQueue,
        queue: Ue.queue,
        next: null
      }, at === null ? we.memoizedState = at = e : at = at.next = e;
    }
    return at;
  }
  function Il() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function mr(e) {
    var t = fr;
    return fr += 1, us === null && (us = []), e = ap(us, e, t), t = we, (at === null ? t.memoizedState : at.next) === null && (t = t.alternate, O.H = t === null || t.memoizedState === null ? Zp : Uu), e;
  }
  function Gl(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return mr(e);
      if (e.$$typeof === L) return gt(e);
    }
    throw Error(o(438, String(e)));
  }
  function ku(e) {
    var t = null, a = we.updateQueue;
    if (a !== null && (t = a.memoCache), t == null) {
      var r = we.alternate;
      r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
        data: r.data.map(function(c) {
          return c.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), a === null && (a = Il(), we.updateQueue = a), a.memoCache = t, a = t.data[t.index], a === void 0)
      for (a = t.data[t.index] = Array(e), r = 0; r < e; r++)
        a[r] = V;
    return t.index++, a;
  }
  function na(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function Yl(e) {
    var t = tt();
    return Mu(t, Ue, e);
  }
  function Mu(e, t, a) {
    var r = e.queue;
    if (r === null) throw Error(o(311));
    r.lastRenderedReducer = a;
    var c = e.baseQueue, u = r.pending;
    if (u !== null) {
      if (c !== null) {
        var x = c.next;
        c.next = u.next, u.next = x;
      }
      t.baseQueue = c = u, r.pending = null;
    }
    if (u = e.baseState, c === null) e.memoizedState = u;
    else {
      t = c.next;
      var v = x = null, j = null, F = t, U = !1;
      do {
        var I = F.lane & -536870913;
        if (I !== F.lane ? (Me & I) === I : (ta & I) === I) {
          var B = F.revertLane;
          if (B === 0)
            j !== null && (j = j.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: F.action,
              hasEagerState: F.hasEagerState,
              eagerState: F.eagerState,
              next: null
            }), I === is && (U = !0);
          else if ((ta & B) === B) {
            F = F.next, B === is && (U = !0);
            continue;
          } else
            I = {
              lane: 0,
              revertLane: F.revertLane,
              gesture: null,
              action: F.action,
              hasEagerState: F.hasEagerState,
              eagerState: F.eagerState,
              next: null
            }, j === null ? (v = j = I, x = u) : j = j.next = I, we.lanes |= B, za |= B;
          I = F.action, xi && a(u, I), u = F.hasEagerState ? F.eagerState : a(u, I);
        } else
          B = {
            lane: I,
            revertLane: F.revertLane,
            gesture: F.gesture,
            action: F.action,
            hasEagerState: F.hasEagerState,
            eagerState: F.eagerState,
            next: null
          }, j === null ? (v = j = B, x = u) : j = j.next = B, we.lanes |= I, za |= I;
        F = F.next;
      } while (F !== null && F !== t);
      if (j === null ? x = u : j.next = v, !Xt(u, e.memoizedState) && (it = !0, U && (a = ss, a !== null)))
        throw a;
      e.memoizedState = u, e.baseState = x, e.baseQueue = j, r.lastRenderedState = u;
    }
    return c === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
  }
  function zu(e) {
    var t = tt(), a = t.queue;
    if (a === null) throw Error(o(311));
    a.lastRenderedReducer = e;
    var r = a.dispatch, c = a.pending, u = t.memoizedState;
    if (c !== null) {
      a.pending = null;
      var x = c = c.next;
      do
        u = e(u, x.action), x = x.next;
      while (x !== c);
      Xt(u, t.memoizedState) || (it = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), a.lastRenderedState = u;
    }
    return [u, r];
  }
  function mp(e, t, a) {
    var r = we, c = tt(), u = Re;
    if (u) {
      if (a === void 0) throw Error(o(407));
      a = a();
    } else a = t();
    var x = !Xt(
      (Ue || c).memoizedState,
      a
    );
    if (x && (c.memoizedState = a, it = !0), c = c.queue, _u(xp.bind(null, r, c, e), [
      e
    ]), c.getSnapshot !== t || x || at !== null && at.memoizedState.tag & 1) {
      if (r.flags |= 2048, ds(
        9,
        { destroy: void 0 },
        gp.bind(
          null,
          r,
          c,
          a,
          t
        ),
        null
      ), qe === null) throw Error(o(349));
      u || (ta & 127) !== 0 || pp(r, t, a);
    }
    return a;
  }
  function pp(e, t, a) {
    e.flags |= 16384, e = { getSnapshot: t, value: a }, t = we.updateQueue, t === null ? (t = Il(), we.updateQueue = t, t.stores = [e]) : (a = t.stores, a === null ? t.stores = [e] : a.push(e));
  }
  function gp(e, t, a, r) {
    t.value = a, t.getSnapshot = r, yp(t) && bp(e);
  }
  function xp(e, t, a) {
    return a(function() {
      yp(t) && bp(e);
    });
  }
  function yp(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var a = t();
      return !Xt(e, a);
    } catch {
      return !0;
    }
  }
  function bp(e) {
    var t = oi(e, 2);
    t !== null && qt(t, e, 2);
  }
  function Ou(e) {
    var t = Mt();
    if (typeof e == "function") {
      var a = e;
      if (e = a(), xi) {
        Nn(!0);
        try {
          a();
        } finally {
          Nn(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = e, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: na,
      lastRenderedState: e
    }, t;
  }
  function vp(e, t, a, r) {
    return e.baseState = a, Mu(
      e,
      Ue,
      typeof r == "function" ? r : na
    );
  }
  function l2(e, t, a, r, c) {
    if (Xl(e)) throw Error(o(485));
    if (e = t.action, e !== null) {
      var u = {
        payload: c,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(x) {
          u.listeners.push(x);
        }
      };
      O.T !== null ? a(!0) : u.isTransition = !1, r(u), a = t.pending, a === null ? (u.next = t.pending = u, wp(t, u)) : (u.next = a.next, t.pending = a.next = u);
    }
  }
  function wp(e, t) {
    var a = t.action, r = t.payload, c = e.state;
    if (t.isTransition) {
      var u = O.T, x = {};
      O.T = x;
      try {
        var v = a(c, r), j = O.S;
        j !== null && j(x, v), jp(e, t, v);
      } catch (F) {
        Ru(e, t, F);
      } finally {
        u !== null && x.types !== null && (u.types = x.types), O.T = u;
      }
    } else
      try {
        u = a(c, r), jp(e, t, u);
      } catch (F) {
        Ru(e, t, F);
      }
  }
  function jp(e, t, a) {
    a !== null && typeof a == "object" && typeof a.then == "function" ? a.then(
      function(r) {
        Sp(e, t, r);
      },
      function(r) {
        return Ru(e, t, r);
      }
    ) : Sp(e, t, a);
  }
  function Sp(e, t, a) {
    t.status = "fulfilled", t.value = a, Np(t), e.state = a, t = e.pending, t !== null && (a = t.next, a === t ? e.pending = null : (a = a.next, t.next = a, wp(e, a)));
  }
  function Ru(e, t, a) {
    var r = e.pending;
    if (e.pending = null, r !== null) {
      r = r.next;
      do
        t.status = "rejected", t.reason = a, Np(t), t = t.next;
      while (t !== r);
    }
    e.action = null;
  }
  function Np(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function Tp(e, t) {
    return t;
  }
  function Ap(e, t) {
    if (Re) {
      var a = qe.formState;
      if (a !== null) {
        e: {
          var r = we;
          if (Re) {
            if (Ye) {
              t: {
                for (var c = Ye, u = mn; c.nodeType !== 8; ) {
                  if (!u) {
                    c = null;
                    break t;
                  }
                  if (c = gn(
                    c.nextSibling
                  ), c === null) {
                    c = null;
                    break t;
                  }
                }
                u = c.data, c = u === "F!" || u === "F" ? c : null;
              }
              if (c) {
                Ye = gn(
                  c.nextSibling
                ), r = c.data === "F!";
                break e;
              }
            }
            ja(r);
          }
          r = !1;
        }
        r && (t = a[0]);
      }
    }
    return a = Mt(), a.memoizedState = a.baseState = t, r = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Tp,
      lastRenderedState: t
    }, a.queue = r, a = Gp.bind(
      null,
      we,
      r
    ), r.dispatch = a, r = Ou(!1), u = Hu.bind(
      null,
      we,
      !1,
      r.queue
    ), r = Mt(), c = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    }, r.queue = c, a = l2.bind(
      null,
      we,
      c,
      u,
      a
    ), c.dispatch = a, r.memoizedState = e, [t, a, !1];
  }
  function Cp(e) {
    var t = tt();
    return Ep(t, Ue, e);
  }
  function Ep(e, t, a) {
    if (t = Mu(
      e,
      t,
      Tp
    )[0], e = Yl(na)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var r = mr(t);
      } catch (x) {
        throw x === rs ? Fl : x;
      }
    else r = t;
    t = tt();
    var c = t.queue, u = c.dispatch;
    return a !== t.memoizedState && (we.flags |= 2048, ds(
      9,
      { destroy: void 0 },
      o2.bind(null, c, a),
      null
    )), [r, u, e];
  }
  function o2(e, t) {
    e.action = t;
  }
  function kp(e) {
    var t = tt(), a = Ue;
    if (a !== null)
      return Ep(t, a, e);
    tt(), t = t.memoizedState, a = tt();
    var r = a.queue.dispatch;
    return a.memoizedState = e, [t, r, !1];
  }
  function ds(e, t, a, r) {
    return e = { tag: e, create: a, deps: r, inst: t, next: null }, t = we.updateQueue, t === null && (t = Il(), we.updateQueue = t), a = t.lastEffect, a === null ? t.lastEffect = e.next = e : (r = a.next, a.next = e, e.next = r, t.lastEffect = e), e;
  }
  function Mp() {
    return tt().memoizedState;
  }
  function Ql(e, t, a, r) {
    var c = Mt();
    we.flags |= e, c.memoizedState = ds(
      1 | t,
      { destroy: void 0 },
      a,
      r === void 0 ? null : r
    );
  }
  function Zl(e, t, a, r) {
    var c = tt();
    r = r === void 0 ? null : r;
    var u = c.memoizedState.inst;
    Ue !== null && r !== null && Nu(r, Ue.memoizedState.deps) ? c.memoizedState = ds(t, u, a, r) : (we.flags |= e, c.memoizedState = ds(
      1 | t,
      u,
      a,
      r
    ));
  }
  function zp(e, t) {
    Ql(8390656, 8, e, t);
  }
  function _u(e, t) {
    Zl(2048, 8, e, t);
  }
  function c2(e) {
    we.flags |= 4;
    var t = we.updateQueue;
    if (t === null)
      t = Il(), we.updateQueue = t, t.events = [e];
    else {
      var a = t.events;
      a === null ? t.events = [e] : a.push(e);
    }
  }
  function Op(e) {
    var t = tt().memoizedState;
    return c2({ ref: t, nextImpl: e }), function() {
      if ((Fe & 2) !== 0) throw Error(o(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function Rp(e, t) {
    return Zl(4, 2, e, t);
  }
  function _p(e, t) {
    return Zl(4, 4, e, t);
  }
  function Dp(e, t) {
    if (typeof t == "function") {
      e = e();
      var a = t(e);
      return function() {
        typeof a == "function" ? a() : t(null);
      };
    }
    if (t != null)
      return e = e(), t.current = e, function() {
        t.current = null;
      };
  }
  function Fp(e, t, a) {
    a = a != null ? a.concat([e]) : null, Zl(4, 4, Dp.bind(null, t, e), a);
  }
  function Du() {
  }
  function Bp(e, t) {
    var a = tt();
    t = t === void 0 ? null : t;
    var r = a.memoizedState;
    return t !== null && Nu(t, r[1]) ? r[0] : (a.memoizedState = [e, t], e);
  }
  function Vp(e, t) {
    var a = tt();
    t = t === void 0 ? null : t;
    var r = a.memoizedState;
    if (t !== null && Nu(t, r[1]))
      return r[0];
    if (r = e(), xi) {
      Nn(!0);
      try {
        e();
      } finally {
        Nn(!1);
      }
    }
    return a.memoizedState = [r, t], r;
  }
  function Fu(e, t, a) {
    return a === void 0 || (ta & 1073741824) !== 0 && (Me & 261930) === 0 ? e.memoizedState = t : (e.memoizedState = a, e = Hg(), we.lanes |= e, za |= e, a);
  }
  function Hp(e, t, a, r) {
    return Xt(a, t) ? a : os.current !== null ? (e = Fu(e, a, r), Xt(e, t) || (it = !0), e) : (ta & 42) === 0 || (ta & 1073741824) !== 0 && (Me & 261930) === 0 ? (it = !0, e.memoizedState = a) : (e = Hg(), we.lanes |= e, za |= e, t);
  }
  function Up(e, t, a, r, c) {
    var u = X.p;
    X.p = u !== 0 && 8 > u ? u : 8;
    var x = O.T, v = {};
    O.T = v, Hu(e, !1, t, a);
    try {
      var j = c(), F = O.S;
      if (F !== null && F(v, j), j !== null && typeof j == "object" && typeof j.then == "function") {
        var U = i2(
          j,
          r
        );
        pr(
          e,
          t,
          U,
          tn(e)
        );
      } else
        pr(
          e,
          t,
          r,
          tn(e)
        );
    } catch (I) {
      pr(
        e,
        t,
        { then: function() {
        }, status: "rejected", reason: I },
        tn()
      );
    } finally {
      X.p = u, x !== null && v.types !== null && (x.types = v.types), O.T = x;
    }
  }
  function u2() {
  }
  function Bu(e, t, a, r) {
    if (e.tag !== 5) throw Error(o(476));
    var c = Lp(e).queue;
    Up(
      e,
      c,
      t,
      te,
      a === null ? u2 : function() {
        return Pp(e), a(r);
      }
    );
  }
  function Lp(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: te,
      baseState: te,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: na,
        lastRenderedState: te
      },
      next: null
    };
    var a = {};
    return t.next = {
      memoizedState: a,
      baseState: a,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: na,
        lastRenderedState: a
      },
      next: null
    }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
  }
  function Pp(e) {
    var t = Lp(e);
    t.next === null && (t = e.alternate.memoizedState), pr(
      e,
      t.next.queue,
      {},
      tn()
    );
  }
  function Vu() {
    return gt(Or);
  }
  function qp() {
    return tt().memoizedState;
  }
  function Ip() {
    return tt().memoizedState;
  }
  function d2(e) {
    for (var t = e.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var a = tn();
          e = Ta(a);
          var r = Aa(t, e, a);
          r !== null && (qt(r, t, a), ur(r, t, a)), t = { cache: fu() }, e.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function h2(e, t, a) {
    var r = tn();
    a = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Xl(e) ? Yp(t, a) : (a = nu(e, t, a, r), a !== null && (qt(a, e, r), Qp(a, t, r)));
  }
  function Gp(e, t, a) {
    var r = tn();
    pr(e, t, a, r);
  }
  function pr(e, t, a, r) {
    var c = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Xl(e)) Yp(t, c);
    else {
      var u = e.alternate;
      if (e.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null))
        try {
          var x = t.lastRenderedState, v = u(x, a);
          if (c.hasEagerState = !0, c.eagerState = v, Xt(v, x))
            return kl(e, t, c, 0), qe === null && El(), !1;
        } catch {
        }
      if (a = nu(e, t, c, r), a !== null)
        return qt(a, e, r), Qp(a, t, r), !0;
    }
    return !1;
  }
  function Hu(e, t, a, r) {
    if (r = {
      lane: 2,
      revertLane: xd(),
      gesture: null,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Xl(e)) {
      if (t) throw Error(o(479));
    } else
      t = nu(
        e,
        a,
        r,
        2
      ), t !== null && qt(t, e, 2);
  }
  function Xl(e) {
    var t = e.alternate;
    return e === we || t !== null && t === we;
  }
  function Yp(e, t) {
    cs = Pl = !0;
    var a = e.pending;
    a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
  }
  function Qp(e, t, a) {
    if ((a & 4194048) !== 0) {
      var r = t.lanes;
      r &= e.pendingLanes, a |= r, t.lanes = a, Dt(e, a);
    }
  }
  var gr = {
    readContext: gt,
    use: Gl,
    useCallback: $e,
    useContext: $e,
    useEffect: $e,
    useImperativeHandle: $e,
    useLayoutEffect: $e,
    useInsertionEffect: $e,
    useMemo: $e,
    useReducer: $e,
    useRef: $e,
    useState: $e,
    useDebugValue: $e,
    useDeferredValue: $e,
    useTransition: $e,
    useSyncExternalStore: $e,
    useId: $e,
    useHostTransitionStatus: $e,
    useFormState: $e,
    useActionState: $e,
    useOptimistic: $e,
    useMemoCache: $e,
    useCacheRefresh: $e
  };
  gr.useEffectEvent = $e;
  var Zp = {
    readContext: gt,
    use: Gl,
    useCallback: function(e, t) {
      return Mt().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    },
    useContext: gt,
    useEffect: zp,
    useImperativeHandle: function(e, t, a) {
      a = a != null ? a.concat([e]) : null, Ql(
        4194308,
        4,
        Dp.bind(null, t, e),
        a
      );
    },
    useLayoutEffect: function(e, t) {
      return Ql(4194308, 4, e, t);
    },
    useInsertionEffect: function(e, t) {
      Ql(4, 2, e, t);
    },
    useMemo: function(e, t) {
      var a = Mt();
      t = t === void 0 ? null : t;
      var r = e();
      if (xi) {
        Nn(!0);
        try {
          e();
        } finally {
          Nn(!1);
        }
      }
      return a.memoizedState = [r, t], r;
    },
    useReducer: function(e, t, a) {
      var r = Mt();
      if (a !== void 0) {
        var c = a(t);
        if (xi) {
          Nn(!0);
          try {
            a(t);
          } finally {
            Nn(!1);
          }
        }
      } else c = t;
      return r.memoizedState = r.baseState = c, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      }, r.queue = e, e = e.dispatch = h2.bind(
        null,
        we,
        e
      ), [r.memoizedState, e];
    },
    useRef: function(e) {
      var t = Mt();
      return e = { current: e }, t.memoizedState = e;
    },
    useState: function(e) {
      e = Ou(e);
      var t = e.queue, a = Gp.bind(null, we, t);
      return t.dispatch = a, [e.memoizedState, a];
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = Mt();
      return Fu(a, e, t);
    },
    useTransition: function() {
      var e = Ou(!1);
      return e = Up.bind(
        null,
        we,
        e.queue,
        !0,
        !1
      ), Mt().memoizedState = e, [!1, e];
    },
    useSyncExternalStore: function(e, t, a) {
      var r = we, c = Mt();
      if (Re) {
        if (a === void 0)
          throw Error(o(407));
        a = a();
      } else {
        if (a = t(), qe === null)
          throw Error(o(349));
        (Me & 127) !== 0 || pp(r, t, a);
      }
      c.memoizedState = a;
      var u = { value: a, getSnapshot: t };
      return c.queue = u, zp(xp.bind(null, r, u, e), [
        e
      ]), r.flags |= 2048, ds(
        9,
        { destroy: void 0 },
        gp.bind(
          null,
          r,
          u,
          a,
          t
        ),
        null
      ), a;
    },
    useId: function() {
      var e = Mt(), t = qe.identifierPrefix;
      if (Re) {
        var a = Bn, r = Fn;
        a = (r & ~(1 << 32 - jt(r) - 1)).toString(32) + a, t = "_" + t + "R_" + a, a = ql++, 0 < a && (t += "H" + a.toString(32)), t += "_";
      } else
        a = s2++, t = "_" + t + "r_" + a.toString(32) + "_";
      return e.memoizedState = t;
    },
    useHostTransitionStatus: Vu,
    useFormState: Ap,
    useActionState: Ap,
    useOptimistic: function(e) {
      var t = Mt();
      t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = a, t = Hu.bind(
        null,
        we,
        !0,
        a
      ), a.dispatch = t, [e, t];
    },
    useMemoCache: ku,
    useCacheRefresh: function() {
      return Mt().memoizedState = d2.bind(
        null,
        we
      );
    },
    useEffectEvent: function(e) {
      var t = Mt(), a = { impl: e };
      return t.memoizedState = a, function() {
        if ((Fe & 2) !== 0)
          throw Error(o(440));
        return a.impl.apply(void 0, arguments);
      };
    }
  }, Uu = {
    readContext: gt,
    use: Gl,
    useCallback: Bp,
    useContext: gt,
    useEffect: _u,
    useImperativeHandle: Fp,
    useInsertionEffect: Rp,
    useLayoutEffect: _p,
    useMemo: Vp,
    useReducer: Yl,
    useRef: Mp,
    useState: function() {
      return Yl(na);
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = tt();
      return Hp(
        a,
        Ue.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = Yl(na)[0], t = tt().memoizedState;
      return [
        typeof e == "boolean" ? e : mr(e),
        t
      ];
    },
    useSyncExternalStore: mp,
    useId: qp,
    useHostTransitionStatus: Vu,
    useFormState: Cp,
    useActionState: Cp,
    useOptimistic: function(e, t) {
      var a = tt();
      return vp(a, Ue, e, t);
    },
    useMemoCache: ku,
    useCacheRefresh: Ip
  };
  Uu.useEffectEvent = Op;
  var Xp = {
    readContext: gt,
    use: Gl,
    useCallback: Bp,
    useContext: gt,
    useEffect: _u,
    useImperativeHandle: Fp,
    useInsertionEffect: Rp,
    useLayoutEffect: _p,
    useMemo: Vp,
    useReducer: zu,
    useRef: Mp,
    useState: function() {
      return zu(na);
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = tt();
      return Ue === null ? Fu(a, e, t) : Hp(
        a,
        Ue.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = zu(na)[0], t = tt().memoizedState;
      return [
        typeof e == "boolean" ? e : mr(e),
        t
      ];
    },
    useSyncExternalStore: mp,
    useId: qp,
    useHostTransitionStatus: Vu,
    useFormState: kp,
    useActionState: kp,
    useOptimistic: function(e, t) {
      var a = tt();
      return Ue !== null ? vp(a, Ue, e, t) : (a.baseState = e, [e, a.queue.dispatch]);
    },
    useMemoCache: ku,
    useCacheRefresh: Ip
  };
  Xp.useEffectEvent = Op;
  function Lu(e, t, a, r) {
    t = e.memoizedState, a = a(r, t), a = a == null ? t : y({}, t, a), e.memoizedState = a, e.lanes === 0 && (e.updateQueue.baseState = a);
  }
  var Pu = {
    enqueueSetState: function(e, t, a) {
      e = e._reactInternals;
      var r = tn(), c = Ta(r);
      c.payload = t, a != null && (c.callback = a), t = Aa(e, c, r), t !== null && (qt(t, e, r), ur(t, e, r));
    },
    enqueueReplaceState: function(e, t, a) {
      e = e._reactInternals;
      var r = tn(), c = Ta(r);
      c.tag = 1, c.payload = t, a != null && (c.callback = a), t = Aa(e, c, r), t !== null && (qt(t, e, r), ur(t, e, r));
    },
    enqueueForceUpdate: function(e, t) {
      e = e._reactInternals;
      var a = tn(), r = Ta(a);
      r.tag = 2, t != null && (r.callback = t), t = Aa(e, r, a), t !== null && (qt(t, e, a), ur(t, e, a));
    }
  };
  function Kp(e, t, a, r, c, u, x) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, u, x) : t.prototype && t.prototype.isPureReactComponent ? !nr(a, r) || !nr(c, u) : !0;
  }
  function $p(e, t, a, r) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, r), t.state !== e && Pu.enqueueReplaceState(t, t.state, null);
  }
  function yi(e, t) {
    var a = t;
    if ("ref" in t) {
      a = {};
      for (var r in t)
        r !== "ref" && (a[r] = t[r]);
    }
    if (e = e.defaultProps) {
      a === t && (a = y({}, a));
      for (var c in e)
        a[c] === void 0 && (a[c] = e[c]);
    }
    return a;
  }
  function Wp(e) {
    Cl(e);
  }
  function Jp(e) {
    console.error(e);
  }
  function eg(e) {
    Cl(e);
  }
  function Kl(e, t) {
    try {
      var a = e.onUncaughtError;
      a(t.value, { componentStack: t.stack });
    } catch (r) {
      setTimeout(function() {
        throw r;
      });
    }
  }
  function tg(e, t, a) {
    try {
      var r = e.onCaughtError;
      r(a.value, {
        componentStack: a.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (c) {
      setTimeout(function() {
        throw c;
      });
    }
  }
  function qu(e, t, a) {
    return a = Ta(a), a.tag = 3, a.payload = { element: null }, a.callback = function() {
      Kl(e, t);
    }, a;
  }
  function ng(e) {
    return e = Ta(e), e.tag = 3, e;
  }
  function ag(e, t, a, r) {
    var c = a.type.getDerivedStateFromError;
    if (typeof c == "function") {
      var u = r.value;
      e.payload = function() {
        return c(u);
      }, e.callback = function() {
        tg(t, a, r);
      };
    }
    var x = a.stateNode;
    x !== null && typeof x.componentDidCatch == "function" && (e.callback = function() {
      tg(t, a, r), typeof c != "function" && (Oa === null ? Oa = /* @__PURE__ */ new Set([this]) : Oa.add(this));
      var v = r.stack;
      this.componentDidCatch(r.value, {
        componentStack: v !== null ? v : ""
      });
    });
  }
  function f2(e, t, a, r, c) {
    if (a.flags |= 32768, r !== null && typeof r == "object" && typeof r.then == "function") {
      if (t = a.alternate, t !== null && as(
        t,
        a,
        c,
        !0
      ), a = $t.current, a !== null) {
        switch (a.tag) {
          case 31:
          case 13:
            return pn === null ? oo() : a.alternate === null && We === 0 && (We = 3), a.flags &= -257, a.flags |= 65536, a.lanes = c, r === Bl ? a.flags |= 16384 : (t = a.updateQueue, t === null ? a.updateQueue = /* @__PURE__ */ new Set([r]) : t.add(r), md(e, r, c)), !1;
          case 22:
            return a.flags |= 65536, r === Bl ? a.flags |= 16384 : (t = a.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([r])
            }, a.updateQueue = t) : (a = t.retryQueue, a === null ? t.retryQueue = /* @__PURE__ */ new Set([r]) : a.add(r)), md(e, r, c)), !1;
        }
        throw Error(o(435, a.tag));
      }
      return md(e, r, c), oo(), !1;
    }
    if (Re)
      return t = $t.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = c, r !== ou && (e = Error(o(422), { cause: r }), sr(dn(e, a)))) : (r !== ou && (t = Error(o(423), {
        cause: r
      }), sr(
        dn(t, a)
      )), e = e.current.alternate, e.flags |= 65536, c &= -c, e.lanes |= c, r = dn(r, a), c = qu(
        e.stateNode,
        r,
        c
      ), bu(e, c), We !== 4 && (We = 2)), !1;
    var u = Error(o(520), { cause: r });
    if (u = dn(u, a), Nr === null ? Nr = [u] : Nr.push(u), We !== 4 && (We = 2), t === null) return !0;
    r = dn(r, a), a = t;
    do {
      switch (a.tag) {
        case 3:
          return a.flags |= 65536, e = c & -c, a.lanes |= e, e = qu(a.stateNode, r, e), bu(a, e), !1;
        case 1:
          if (t = a.type, u = a.stateNode, (a.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || u !== null && typeof u.componentDidCatch == "function" && (Oa === null || !Oa.has(u))))
            return a.flags |= 65536, c &= -c, a.lanes |= c, c = ng(c), ag(
              c,
              e,
              a,
              r
            ), bu(a, c), !1;
      }
      a = a.return;
    } while (a !== null);
    return !1;
  }
  var Iu = Error(o(461)), it = !1;
  function xt(e, t, a, r) {
    t.child = e === null ? lp(t, null, a, r) : gi(
      t,
      e.child,
      a,
      r
    );
  }
  function ig(e, t, a, r, c) {
    a = a.render;
    var u = t.ref;
    if ("ref" in r) {
      var x = {};
      for (var v in r)
        v !== "ref" && (x[v] = r[v]);
    } else x = r;
    return hi(t), r = Tu(
      e,
      t,
      a,
      x,
      u,
      c
    ), v = Au(), e !== null && !it ? (Cu(e, t, c), aa(e, t, c)) : (Re && v && ru(t), t.flags |= 1, xt(e, t, r, c), t.child);
  }
  function sg(e, t, a, r, c) {
    if (e === null) {
      var u = a.type;
      return typeof u == "function" && !au(u) && u.defaultProps === void 0 && a.compare === null ? (t.tag = 15, t.type = u, rg(
        e,
        t,
        u,
        r,
        c
      )) : (e = zl(
        a.type,
        null,
        r,
        t,
        t.mode,
        c
      ), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (u = e.child, !Wu(e, c)) {
      var x = u.memoizedProps;
      if (a = a.compare, a = a !== null ? a : nr, a(x, r) && e.ref === t.ref)
        return aa(e, t, c);
    }
    return t.flags |= 1, e = $n(u, r), e.ref = t.ref, e.return = t, t.child = e;
  }
  function rg(e, t, a, r, c) {
    if (e !== null) {
      var u = e.memoizedProps;
      if (nr(u, r) && e.ref === t.ref)
        if (it = !1, t.pendingProps = r = u, Wu(e, c))
          (e.flags & 131072) !== 0 && (it = !0);
        else
          return t.lanes = e.lanes, aa(e, t, c);
    }
    return Gu(
      e,
      t,
      a,
      r,
      c
    );
  }
  function lg(e, t, a, r) {
    var c = r.children, u = e !== null ? e.memoizedState : null;
    if (e === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), r.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (u = u !== null ? u.baseLanes | a : a, e !== null) {
          for (r = t.child = e.child, c = 0; r !== null; )
            c = c | r.lanes | r.childLanes, r = r.sibling;
          r = c & ~u;
        } else r = 0, t.child = null;
        return og(
          e,
          t,
          u,
          a,
          r
        );
      }
      if ((a & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && Dl(
          t,
          u !== null ? u.cachePool : null
        ), u !== null ? up(t, u) : wu(), dp(t);
      else
        return r = t.lanes = 536870912, og(
          e,
          t,
          u !== null ? u.baseLanes | a : a,
          a,
          r
        );
    } else
      u !== null ? (Dl(t, u.cachePool), up(t, u), Ea(), t.memoizedState = null) : (e !== null && Dl(t, null), wu(), Ea());
    return xt(e, t, c, a), t.child;
  }
  function xr(e, t) {
    return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function og(e, t, a, r, c) {
    var u = pu();
    return u = u === null ? null : { parent: nt._currentValue, pool: u }, t.memoizedState = {
      baseLanes: a,
      cachePool: u
    }, e !== null && Dl(t, null), wu(), dp(t), e !== null && as(e, t, r, !0), t.childLanes = c, null;
  }
  function $l(e, t) {
    return t = Jl(
      { mode: t.mode, children: t.children },
      e.mode
    ), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function cg(e, t, a) {
    return gi(t, e.child, null, a), e = $l(t, t.pendingProps), e.flags |= 2, Wt(t), t.memoizedState = null, e;
  }
  function m2(e, t, a) {
    var r = t.pendingProps, c = (t.flags & 128) !== 0;
    if (t.flags &= -129, e === null) {
      if (Re) {
        if (r.mode === "hidden")
          return e = $l(t, r), t.lanes = 536870912, xr(null, e);
        if (Su(t), (e = Ye) ? (e = wx(
          e,
          mn
        ), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: va !== null ? { id: Fn, overflow: Bn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, a = Ym(e), a.return = t, t.child = a, pt = t, Ye = null)) : e = null, e === null) throw ja(t);
        return t.lanes = 536870912, null;
      }
      return $l(t, r);
    }
    var u = e.memoizedState;
    if (u !== null) {
      var x = u.dehydrated;
      if (Su(t), c)
        if (t.flags & 256)
          t.flags &= -257, t = cg(
            e,
            t,
            a
          );
        else if (t.memoizedState !== null)
          t.child = e.child, t.flags |= 128, t = null;
        else throw Error(o(558));
      else if (it || as(e, t, a, !1), c = (a & e.childLanes) !== 0, it || c) {
        if (r = qe, r !== null && (x = Ft(r, a), x !== 0 && x !== u.retryLane))
          throw u.retryLane = x, oi(e, x), qt(r, e, x), Iu;
        oo(), t = cg(
          e,
          t,
          a
        );
      } else
        e = u.treeContext, Ye = gn(x.nextSibling), pt = t, Re = !0, wa = null, mn = !1, e !== null && Xm(t, e), t = $l(t, r), t.flags |= 4096;
      return t;
    }
    return e = $n(e.child, {
      mode: r.mode,
      children: r.children
    }), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Wl(e, t) {
    var a = t.ref;
    if (a === null)
      e !== null && e.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof a != "function" && typeof a != "object")
        throw Error(o(284));
      (e === null || e.ref !== a) && (t.flags |= 4194816);
    }
  }
  function Gu(e, t, a, r, c) {
    return hi(t), a = Tu(
      e,
      t,
      a,
      r,
      void 0,
      c
    ), r = Au(), e !== null && !it ? (Cu(e, t, c), aa(e, t, c)) : (Re && r && ru(t), t.flags |= 1, xt(e, t, a, c), t.child);
  }
  function ug(e, t, a, r, c, u) {
    return hi(t), t.updateQueue = null, a = fp(
      t,
      r,
      a,
      c
    ), hp(e), r = Au(), e !== null && !it ? (Cu(e, t, u), aa(e, t, u)) : (Re && r && ru(t), t.flags |= 1, xt(e, t, a, u), t.child);
  }
  function dg(e, t, a, r, c) {
    if (hi(t), t.stateNode === null) {
      var u = Ji, x = a.contextType;
      typeof x == "object" && x !== null && (u = gt(x)), u = new a(r, u), t.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = Pu, t.stateNode = u, u._reactInternals = t, u = t.stateNode, u.props = r, u.state = t.memoizedState, u.refs = {}, xu(t), x = a.contextType, u.context = typeof x == "object" && x !== null ? gt(x) : Ji, u.state = t.memoizedState, x = a.getDerivedStateFromProps, typeof x == "function" && (Lu(
        t,
        a,
        x,
        r
      ), u.state = t.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof u.getSnapshotBeforeUpdate == "function" || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (x = u.state, typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), x !== u.state && Pu.enqueueReplaceState(u, u.state, null), hr(t, r, u, c), dr(), u.state = t.memoizedState), typeof u.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
    } else if (e === null) {
      u = t.stateNode;
      var v = t.memoizedProps, j = yi(a, v);
      u.props = j;
      var F = u.context, U = a.contextType;
      x = Ji, typeof U == "object" && U !== null && (x = gt(U));
      var I = a.getDerivedStateFromProps;
      U = typeof I == "function" || typeof u.getSnapshotBeforeUpdate == "function", v = t.pendingProps !== v, U || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (v || F !== x) && $p(
        t,
        u,
        r,
        x
      ), Na = !1;
      var B = t.memoizedState;
      u.state = B, hr(t, r, u, c), dr(), F = t.memoizedState, v || B !== F || Na ? (typeof I == "function" && (Lu(
        t,
        a,
        I,
        r
      ), F = t.memoizedState), (j = Na || Kp(
        t,
        a,
        j,
        r,
        B,
        F,
        x
      )) ? (U || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = F), u.props = r, u.state = F, u.context = x, r = j) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
    } else {
      u = t.stateNode, yu(e, t), x = t.memoizedProps, U = yi(a, x), u.props = U, I = t.pendingProps, B = u.context, F = a.contextType, j = Ji, typeof F == "object" && F !== null && (j = gt(F)), v = a.getDerivedStateFromProps, (F = typeof v == "function" || typeof u.getSnapshotBeforeUpdate == "function") || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (x !== I || B !== j) && $p(
        t,
        u,
        r,
        j
      ), Na = !1, B = t.memoizedState, u.state = B, hr(t, r, u, c), dr();
      var H = t.memoizedState;
      x !== I || B !== H || Na || e !== null && e.dependencies !== null && Rl(e.dependencies) ? (typeof v == "function" && (Lu(
        t,
        a,
        v,
        r
      ), H = t.memoizedState), (U = Na || Kp(
        t,
        a,
        U,
        r,
        B,
        H,
        j
      ) || e !== null && e.dependencies !== null && Rl(e.dependencies)) ? (F || typeof u.UNSAFE_componentWillUpdate != "function" && typeof u.componentWillUpdate != "function" || (typeof u.componentWillUpdate == "function" && u.componentWillUpdate(r, H, j), typeof u.UNSAFE_componentWillUpdate == "function" && u.UNSAFE_componentWillUpdate(
        r,
        H,
        j
      )), typeof u.componentDidUpdate == "function" && (t.flags |= 4), typeof u.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof u.componentDidUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = H), u.props = r, u.state = H, u.context = j, r = U) : (typeof u.componentDidUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return u = r, Wl(e, t), r = (t.flags & 128) !== 0, u || r ? (u = t.stateNode, a = r && typeof a.getDerivedStateFromError != "function" ? null : u.render(), t.flags |= 1, e !== null && r ? (t.child = gi(
      t,
      e.child,
      null,
      c
    ), t.child = gi(
      t,
      null,
      a,
      c
    )) : xt(e, t, a, c), t.memoizedState = u.state, e = t.child) : e = aa(
      e,
      t,
      c
    ), e;
  }
  function hg(e, t, a, r) {
    return ui(), t.flags |= 256, xt(e, t, a, r), t.child;
  }
  var Yu = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Qu(e) {
    return { baseLanes: e, cachePool: tp() };
  }
  function Zu(e, t, a) {
    return e = e !== null ? e.childLanes & ~a : 0, t && (e |= en), e;
  }
  function fg(e, t, a) {
    var r = t.pendingProps, c = !1, u = (t.flags & 128) !== 0, x;
    if ((x = u) || (x = e !== null && e.memoizedState === null ? !1 : (et.current & 2) !== 0), x && (c = !0, t.flags &= -129), x = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
      if (Re) {
        if (c ? Ca(t) : Ea(), (e = Ye) ? (e = wx(
          e,
          mn
        ), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: va !== null ? { id: Fn, overflow: Bn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, a = Ym(e), a.return = t, t.child = a, pt = t, Ye = null)) : e = null, e === null) throw ja(t);
        return Md(e) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var v = r.children;
      return r = r.fallback, c ? (Ea(), c = t.mode, v = Jl(
        { mode: "hidden", children: v },
        c
      ), r = ci(
        r,
        c,
        a,
        null
      ), v.return = t, r.return = t, v.sibling = r, t.child = v, r = t.child, r.memoizedState = Qu(a), r.childLanes = Zu(
        e,
        x,
        a
      ), t.memoizedState = Yu, xr(null, r)) : (Ca(t), Xu(t, v));
    }
    var j = e.memoizedState;
    if (j !== null && (v = j.dehydrated, v !== null)) {
      if (u)
        t.flags & 256 ? (Ca(t), t.flags &= -257, t = Ku(
          e,
          t,
          a
        )) : t.memoizedState !== null ? (Ea(), t.child = e.child, t.flags |= 128, t = null) : (Ea(), v = r.fallback, c = t.mode, r = Jl(
          { mode: "visible", children: r.children },
          c
        ), v = ci(
          v,
          c,
          a,
          null
        ), v.flags |= 2, r.return = t, v.return = t, r.sibling = v, t.child = r, gi(
          t,
          e.child,
          null,
          a
        ), r = t.child, r.memoizedState = Qu(a), r.childLanes = Zu(
          e,
          x,
          a
        ), t.memoizedState = Yu, t = xr(null, r));
      else if (Ca(t), Md(v)) {
        if (x = v.nextSibling && v.nextSibling.dataset, x) var F = x.dgst;
        x = F, r = Error(o(419)), r.stack = "", r.digest = x, sr({ value: r, source: null, stack: null }), t = Ku(
          e,
          t,
          a
        );
      } else if (it || as(e, t, a, !1), x = (a & e.childLanes) !== 0, it || x) {
        if (x = qe, x !== null && (r = Ft(x, a), r !== 0 && r !== j.retryLane))
          throw j.retryLane = r, oi(e, r), qt(x, e, r), Iu;
        kd(v) || oo(), t = Ku(
          e,
          t,
          a
        );
      } else
        kd(v) ? (t.flags |= 192, t.child = e.child, t = null) : (e = j.treeContext, Ye = gn(
          v.nextSibling
        ), pt = t, Re = !0, wa = null, mn = !1, e !== null && Xm(t, e), t = Xu(
          t,
          r.children
        ), t.flags |= 4096);
      return t;
    }
    return c ? (Ea(), v = r.fallback, c = t.mode, j = e.child, F = j.sibling, r = $n(j, {
      mode: "hidden",
      children: r.children
    }), r.subtreeFlags = j.subtreeFlags & 65011712, F !== null ? v = $n(
      F,
      v
    ) : (v = ci(
      v,
      c,
      a,
      null
    ), v.flags |= 2), v.return = t, r.return = t, r.sibling = v, t.child = r, xr(null, r), r = t.child, v = e.child.memoizedState, v === null ? v = Qu(a) : (c = v.cachePool, c !== null ? (j = nt._currentValue, c = c.parent !== j ? { parent: j, pool: j } : c) : c = tp(), v = {
      baseLanes: v.baseLanes | a,
      cachePool: c
    }), r.memoizedState = v, r.childLanes = Zu(
      e,
      x,
      a
    ), t.memoizedState = Yu, xr(e.child, r)) : (Ca(t), a = e.child, e = a.sibling, a = $n(a, {
      mode: "visible",
      children: r.children
    }), a.return = t, a.sibling = null, e !== null && (x = t.deletions, x === null ? (t.deletions = [e], t.flags |= 16) : x.push(e)), t.child = a, t.memoizedState = null, a);
  }
  function Xu(e, t) {
    return t = Jl(
      { mode: "visible", children: t },
      e.mode
    ), t.return = e, e.child = t;
  }
  function Jl(e, t) {
    return e = Kt(22, e, null, t), e.lanes = 0, e;
  }
  function Ku(e, t, a) {
    return gi(t, e.child, null, a), e = Xu(
      t,
      t.pendingProps.children
    ), e.flags |= 2, t.memoizedState = null, e;
  }
  function mg(e, t, a) {
    e.lanes |= t;
    var r = e.alternate;
    r !== null && (r.lanes |= t), du(e.return, t, a);
  }
  function $u(e, t, a, r, c, u) {
    var x = e.memoizedState;
    x === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: r,
      tail: a,
      tailMode: c,
      treeForkCount: u
    } : (x.isBackwards = t, x.rendering = null, x.renderingStartTime = 0, x.last = r, x.tail = a, x.tailMode = c, x.treeForkCount = u);
  }
  function pg(e, t, a) {
    var r = t.pendingProps, c = r.revealOrder, u = r.tail;
    r = r.children;
    var x = et.current, v = (x & 2) !== 0;
    if (v ? (x = x & 1 | 2, t.flags |= 128) : x &= 1, G(et, x), xt(e, t, r, a), r = Re ? ir : 0, !v && e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13)
          e.memoizedState !== null && mg(e, a, t);
        else if (e.tag === 19)
          mg(e, a, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t)
            break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    switch (c) {
      case "forwards":
        for (a = t.child, c = null; a !== null; )
          e = a.alternate, e !== null && Ll(e) === null && (c = a), a = a.sibling;
        a = c, a === null ? (c = t.child, t.child = null) : (c = a.sibling, a.sibling = null), $u(
          t,
          !1,
          c,
          a,
          u,
          r
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (a = null, c = t.child, t.child = null; c !== null; ) {
          if (e = c.alternate, e !== null && Ll(e) === null) {
            t.child = c;
            break;
          }
          e = c.sibling, c.sibling = a, a = c, c = e;
        }
        $u(
          t,
          !0,
          a,
          null,
          u,
          r
        );
        break;
      case "together":
        $u(
          t,
          !1,
          null,
          null,
          void 0,
          r
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function aa(e, t, a) {
    if (e !== null && (t.dependencies = e.dependencies), za |= t.lanes, (a & t.childLanes) === 0)
      if (e !== null) {
        if (as(
          e,
          t,
          a,
          !1
        ), (a & t.childLanes) === 0)
          return null;
      } else return null;
    if (e !== null && t.child !== e.child)
      throw Error(o(153));
    if (t.child !== null) {
      for (e = t.child, a = $n(e, e.pendingProps), t.child = a, a.return = t; e.sibling !== null; )
        e = e.sibling, a = a.sibling = $n(e, e.pendingProps), a.return = t;
      a.sibling = null;
    }
    return t.child;
  }
  function Wu(e, t) {
    return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && Rl(e)));
  }
  function p2(e, t, a) {
    switch (t.tag) {
      case 3:
        be(t, t.stateNode.containerInfo), Sa(t, nt, e.memoizedState.cache), ui();
        break;
      case 27:
      case 5:
        Qt(t);
        break;
      case 4:
        be(t, t.stateNode.containerInfo);
        break;
      case 10:
        Sa(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, Su(t), null;
        break;
      case 13:
        var r = t.memoizedState;
        if (r !== null)
          return r.dehydrated !== null ? (Ca(t), t.flags |= 128, null) : (a & t.child.childLanes) !== 0 ? fg(e, t, a) : (Ca(t), e = aa(
            e,
            t,
            a
          ), e !== null ? e.sibling : null);
        Ca(t);
        break;
      case 19:
        var c = (e.flags & 128) !== 0;
        if (r = (a & t.childLanes) !== 0, r || (as(
          e,
          t,
          a,
          !1
        ), r = (a & t.childLanes) !== 0), c) {
          if (r)
            return pg(
              e,
              t,
              a
            );
          t.flags |= 128;
        }
        if (c = t.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), G(et, et.current), r) break;
        return null;
      case 22:
        return t.lanes = 0, lg(
          e,
          t,
          a,
          t.pendingProps
        );
      case 24:
        Sa(t, nt, e.memoizedState.cache);
    }
    return aa(e, t, a);
  }
  function gg(e, t, a) {
    if (e !== null)
      if (e.memoizedProps !== t.pendingProps)
        it = !0;
      else {
        if (!Wu(e, a) && (t.flags & 128) === 0)
          return it = !1, p2(
            e,
            t,
            a
          );
        it = (e.flags & 131072) !== 0;
      }
    else
      it = !1, Re && (t.flags & 1048576) !== 0 && Zm(t, ir, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        e: {
          var r = t.pendingProps;
          if (e = mi(t.elementType), t.type = e, typeof e == "function")
            au(e) ? (r = yi(e, r), t.tag = 1, t = dg(
              null,
              t,
              e,
              r,
              a
            )) : (t.tag = 0, t = Gu(
              null,
              t,
              e,
              r,
              a
            ));
          else {
            if (e != null) {
              var c = e.$$typeof;
              if (c === Y) {
                t.tag = 11, t = ig(
                  null,
                  t,
                  e,
                  r,
                  a
                );
                break e;
              } else if (c === Z) {
                t.tag = 14, t = sg(
                  null,
                  t,
                  e,
                  r,
                  a
                );
                break e;
              }
            }
            throw t = ke(e) || e, Error(o(306, t, ""));
          }
        }
        return t;
      case 0:
        return Gu(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 1:
        return r = t.type, c = yi(
          r,
          t.pendingProps
        ), dg(
          e,
          t,
          r,
          c,
          a
        );
      case 3:
        e: {
          if (be(
            t,
            t.stateNode.containerInfo
          ), e === null) throw Error(o(387));
          r = t.pendingProps;
          var u = t.memoizedState;
          c = u.element, yu(e, t), hr(t, r, null, a);
          var x = t.memoizedState;
          if (r = x.cache, Sa(t, nt, r), r !== u.cache && hu(
            t,
            [nt],
            a,
            !0
          ), dr(), r = x.element, u.isDehydrated)
            if (u = {
              element: r,
              isDehydrated: !1,
              cache: x.cache
            }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
              t = hg(
                e,
                t,
                r,
                a
              );
              break e;
            } else if (r !== c) {
              c = dn(
                Error(o(424)),
                t
              ), sr(c), t = hg(
                e,
                t,
                r,
                a
              );
              break e;
            } else
              for (e = t.stateNode.containerInfo, e.nodeType === 9 ? e = e.body : e = e.nodeName === "HTML" ? e.ownerDocument.body : e, Ye = gn(e.firstChild), pt = t, Re = !0, wa = null, mn = !0, a = lp(
                t,
                null,
                r,
                a
              ), t.child = a; a; )
                a.flags = a.flags & -3 | 4096, a = a.sibling;
          else {
            if (ui(), r === c) {
              t = aa(
                e,
                t,
                a
              );
              break e;
            }
            xt(e, t, r, a);
          }
          t = t.child;
        }
        return t;
      case 26:
        return Wl(e, t), e === null ? (a = Cx(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = a : Re || (a = t.type, e = t.pendingProps, r = go(
          le.current
        ).createElement(a), r[mt] = t, r[Bt] = e, yt(r, a, e), dt(r), t.stateNode = r) : t.memoizedState = Cx(
          t.type,
          e.memoizedProps,
          t.pendingProps,
          e.memoizedState
        ), null;
      case 27:
        return Qt(t), e === null && Re && (r = t.stateNode = Nx(
          t.type,
          t.pendingProps,
          le.current
        ), pt = t, mn = !0, c = Ye, Fa(t.type) ? (zd = c, Ye = gn(r.firstChild)) : Ye = c), xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), Wl(e, t), e === null && (t.flags |= 4194304), t.child;
      case 5:
        return e === null && Re && ((c = r = Ye) && (r = G2(
          r,
          t.type,
          t.pendingProps,
          mn
        ), r !== null ? (t.stateNode = r, pt = t, Ye = gn(r.firstChild), mn = !1, c = !0) : c = !1), c || ja(t)), Qt(t), c = t.type, u = t.pendingProps, x = e !== null ? e.memoizedProps : null, r = u.children, Ad(c, u) ? r = null : x !== null && Ad(c, x) && (t.flags |= 32), t.memoizedState !== null && (c = Tu(
          e,
          t,
          r2,
          null,
          null,
          a
        ), Or._currentValue = c), Wl(e, t), xt(e, t, r, a), t.child;
      case 6:
        return e === null && Re && ((e = a = Ye) && (a = Y2(
          a,
          t.pendingProps,
          mn
        ), a !== null ? (t.stateNode = a, pt = t, Ye = null, e = !0) : e = !1), e || ja(t)), null;
      case 13:
        return fg(e, t, a);
      case 4:
        return be(
          t,
          t.stateNode.containerInfo
        ), r = t.pendingProps, e === null ? t.child = gi(
          t,
          null,
          r,
          a
        ) : xt(e, t, r, a), t.child;
      case 11:
        return ig(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 7:
        return xt(
          e,
          t,
          t.pendingProps,
          a
        ), t.child;
      case 8:
        return xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 12:
        return xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 10:
        return r = t.pendingProps, Sa(t, t.type, r.value), xt(e, t, r.children, a), t.child;
      case 9:
        return c = t.type._context, r = t.pendingProps.children, hi(t), c = gt(c), r = r(c), t.flags |= 1, xt(e, t, r, a), t.child;
      case 14:
        return sg(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 15:
        return rg(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 19:
        return pg(e, t, a);
      case 31:
        return m2(e, t, a);
      case 22:
        return lg(
          e,
          t,
          a,
          t.pendingProps
        );
      case 24:
        return hi(t), r = gt(nt), e === null ? (c = pu(), c === null && (c = qe, u = fu(), c.pooledCache = u, u.refCount++, u !== null && (c.pooledCacheLanes |= a), c = u), t.memoizedState = { parent: r, cache: c }, xu(t), Sa(t, nt, c)) : ((e.lanes & a) !== 0 && (yu(e, t), hr(t, null, null, a), dr()), c = e.memoizedState, u = t.memoizedState, c.parent !== r ? (c = { parent: r, cache: r }, t.memoizedState = c, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = c), Sa(t, nt, r)) : (r = u.cache, Sa(t, nt, r), r !== c.cache && hu(
          t,
          [nt],
          a,
          !0
        ))), xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(o(156, t.tag));
  }
  function ia(e) {
    e.flags |= 4;
  }
  function Ju(e, t, a, r, c) {
    if ((t = (e.mode & 32) !== 0) && (t = !1), t) {
      if (e.flags |= 16777216, (c & 335544128) === c)
        if (e.stateNode.complete) e.flags |= 8192;
        else if (qg()) e.flags |= 8192;
        else
          throw pi = Bl, gu;
    } else e.flags &= -16777217;
  }
  function xg(e, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (e.flags |= 16777216, !Ox(t))
      if (qg()) e.flags |= 8192;
      else
        throw pi = Bl, gu;
  }
  function eo(e, t) {
    t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? St() : 536870912, e.lanes |= t, ps |= t);
  }
  function yr(e, t) {
    if (!Re)
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var a = null; t !== null; )
            t.alternate !== null && (a = t), t = t.sibling;
          a === null ? e.tail = null : a.sibling = null;
          break;
        case "collapsed":
          a = e.tail;
          for (var r = null; a !== null; )
            a.alternate !== null && (r = a), a = a.sibling;
          r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
  }
  function Qe(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, a = 0, r = 0;
    if (t)
      for (var c = e.child; c !== null; )
        a |= c.lanes | c.childLanes, r |= c.subtreeFlags & 65011712, r |= c.flags & 65011712, c.return = e, c = c.sibling;
    else
      for (c = e.child; c !== null; )
        a |= c.lanes | c.childLanes, r |= c.subtreeFlags, r |= c.flags, c.return = e, c = c.sibling;
    return e.subtreeFlags |= r, e.childLanes = a, t;
  }
  function g2(e, t, a) {
    var r = t.pendingProps;
    switch (lu(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Qe(t), null;
      case 1:
        return Qe(t), null;
      case 3:
        return a = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), ea(nt), ge(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), (e === null || e.child === null) && (ns(t) ? ia(t) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, cu())), Qe(t), null;
      case 26:
        var c = t.type, u = t.memoizedState;
        return e === null ? (ia(t), u !== null ? (Qe(t), xg(t, u)) : (Qe(t), Ju(
          t,
          c,
          null,
          r,
          a
        ))) : u ? u !== e.memoizedState ? (ia(t), Qe(t), xg(t, u)) : (Qe(t), t.flags &= -16777217) : (e = e.memoizedProps, e !== r && ia(t), Qe(t), Ju(
          t,
          c,
          e,
          r,
          a
        )), null;
      case 27:
        if (Rt(t), a = le.current, c = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== r && ia(t);
        else {
          if (!r) {
            if (t.stateNode === null)
              throw Error(o(166));
            return Qe(t), null;
          }
          e = W.current, ns(t) ? Km(t) : (e = Nx(c, r, a), t.stateNode = e, ia(t));
        }
        return Qe(t), null;
      case 5:
        if (Rt(t), c = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== r && ia(t);
        else {
          if (!r) {
            if (t.stateNode === null)
              throw Error(o(166));
            return Qe(t), null;
          }
          if (u = W.current, ns(t))
            Km(t);
          else {
            var x = go(
              le.current
            );
            switch (u) {
              case 1:
                u = x.createElementNS(
                  "http://www.w3.org/2000/svg",
                  c
                );
                break;
              case 2:
                u = x.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  c
                );
                break;
              default:
                switch (c) {
                  case "svg":
                    u = x.createElementNS(
                      "http://www.w3.org/2000/svg",
                      c
                    );
                    break;
                  case "math":
                    u = x.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      c
                    );
                    break;
                  case "script":
                    u = x.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(
                      u.firstChild
                    );
                    break;
                  case "select":
                    u = typeof r.is == "string" ? x.createElement("select", {
                      is: r.is
                    }) : x.createElement("select"), r.multiple ? u.multiple = !0 : r.size && (u.size = r.size);
                    break;
                  default:
                    u = typeof r.is == "string" ? x.createElement(c, { is: r.is }) : x.createElement(c);
                }
            }
            u[mt] = t, u[Bt] = r;
            e: for (x = t.child; x !== null; ) {
              if (x.tag === 5 || x.tag === 6)
                u.appendChild(x.stateNode);
              else if (x.tag !== 4 && x.tag !== 27 && x.child !== null) {
                x.child.return = x, x = x.child;
                continue;
              }
              if (x === t) break e;
              for (; x.sibling === null; ) {
                if (x.return === null || x.return === t)
                  break e;
                x = x.return;
              }
              x.sibling.return = x.return, x = x.sibling;
            }
            t.stateNode = u;
            e: switch (yt(u, c, r), c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
            r && ia(t);
          }
        }
        return Qe(t), Ju(
          t,
          t.type,
          e === null ? null : e.memoizedProps,
          t.pendingProps,
          a
        ), null;
      case 6:
        if (e && t.stateNode != null)
          e.memoizedProps !== r && ia(t);
        else {
          if (typeof r != "string" && t.stateNode === null)
            throw Error(o(166));
          if (e = le.current, ns(t)) {
            if (e = t.stateNode, a = t.memoizedProps, r = null, c = pt, c !== null)
              switch (c.tag) {
                case 27:
                case 5:
                  r = c.memoizedProps;
              }
            e[mt] = t, e = !!(e.nodeValue === a || r !== null && r.suppressHydrationWarning === !0 || fx(e.nodeValue, a)), e || ja(t, !0);
          } else
            e = go(e).createTextNode(
              r
            ), e[mt] = t, t.stateNode = e;
        }
        return Qe(t), null;
      case 31:
        if (a = t.memoizedState, e === null || e.memoizedState !== null) {
          if (r = ns(t), a !== null) {
            if (e === null) {
              if (!r) throw Error(o(318));
              if (e = t.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(557));
              e[mt] = t;
            } else
              ui(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            Qe(t), e = !1;
          } else
            a = cu(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), e = !0;
          if (!e)
            return t.flags & 256 ? (Wt(t), t) : (Wt(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(o(558));
        }
        return Qe(t), null;
      case 13:
        if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (c = ns(t), r !== null && r.dehydrated !== null) {
            if (e === null) {
              if (!c) throw Error(o(318));
              if (c = t.memoizedState, c = c !== null ? c.dehydrated : null, !c) throw Error(o(317));
              c[mt] = t;
            } else
              ui(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            Qe(t), c = !1;
          } else
            c = cu(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = c), c = !0;
          if (!c)
            return t.flags & 256 ? (Wt(t), t) : (Wt(t), null);
        }
        return Wt(t), (t.flags & 128) !== 0 ? (t.lanes = a, t) : (a = r !== null, e = e !== null && e.memoizedState !== null, a && (r = t.child, c = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (c = r.alternate.memoizedState.cachePool.pool), u = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (u = r.memoizedState.cachePool.pool), u !== c && (r.flags |= 2048)), a !== e && a && (t.child.flags |= 8192), eo(t, t.updateQueue), Qe(t), null);
      case 4:
        return ge(), e === null && wd(t.stateNode.containerInfo), Qe(t), null;
      case 10:
        return ea(t.type), Qe(t), null;
      case 19:
        if (P(et), r = t.memoizedState, r === null) return Qe(t), null;
        if (c = (t.flags & 128) !== 0, u = r.rendering, u === null)
          if (c) yr(r, !1);
          else {
            if (We !== 0 || e !== null && (e.flags & 128) !== 0)
              for (e = t.child; e !== null; ) {
                if (u = Ll(e), u !== null) {
                  for (t.flags |= 128, yr(r, !1), e = u.updateQueue, t.updateQueue = e, eo(t, e), t.subtreeFlags = 0, e = a, a = t.child; a !== null; )
                    Gm(a, e), a = a.sibling;
                  return G(
                    et,
                    et.current & 1 | 2
                  ), Re && Wn(t, r.treeForkCount), t.child;
                }
                e = e.sibling;
              }
            r.tail !== null && Et() > so && (t.flags |= 128, c = !0, yr(r, !1), t.lanes = 4194304);
          }
        else {
          if (!c)
            if (e = Ll(u), e !== null) {
              if (t.flags |= 128, c = !0, e = e.updateQueue, t.updateQueue = e, eo(t, e), yr(r, !0), r.tail === null && r.tailMode === "hidden" && !u.alternate && !Re)
                return Qe(t), null;
            } else
              2 * Et() - r.renderingStartTime > so && a !== 536870912 && (t.flags |= 128, c = !0, yr(r, !1), t.lanes = 4194304);
          r.isBackwards ? (u.sibling = t.child, t.child = u) : (e = r.last, e !== null ? e.sibling = u : t.child = u, r.last = u);
        }
        return r.tail !== null ? (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = Et(), e.sibling = null, a = et.current, G(
          et,
          c ? a & 1 | 2 : a & 1
        ), Re && Wn(t, r.treeForkCount), e) : (Qe(t), null);
      case 22:
      case 23:
        return Wt(t), ju(), r = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== r && (t.flags |= 8192) : r && (t.flags |= 8192), r ? (a & 536870912) !== 0 && (t.flags & 128) === 0 && (Qe(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Qe(t), a = t.updateQueue, a !== null && eo(t, a.retryQueue), a = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== a && (t.flags |= 2048), e !== null && P(fi), null;
      case 24:
        return a = null, e !== null && (a = e.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), ea(nt), Qe(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(o(156, t.tag));
  }
  function x2(e, t) {
    switch (lu(t), t.tag) {
      case 1:
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return ea(nt), ge(), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return Rt(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (Wt(t), t.alternate === null)
            throw Error(o(340));
          ui();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 13:
        if (Wt(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(o(340));
          ui();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return P(et), null;
      case 4:
        return ge(), null;
      case 10:
        return ea(t.type), null;
      case 22:
      case 23:
        return Wt(t), ju(), e !== null && P(fi), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 24:
        return ea(nt), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function yg(e, t) {
    switch (lu(t), t.tag) {
      case 3:
        ea(nt), ge();
        break;
      case 26:
      case 27:
      case 5:
        Rt(t);
        break;
      case 4:
        ge();
        break;
      case 31:
        t.memoizedState !== null && Wt(t);
        break;
      case 13:
        Wt(t);
        break;
      case 19:
        P(et);
        break;
      case 10:
        ea(t.type);
        break;
      case 22:
      case 23:
        Wt(t), ju(), e !== null && P(fi);
        break;
      case 24:
        ea(nt);
    }
  }
  function br(e, t) {
    try {
      var a = t.updateQueue, r = a !== null ? a.lastEffect : null;
      if (r !== null) {
        var c = r.next;
        a = c;
        do {
          if ((a.tag & e) === e) {
            r = void 0;
            var u = a.create, x = a.inst;
            r = u(), x.destroy = r;
          }
          a = a.next;
        } while (a !== c);
      }
    } catch (v) {
      He(t, t.return, v);
    }
  }
  function ka(e, t, a) {
    try {
      var r = t.updateQueue, c = r !== null ? r.lastEffect : null;
      if (c !== null) {
        var u = c.next;
        r = u;
        do {
          if ((r.tag & e) === e) {
            var x = r.inst, v = x.destroy;
            if (v !== void 0) {
              x.destroy = void 0, c = t;
              var j = a, F = v;
              try {
                F();
              } catch (U) {
                He(
                  c,
                  j,
                  U
                );
              }
            }
          }
          r = r.next;
        } while (r !== u);
      }
    } catch (U) {
      He(t, t.return, U);
    }
  }
  function bg(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var a = e.stateNode;
      try {
        cp(t, a);
      } catch (r) {
        He(e, e.return, r);
      }
    }
  }
  function vg(e, t, a) {
    a.props = yi(
      e.type,
      e.memoizedProps
    ), a.state = e.memoizedState;
    try {
      a.componentWillUnmount();
    } catch (r) {
      He(e, t, r);
    }
  }
  function vr(e, t) {
    try {
      var a = e.ref;
      if (a !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var r = e.stateNode;
            break;
          case 30:
            r = e.stateNode;
            break;
          default:
            r = e.stateNode;
        }
        typeof a == "function" ? e.refCleanup = a(r) : a.current = r;
      }
    } catch (c) {
      He(e, t, c);
    }
  }
  function Vn(e, t) {
    var a = e.ref, r = e.refCleanup;
    if (a !== null)
      if (typeof r == "function")
        try {
          r();
        } catch (c) {
          He(e, t, c);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        }
      else if (typeof a == "function")
        try {
          a(null);
        } catch (c) {
          He(e, t, c);
        }
      else a.current = null;
  }
  function wg(e) {
    var t = e.type, a = e.memoizedProps, r = e.stateNode;
    try {
      e: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && r.focus();
          break e;
        case "img":
          a.src ? r.src = a.src : a.srcSet && (r.srcset = a.srcSet);
      }
    } catch (c) {
      He(e, e.return, c);
    }
  }
  function ed(e, t, a) {
    try {
      var r = e.stateNode;
      H2(r, e.type, a, t), r[Bt] = t;
    } catch (c) {
      He(e, e.return, c);
    }
  }
  function jg(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Fa(e.type) || e.tag === 4;
  }
  function td(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || jg(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && Fa(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function nd(e, t, a) {
    var r = e.tag;
    if (r === 5 || r === 6)
      e = e.stateNode, t ? (a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).insertBefore(e, t) : (t = a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a, t.appendChild(e), a = a._reactRootContainer, a != null || t.onclick !== null || (t.onclick = Xn));
    else if (r !== 4 && (r === 27 && Fa(e.type) && (a = e.stateNode, t = null), e = e.child, e !== null))
      for (nd(e, t, a), e = e.sibling; e !== null; )
        nd(e, t, a), e = e.sibling;
  }
  function to(e, t, a) {
    var r = e.tag;
    if (r === 5 || r === 6)
      e = e.stateNode, t ? a.insertBefore(e, t) : a.appendChild(e);
    else if (r !== 4 && (r === 27 && Fa(e.type) && (a = e.stateNode), e = e.child, e !== null))
      for (to(e, t, a), e = e.sibling; e !== null; )
        to(e, t, a), e = e.sibling;
  }
  function Sg(e) {
    var t = e.stateNode, a = e.memoizedProps;
    try {
      for (var r = e.type, c = t.attributes; c.length; )
        t.removeAttributeNode(c[0]);
      yt(t, r, a), t[mt] = e, t[Bt] = a;
    } catch (u) {
      He(e, e.return, u);
    }
  }
  var sa = !1, st = !1, ad = !1, Ng = typeof WeakSet == "function" ? WeakSet : Set, ht = null;
  function y2(e, t) {
    if (e = e.containerInfo, Nd = So, e = Fm(e), Kc(e)) {
      if ("selectionStart" in e)
        var a = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      else
        e: {
          a = (a = e.ownerDocument) && a.defaultView || window;
          var r = a.getSelection && a.getSelection();
          if (r && r.rangeCount !== 0) {
            a = r.anchorNode;
            var c = r.anchorOffset, u = r.focusNode;
            r = r.focusOffset;
            try {
              a.nodeType, u.nodeType;
            } catch {
              a = null;
              break e;
            }
            var x = 0, v = -1, j = -1, F = 0, U = 0, I = e, B = null;
            t: for (; ; ) {
              for (var H; I !== a || c !== 0 && I.nodeType !== 3 || (v = x + c), I !== u || r !== 0 && I.nodeType !== 3 || (j = x + r), I.nodeType === 3 && (x += I.nodeValue.length), (H = I.firstChild) !== null; )
                B = I, I = H;
              for (; ; ) {
                if (I === e) break t;
                if (B === a && ++F === c && (v = x), B === u && ++U === r && (j = x), (H = I.nextSibling) !== null) break;
                I = B, B = I.parentNode;
              }
              I = H;
            }
            a = v === -1 || j === -1 ? null : { start: v, end: j };
          } else a = null;
        }
      a = a || { start: 0, end: 0 };
    } else a = null;
    for (Td = { focusedElem: e, selectionRange: a }, So = !1, ht = t; ht !== null; )
      if (t = ht, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
        e.return = t, ht = e;
      else
        for (; ht !== null; ) {
          switch (t = ht, u = t.alternate, e = t.flags, t.tag) {
            case 0:
              if ((e & 4) !== 0 && (e = t.updateQueue, e = e !== null ? e.events : null, e !== null))
                for (a = 0; a < e.length; a++)
                  c = e[a], c.ref.impl = c.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && u !== null) {
                e = void 0, a = t, c = u.memoizedProps, u = u.memoizedState, r = a.stateNode;
                try {
                  var ce = yi(
                    a.type,
                    c
                  );
                  e = r.getSnapshotBeforeUpdate(
                    ce,
                    u
                  ), r.__reactInternalSnapshotBeforeUpdate = e;
                } catch (pe) {
                  He(
                    a,
                    a.return,
                    pe
                  );
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (e = t.stateNode.containerInfo, a = e.nodeType, a === 9)
                  Ed(e);
                else if (a === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Ed(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(o(163));
          }
          if (e = t.sibling, e !== null) {
            e.return = t.return, ht = e;
            break;
          }
          ht = t.return;
        }
  }
  function Tg(e, t, a) {
    var r = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        la(e, a), r & 4 && br(5, a);
        break;
      case 1:
        if (la(e, a), r & 4)
          if (e = a.stateNode, t === null)
            try {
              e.componentDidMount();
            } catch (x) {
              He(a, a.return, x);
            }
          else {
            var c = yi(
              a.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              e.componentDidUpdate(
                c,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            } catch (x) {
              He(
                a,
                a.return,
                x
              );
            }
          }
        r & 64 && bg(a), r & 512 && vr(a, a.return);
        break;
      case 3:
        if (la(e, a), r & 64 && (e = a.updateQueue, e !== null)) {
          if (t = null, a.child !== null)
            switch (a.child.tag) {
              case 27:
              case 5:
                t = a.child.stateNode;
                break;
              case 1:
                t = a.child.stateNode;
            }
          try {
            cp(e, t);
          } catch (x) {
            He(a, a.return, x);
          }
        }
        break;
      case 27:
        t === null && r & 4 && Sg(a);
      case 26:
      case 5:
        la(e, a), t === null && r & 4 && wg(a), r & 512 && vr(a, a.return);
        break;
      case 12:
        la(e, a);
        break;
      case 31:
        la(e, a), r & 4 && Eg(e, a);
        break;
      case 13:
        la(e, a), r & 4 && kg(e, a), r & 64 && (e = a.memoizedState, e !== null && (e = e.dehydrated, e !== null && (a = C2.bind(
          null,
          a
        ), Q2(e, a))));
        break;
      case 22:
        if (r = a.memoizedState !== null || sa, !r) {
          t = t !== null && t.memoizedState !== null || st, c = sa;
          var u = st;
          sa = r, (st = t) && !u ? oa(
            e,
            a,
            (a.subtreeFlags & 8772) !== 0
          ) : la(e, a), sa = c, st = u;
        }
        break;
      case 30:
        break;
      default:
        la(e, a);
    }
  }
  function Ag(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, Ag(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && Rc(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  var Xe = null, Ht = !1;
  function ra(e, t, a) {
    for (a = a.child; a !== null; )
      Cg(e, t, a), a = a.sibling;
  }
  function Cg(e, t, a) {
    if (kt && typeof kt.onCommitFiberUnmount == "function")
      try {
        kt.onCommitFiberUnmount(ti, a);
      } catch {
      }
    switch (a.tag) {
      case 26:
        st || Vn(a, t), ra(
          e,
          t,
          a
        ), a.memoizedState ? a.memoizedState.count-- : a.stateNode && (a = a.stateNode, a.parentNode.removeChild(a));
        break;
      case 27:
        st || Vn(a, t);
        var r = Xe, c = Ht;
        Fa(a.type) && (Xe = a.stateNode, Ht = !1), ra(
          e,
          t,
          a
        ), kr(a.stateNode), Xe = r, Ht = c;
        break;
      case 5:
        st || Vn(a, t);
      case 6:
        if (r = Xe, c = Ht, Xe = null, ra(
          e,
          t,
          a
        ), Xe = r, Ht = c, Xe !== null)
          if (Ht)
            try {
              (Xe.nodeType === 9 ? Xe.body : Xe.nodeName === "HTML" ? Xe.ownerDocument.body : Xe).removeChild(a.stateNode);
            } catch (u) {
              He(
                a,
                t,
                u
              );
            }
          else
            try {
              Xe.removeChild(a.stateNode);
            } catch (u) {
              He(
                a,
                t,
                u
              );
            }
        break;
      case 18:
        Xe !== null && (Ht ? (e = Xe, bx(
          e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
          a.stateNode
        ), Ss(e)) : bx(Xe, a.stateNode));
        break;
      case 4:
        r = Xe, c = Ht, Xe = a.stateNode.containerInfo, Ht = !0, ra(
          e,
          t,
          a
        ), Xe = r, Ht = c;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ka(2, a, t), st || ka(4, a, t), ra(
          e,
          t,
          a
        );
        break;
      case 1:
        st || (Vn(a, t), r = a.stateNode, typeof r.componentWillUnmount == "function" && vg(
          a,
          t,
          r
        )), ra(
          e,
          t,
          a
        );
        break;
      case 21:
        ra(
          e,
          t,
          a
        );
        break;
      case 22:
        st = (r = st) || a.memoizedState !== null, ra(
          e,
          t,
          a
        ), st = r;
        break;
      default:
        ra(
          e,
          t,
          a
        );
    }
  }
  function Eg(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Ss(e);
      } catch (a) {
        He(t, t.return, a);
      }
    }
  }
  function kg(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
      try {
        Ss(e);
      } catch (a) {
        He(t, t.return, a);
      }
  }
  function b2(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return t === null && (t = e.stateNode = new Ng()), t;
      case 22:
        return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new Ng()), t;
      default:
        throw Error(o(435, e.tag));
    }
  }
  function no(e, t) {
    var a = b2(e);
    t.forEach(function(r) {
      if (!a.has(r)) {
        a.add(r);
        var c = E2.bind(null, e, r);
        r.then(c, c);
      }
    });
  }
  function Ut(e, t) {
    var a = t.deletions;
    if (a !== null)
      for (var r = 0; r < a.length; r++) {
        var c = a[r], u = e, x = t, v = x;
        e: for (; v !== null; ) {
          switch (v.tag) {
            case 27:
              if (Fa(v.type)) {
                Xe = v.stateNode, Ht = !1;
                break e;
              }
              break;
            case 5:
              Xe = v.stateNode, Ht = !1;
              break e;
            case 3:
            case 4:
              Xe = v.stateNode.containerInfo, Ht = !0;
              break e;
          }
          v = v.return;
        }
        if (Xe === null) throw Error(o(160));
        Cg(u, x, c), Xe = null, Ht = !1, u = c.alternate, u !== null && (u.return = null), c.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        Mg(t, e), t = t.sibling;
  }
  var Cn = null;
  function Mg(e, t) {
    var a = e.alternate, r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Ut(t, e), Lt(e), r & 4 && (ka(3, e, e.return), br(3, e), ka(5, e, e.return));
        break;
      case 1:
        Ut(t, e), Lt(e), r & 512 && (st || a === null || Vn(a, a.return)), r & 64 && sa && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (a = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = a === null ? r : a.concat(r))));
        break;
      case 26:
        var c = Cn;
        if (Ut(t, e), Lt(e), r & 512 && (st || a === null || Vn(a, a.return)), r & 4) {
          var u = a !== null ? a.memoizedState : null;
          if (r = e.memoizedState, a === null)
            if (r === null)
              if (e.stateNode === null) {
                e: {
                  r = e.type, a = e.memoizedProps, c = c.ownerDocument || c;
                  t: switch (r) {
                    case "title":
                      u = c.getElementsByTagName("title")[0], (!u || u[Qs] || u[mt] || u.namespaceURI === "http://www.w3.org/2000/svg" || u.hasAttribute("itemprop")) && (u = c.createElement(r), c.head.insertBefore(
                        u,
                        c.querySelector("head > title")
                      )), yt(u, r, a), u[mt] = e, dt(u), r = u;
                      break e;
                    case "link":
                      var x = Mx(
                        "link",
                        "href",
                        c
                      ).get(r + (a.href || ""));
                      if (x) {
                        for (var v = 0; v < x.length; v++)
                          if (u = x[v], u.getAttribute("href") === (a.href == null || a.href === "" ? null : a.href) && u.getAttribute("rel") === (a.rel == null ? null : a.rel) && u.getAttribute("title") === (a.title == null ? null : a.title) && u.getAttribute("crossorigin") === (a.crossOrigin == null ? null : a.crossOrigin)) {
                            x.splice(v, 1);
                            break t;
                          }
                      }
                      u = c.createElement(r), yt(u, r, a), c.head.appendChild(u);
                      break;
                    case "meta":
                      if (x = Mx(
                        "meta",
                        "content",
                        c
                      ).get(r + (a.content || ""))) {
                        for (v = 0; v < x.length; v++)
                          if (u = x[v], u.getAttribute("content") === (a.content == null ? null : "" + a.content) && u.getAttribute("name") === (a.name == null ? null : a.name) && u.getAttribute("property") === (a.property == null ? null : a.property) && u.getAttribute("http-equiv") === (a.httpEquiv == null ? null : a.httpEquiv) && u.getAttribute("charset") === (a.charSet == null ? null : a.charSet)) {
                            x.splice(v, 1);
                            break t;
                          }
                      }
                      u = c.createElement(r), yt(u, r, a), c.head.appendChild(u);
                      break;
                    default:
                      throw Error(o(468, r));
                  }
                  u[mt] = e, dt(u), r = u;
                }
                e.stateNode = r;
              } else
                zx(
                  c,
                  e.type,
                  e.stateNode
                );
            else
              e.stateNode = kx(
                c,
                r,
                e.memoizedProps
              );
          else
            u !== r ? (u === null ? a.stateNode !== null && (a = a.stateNode, a.parentNode.removeChild(a)) : u.count--, r === null ? zx(
              c,
              e.type,
              e.stateNode
            ) : kx(
              c,
              r,
              e.memoizedProps
            )) : r === null && e.stateNode !== null && ed(
              e,
              e.memoizedProps,
              a.memoizedProps
            );
        }
        break;
      case 27:
        Ut(t, e), Lt(e), r & 512 && (st || a === null || Vn(a, a.return)), a !== null && r & 4 && ed(
          e,
          e.memoizedProps,
          a.memoizedProps
        );
        break;
      case 5:
        if (Ut(t, e), Lt(e), r & 512 && (st || a === null || Vn(a, a.return)), e.flags & 32) {
          c = e.stateNode;
          try {
            Yi(c, "");
          } catch (ce) {
            He(e, e.return, ce);
          }
        }
        r & 4 && e.stateNode != null && (c = e.memoizedProps, ed(
          e,
          c,
          a !== null ? a.memoizedProps : c
        )), r & 1024 && (ad = !0);
        break;
      case 6:
        if (Ut(t, e), Lt(e), r & 4) {
          if (e.stateNode === null)
            throw Error(o(162));
          r = e.memoizedProps, a = e.stateNode;
          try {
            a.nodeValue = r;
          } catch (ce) {
            He(e, e.return, ce);
          }
        }
        break;
      case 3:
        if (bo = null, c = Cn, Cn = xo(t.containerInfo), Ut(t, e), Cn = c, Lt(e), r & 4 && a !== null && a.memoizedState.isDehydrated)
          try {
            Ss(t.containerInfo);
          } catch (ce) {
            He(e, e.return, ce);
          }
        ad && (ad = !1, zg(e));
        break;
      case 4:
        r = Cn, Cn = xo(
          e.stateNode.containerInfo
        ), Ut(t, e), Lt(e), Cn = r;
        break;
      case 12:
        Ut(t, e), Lt(e);
        break;
      case 31:
        Ut(t, e), Lt(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 13:
        Ut(t, e), Lt(e), e.child.flags & 8192 && e.memoizedState !== null != (a !== null && a.memoizedState !== null) && (io = Et()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 22:
        c = e.memoizedState !== null;
        var j = a !== null && a.memoizedState !== null, F = sa, U = st;
        if (sa = F || c, st = U || j, Ut(t, e), st = U, sa = F, Lt(e), r & 8192)
          e: for (t = e.stateNode, t._visibility = c ? t._visibility & -2 : t._visibility | 1, c && (a === null || j || sa || st || bi(e)), a = null, t = e; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (a === null) {
                j = a = t;
                try {
                  if (u = j.stateNode, c)
                    x = u.style, typeof x.setProperty == "function" ? x.setProperty("display", "none", "important") : x.display = "none";
                  else {
                    v = j.stateNode;
                    var I = j.memoizedProps.style, B = I != null && I.hasOwnProperty("display") ? I.display : null;
                    v.style.display = B == null || typeof B == "boolean" ? "" : ("" + B).trim();
                  }
                } catch (ce) {
                  He(j, j.return, ce);
                }
              }
            } else if (t.tag === 6) {
              if (a === null) {
                j = t;
                try {
                  j.stateNode.nodeValue = c ? "" : j.memoizedProps;
                } catch (ce) {
                  He(j, j.return, ce);
                }
              }
            } else if (t.tag === 18) {
              if (a === null) {
                j = t;
                try {
                  var H = j.stateNode;
                  c ? vx(H, !0) : vx(j.stateNode, !1);
                } catch (ce) {
                  He(j, j.return, ce);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break e;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) break e;
              a === t && (a = null), t = t.return;
            }
            a === t && (a = null), t.sibling.return = t.return, t = t.sibling;
          }
        r & 4 && (r = e.updateQueue, r !== null && (a = r.retryQueue, a !== null && (r.retryQueue = null, no(e, a))));
        break;
      case 19:
        Ut(t, e), Lt(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Ut(t, e), Lt(e);
    }
  }
  function Lt(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var a, r = e.return; r !== null; ) {
          if (jg(r)) {
            a = r;
            break;
          }
          r = r.return;
        }
        if (a == null) throw Error(o(160));
        switch (a.tag) {
          case 27:
            var c = a.stateNode, u = td(e);
            to(e, u, c);
            break;
          case 5:
            var x = a.stateNode;
            a.flags & 32 && (Yi(x, ""), a.flags &= -33);
            var v = td(e);
            to(e, v, x);
            break;
          case 3:
          case 4:
            var j = a.stateNode.containerInfo, F = td(e);
            nd(
              e,
              F,
              j
            );
            break;
          default:
            throw Error(o(161));
        }
      } catch (U) {
        He(e, e.return, U);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function zg(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null; ) {
        var t = e;
        zg(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
      }
  }
  function la(e, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        Tg(e, t.alternate, t), t = t.sibling;
  }
  function bi(e) {
    for (e = e.child; e !== null; ) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ka(4, t, t.return), bi(t);
          break;
        case 1:
          Vn(t, t.return);
          var a = t.stateNode;
          typeof a.componentWillUnmount == "function" && vg(
            t,
            t.return,
            a
          ), bi(t);
          break;
        case 27:
          kr(t.stateNode);
        case 26:
        case 5:
          Vn(t, t.return), bi(t);
          break;
        case 22:
          t.memoizedState === null && bi(t);
          break;
        case 30:
          bi(t);
          break;
        default:
          bi(t);
      }
      e = e.sibling;
    }
  }
  function oa(e, t, a) {
    for (a = a && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var r = t.alternate, c = e, u = t, x = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          oa(
            c,
            u,
            a
          ), br(4, u);
          break;
        case 1:
          if (oa(
            c,
            u,
            a
          ), r = u, c = r.stateNode, typeof c.componentDidMount == "function")
            try {
              c.componentDidMount();
            } catch (F) {
              He(r, r.return, F);
            }
          if (r = u, c = r.updateQueue, c !== null) {
            var v = r.stateNode;
            try {
              var j = c.shared.hiddenCallbacks;
              if (j !== null)
                for (c.shared.hiddenCallbacks = null, c = 0; c < j.length; c++)
                  op(j[c], v);
            } catch (F) {
              He(r, r.return, F);
            }
          }
          a && x & 64 && bg(u), vr(u, u.return);
          break;
        case 27:
          Sg(u);
        case 26:
        case 5:
          oa(
            c,
            u,
            a
          ), a && r === null && x & 4 && wg(u), vr(u, u.return);
          break;
        case 12:
          oa(
            c,
            u,
            a
          );
          break;
        case 31:
          oa(
            c,
            u,
            a
          ), a && x & 4 && Eg(c, u);
          break;
        case 13:
          oa(
            c,
            u,
            a
          ), a && x & 4 && kg(c, u);
          break;
        case 22:
          u.memoizedState === null && oa(
            c,
            u,
            a
          ), vr(u, u.return);
          break;
        case 30:
          break;
        default:
          oa(
            c,
            u,
            a
          );
      }
      t = t.sibling;
    }
  }
  function id(e, t) {
    var a = null;
    e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== a && (e != null && e.refCount++, a != null && rr(a));
  }
  function sd(e, t) {
    e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && rr(e));
  }
  function En(e, t, a, r) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        Og(
          e,
          t,
          a,
          r
        ), t = t.sibling;
  }
  function Og(e, t, a, r) {
    var c = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && br(9, t);
        break;
      case 1:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 3:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && rr(e)));
        break;
      case 12:
        if (c & 2048) {
          En(
            e,
            t,
            a,
            r
          ), e = t.stateNode;
          try {
            var u = t.memoizedProps, x = u.id, v = u.onPostCommit;
            typeof v == "function" && v(
              x,
              t.alternate === null ? "mount" : "update",
              e.passiveEffectDuration,
              -0
            );
          } catch (j) {
            He(t, t.return, j);
          }
        } else
          En(
            e,
            t,
            a,
            r
          );
        break;
      case 31:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 13:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 23:
        break;
      case 22:
        u = t.stateNode, x = t.alternate, t.memoizedState !== null ? u._visibility & 2 ? En(
          e,
          t,
          a,
          r
        ) : wr(e, t) : u._visibility & 2 ? En(
          e,
          t,
          a,
          r
        ) : (u._visibility |= 2, hs(
          e,
          t,
          a,
          r,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), c & 2048 && id(x, t);
        break;
      case 24:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && sd(t.alternate, t);
        break;
      default:
        En(
          e,
          t,
          a,
          r
        );
    }
  }
  function hs(e, t, a, r, c) {
    for (c = c && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var u = e, x = t, v = a, j = r, F = x.flags;
      switch (x.tag) {
        case 0:
        case 11:
        case 15:
          hs(
            u,
            x,
            v,
            j,
            c
          ), br(8, x);
          break;
        case 23:
          break;
        case 22:
          var U = x.stateNode;
          x.memoizedState !== null ? U._visibility & 2 ? hs(
            u,
            x,
            v,
            j,
            c
          ) : wr(
            u,
            x
          ) : (U._visibility |= 2, hs(
            u,
            x,
            v,
            j,
            c
          )), c && F & 2048 && id(
            x.alternate,
            x
          );
          break;
        case 24:
          hs(
            u,
            x,
            v,
            j,
            c
          ), c && F & 2048 && sd(x.alternate, x);
          break;
        default:
          hs(
            u,
            x,
            v,
            j,
            c
          );
      }
      t = t.sibling;
    }
  }
  function wr(e, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var a = e, r = t, c = r.flags;
        switch (r.tag) {
          case 22:
            wr(a, r), c & 2048 && id(
              r.alternate,
              r
            );
            break;
          case 24:
            wr(a, r), c & 2048 && sd(r.alternate, r);
            break;
          default:
            wr(a, r);
        }
        t = t.sibling;
      }
  }
  var jr = 8192;
  function fs(e, t, a) {
    if (e.subtreeFlags & jr)
      for (e = e.child; e !== null; )
        Rg(
          e,
          t,
          a
        ), e = e.sibling;
  }
  function Rg(e, t, a) {
    switch (e.tag) {
      case 26:
        fs(
          e,
          t,
          a
        ), e.flags & jr && e.memoizedState !== null && sj(
          a,
          Cn,
          e.memoizedState,
          e.memoizedProps
        );
        break;
      case 5:
        fs(
          e,
          t,
          a
        );
        break;
      case 3:
      case 4:
        var r = Cn;
        Cn = xo(e.stateNode.containerInfo), fs(
          e,
          t,
          a
        ), Cn = r;
        break;
      case 22:
        e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = jr, jr = 16777216, fs(
          e,
          t,
          a
        ), jr = r) : fs(
          e,
          t,
          a
        ));
        break;
      default:
        fs(
          e,
          t,
          a
        );
    }
  }
  function _g(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do
        t = e.sibling, e.sibling = null, e = t;
      while (e !== null);
    }
  }
  function Sr(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          ht = r, Fg(
            r,
            e
          );
        }
      _g(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Dg(e), e = e.sibling;
  }
  function Dg(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Sr(e), e.flags & 2048 && ka(9, e, e.return);
        break;
      case 3:
        Sr(e);
        break;
      case 12:
        Sr(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, ao(e)) : Sr(e);
        break;
      default:
        Sr(e);
    }
  }
  function ao(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          ht = r, Fg(
            r,
            e
          );
        }
      _g(e);
    }
    for (e = e.child; e !== null; ) {
      switch (t = e, t.tag) {
        case 0:
        case 11:
        case 15:
          ka(8, t, t.return), ao(t);
          break;
        case 22:
          a = t.stateNode, a._visibility & 2 && (a._visibility &= -3, ao(t));
          break;
        default:
          ao(t);
      }
      e = e.sibling;
    }
  }
  function Fg(e, t) {
    for (; ht !== null; ) {
      var a = ht;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          ka(8, a, t);
          break;
        case 23:
        case 22:
          if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
            var r = a.memoizedState.cachePool.pool;
            r != null && r.refCount++;
          }
          break;
        case 24:
          rr(a.memoizedState.cache);
      }
      if (r = a.child, r !== null) r.return = a, ht = r;
      else
        e: for (a = e; ht !== null; ) {
          r = ht;
          var c = r.sibling, u = r.return;
          if (Ag(r), r === a) {
            ht = null;
            break e;
          }
          if (c !== null) {
            c.return = u, ht = c;
            break e;
          }
          ht = u;
        }
    }
  }
  var v2 = {
    getCacheForType: function(e) {
      var t = gt(nt), a = t.data.get(e);
      return a === void 0 && (a = e(), t.data.set(e, a)), a;
    },
    cacheSignal: function() {
      return gt(nt).controller.signal;
    }
  }, w2 = typeof WeakMap == "function" ? WeakMap : Map, Fe = 0, qe = null, Ce = null, Me = 0, Ve = 0, Jt = null, Ma = !1, ms = !1, rd = !1, ca = 0, We = 0, za = 0, vi = 0, ld = 0, en = 0, ps = 0, Nr = null, Pt = null, od = !1, io = 0, Bg = 0, so = 1 / 0, ro = null, Oa = null, lt = 0, Ra = null, gs = null, ua = 0, cd = 0, ud = null, Vg = null, Tr = 0, dd = null;
  function tn() {
    return (Fe & 2) !== 0 && Me !== 0 ? Me & -Me : O.T !== null ? xd() : zc();
  }
  function Hg() {
    if (en === 0)
      if ((Me & 536870912) === 0 || Re) {
        var e = Vi;
        Vi <<= 1, (Vi & 3932160) === 0 && (Vi = 262144), en = e;
      } else en = 536870912;
    return e = $t.current, e !== null && (e.flags |= 32), en;
  }
  function qt(e, t, a) {
    (e === qe && (Ve === 2 || Ve === 9) || e.cancelPendingCommit !== null) && (xs(e, 0), _a(
      e,
      Me,
      en,
      !1
    )), Ke(e, a), ((Fe & 2) === 0 || e !== qe) && (e === qe && ((Fe & 2) === 0 && (vi |= a), We === 4 && _a(
      e,
      Me,
      en,
      !1
    )), Hn(e));
  }
  function Ug(e, t, a) {
    if ((Fe & 6) !== 0) throw Error(o(327));
    var r = !a && (t & 127) === 0 && (t & e.expiredLanes) === 0 || Ze(e, t), c = r ? N2(e, t) : fd(e, t, !0), u = r;
    do {
      if (c === 0) {
        ms && !r && _a(e, t, 0, !1);
        break;
      } else {
        if (a = e.current.alternate, u && !j2(a)) {
          c = fd(e, t, !1), u = !1;
          continue;
        }
        if (c === 2) {
          if (u = t, e.errorRecoveryDisabledLanes & u)
            var x = 0;
          else
            x = e.pendingLanes & -536870913, x = x !== 0 ? x : x & 536870912 ? 536870912 : 0;
          if (x !== 0) {
            t = x;
            e: {
              var v = e;
              c = Nr;
              var j = v.current.memoizedState.isDehydrated;
              if (j && (xs(v, x).flags |= 256), x = fd(
                v,
                x,
                !1
              ), x !== 2) {
                if (rd && !j) {
                  v.errorRecoveryDisabledLanes |= u, vi |= u, c = 4;
                  break e;
                }
                u = Pt, Pt = c, u !== null && (Pt === null ? Pt = u : Pt.push.apply(
                  Pt,
                  u
                ));
              }
              c = x;
            }
            if (u = !1, c !== 2) continue;
          }
        }
        if (c === 1) {
          xs(e, 0), _a(e, t, 0, !0);
          break;
        }
        e: {
          switch (r = e, u = c, u) {
            case 0:
            case 1:
              throw Error(o(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              _a(
                r,
                t,
                en,
                !Ma
              );
              break e;
            case 2:
              Pt = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(o(329));
          }
          if ((t & 62914560) === t && (c = io + 300 - Et(), 10 < c)) {
            if (_a(
              r,
              t,
              en,
              !Ma
            ), xe(r, 0, !0) !== 0) break e;
            ua = t, r.timeoutHandle = xx(
              Lg.bind(
                null,
                r,
                a,
                Pt,
                ro,
                od,
                t,
                en,
                vi,
                ps,
                Ma,
                u,
                "Throttled",
                -0,
                0
              ),
              c
            );
            break e;
          }
          Lg(
            r,
            a,
            Pt,
            ro,
            od,
            t,
            en,
            vi,
            ps,
            Ma,
            u,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Hn(e);
  }
  function Lg(e, t, a, r, c, u, x, v, j, F, U, I, B, H) {
    if (e.timeoutHandle = -1, I = t.subtreeFlags, I & 8192 || (I & 16785408) === 16785408) {
      I = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Xn
      }, Rg(
        t,
        u,
        I
      );
      var ce = (u & 62914560) === u ? io - Et() : (u & 4194048) === u ? Bg - Et() : 0;
      if (ce = rj(
        I,
        ce
      ), ce !== null) {
        ua = u, e.cancelPendingCommit = ce(
          Xg.bind(
            null,
            e,
            t,
            u,
            a,
            r,
            c,
            x,
            v,
            j,
            U,
            I,
            null,
            B,
            H
          )
        ), _a(e, u, x, !F);
        return;
      }
    }
    Xg(
      e,
      t,
      u,
      a,
      r,
      c,
      x,
      v,
      j
    );
  }
  function j2(e) {
    for (var t = e; ; ) {
      var a = t.tag;
      if ((a === 0 || a === 11 || a === 15) && t.flags & 16384 && (a = t.updateQueue, a !== null && (a = a.stores, a !== null)))
        for (var r = 0; r < a.length; r++) {
          var c = a[r], u = c.getSnapshot;
          c = c.value;
          try {
            if (!Xt(u(), c)) return !1;
          } catch {
            return !1;
          }
        }
      if (a = t.child, t.subtreeFlags & 16384 && a !== null)
        a.return = t, t = a;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function _a(e, t, a, r) {
    t &= ~ld, t &= ~vi, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
    for (var c = t; 0 < c; ) {
      var u = 31 - jt(c), x = 1 << u;
      r[u] = -1, c &= ~x;
    }
    a !== 0 && ai(e, a, t);
  }
  function lo() {
    return (Fe & 6) === 0 ? (Ar(0), !1) : !0;
  }
  function hd() {
    if (Ce !== null) {
      if (Ve === 0)
        var e = Ce.return;
      else
        e = Ce, Jn = di = null, Eu(e), ls = null, or = 0, e = Ce;
      for (; e !== null; )
        yg(e.alternate, e), e = e.return;
      Ce = null;
    }
  }
  function xs(e, t) {
    var a = e.timeoutHandle;
    a !== -1 && (e.timeoutHandle = -1, P2(a)), a = e.cancelPendingCommit, a !== null && (e.cancelPendingCommit = null, a()), ua = 0, hd(), qe = e, Ce = a = $n(e.current, null), Me = t, Ve = 0, Jt = null, Ma = !1, ms = Ze(e, t), rd = !1, ps = en = ld = vi = za = We = 0, Pt = Nr = null, od = !1, (t & 8) !== 0 && (t |= t & 32);
    var r = e.entangledLanes;
    if (r !== 0)
      for (e = e.entanglements, r &= t; 0 < r; ) {
        var c = 31 - jt(r), u = 1 << c;
        t |= e[c], r &= ~u;
      }
    return ca = t, El(), a;
  }
  function Pg(e, t) {
    we = null, O.H = gr, t === rs || t === Fl ? (t = ip(), Ve = 3) : t === gu ? (t = ip(), Ve = 4) : Ve = t === Iu ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, Jt = t, Ce === null && (We = 1, Kl(
      e,
      dn(t, e.current)
    ));
  }
  function qg() {
    var e = $t.current;
    return e === null ? !0 : (Me & 4194048) === Me ? pn === null : (Me & 62914560) === Me || (Me & 536870912) !== 0 ? e === pn : !1;
  }
  function Ig() {
    var e = O.H;
    return O.H = gr, e === null ? gr : e;
  }
  function Gg() {
    var e = O.A;
    return O.A = v2, e;
  }
  function oo() {
    We = 4, Ma || (Me & 4194048) !== Me && $t.current !== null || (ms = !0), (za & 134217727) === 0 && (vi & 134217727) === 0 || qe === null || _a(
      qe,
      Me,
      en,
      !1
    );
  }
  function fd(e, t, a) {
    var r = Fe;
    Fe |= 2;
    var c = Ig(), u = Gg();
    (qe !== e || Me !== t) && (ro = null, xs(e, t)), t = !1;
    var x = We;
    e: do
      try {
        if (Ve !== 0 && Ce !== null) {
          var v = Ce, j = Jt;
          switch (Ve) {
            case 8:
              hd(), x = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              $t.current === null && (t = !0);
              var F = Ve;
              if (Ve = 0, Jt = null, ys(e, v, j, F), a && ms) {
                x = 0;
                break e;
              }
              break;
            default:
              F = Ve, Ve = 0, Jt = null, ys(e, v, j, F);
          }
        }
        S2(), x = We;
        break;
      } catch (U) {
        Pg(e, U);
      }
    while (!0);
    return t && e.shellSuspendCounter++, Jn = di = null, Fe = r, O.H = c, O.A = u, Ce === null && (qe = null, Me = 0, El()), x;
  }
  function S2() {
    for (; Ce !== null; ) Yg(Ce);
  }
  function N2(e, t) {
    var a = Fe;
    Fe |= 2;
    var r = Ig(), c = Gg();
    qe !== e || Me !== t ? (ro = null, so = Et() + 500, xs(e, t)) : ms = Ze(
      e,
      t
    );
    e: do
      try {
        if (Ve !== 0 && Ce !== null) {
          t = Ce;
          var u = Jt;
          t: switch (Ve) {
            case 1:
              Ve = 0, Jt = null, ys(e, t, u, 1);
              break;
            case 2:
            case 9:
              if (np(u)) {
                Ve = 0, Jt = null, Qg(t);
                break;
              }
              t = function() {
                Ve !== 2 && Ve !== 9 || qe !== e || (Ve = 7), Hn(e);
              }, u.then(t, t);
              break e;
            case 3:
              Ve = 7;
              break e;
            case 4:
              Ve = 5;
              break e;
            case 7:
              np(u) ? (Ve = 0, Jt = null, Qg(t)) : (Ve = 0, Jt = null, ys(e, t, u, 7));
              break;
            case 5:
              var x = null;
              switch (Ce.tag) {
                case 26:
                  x = Ce.memoizedState;
                case 5:
                case 27:
                  var v = Ce;
                  if (x ? Ox(x) : v.stateNode.complete) {
                    Ve = 0, Jt = null;
                    var j = v.sibling;
                    if (j !== null) Ce = j;
                    else {
                      var F = v.return;
                      F !== null ? (Ce = F, co(F)) : Ce = null;
                    }
                    break t;
                  }
              }
              Ve = 0, Jt = null, ys(e, t, u, 5);
              break;
            case 6:
              Ve = 0, Jt = null, ys(e, t, u, 6);
              break;
            case 8:
              hd(), We = 6;
              break e;
            default:
              throw Error(o(462));
          }
        }
        T2();
        break;
      } catch (U) {
        Pg(e, U);
      }
    while (!0);
    return Jn = di = null, O.H = r, O.A = c, Fe = a, Ce !== null ? 0 : (qe = null, Me = 0, El(), We);
  }
  function T2() {
    for (; Ce !== null && !Ct(); )
      Yg(Ce);
  }
  function Yg(e) {
    var t = gg(e.alternate, e, ca);
    e.memoizedProps = e.pendingProps, t === null ? co(e) : Ce = t;
  }
  function Qg(e) {
    var t = e, a = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = ug(
          a,
          t,
          t.pendingProps,
          t.type,
          void 0,
          Me
        );
        break;
      case 11:
        t = ug(
          a,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          Me
        );
        break;
      case 5:
        Eu(t);
      default:
        yg(a, t), t = Ce = Gm(t, ca), t = gg(a, t, ca);
    }
    e.memoizedProps = e.pendingProps, t === null ? co(e) : Ce = t;
  }
  function ys(e, t, a, r) {
    Jn = di = null, Eu(t), ls = null, or = 0;
    var c = t.return;
    try {
      if (f2(
        e,
        c,
        t,
        a,
        Me
      )) {
        We = 1, Kl(
          e,
          dn(a, e.current)
        ), Ce = null;
        return;
      }
    } catch (u) {
      if (c !== null) throw Ce = c, u;
      We = 1, Kl(
        e,
        dn(a, e.current)
      ), Ce = null;
      return;
    }
    t.flags & 32768 ? (Re || r === 1 ? e = !0 : ms || (Me & 536870912) !== 0 ? e = !1 : (Ma = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = $t.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Zg(t, e)) : co(t);
  }
  function co(e) {
    var t = e;
    do {
      if ((t.flags & 32768) !== 0) {
        Zg(
          t,
          Ma
        );
        return;
      }
      e = t.return;
      var a = g2(
        t.alternate,
        t,
        ca
      );
      if (a !== null) {
        Ce = a;
        return;
      }
      if (t = t.sibling, t !== null) {
        Ce = t;
        return;
      }
      Ce = t = e;
    } while (t !== null);
    We === 0 && (We = 5);
  }
  function Zg(e, t) {
    do {
      var a = x2(e.alternate, e);
      if (a !== null) {
        a.flags &= 32767, Ce = a;
        return;
      }
      if (a = e.return, a !== null && (a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null), !t && (e = e.sibling, e !== null)) {
        Ce = e;
        return;
      }
      Ce = e = a;
    } while (e !== null);
    We = 6, Ce = null;
  }
  function Xg(e, t, a, r, c, u, x, v, j) {
    e.cancelPendingCommit = null;
    do
      uo();
    while (lt !== 0);
    if ((Fe & 6) !== 0) throw Error(o(327));
    if (t !== null) {
      if (t === e.current) throw Error(o(177));
      if (u = t.lanes | t.childLanes, u |= tu, _t(
        e,
        a,
        u,
        x,
        v,
        j
      ), e === qe && (Ce = qe = null, Me = 0), gs = t, Ra = e, ua = a, cd = u, ud = c, Vg = r, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, k2(ei, function() {
        return ex(), null;
      })) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || r) {
        r = O.T, O.T = null, c = X.p, X.p = 2, x = Fe, Fe |= 4;
        try {
          y2(e, t, a);
        } finally {
          Fe = x, X.p = c, O.T = r;
        }
      }
      lt = 1, Kg(), $g(), Wg();
    }
  }
  function Kg() {
    if (lt === 1) {
      lt = 0;
      var e = Ra, t = gs, a = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || a) {
        a = O.T, O.T = null;
        var r = X.p;
        X.p = 2;
        var c = Fe;
        Fe |= 4;
        try {
          Mg(t, e);
          var u = Td, x = Fm(e.containerInfo), v = u.focusedElem, j = u.selectionRange;
          if (x !== v && v && v.ownerDocument && Dm(
            v.ownerDocument.documentElement,
            v
          )) {
            if (j !== null && Kc(v)) {
              var F = j.start, U = j.end;
              if (U === void 0 && (U = F), "selectionStart" in v)
                v.selectionStart = F, v.selectionEnd = Math.min(
                  U,
                  v.value.length
                );
              else {
                var I = v.ownerDocument || document, B = I && I.defaultView || window;
                if (B.getSelection) {
                  var H = B.getSelection(), ce = v.textContent.length, pe = Math.min(j.start, ce), Pe = j.end === void 0 ? pe : Math.min(j.end, ce);
                  !H.extend && pe > Pe && (x = Pe, Pe = pe, pe = x);
                  var M = _m(
                    v,
                    pe
                  ), A = _m(
                    v,
                    Pe
                  );
                  if (M && A && (H.rangeCount !== 1 || H.anchorNode !== M.node || H.anchorOffset !== M.offset || H.focusNode !== A.node || H.focusOffset !== A.offset)) {
                    var D = I.createRange();
                    D.setStart(M.node, M.offset), H.removeAllRanges(), pe > Pe ? (H.addRange(D), H.extend(A.node, A.offset)) : (D.setEnd(A.node, A.offset), H.addRange(D));
                  }
                }
              }
            }
            for (I = [], H = v; H = H.parentNode; )
              H.nodeType === 1 && I.push({
                element: H,
                left: H.scrollLeft,
                top: H.scrollTop
              });
            for (typeof v.focus == "function" && v.focus(), v = 0; v < I.length; v++) {
              var q = I[v];
              q.element.scrollLeft = q.left, q.element.scrollTop = q.top;
            }
          }
          So = !!Nd, Td = Nd = null;
        } finally {
          Fe = c, X.p = r, O.T = a;
        }
      }
      e.current = t, lt = 2;
    }
  }
  function $g() {
    if (lt === 2) {
      lt = 0;
      var e = Ra, t = gs, a = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || a) {
        a = O.T, O.T = null;
        var r = X.p;
        X.p = 2;
        var c = Fe;
        Fe |= 4;
        try {
          Tg(e, t.alternate, t);
        } finally {
          Fe = c, X.p = r, O.T = a;
        }
      }
      lt = 3;
    }
  }
  function Wg() {
    if (lt === 4 || lt === 3) {
      lt = 0, pa();
      var e = Ra, t = gs, a = ua, r = Vg;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? lt = 5 : (lt = 0, gs = Ra = null, Jg(e, e.pendingLanes));
      var c = e.pendingLanes;
      if (c === 0 && (Oa = null), Tn(a), t = t.stateNode, kt && typeof kt.onCommitFiberRoot == "function")
        try {
          kt.onCommitFiberRoot(
            ti,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (r !== null) {
        t = O.T, c = X.p, X.p = 2, O.T = null;
        try {
          for (var u = e.onRecoverableError, x = 0; x < r.length; x++) {
            var v = r[x];
            u(v.value, {
              componentStack: v.stack
            });
          }
        } finally {
          O.T = t, X.p = c;
        }
      }
      (ua & 3) !== 0 && uo(), Hn(e), c = e.pendingLanes, (a & 261930) !== 0 && (c & 42) !== 0 ? e === dd ? Tr++ : (Tr = 0, dd = e) : Tr = 0, Ar(0);
    }
  }
  function Jg(e, t) {
    (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, rr(t)));
  }
  function uo() {
    return Kg(), $g(), Wg(), ex();
  }
  function ex() {
    if (lt !== 5) return !1;
    var e = Ra, t = cd;
    cd = 0;
    var a = Tn(ua), r = O.T, c = X.p;
    try {
      X.p = 32 > a ? 32 : a, O.T = null, a = ud, ud = null;
      var u = Ra, x = ua;
      if (lt = 0, gs = Ra = null, ua = 0, (Fe & 6) !== 0) throw Error(o(331));
      var v = Fe;
      if (Fe |= 4, Dg(u.current), Og(
        u,
        u.current,
        x,
        a
      ), Fe = v, Ar(0, !1), kt && typeof kt.onPostCommitFiberRoot == "function")
        try {
          kt.onPostCommitFiberRoot(ti, u);
        } catch {
        }
      return !0;
    } finally {
      X.p = c, O.T = r, Jg(e, t);
    }
  }
  function tx(e, t, a) {
    t = dn(a, t), t = qu(e.stateNode, t, 2), e = Aa(e, t, 2), e !== null && (Ke(e, 2), Hn(e));
  }
  function He(e, t, a) {
    if (e.tag === 3)
      tx(e, e, a);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          tx(
            t,
            e,
            a
          );
          break;
        } else if (t.tag === 1) {
          var r = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (Oa === null || !Oa.has(r))) {
            e = dn(a, e), a = ng(2), r = Aa(t, a, 2), r !== null && (ag(
              a,
              r,
              t,
              e
            ), Ke(r, 2), Hn(r));
            break;
          }
        }
        t = t.return;
      }
  }
  function md(e, t, a) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new w2();
      var c = /* @__PURE__ */ new Set();
      r.set(t, c);
    } else
      c = r.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), r.set(t, c));
    c.has(a) || (rd = !0, c.add(a), e = A2.bind(null, e, t, a), t.then(e, e));
  }
  function A2(e, t, a) {
    var r = e.pingCache;
    r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & a, e.warmLanes &= ~a, qe === e && (Me & a) === a && (We === 4 || We === 3 && (Me & 62914560) === Me && 300 > Et() - io ? (Fe & 2) === 0 && xs(e, 0) : ld |= a, ps === Me && (ps = 0)), Hn(e);
  }
  function nx(e, t) {
    t === 0 && (t = St()), e = oi(e, t), e !== null && (Ke(e, t), Hn(e));
  }
  function C2(e) {
    var t = e.memoizedState, a = 0;
    t !== null && (a = t.retryLane), nx(e, a);
  }
  function E2(e, t) {
    var a = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var r = e.stateNode, c = e.memoizedState;
        c !== null && (a = c.retryLane);
        break;
      case 19:
        r = e.stateNode;
        break;
      case 22:
        r = e.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    r !== null && r.delete(t), nx(e, a);
  }
  function k2(e, t) {
    return qs(e, t);
  }
  var ho = null, bs = null, pd = !1, fo = !1, gd = !1, Da = 0;
  function Hn(e) {
    e !== bs && e.next === null && (bs === null ? ho = bs = e : bs = bs.next = e), fo = !0, pd || (pd = !0, z2());
  }
  function Ar(e, t) {
    if (!gd && fo) {
      gd = !0;
      do
        for (var a = !1, r = ho; r !== null; ) {
          if (e !== 0) {
            var c = r.pendingLanes;
            if (c === 0) var u = 0;
            else {
              var x = r.suspendedLanes, v = r.pingedLanes;
              u = (1 << 31 - jt(42 | e) + 1) - 1, u &= c & ~(x & ~v), u = u & 201326741 ? u & 201326741 | 1 : u ? u | 2 : 0;
            }
            u !== 0 && (a = !0, rx(r, u));
          } else
            u = Me, u = xe(
              r,
              r === qe ? u : 0,
              r.cancelPendingCommit !== null || r.timeoutHandle !== -1
            ), (u & 3) === 0 || Ze(r, u) || (a = !0, rx(r, u));
          r = r.next;
        }
      while (a);
      gd = !1;
    }
  }
  function M2() {
    ax();
  }
  function ax() {
    fo = pd = !1;
    var e = 0;
    Da !== 0 && L2() && (e = Da);
    for (var t = Et(), a = null, r = ho; r !== null; ) {
      var c = r.next, u = ix(r, t);
      u === 0 ? (r.next = null, a === null ? ho = c : a.next = c, c === null && (bs = a)) : (a = r, (e !== 0 || (u & 3) !== 0) && (fo = !0)), r = c;
    }
    lt !== 0 && lt !== 5 || Ar(e), Da !== 0 && (Da = 0);
  }
  function ix(e, t) {
    for (var a = e.suspendedLanes, r = e.pingedLanes, c = e.expirationTimes, u = e.pendingLanes & -62914561; 0 < u; ) {
      var x = 31 - jt(u), v = 1 << x, j = c[x];
      j === -1 ? ((v & a) === 0 || (v & r) !== 0) && (c[x] = ut(v, t)) : j <= t && (e.expiredLanes |= v), u &= ~v;
    }
    if (t = qe, a = Me, a = xe(
      e,
      e === t ? a : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), r = e.callbackNode, a === 0 || e === t && (Ve === 2 || Ve === 9) || e.cancelPendingCommit !== null)
      return r !== null && r !== null && Is(r), e.callbackNode = null, e.callbackPriority = 0;
    if ((a & 3) === 0 || Ze(e, a)) {
      if (t = a & -a, t === e.callbackPriority) return t;
      switch (r !== null && Is(r), Tn(a)) {
        case 2:
        case 8:
          a = pl;
          break;
        case 32:
          a = ei;
          break;
        case 268435456:
          a = Qn;
          break;
        default:
          a = ei;
      }
      return r = sx.bind(null, e), a = qs(a, r), e.callbackPriority = t, e.callbackNode = a, t;
    }
    return r !== null && r !== null && Is(r), e.callbackPriority = 2, e.callbackNode = null, 2;
  }
  function sx(e, t) {
    if (lt !== 0 && lt !== 5)
      return e.callbackNode = null, e.callbackPriority = 0, null;
    var a = e.callbackNode;
    if (uo() && e.callbackNode !== a)
      return null;
    var r = Me;
    return r = xe(
      e,
      e === qe ? r : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), r === 0 ? null : (Ug(e, r, t), ix(e, Et()), e.callbackNode != null && e.callbackNode === a ? sx.bind(null, e) : null);
  }
  function rx(e, t) {
    if (uo()) return null;
    Ug(e, t, !0);
  }
  function z2() {
    q2(function() {
      (Fe & 6) !== 0 ? qs(
        Ja,
        M2
      ) : ax();
    });
  }
  function xd() {
    if (Da === 0) {
      var e = is;
      e === 0 && (e = Bi, Bi <<= 1, (Bi & 261888) === 0 && (Bi = 256)), Da = e;
    }
    return Da;
  }
  function lx(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : vl("" + e);
  }
  function ox(e, t) {
    var a = t.ownerDocument.createElement("input");
    return a.name = t.name, a.value = t.value, e.id && a.setAttribute("form", e.id), t.parentNode.insertBefore(a, t), e = new FormData(e), a.parentNode.removeChild(a), e;
  }
  function O2(e, t, a, r, c) {
    if (t === "submit" && a && a.stateNode === c) {
      var u = lx(
        (c[Bt] || null).action
      ), x = r.submitter;
      x && (t = (t = x[Bt] || null) ? lx(t.formAction) : x.getAttribute("formAction"), t !== null && (u = t, x = null));
      var v = new Nl(
        "action",
        "action",
        null,
        r,
        c
      );
      e.push({
        event: v,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (r.defaultPrevented) {
                if (Da !== 0) {
                  var j = x ? ox(c, x) : new FormData(c);
                  Bu(
                    a,
                    {
                      pending: !0,
                      data: j,
                      method: c.method,
                      action: u
                    },
                    null,
                    j
                  );
                }
              } else
                typeof u == "function" && (v.preventDefault(), j = x ? ox(c, x) : new FormData(c), Bu(
                  a,
                  {
                    pending: !0,
                    data: j,
                    method: c.method,
                    action: u
                  },
                  u,
                  j
                ));
            },
            currentTarget: c
          }
        ]
      });
    }
  }
  for (var yd = 0; yd < eu.length; yd++) {
    var bd = eu[yd], R2 = bd.toLowerCase(), _2 = bd[0].toUpperCase() + bd.slice(1);
    An(
      R2,
      "on" + _2
    );
  }
  An(Hm, "onAnimationEnd"), An(Um, "onAnimationIteration"), An(Lm, "onAnimationStart"), An("dblclick", "onDoubleClick"), An("focusin", "onFocus"), An("focusout", "onBlur"), An(Kw, "onTransitionRun"), An($w, "onTransitionStart"), An(Ww, "onTransitionCancel"), An(Pm, "onTransitionEnd"), Ii("onMouseEnter", ["mouseout", "mouseover"]), Ii("onMouseLeave", ["mouseout", "mouseover"]), Ii("onPointerEnter", ["pointerout", "pointerover"]), Ii("onPointerLeave", ["pointerout", "pointerover"]), ii(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), ii(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), ii("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), ii(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), ii(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), ii(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Cr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), D2 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Cr)
  );
  function cx(e, t) {
    t = (t & 4) !== 0;
    for (var a = 0; a < e.length; a++) {
      var r = e[a], c = r.event;
      r = r.listeners;
      e: {
        var u = void 0;
        if (t)
          for (var x = r.length - 1; 0 <= x; x--) {
            var v = r[x], j = v.instance, F = v.currentTarget;
            if (v = v.listener, j !== u && c.isPropagationStopped())
              break e;
            u = v, c.currentTarget = F;
            try {
              u(c);
            } catch (U) {
              Cl(U);
            }
            c.currentTarget = null, u = j;
          }
        else
          for (x = 0; x < r.length; x++) {
            if (v = r[x], j = v.instance, F = v.currentTarget, v = v.listener, j !== u && c.isPropagationStopped())
              break e;
            u = v, c.currentTarget = F;
            try {
              u(c);
            } catch (U) {
              Cl(U);
            }
            c.currentTarget = null, u = j;
          }
      }
    }
  }
  function Ee(e, t) {
    var a = t[Oc];
    a === void 0 && (a = t[Oc] = /* @__PURE__ */ new Set());
    var r = e + "__bubble";
    a.has(r) || (ux(t, e, 2, !1), a.add(r));
  }
  function vd(e, t, a) {
    var r = 0;
    t && (r |= 4), ux(
      a,
      e,
      r,
      t
    );
  }
  var mo = "_reactListening" + Math.random().toString(36).slice(2);
  function wd(e) {
    if (!e[mo]) {
      e[mo] = !0, am.forEach(function(a) {
        a !== "selectionchange" && (D2.has(a) || vd(a, !1, e), vd(a, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[mo] || (t[mo] = !0, vd("selectionchange", !1, t));
    }
  }
  function ux(e, t, a, r) {
    switch (Hx(t)) {
      case 2:
        var c = cj;
        break;
      case 8:
        c = uj;
        break;
      default:
        c = Fd;
    }
    a = c.bind(
      null,
      t,
      a,
      e
    ), c = void 0, !Lc || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (c = !0), r ? c !== void 0 ? e.addEventListener(t, a, {
      capture: !0,
      passive: c
    }) : e.addEventListener(t, a, !0) : c !== void 0 ? e.addEventListener(t, a, {
      passive: c
    }) : e.addEventListener(t, a, !1);
  }
  function jd(e, t, a, r, c) {
    var u = r;
    if ((t & 1) === 0 && (t & 2) === 0 && r !== null)
      e: for (; ; ) {
        if (r === null) return;
        var x = r.tag;
        if (x === 3 || x === 4) {
          var v = r.stateNode.containerInfo;
          if (v === c) break;
          if (x === 4)
            for (x = r.return; x !== null; ) {
              var j = x.tag;
              if ((j === 3 || j === 4) && x.stateNode.containerInfo === c)
                return;
              x = x.return;
            }
          for (; v !== null; ) {
            if (x = Li(v), x === null) return;
            if (j = x.tag, j === 5 || j === 6 || j === 26 || j === 27) {
              r = u = x;
              continue e;
            }
            v = v.parentNode;
          }
        }
        r = r.return;
      }
    pm(function() {
      var F = u, U = Hc(a), I = [];
      e: {
        var B = qm.get(e);
        if (B !== void 0) {
          var H = Nl, ce = e;
          switch (e) {
            case "keypress":
              if (jl(a) === 0) break e;
            case "keydown":
            case "keyup":
              H = Ew;
              break;
            case "focusin":
              ce = "focus", H = Gc;
              break;
            case "focusout":
              ce = "blur", H = Gc;
              break;
            case "beforeblur":
            case "afterblur":
              H = Gc;
              break;
            case "click":
              if (a.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              H = ym;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              H = gw;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              H = zw;
              break;
            case Hm:
            case Um:
            case Lm:
              H = bw;
              break;
            case Pm:
              H = Rw;
              break;
            case "scroll":
            case "scrollend":
              H = mw;
              break;
            case "wheel":
              H = Dw;
              break;
            case "copy":
            case "cut":
            case "paste":
              H = ww;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              H = vm;
              break;
            case "toggle":
            case "beforetoggle":
              H = Bw;
          }
          var pe = (t & 4) !== 0, Pe = !pe && (e === "scroll" || e === "scrollend"), M = pe ? B !== null ? B + "Capture" : null : B;
          pe = [];
          for (var A = F, D; A !== null; ) {
            var q = A;
            if (D = q.stateNode, q = q.tag, q !== 5 && q !== 26 && q !== 27 || D === null || M === null || (q = Xs(A, M), q != null && pe.push(
              Er(A, q, D)
            )), Pe) break;
            A = A.return;
          }
          0 < pe.length && (B = new H(
            B,
            ce,
            null,
            a,
            U
          ), I.push({ event: B, listeners: pe }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (B = e === "mouseover" || e === "pointerover", H = e === "mouseout" || e === "pointerout", B && a !== Vc && (ce = a.relatedTarget || a.fromElement) && (Li(ce) || ce[Ui]))
            break e;
          if ((H || B) && (B = U.window === U ? U : (B = U.ownerDocument) ? B.defaultView || B.parentWindow : window, H ? (ce = a.relatedTarget || a.toElement, H = F, ce = ce ? Li(ce) : null, ce !== null && (Pe = f(ce), pe = ce.tag, ce !== Pe || pe !== 5 && pe !== 27 && pe !== 6) && (ce = null)) : (H = null, ce = F), H !== ce)) {
            if (pe = ym, q = "onMouseLeave", M = "onMouseEnter", A = "mouse", (e === "pointerout" || e === "pointerover") && (pe = vm, q = "onPointerLeave", M = "onPointerEnter", A = "pointer"), Pe = H == null ? B : Zs(H), D = ce == null ? B : Zs(ce), B = new pe(
              q,
              A + "leave",
              H,
              a,
              U
            ), B.target = Pe, B.relatedTarget = D, q = null, Li(U) === F && (pe = new pe(
              M,
              A + "enter",
              ce,
              a,
              U
            ), pe.target = D, pe.relatedTarget = Pe, q = pe), Pe = q, H && ce)
              t: {
                for (pe = F2, M = H, A = ce, D = 0, q = M; q; q = pe(q))
                  D++;
                q = 0;
                for (var fe = A; fe; fe = pe(fe))
                  q++;
                for (; 0 < D - q; )
                  M = pe(M), D--;
                for (; 0 < q - D; )
                  A = pe(A), q--;
                for (; D--; ) {
                  if (M === A || A !== null && M === A.alternate) {
                    pe = M;
                    break t;
                  }
                  M = pe(M), A = pe(A);
                }
                pe = null;
              }
            else pe = null;
            H !== null && dx(
              I,
              B,
              H,
              pe,
              !1
            ), ce !== null && Pe !== null && dx(
              I,
              Pe,
              ce,
              pe,
              !0
            );
          }
        }
        e: {
          if (B = F ? Zs(F) : window, H = B.nodeName && B.nodeName.toLowerCase(), H === "select" || H === "input" && B.type === "file")
            var _e = Em;
          else if (Am(B))
            if (km)
              _e = Qw;
            else {
              _e = Gw;
              var de = Iw;
            }
          else
            H = B.nodeName, !H || H.toLowerCase() !== "input" || B.type !== "checkbox" && B.type !== "radio" ? F && Bc(F.elementType) && (_e = Em) : _e = Yw;
          if (_e && (_e = _e(e, F))) {
            Cm(
              I,
              _e,
              a,
              U
            );
            break e;
          }
          de && de(e, B, F), e === "focusout" && F && B.type === "number" && F.memoizedProps.value != null && Fc(B, "number", B.value);
        }
        switch (de = F ? Zs(F) : window, e) {
          case "focusin":
            (Am(de) || de.contentEditable === "true") && (Ki = de, $c = F, ar = null);
            break;
          case "focusout":
            ar = $c = Ki = null;
            break;
          case "mousedown":
            Wc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Wc = !1, Bm(I, a, U);
            break;
          case "selectionchange":
            if (Xw) break;
          case "keydown":
          case "keyup":
            Bm(I, a, U);
        }
        var Ne;
        if (Qc)
          e: {
            switch (e) {
              case "compositionstart":
                var ze = "onCompositionStart";
                break e;
              case "compositionend":
                ze = "onCompositionEnd";
                break e;
              case "compositionupdate":
                ze = "onCompositionUpdate";
                break e;
            }
            ze = void 0;
          }
        else
          Xi ? Nm(e, a) && (ze = "onCompositionEnd") : e === "keydown" && a.keyCode === 229 && (ze = "onCompositionStart");
        ze && (wm && a.locale !== "ko" && (Xi || ze !== "onCompositionStart" ? ze === "onCompositionEnd" && Xi && (Ne = gm()) : (ba = U, Pc = "value" in ba ? ba.value : ba.textContent, Xi = !0)), de = po(F, ze), 0 < de.length && (ze = new bm(
          ze,
          e,
          null,
          a,
          U
        ), I.push({ event: ze, listeners: de }), Ne ? ze.data = Ne : (Ne = Tm(a), Ne !== null && (ze.data = Ne)))), (Ne = Hw ? Uw(e, a) : Lw(e, a)) && (ze = po(F, "onBeforeInput"), 0 < ze.length && (de = new bm(
          "onBeforeInput",
          "beforeinput",
          null,
          a,
          U
        ), I.push({
          event: de,
          listeners: ze
        }), de.data = Ne)), O2(
          I,
          e,
          F,
          a,
          U
        );
      }
      cx(I, t);
    });
  }
  function Er(e, t, a) {
    return {
      instance: e,
      listener: t,
      currentTarget: a
    };
  }
  function po(e, t) {
    for (var a = t + "Capture", r = []; e !== null; ) {
      var c = e, u = c.stateNode;
      if (c = c.tag, c !== 5 && c !== 26 && c !== 27 || u === null || (c = Xs(e, a), c != null && r.unshift(
        Er(e, c, u)
      ), c = Xs(e, t), c != null && r.push(
        Er(e, c, u)
      )), e.tag === 3) return r;
      e = e.return;
    }
    return [];
  }
  function F2(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function dx(e, t, a, r, c) {
    for (var u = t._reactName, x = []; a !== null && a !== r; ) {
      var v = a, j = v.alternate, F = v.stateNode;
      if (v = v.tag, j !== null && j === r) break;
      v !== 5 && v !== 26 && v !== 27 || F === null || (j = F, c ? (F = Xs(a, u), F != null && x.unshift(
        Er(a, F, j)
      )) : c || (F = Xs(a, u), F != null && x.push(
        Er(a, F, j)
      ))), a = a.return;
    }
    x.length !== 0 && e.push({ event: t, listeners: x });
  }
  var B2 = /\r\n?/g, V2 = /\u0000|\uFFFD/g;
  function hx(e) {
    return (typeof e == "string" ? e : "" + e).replace(B2, `
`).replace(V2, "");
  }
  function fx(e, t) {
    return t = hx(t), hx(e) === t;
  }
  function Le(e, t, a, r, c, u) {
    switch (a) {
      case "children":
        typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Yi(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Yi(e, "" + r);
        break;
      case "className":
        yl(e, "class", r);
        break;
      case "tabIndex":
        yl(e, "tabindex", r);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        yl(e, a, r);
        break;
      case "style":
        fm(e, r, u);
        break;
      case "data":
        if (t !== "object") {
          yl(e, "data", r);
          break;
        }
      case "src":
      case "href":
        if (r === "" && (t !== "a" || a !== "href")) {
          e.removeAttribute(a);
          break;
        }
        if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
          e.removeAttribute(a);
          break;
        }
        r = vl("" + r), e.setAttribute(a, r);
        break;
      case "action":
      case "formAction":
        if (typeof r == "function") {
          e.setAttribute(
            a,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" && (a === "formAction" ? (t !== "input" && Le(e, t, "name", c.name, c, null), Le(
            e,
            t,
            "formEncType",
            c.formEncType,
            c,
            null
          ), Le(
            e,
            t,
            "formMethod",
            c.formMethod,
            c,
            null
          ), Le(
            e,
            t,
            "formTarget",
            c.formTarget,
            c,
            null
          )) : (Le(e, t, "encType", c.encType, c, null), Le(e, t, "method", c.method, c, null), Le(e, t, "target", c.target, c, null)));
        if (r == null || typeof r == "symbol" || typeof r == "boolean") {
          e.removeAttribute(a);
          break;
        }
        r = vl("" + r), e.setAttribute(a, r);
        break;
      case "onClick":
        r != null && (e.onclick = Xn);
        break;
      case "onScroll":
        r != null && Ee("scroll", e);
        break;
      case "onScrollEnd":
        r != null && Ee("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (r != null) {
          if (typeof r != "object" || !("__html" in r))
            throw Error(o(61));
          if (a = r.__html, a != null) {
            if (c.children != null) throw Error(o(60));
            e.innerHTML = a;
          }
        }
        break;
      case "multiple":
        e.multiple = r && typeof r != "function" && typeof r != "symbol";
        break;
      case "muted":
        e.muted = r && typeof r != "function" && typeof r != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
          e.removeAttribute("xlink:href");
          break;
        }
        a = vl("" + r), e.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          a
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, "" + r) : e.removeAttribute(a);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, "") : e.removeAttribute(a);
        break;
      case "capture":
      case "download":
        r === !0 ? e.setAttribute(a, "") : r !== !1 && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, r) : e.removeAttribute(a);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(a, r) : e.removeAttribute(a);
        break;
      case "rowSpan":
      case "start":
        r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(a) : e.setAttribute(a, r);
        break;
      case "popover":
        Ee("beforetoggle", e), Ee("toggle", e), xl(e, "popover", r);
        break;
      case "xlinkActuate":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          r
        );
        break;
      case "xlinkArcrole":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          r
        );
        break;
      case "xlinkRole":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          r
        );
        break;
      case "xlinkShow":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          r
        );
        break;
      case "xlinkTitle":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          r
        );
        break;
      case "xlinkType":
        Zn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          r
        );
        break;
      case "xmlBase":
        Zn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          r
        );
        break;
      case "xmlLang":
        Zn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          r
        );
        break;
      case "xmlSpace":
        Zn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          r
        );
        break;
      case "is":
        xl(e, "is", r);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && (a = hw.get(a) || a, xl(e, a, r));
    }
  }
  function Sd(e, t, a, r, c, u) {
    switch (a) {
      case "style":
        fm(e, r, u);
        break;
      case "dangerouslySetInnerHTML":
        if (r != null) {
          if (typeof r != "object" || !("__html" in r))
            throw Error(o(61));
          if (a = r.__html, a != null) {
            if (c.children != null) throw Error(o(60));
            e.innerHTML = a;
          }
        }
        break;
      case "children":
        typeof r == "string" ? Yi(e, r) : (typeof r == "number" || typeof r == "bigint") && Yi(e, "" + r);
        break;
      case "onScroll":
        r != null && Ee("scroll", e);
        break;
      case "onScrollEnd":
        r != null && Ee("scrollend", e);
        break;
      case "onClick":
        r != null && (e.onclick = Xn);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!im.hasOwnProperty(a))
          e: {
            if (a[0] === "o" && a[1] === "n" && (c = a.endsWith("Capture"), t = a.slice(2, c ? a.length - 7 : void 0), u = e[Bt] || null, u = u != null ? u[a] : null, typeof u == "function" && e.removeEventListener(t, u, c), typeof r == "function")) {
              typeof u != "function" && u !== null && (a in e ? e[a] = null : e.hasAttribute(a) && e.removeAttribute(a)), e.addEventListener(t, r, c);
              break e;
            }
            a in e ? e[a] = r : r === !0 ? e.setAttribute(a, "") : xl(e, a, r);
          }
    }
  }
  function yt(e, t, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ee("error", e), Ee("load", e);
        var r = !1, c = !1, u;
        for (u in a)
          if (a.hasOwnProperty(u)) {
            var x = a[u];
            if (x != null)
              switch (u) {
                case "src":
                  r = !0;
                  break;
                case "srcSet":
                  c = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(o(137, t));
                default:
                  Le(e, t, u, x, a, null);
              }
          }
        c && Le(e, t, "srcSet", a.srcSet, a, null), r && Le(e, t, "src", a.src, a, null);
        return;
      case "input":
        Ee("invalid", e);
        var v = u = x = c = null, j = null, F = null;
        for (r in a)
          if (a.hasOwnProperty(r)) {
            var U = a[r];
            if (U != null)
              switch (r) {
                case "name":
                  c = U;
                  break;
                case "type":
                  x = U;
                  break;
                case "checked":
                  j = U;
                  break;
                case "defaultChecked":
                  F = U;
                  break;
                case "value":
                  u = U;
                  break;
                case "defaultValue":
                  v = U;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (U != null)
                    throw Error(o(137, t));
                  break;
                default:
                  Le(e, t, r, U, a, null);
              }
          }
        cm(
          e,
          u,
          v,
          j,
          F,
          x,
          c,
          !1
        );
        return;
      case "select":
        Ee("invalid", e), r = x = u = null;
        for (c in a)
          if (a.hasOwnProperty(c) && (v = a[c], v != null))
            switch (c) {
              case "value":
                u = v;
                break;
              case "defaultValue":
                x = v;
                break;
              case "multiple":
                r = v;
              default:
                Le(e, t, c, v, a, null);
            }
        t = u, a = x, e.multiple = !!r, t != null ? Gi(e, !!r, t, !1) : a != null && Gi(e, !!r, a, !0);
        return;
      case "textarea":
        Ee("invalid", e), u = c = r = null;
        for (x in a)
          if (a.hasOwnProperty(x) && (v = a[x], v != null))
            switch (x) {
              case "value":
                r = v;
                break;
              case "defaultValue":
                c = v;
                break;
              case "children":
                u = v;
                break;
              case "dangerouslySetInnerHTML":
                if (v != null) throw Error(o(91));
                break;
              default:
                Le(e, t, x, v, a, null);
            }
        dm(e, r, c, u);
        return;
      case "option":
        for (j in a)
          a.hasOwnProperty(j) && (r = a[j], r != null) && (j === "selected" ? e.selected = r && typeof r != "function" && typeof r != "symbol" : Le(e, t, j, r, a, null));
        return;
      case "dialog":
        Ee("beforetoggle", e), Ee("toggle", e), Ee("cancel", e), Ee("close", e);
        break;
      case "iframe":
      case "object":
        Ee("load", e);
        break;
      case "video":
      case "audio":
        for (r = 0; r < Cr.length; r++)
          Ee(Cr[r], e);
        break;
      case "image":
        Ee("error", e), Ee("load", e);
        break;
      case "details":
        Ee("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        Ee("error", e), Ee("load", e);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (F in a)
          if (a.hasOwnProperty(F) && (r = a[F], r != null))
            switch (F) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(o(137, t));
              default:
                Le(e, t, F, r, a, null);
            }
        return;
      default:
        if (Bc(t)) {
          for (U in a)
            a.hasOwnProperty(U) && (r = a[U], r !== void 0 && Sd(
              e,
              t,
              U,
              r,
              a,
              void 0
            ));
          return;
        }
    }
    for (v in a)
      a.hasOwnProperty(v) && (r = a[v], r != null && Le(e, t, v, r, a, null));
  }
  function H2(e, t, a, r) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var c = null, u = null, x = null, v = null, j = null, F = null, U = null;
        for (H in a) {
          var I = a[H];
          if (a.hasOwnProperty(H) && I != null)
            switch (H) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                j = I;
              default:
                r.hasOwnProperty(H) || Le(e, t, H, null, r, I);
            }
        }
        for (var B in r) {
          var H = r[B];
          if (I = a[B], r.hasOwnProperty(B) && (H != null || I != null))
            switch (B) {
              case "type":
                u = H;
                break;
              case "name":
                c = H;
                break;
              case "checked":
                F = H;
                break;
              case "defaultChecked":
                U = H;
                break;
              case "value":
                x = H;
                break;
              case "defaultValue":
                v = H;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (H != null)
                  throw Error(o(137, t));
                break;
              default:
                H !== I && Le(
                  e,
                  t,
                  B,
                  H,
                  r,
                  I
                );
            }
        }
        Dc(
          e,
          x,
          v,
          j,
          F,
          U,
          u,
          c
        );
        return;
      case "select":
        H = x = v = B = null;
        for (u in a)
          if (j = a[u], a.hasOwnProperty(u) && j != null)
            switch (u) {
              case "value":
                break;
              case "multiple":
                H = j;
              default:
                r.hasOwnProperty(u) || Le(
                  e,
                  t,
                  u,
                  null,
                  r,
                  j
                );
            }
        for (c in r)
          if (u = r[c], j = a[c], r.hasOwnProperty(c) && (u != null || j != null))
            switch (c) {
              case "value":
                B = u;
                break;
              case "defaultValue":
                v = u;
                break;
              case "multiple":
                x = u;
              default:
                u !== j && Le(
                  e,
                  t,
                  c,
                  u,
                  r,
                  j
                );
            }
        t = v, a = x, r = H, B != null ? Gi(e, !!a, B, !1) : !!r != !!a && (t != null ? Gi(e, !!a, t, !0) : Gi(e, !!a, a ? [] : "", !1));
        return;
      case "textarea":
        H = B = null;
        for (v in a)
          if (c = a[v], a.hasOwnProperty(v) && c != null && !r.hasOwnProperty(v))
            switch (v) {
              case "value":
                break;
              case "children":
                break;
              default:
                Le(e, t, v, null, r, c);
            }
        for (x in r)
          if (c = r[x], u = a[x], r.hasOwnProperty(x) && (c != null || u != null))
            switch (x) {
              case "value":
                B = c;
                break;
              case "defaultValue":
                H = c;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(o(91));
                break;
              default:
                c !== u && Le(e, t, x, c, r, u);
            }
        um(e, B, H);
        return;
      case "option":
        for (var ce in a)
          B = a[ce], a.hasOwnProperty(ce) && B != null && !r.hasOwnProperty(ce) && (ce === "selected" ? e.selected = !1 : Le(
            e,
            t,
            ce,
            null,
            r,
            B
          ));
        for (j in r)
          B = r[j], H = a[j], r.hasOwnProperty(j) && B !== H && (B != null || H != null) && (j === "selected" ? e.selected = B && typeof B != "function" && typeof B != "symbol" : Le(
            e,
            t,
            j,
            B,
            r,
            H
          ));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var pe in a)
          B = a[pe], a.hasOwnProperty(pe) && B != null && !r.hasOwnProperty(pe) && Le(e, t, pe, null, r, B);
        for (F in r)
          if (B = r[F], H = a[F], r.hasOwnProperty(F) && B !== H && (B != null || H != null))
            switch (F) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (B != null)
                  throw Error(o(137, t));
                break;
              default:
                Le(
                  e,
                  t,
                  F,
                  B,
                  r,
                  H
                );
            }
        return;
      default:
        if (Bc(t)) {
          for (var Pe in a)
            B = a[Pe], a.hasOwnProperty(Pe) && B !== void 0 && !r.hasOwnProperty(Pe) && Sd(
              e,
              t,
              Pe,
              void 0,
              r,
              B
            );
          for (U in r)
            B = r[U], H = a[U], !r.hasOwnProperty(U) || B === H || B === void 0 && H === void 0 || Sd(
              e,
              t,
              U,
              B,
              r,
              H
            );
          return;
        }
    }
    for (var M in a)
      B = a[M], a.hasOwnProperty(M) && B != null && !r.hasOwnProperty(M) && Le(e, t, M, null, r, B);
    for (I in r)
      B = r[I], H = a[I], !r.hasOwnProperty(I) || B === H || B == null && H == null || Le(e, t, I, B, r, H);
  }
  function mx(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function U2() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e = 0, t = 0, a = performance.getEntriesByType("resource"), r = 0; r < a.length; r++) {
        var c = a[r], u = c.transferSize, x = c.initiatorType, v = c.duration;
        if (u && v && mx(x)) {
          for (x = 0, v = c.responseEnd, r += 1; r < a.length; r++) {
            var j = a[r], F = j.startTime;
            if (F > v) break;
            var U = j.transferSize, I = j.initiatorType;
            U && mx(I) && (j = j.responseEnd, x += U * (j < v ? 1 : (v - F) / (j - F)));
          }
          if (--r, t += 8 * (u + x) / (c.duration / 1e3), e++, 10 < e) break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
  }
  var Nd = null, Td = null;
  function go(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function px(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function gx(e, t) {
    if (e === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && t === "foreignObject" ? 0 : e;
  }
  function Ad(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Cd = null;
  function L2() {
    var e = window.event;
    return e && e.type === "popstate" ? e === Cd ? !1 : (Cd = e, !0) : (Cd = null, !1);
  }
  var xx = typeof setTimeout == "function" ? setTimeout : void 0, P2 = typeof clearTimeout == "function" ? clearTimeout : void 0, yx = typeof Promise == "function" ? Promise : void 0, q2 = typeof queueMicrotask == "function" ? queueMicrotask : typeof yx < "u" ? function(e) {
    return yx.resolve(null).then(e).catch(I2);
  } : xx;
  function I2(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Fa(e) {
    return e === "head";
  }
  function bx(e, t) {
    var a = t, r = 0;
    do {
      var c = a.nextSibling;
      if (e.removeChild(a), c && c.nodeType === 8)
        if (a = c.data, a === "/$" || a === "/&") {
          if (r === 0) {
            e.removeChild(c), Ss(t);
            return;
          }
          r--;
        } else if (a === "$" || a === "$?" || a === "$~" || a === "$!" || a === "&")
          r++;
        else if (a === "html")
          kr(e.ownerDocument.documentElement);
        else if (a === "head") {
          a = e.ownerDocument.head, kr(a);
          for (var u = a.firstChild; u; ) {
            var x = u.nextSibling, v = u.nodeName;
            u[Qs] || v === "SCRIPT" || v === "STYLE" || v === "LINK" && u.rel.toLowerCase() === "stylesheet" || a.removeChild(u), u = x;
          }
        } else
          a === "body" && kr(e.ownerDocument.body);
      a = c;
    } while (a);
    Ss(t);
  }
  function vx(e, t) {
    var a = e;
    e = 0;
    do {
      var r = a.nextSibling;
      if (a.nodeType === 1 ? t ? (a._stashedDisplay = a.style.display, a.style.display = "none") : (a.style.display = a._stashedDisplay || "", a.getAttribute("style") === "" && a.removeAttribute("style")) : a.nodeType === 3 && (t ? (a._stashedText = a.nodeValue, a.nodeValue = "") : a.nodeValue = a._stashedText || ""), r && r.nodeType === 8)
        if (a = r.data, a === "/$") {
          if (e === 0) break;
          e--;
        } else
          a !== "$" && a !== "$?" && a !== "$~" && a !== "$!" || e++;
      a = r;
    } while (a);
  }
  function Ed(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var a = t;
      switch (t = t.nextSibling, a.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ed(a), Rc(a);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (a.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(a);
    }
  }
  function G2(e, t, a, r) {
    for (; e.nodeType === 1; ) {
      var c = a;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden"))
          break;
      } else if (r) {
        if (!e[Qs])
          switch (t) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (u = e.getAttribute("rel"), u === "stylesheet" && e.hasAttribute("data-precedence"))
                break;
              if (u !== c.rel || e.getAttribute("href") !== (c.href == null || c.href === "" ? null : c.href) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin) || e.getAttribute("title") !== (c.title == null ? null : c.title))
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (u = e.getAttribute("src"), (u !== (c.src == null ? null : c.src) || e.getAttribute("type") !== (c.type == null ? null : c.type) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin)) && u && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                break;
              return e;
            default:
              return e;
          }
      } else if (t === "input" && e.type === "hidden") {
        var u = c.name == null ? null : "" + c.name;
        if (c.type === "hidden" && e.getAttribute("name") === u)
          return e;
      } else return e;
      if (e = gn(e.nextSibling), e === null) break;
    }
    return null;
  }
  function Y2(e, t, a) {
    if (t === "") return null;
    for (; e.nodeType !== 3; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !a || (e = gn(e.nextSibling), e === null)) return null;
    return e;
  }
  function wx(e, t) {
    for (; e.nodeType !== 8; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = gn(e.nextSibling), e === null)) return null;
    return e;
  }
  function kd(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Md(e) {
    return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
  }
  function Q2(e, t) {
    var a = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = t;
    else if (e.data !== "$?" || a.readyState !== "loading")
      t();
    else {
      var r = function() {
        t(), a.removeEventListener("DOMContentLoaded", r);
      };
      a.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
    }
  }
  function gn(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return e;
  }
  var zd = null;
  function jx(e) {
    e = e.nextSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "/$" || a === "/&") {
          if (t === 0)
            return gn(e.nextSibling);
          t--;
        } else
          a !== "$" && a !== "$!" && a !== "$?" && a !== "$~" && a !== "&" || t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function Sx(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "$" || a === "$!" || a === "$?" || a === "$~" || a === "&") {
          if (t === 0) return e;
          t--;
        } else a !== "/$" && a !== "/&" || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function Nx(e, t, a) {
    switch (t = go(a), e) {
      case "html":
        if (e = t.documentElement, !e) throw Error(o(452));
        return e;
      case "head":
        if (e = t.head, !e) throw Error(o(453));
        return e;
      case "body":
        if (e = t.body, !e) throw Error(o(454));
        return e;
      default:
        throw Error(o(451));
    }
  }
  function kr(e) {
    for (var t = e.attributes; t.length; )
      e.removeAttributeNode(t[0]);
    Rc(e);
  }
  var xn = /* @__PURE__ */ new Map(), Tx = /* @__PURE__ */ new Set();
  function xo(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var da = X.d;
  X.d = {
    f: Z2,
    r: X2,
    D: K2,
    C: $2,
    L: W2,
    m: J2,
    X: tj,
    S: ej,
    M: nj
  };
  function Z2() {
    var e = da.f(), t = lo();
    return e || t;
  }
  function X2(e) {
    var t = Pi(e);
    t !== null && t.tag === 5 && t.type === "form" ? Pp(t) : da.r(e);
  }
  var vs = typeof document > "u" ? null : document;
  function Ax(e, t, a) {
    var r = vs;
    if (r && typeof t == "string" && t) {
      var c = cn(t);
      c = 'link[rel="' + e + '"][href="' + c + '"]', typeof a == "string" && (c += '[crossorigin="' + a + '"]'), Tx.has(c) || (Tx.add(c), e = { rel: e, crossOrigin: a, href: t }, r.querySelector(c) === null && (t = r.createElement("link"), yt(t, "link", e), dt(t), r.head.appendChild(t)));
    }
  }
  function K2(e) {
    da.D(e), Ax("dns-prefetch", e, null);
  }
  function $2(e, t) {
    da.C(e, t), Ax("preconnect", e, t);
  }
  function W2(e, t, a) {
    da.L(e, t, a);
    var r = vs;
    if (r && e && t) {
      var c = 'link[rel="preload"][as="' + cn(t) + '"]';
      t === "image" && a && a.imageSrcSet ? (c += '[imagesrcset="' + cn(
        a.imageSrcSet
      ) + '"]', typeof a.imageSizes == "string" && (c += '[imagesizes="' + cn(
        a.imageSizes
      ) + '"]')) : c += '[href="' + cn(e) + '"]';
      var u = c;
      switch (t) {
        case "style":
          u = ws(e);
          break;
        case "script":
          u = js(e);
      }
      xn.has(u) || (e = y(
        {
          rel: "preload",
          href: t === "image" && a && a.imageSrcSet ? void 0 : e,
          as: t
        },
        a
      ), xn.set(u, e), r.querySelector(c) !== null || t === "style" && r.querySelector(Mr(u)) || t === "script" && r.querySelector(zr(u)) || (t = r.createElement("link"), yt(t, "link", e), dt(t), r.head.appendChild(t)));
    }
  }
  function J2(e, t) {
    da.m(e, t);
    var a = vs;
    if (a && e) {
      var r = t && typeof t.as == "string" ? t.as : "script", c = 'link[rel="modulepreload"][as="' + cn(r) + '"][href="' + cn(e) + '"]', u = c;
      switch (r) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = js(e);
      }
      if (!xn.has(u) && (e = y({ rel: "modulepreload", href: e }, t), xn.set(u, e), a.querySelector(c) === null)) {
        switch (r) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (a.querySelector(zr(u)))
              return;
        }
        r = a.createElement("link"), yt(r, "link", e), dt(r), a.head.appendChild(r);
      }
    }
  }
  function ej(e, t, a) {
    da.S(e, t, a);
    var r = vs;
    if (r && e) {
      var c = qi(r).hoistableStyles, u = ws(e);
      t = t || "default";
      var x = c.get(u);
      if (!x) {
        var v = { loading: 0, preload: null };
        if (x = r.querySelector(
          Mr(u)
        ))
          v.loading = 5;
        else {
          e = y(
            { rel: "stylesheet", href: e, "data-precedence": t },
            a
          ), (a = xn.get(u)) && Od(e, a);
          var j = x = r.createElement("link");
          dt(j), yt(j, "link", e), j._p = new Promise(function(F, U) {
            j.onload = F, j.onerror = U;
          }), j.addEventListener("load", function() {
            v.loading |= 1;
          }), j.addEventListener("error", function() {
            v.loading |= 2;
          }), v.loading |= 4, yo(x, t, r);
        }
        x = {
          type: "stylesheet",
          instance: x,
          count: 1,
          state: v
        }, c.set(u, x);
      }
    }
  }
  function tj(e, t) {
    da.X(e, t);
    var a = vs;
    if (a && e) {
      var r = qi(a).hoistableScripts, c = js(e), u = r.get(c);
      u || (u = a.querySelector(zr(c)), u || (e = y({ src: e, async: !0 }, t), (t = xn.get(c)) && Rd(e, t), u = a.createElement("script"), dt(u), yt(u, "link", e), a.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, r.set(c, u));
    }
  }
  function nj(e, t) {
    da.M(e, t);
    var a = vs;
    if (a && e) {
      var r = qi(a).hoistableScripts, c = js(e), u = r.get(c);
      u || (u = a.querySelector(zr(c)), u || (e = y({ src: e, async: !0, type: "module" }, t), (t = xn.get(c)) && Rd(e, t), u = a.createElement("script"), dt(u), yt(u, "link", e), a.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, r.set(c, u));
    }
  }
  function Cx(e, t, a, r) {
    var c = (c = le.current) ? xo(c) : null;
    if (!c) throw Error(o(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof a.precedence == "string" && typeof a.href == "string" ? (t = ws(a.href), a = qi(
          c
        ).hoistableStyles, r = a.get(t), r || (r = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, a.set(t, r)), r) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (a.rel === "stylesheet" && typeof a.href == "string" && typeof a.precedence == "string") {
          e = ws(a.href);
          var u = qi(
            c
          ).hoistableStyles, x = u.get(e);
          if (x || (c = c.ownerDocument || c, x = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, u.set(e, x), (u = c.querySelector(
            Mr(e)
          )) && !u._p && (x.instance = u, x.state.loading = 5), xn.has(e) || (a = {
            rel: "preload",
            as: "style",
            href: a.href,
            crossOrigin: a.crossOrigin,
            integrity: a.integrity,
            media: a.media,
            hrefLang: a.hrefLang,
            referrerPolicy: a.referrerPolicy
          }, xn.set(e, a), u || aj(
            c,
            e,
            a,
            x.state
          ))), t && r === null)
            throw Error(o(528, ""));
          return x;
        }
        if (t && r !== null)
          throw Error(o(529, ""));
        return null;
      case "script":
        return t = a.async, a = a.src, typeof a == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = js(a), a = qi(
          c
        ).hoistableScripts, r = a.get(t), r || (r = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, a.set(t, r)), r) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(o(444, e));
    }
  }
  function ws(e) {
    return 'href="' + cn(e) + '"';
  }
  function Mr(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function Ex(e) {
    return y({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function aj(e, t, a, r) {
    e.querySelector('link[rel="preload"][as="style"][' + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
      return r.loading |= 1;
    }), t.addEventListener("error", function() {
      return r.loading |= 2;
    }), yt(t, "link", a), dt(t), e.head.appendChild(t));
  }
  function js(e) {
    return '[src="' + cn(e) + '"]';
  }
  function zr(e) {
    return "script[async]" + e;
  }
  function kx(e, t, a) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var r = e.querySelector(
            'style[data-href~="' + cn(a.href) + '"]'
          );
          if (r)
            return t.instance = r, dt(r), r;
          var c = y({}, a, {
            "data-href": a.href,
            "data-precedence": a.precedence,
            href: null,
            precedence: null
          });
          return r = (e.ownerDocument || e).createElement(
            "style"
          ), dt(r), yt(r, "style", c), yo(r, a.precedence, e), t.instance = r;
        case "stylesheet":
          c = ws(a.href);
          var u = e.querySelector(
            Mr(c)
          );
          if (u)
            return t.state.loading |= 4, t.instance = u, dt(u), u;
          r = Ex(a), (c = xn.get(c)) && Od(r, c), u = (e.ownerDocument || e).createElement("link"), dt(u);
          var x = u;
          return x._p = new Promise(function(v, j) {
            x.onload = v, x.onerror = j;
          }), yt(u, "link", r), t.state.loading |= 4, yo(u, a.precedence, e), t.instance = u;
        case "script":
          return u = js(a.src), (c = e.querySelector(
            zr(u)
          )) ? (t.instance = c, dt(c), c) : (r = a, (c = xn.get(u)) && (r = y({}, a), Rd(r, c)), e = e.ownerDocument || e, c = e.createElement("script"), dt(c), yt(c, "link", r), e.head.appendChild(c), t.instance = c);
        case "void":
          return null;
        default:
          throw Error(o(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (r = t.instance, t.state.loading |= 4, yo(r, a.precedence, e));
    return t.instance;
  }
  function yo(e, t, a) {
    for (var r = a.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), c = r.length ? r[r.length - 1] : null, u = c, x = 0; x < r.length; x++) {
      var v = r[x];
      if (v.dataset.precedence === t) u = v;
      else if (u !== c) break;
    }
    u ? u.parentNode.insertBefore(e, u.nextSibling) : (t = a.nodeType === 9 ? a.head : a, t.insertBefore(e, t.firstChild));
  }
  function Od(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
  }
  function Rd(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
  }
  var bo = null;
  function Mx(e, t, a) {
    if (bo === null) {
      var r = /* @__PURE__ */ new Map(), c = bo = /* @__PURE__ */ new Map();
      c.set(a, r);
    } else
      c = bo, r = c.get(a), r || (r = /* @__PURE__ */ new Map(), c.set(a, r));
    if (r.has(e)) return r;
    for (r.set(e, null), a = a.getElementsByTagName(e), c = 0; c < a.length; c++) {
      var u = a[c];
      if (!(u[Qs] || u[mt] || e === "link" && u.getAttribute("rel") === "stylesheet") && u.namespaceURI !== "http://www.w3.org/2000/svg") {
        var x = u.getAttribute(t) || "";
        x = e + x;
        var v = r.get(x);
        v ? v.push(u) : r.set(x, [u]);
      }
    }
    return r;
  }
  function zx(e, t, a) {
    e = e.ownerDocument || e, e.head.insertBefore(
      a,
      t === "title" ? e.querySelector("head > title") : null
    );
  }
  function ij(e, t, a) {
    if (a === 1 || t.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        return t.rel === "stylesheet" ? (e = t.disabled, typeof t.precedence == "string" && e == null) : !0;
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function Ox(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function sj(e, t, a, r) {
    if (a.type === "stylesheet" && (typeof r.media != "string" || matchMedia(r.media).matches !== !1) && (a.state.loading & 4) === 0) {
      if (a.instance === null) {
        var c = ws(r.href), u = t.querySelector(
          Mr(c)
        );
        if (u) {
          t = u._p, t !== null && typeof t == "object" && typeof t.then == "function" && (e.count++, e = vo.bind(e), t.then(e, e)), a.state.loading |= 4, a.instance = u, dt(u);
          return;
        }
        u = t.ownerDocument || t, r = Ex(r), (c = xn.get(c)) && Od(r, c), u = u.createElement("link"), dt(u);
        var x = u;
        x._p = new Promise(function(v, j) {
          x.onload = v, x.onerror = j;
        }), yt(u, "link", r), a.instance = u;
      }
      e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(a, t), (t = a.state.preload) && (a.state.loading & 3) === 0 && (e.count++, a = vo.bind(e), t.addEventListener("load", a), t.addEventListener("error", a));
    }
  }
  var _d = 0;
  function rj(e, t) {
    return e.stylesheets && e.count === 0 && jo(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(a) {
      var r = setTimeout(function() {
        if (e.stylesheets && jo(e, e.stylesheets), e.unsuspend) {
          var u = e.unsuspend;
          e.unsuspend = null, u();
        }
      }, 6e4 + t);
      0 < e.imgBytes && _d === 0 && (_d = 62500 * U2());
      var c = setTimeout(
        function() {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && jo(e, e.stylesheets), e.unsuspend)) {
            var u = e.unsuspend;
            e.unsuspend = null, u();
          }
        },
        (e.imgBytes > _d ? 50 : 800) + t
      );
      return e.unsuspend = a, function() {
        e.unsuspend = null, clearTimeout(r), clearTimeout(c);
      };
    } : null;
  }
  function vo() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) jo(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        this.unsuspend = null, e();
      }
    }
  }
  var wo = null;
  function jo(e, t) {
    e.stylesheets = null, e.unsuspend !== null && (e.count++, wo = /* @__PURE__ */ new Map(), t.forEach(lj, e), wo = null, vo.call(e));
  }
  function lj(e, t) {
    if (!(t.state.loading & 4)) {
      var a = wo.get(e);
      if (a) var r = a.get(null);
      else {
        a = /* @__PURE__ */ new Map(), wo.set(e, a);
        for (var c = e.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), u = 0; u < c.length; u++) {
          var x = c[u];
          (x.nodeName === "LINK" || x.getAttribute("media") !== "not all") && (a.set(x.dataset.precedence, x), r = x);
        }
        r && a.set(null, r);
      }
      c = t.instance, x = c.getAttribute("data-precedence"), u = a.get(x) || r, u === r && a.set(null, c), a.set(x, c), this.count++, r = vo.bind(this), c.addEventListener("load", r), c.addEventListener("error", r), u ? u.parentNode.insertBefore(c, u.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(c, e.firstChild)), t.state.loading |= 4;
    }
  }
  var Or = {
    $$typeof: L,
    Provider: null,
    Consumer: null,
    _currentValue: te,
    _currentValue2: te,
    _threadCount: 0
  };
  function oj(e, t, a, r, c, u, x, v, j) {
    this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = xa(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = xa(0), this.hiddenUpdates = xa(null), this.identifierPrefix = r, this.onUncaughtError = c, this.onCaughtError = u, this.onRecoverableError = x, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = j, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Rx(e, t, a, r, c, u, x, v, j, F, U, I) {
    return e = new oj(
      e,
      t,
      a,
      x,
      j,
      F,
      U,
      I,
      v
    ), t = 1, u === !0 && (t |= 24), u = Kt(3, null, null, t), e.current = u, u.stateNode = e, t = fu(), t.refCount++, e.pooledCache = t, t.refCount++, u.memoizedState = {
      element: r,
      isDehydrated: a,
      cache: t
    }, xu(u), e;
  }
  function _x(e) {
    return e ? (e = Ji, e) : Ji;
  }
  function Dx(e, t, a, r, c, u) {
    c = _x(c), r.context === null ? r.context = c : r.pendingContext = c, r = Ta(t), r.payload = { element: a }, u = u === void 0 ? null : u, u !== null && (r.callback = u), a = Aa(e, r, t), a !== null && (qt(a, e, t), ur(a, e, t));
  }
  function Fx(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var a = e.retryLane;
      e.retryLane = a !== 0 && a < t ? a : t;
    }
  }
  function Dd(e, t) {
    Fx(e, t), (e = e.alternate) && Fx(e, t);
  }
  function Bx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = oi(e, 67108864);
      t !== null && qt(t, e, 67108864), Dd(e, 67108864);
    }
  }
  function Vx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = tn();
      t = Hi(t);
      var a = oi(e, t);
      a !== null && qt(a, e, t), Dd(e, t);
    }
  }
  var So = !0;
  function cj(e, t, a, r) {
    var c = O.T;
    O.T = null;
    var u = X.p;
    try {
      X.p = 2, Fd(e, t, a, r);
    } finally {
      X.p = u, O.T = c;
    }
  }
  function uj(e, t, a, r) {
    var c = O.T;
    O.T = null;
    var u = X.p;
    try {
      X.p = 8, Fd(e, t, a, r);
    } finally {
      X.p = u, O.T = c;
    }
  }
  function Fd(e, t, a, r) {
    if (So) {
      var c = Bd(r);
      if (c === null)
        jd(
          e,
          t,
          r,
          No,
          a
        ), Ux(e, r);
      else if (hj(
        c,
        e,
        t,
        a,
        r
      ))
        r.stopPropagation();
      else if (Ux(e, r), t & 4 && -1 < dj.indexOf(e)) {
        for (; c !== null; ) {
          var u = Pi(c);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                  var x = Dn(u.pendingLanes);
                  if (x !== 0) {
                    var v = u;
                    for (v.pendingLanes |= 2, v.entangledLanes |= 2; x; ) {
                      var j = 1 << 31 - jt(x);
                      v.entanglements[1] |= j, x &= ~j;
                    }
                    Hn(u), (Fe & 6) === 0 && (so = Et() + 500, Ar(0));
                  }
                }
                break;
              case 31:
              case 13:
                v = oi(u, 2), v !== null && qt(v, u, 2), lo(), Dd(u, 2);
            }
          if (u = Bd(r), u === null && jd(
            e,
            t,
            r,
            No,
            a
          ), u === c) break;
          c = u;
        }
        c !== null && r.stopPropagation();
      } else
        jd(
          e,
          t,
          r,
          null,
          a
        );
    }
  }
  function Bd(e) {
    return e = Hc(e), Vd(e);
  }
  var No = null;
  function Vd(e) {
    if (No = null, e = Li(e), e !== null) {
      var t = f(e);
      if (t === null) e = null;
      else {
        var a = t.tag;
        if (a === 13) {
          if (e = h(t), e !== null) return e;
          e = null;
        } else if (a === 31) {
          if (e = p(t), e !== null) return e;
          e = null;
        } else if (a === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return No = e, null;
  }
  function Hx(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (kc()) {
          case Ja:
            return 2;
          case pl:
            return 8;
          case ei:
          case Gs:
            return 32;
          case Qn:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Hd = !1, Ba = null, Va = null, Ha = null, Rr = /* @__PURE__ */ new Map(), _r = /* @__PURE__ */ new Map(), Ua = [], dj = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Ux(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Ba = null;
        break;
      case "dragenter":
      case "dragleave":
        Va = null;
        break;
      case "mouseover":
      case "mouseout":
        Ha = null;
        break;
      case "pointerover":
      case "pointerout":
        Rr.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        _r.delete(t.pointerId);
    }
  }
  function Dr(e, t, a, r, c, u) {
    return e === null || e.nativeEvent !== u ? (e = {
      blockedOn: t,
      domEventName: a,
      eventSystemFlags: r,
      nativeEvent: u,
      targetContainers: [c]
    }, t !== null && (t = Pi(t), t !== null && Bx(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, c !== null && t.indexOf(c) === -1 && t.push(c), e);
  }
  function hj(e, t, a, r, c) {
    switch (t) {
      case "focusin":
        return Ba = Dr(
          Ba,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "dragenter":
        return Va = Dr(
          Va,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "mouseover":
        return Ha = Dr(
          Ha,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "pointerover":
        var u = c.pointerId;
        return Rr.set(
          u,
          Dr(
            Rr.get(u) || null,
            e,
            t,
            a,
            r,
            c
          )
        ), !0;
      case "gotpointercapture":
        return u = c.pointerId, _r.set(
          u,
          Dr(
            _r.get(u) || null,
            e,
            t,
            a,
            r,
            c
          )
        ), !0;
    }
    return !1;
  }
  function Lx(e) {
    var t = Li(e.target);
    if (t !== null) {
      var a = f(t);
      if (a !== null) {
        if (t = a.tag, t === 13) {
          if (t = h(a), t !== null) {
            e.blockedOn = t, tm(e.priority, function() {
              Vx(a);
            });
            return;
          }
        } else if (t === 31) {
          if (t = p(a), t !== null) {
            e.blockedOn = t, tm(e.priority, function() {
              Vx(a);
            });
            return;
          }
        } else if (t === 3 && a.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function To(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var a = Bd(e.nativeEvent);
      if (a === null) {
        a = e.nativeEvent;
        var r = new a.constructor(
          a.type,
          a
        );
        Vc = r, a.target.dispatchEvent(r), Vc = null;
      } else
        return t = Pi(a), t !== null && Bx(t), e.blockedOn = a, !1;
      t.shift();
    }
    return !0;
  }
  function Px(e, t, a) {
    To(e) && a.delete(t);
  }
  function fj() {
    Hd = !1, Ba !== null && To(Ba) && (Ba = null), Va !== null && To(Va) && (Va = null), Ha !== null && To(Ha) && (Ha = null), Rr.forEach(Px), _r.forEach(Px);
  }
  function Ao(e, t) {
    e.blockedOn === t && (e.blockedOn = null, Hd || (Hd = !0, n.unstable_scheduleCallback(
      n.unstable_NormalPriority,
      fj
    )));
  }
  var Co = null;
  function qx(e) {
    Co !== e && (Co = e, n.unstable_scheduleCallback(
      n.unstable_NormalPriority,
      function() {
        Co === e && (Co = null);
        for (var t = 0; t < e.length; t += 3) {
          var a = e[t], r = e[t + 1], c = e[t + 2];
          if (typeof r != "function") {
            if (Vd(r || a) === null)
              continue;
            break;
          }
          var u = Pi(a);
          u !== null && (e.splice(t, 3), t -= 3, Bu(
            u,
            {
              pending: !0,
              data: c,
              method: a.method,
              action: r
            },
            r,
            c
          ));
        }
      }
    ));
  }
  function Ss(e) {
    function t(j) {
      return Ao(j, e);
    }
    Ba !== null && Ao(Ba, e), Va !== null && Ao(Va, e), Ha !== null && Ao(Ha, e), Rr.forEach(t), _r.forEach(t);
    for (var a = 0; a < Ua.length; a++) {
      var r = Ua[a];
      r.blockedOn === e && (r.blockedOn = null);
    }
    for (; 0 < Ua.length && (a = Ua[0], a.blockedOn === null); )
      Lx(a), a.blockedOn === null && Ua.shift();
    if (a = (e.ownerDocument || e).$$reactFormReplay, a != null)
      for (r = 0; r < a.length; r += 3) {
        var c = a[r], u = a[r + 1], x = c[Bt] || null;
        if (typeof u == "function")
          x || qx(a);
        else if (x) {
          var v = null;
          if (u && u.hasAttribute("formAction")) {
            if (c = u, x = u[Bt] || null)
              v = x.formAction;
            else if (Vd(c) !== null) continue;
          } else v = x.action;
          typeof v == "function" ? a[r + 1] = v : (a.splice(r, 3), r -= 3), qx(a);
        }
      }
  }
  function Ix() {
    function e(u) {
      u.canIntercept && u.info === "react-transition" && u.intercept({
        handler: function() {
          return new Promise(function(x) {
            return c = x;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      c !== null && (c(), c = null), r || setTimeout(a, 20);
    }
    function a() {
      if (!r && !navigation.transition) {
        var u = navigation.currentEntry;
        u && u.url != null && navigation.navigate(u.url, {
          state: u.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var r = !1, c = null;
      return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(a, 100), function() {
        r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), c !== null && (c(), c = null);
      };
    }
  }
  function Ud(e) {
    this._internalRoot = e;
  }
  Eo.prototype.render = Ud.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(o(409));
    var a = t.current, r = tn();
    Dx(a, r, e, t, null, null);
  }, Eo.prototype.unmount = Ud.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      Dx(e.current, 2, null, e, null, null), lo(), t[Ui] = null;
    }
  };
  function Eo(e) {
    this._internalRoot = e;
  }
  Eo.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = zc();
      e = { blockedOn: null, target: e, priority: t };
      for (var a = 0; a < Ua.length && t !== 0 && t < Ua[a].priority; a++) ;
      Ua.splice(a, 0, e), a === 0 && Lx(e);
    }
  };
  var Gx = i.version;
  if (Gx !== "19.2.8")
    throw Error(
      o(
        527,
        Gx,
        "19.2.8"
      )
    );
  X.findDOMNode = function(e) {
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(o(188)) : (e = Object.keys(e).join(","), Error(o(268, e)));
    return e = m(t), e = e !== null ? b(e) : null, e = e === null ? null : e.stateNode, e;
  };
  var mj = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: O,
    reconcilerVersion: "19.2.8"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ko = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ko.isDisabled && ko.supportsFiber)
      try {
        ti = ko.inject(
          mj
        ), kt = ko;
      } catch {
      }
  }
  return Br.createRoot = function(e, t) {
    if (!d(e)) throw Error(o(299));
    var a = !1, r = "", c = Wp, u = Jp, x = eg;
    return t != null && (t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (c = t.onUncaughtError), t.onCaughtError !== void 0 && (u = t.onCaughtError), t.onRecoverableError !== void 0 && (x = t.onRecoverableError)), t = Rx(
      e,
      1,
      !1,
      null,
      null,
      a,
      r,
      null,
      c,
      u,
      x,
      Ix
    ), e[Ui] = t.current, wd(e), new Ud(t);
  }, Br.hydrateRoot = function(e, t, a) {
    if (!d(e)) throw Error(o(299));
    var r = !1, c = "", u = Wp, x = Jp, v = eg, j = null;
    return a != null && (a.unstable_strictMode === !0 && (r = !0), a.identifierPrefix !== void 0 && (c = a.identifierPrefix), a.onUncaughtError !== void 0 && (u = a.onUncaughtError), a.onCaughtError !== void 0 && (x = a.onCaughtError), a.onRecoverableError !== void 0 && (v = a.onRecoverableError), a.formState !== void 0 && (j = a.formState)), t = Rx(
      e,
      1,
      !0,
      t,
      a ?? null,
      r,
      c,
      j,
      u,
      x,
      v,
      Ix
    ), t.context = _x(null), a = t.current, r = tn(), r = Hi(r), c = Ta(r), c.callback = null, Aa(a, c, r), a = r, t.current.lanes = a, Ke(t, a), Hn(t), e[Ui] = t.current, wd(e), new Eo(t);
  }, Br.version = "19.2.8", Br;
}
var ty;
function Nj() {
  if (ty) return Pd.exports;
  ty = 1;
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (i) {
        console.error(i);
      }
  }
  return n(), Pd.exports = Sj(), Pd.exports;
}
var Tj = Nj(), C = xc();
const K = /* @__PURE__ */ ll(C), mv = /* @__PURE__ */ gj({
  __proto__: null,
  default: K
}, [C]);
var Aj = (n, i, l, o, d, f, h, p) => {
  let g = document.documentElement, m = ["light", "dark"];
  function b(S) {
    (Array.isArray(n) ? n : [n]).forEach((T) => {
      let _ = T === "class", R = _ && f ? d.map((z) => f[z] || z) : d;
      _ ? (g.classList.remove(...R), g.classList.add(f && f[S] ? f[S] : S)) : g.setAttribute(T, S);
    }), y(S);
  }
  function y(S) {
    p && m.includes(S) && (g.style.colorScheme = S);
  }
  function w() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  if (o) b(o);
  else try {
    let S = localStorage.getItem(i) || l, T = h && S === "system" ? w() : S;
    b(T);
  } catch {
  }
}, Cj = C.createContext(void 0), Ej = { setTheme: (n) => {
}, themes: [] }, kj = () => {
  var n;
  return (n = C.useContext(Cj)) != null ? n : Ej;
};
C.memo(({ forcedTheme: n, storageKey: i, attribute: l, enableSystem: o, enableColorScheme: d, defaultTheme: f, value: h, themes: p, nonce: g, scriptProps: m }) => {
  let b = JSON.stringify([l, i, f, n, p, h, o, d]).slice(1, -1);
  return C.createElement("script", { ...m, suppressHydrationWarning: !0, nonce: typeof window > "u" ? g : "", dangerouslySetInnerHTML: { __html: `(${Aj.toString()})(${b})` } });
});
var Mj = fv();
const zj = /* @__PURE__ */ ll(Mj);
function Oj(n) {
  if (typeof document > "u") return;
  let i = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.type = "text/css", i.appendChild(l), l.styleSheet ? l.styleSheet.cssText = n : l.appendChild(document.createTextNode(n));
}
const Rj = (n) => {
  switch (n) {
    case "success":
      return Fj;
    case "info":
      return Vj;
    case "warning":
      return Bj;
    case "error":
      return Hj;
    default:
      return null;
  }
}, _j = Array(12).fill(0), Dj = ({ visible: n, className: i }) => /* @__PURE__ */ K.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    i
  ].filter(Boolean).join(" "),
  "data-visible": n
}, /* @__PURE__ */ K.createElement("div", {
  className: "sonner-spinner"
}, _j.map((l, o) => /* @__PURE__ */ K.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${o}`
})))), Fj = /* @__PURE__ */ K.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ K.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), Bj = /* @__PURE__ */ K.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ K.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), Vj = /* @__PURE__ */ K.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ K.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), Hj = /* @__PURE__ */ K.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ K.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), Uj = /* @__PURE__ */ K.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ K.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ K.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), Lj = () => {
  const [n, i] = K.useState(document.hidden);
  return K.useEffect(() => {
    const l = () => {
      i(document.hidden);
    };
    return document.addEventListener("visibilitychange", l), () => window.removeEventListener("visibilitychange", l);
  }, []), n;
};
let Eh = 1;
class Pj {
  constructor() {
    this.subscribe = (i) => (this.subscribers.push(i), () => {
      const l = this.subscribers.indexOf(i);
      this.subscribers.splice(l, 1);
    }), this.publish = (i) => {
      this.subscribers.forEach((l) => l(i));
    }, this.addToast = (i) => {
      this.publish(i), this.toasts = [
        ...this.toasts,
        i
      ];
    }, this.create = (i) => {
      var l;
      const { message: o, ...d } = i, f = typeof i?.id == "number" || ((l = i.id) == null ? void 0 : l.length) > 0 ? i.id : Eh++, h = this.toasts.find((g) => g.id === f), p = i.dismissible === void 0 ? !0 : i.dismissible;
      return this.dismissedToasts.has(f) && this.dismissedToasts.delete(f), h ? this.toasts = this.toasts.map((g) => g.id === f ? (this.publish({
        ...g,
        ...i,
        id: f,
        title: o
      }), {
        ...g,
        ...i,
        id: f,
        dismissible: p,
        title: o
      }) : g) : this.addToast({
        title: o,
        ...d,
        dismissible: p,
        id: f
      }), f;
    }, this.dismiss = (i) => (i ? (this.dismissedToasts.add(i), requestAnimationFrame(() => this.subscribers.forEach((l) => l({
      id: i,
      dismiss: !0
    })))) : this.toasts.forEach((l) => {
      this.subscribers.forEach((o) => o({
        id: l.id,
        dismiss: !0
      }));
    }), i), this.message = (i, l) => this.create({
      ...l,
      message: i
    }), this.error = (i, l) => this.create({
      ...l,
      message: i,
      type: "error"
    }), this.success = (i, l) => this.create({
      ...l,
      type: "success",
      message: i
    }), this.info = (i, l) => this.create({
      ...l,
      type: "info",
      message: i
    }), this.warning = (i, l) => this.create({
      ...l,
      type: "warning",
      message: i
    }), this.loading = (i, l) => this.create({
      ...l,
      type: "loading",
      message: i
    }), this.promise = (i, l) => {
      if (!l)
        return;
      let o;
      l.loading !== void 0 && (o = this.create({
        ...l,
        promise: i,
        type: "loading",
        message: l.loading,
        description: typeof l.description != "function" ? l.description : void 0
      }));
      const d = Promise.resolve(i instanceof Function ? i() : i);
      let f = o !== void 0, h;
      const p = d.then(async (m) => {
        if (h = [
          "resolve",
          m
        ], K.isValidElement(m))
          f = !1, this.create({
            id: o,
            type: "default",
            message: m
          });
        else if (Ij(m) && !m.ok) {
          f = !1;
          const y = typeof l.error == "function" ? await l.error(`HTTP error! status: ${m.status}`) : l.error, w = typeof l.description == "function" ? await l.description(`HTTP error! status: ${m.status}`) : l.description, T = typeof y == "object" && !K.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "error",
            description: w,
            ...T
          });
        } else if (m instanceof Error) {
          f = !1;
          const y = typeof l.error == "function" ? await l.error(m) : l.error, w = typeof l.description == "function" ? await l.description(m) : l.description, T = typeof y == "object" && !K.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "error",
            description: w,
            ...T
          });
        } else if (l.success !== void 0) {
          f = !1;
          const y = typeof l.success == "function" ? await l.success(m) : l.success, w = typeof l.description == "function" ? await l.description(m) : l.description, T = typeof y == "object" && !K.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "success",
            description: w,
            ...T
          });
        }
      }).catch(async (m) => {
        if (h = [
          "reject",
          m
        ], l.error !== void 0) {
          f = !1;
          const b = typeof l.error == "function" ? await l.error(m) : l.error, y = typeof l.description == "function" ? await l.description(m) : l.description, S = typeof b == "object" && !K.isValidElement(b) ? b : {
            message: b
          };
          this.create({
            id: o,
            type: "error",
            description: y,
            ...S
          });
        }
      }).finally(() => {
        f && (this.dismiss(o), o = void 0), l.finally == null || l.finally.call(l);
      }), g = () => new Promise((m, b) => p.then(() => h[0] === "reject" ? b(h[1]) : m(h[1])).catch(b));
      return typeof o != "string" && typeof o != "number" ? {
        unwrap: g
      } : Object.assign(o, {
        unwrap: g
      });
    }, this.custom = (i, l) => {
      const o = l?.id || Eh++;
      return this.create({
        jsx: i(o),
        id: o,
        ...l
      }), o;
    }, this.getActiveToasts = () => this.toasts.filter((i) => !this.dismissedToasts.has(i.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Gt = new Pj(), qj = (n, i) => {
  const l = i?.id || Eh++;
  return Gt.addToast({
    title: n,
    ...i,
    id: l
  }), l;
}, Ij = (n) => n && typeof n == "object" && "ok" in n && typeof n.ok == "boolean" && "status" in n && typeof n.status == "number", Gj = qj, Yj = () => Gt.toasts, Qj = () => Gt.getActiveToasts();
Object.assign(Gj, {
  success: Gt.success,
  info: Gt.info,
  warning: Gt.warning,
  error: Gt.error,
  custom: Gt.custom,
  message: Gt.message,
  promise: Gt.promise,
  dismiss: Gt.dismiss,
  loading: Gt.loading
}, {
  getHistory: Yj,
  getToasts: Qj
});
Oj("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function Mo(n) {
  return n.label !== void 0;
}
const Zj = 3, Xj = "24px", Kj = "16px", ny = 4e3, $j = 356, Wj = 14, Jj = 45, eS = 200;
function Un(...n) {
  return n.filter(Boolean).join(" ");
}
function tS(n) {
  const [i, l] = n.split("-"), o = [];
  return i && o.push(i), l && o.push(l), o;
}
const nS = (n) => {
  var i, l, o, d, f, h, p, g, m;
  const { invert: b, toast: y, unstyled: w, interacting: S, setHeights: T, visibleToasts: _, heights: R, index: z, toasts: Q, expanded: L, removeToast: Y, defaultRichColors: ae, closeButton: ee, style: Z, cancelButtonStyle: k, actionButtonStyle: ne, className: V = "", descriptionClassName: ie = "", duration: he, position: je, gap: ke, expandByDefault: Se, classNames: O, icons: X, closeButtonAriaLabel: te = "Close toast" } = n, [me, $] = K.useState(null), [N, P] = K.useState(null), [G, W] = K.useState(!1), [J, le] = K.useState(!1), [ve, be] = K.useState(!1), [ge, Qt] = K.useState(!1), [Rt, At] = K.useState(!1), [ma, wt] = K.useState(0), [Ls, Fi] = K.useState(0), Wa = K.useRef(y.duration || he || ny), Ps = K.useRef(null), Zt = K.useRef(null), qs = z === 0, Is = z + 1 <= _, Ct = y.type, pa = y.dismissible !== !1, Et = y.className || "", kc = y.descriptionClassName || "", Ja = K.useMemo(() => R.findIndex((xe) => xe.toastId === y.id) || 0, [
    R,
    y.id
  ]), pl = K.useMemo(() => {
    var xe;
    return (xe = y.closeButton) != null ? xe : ee;
  }, [
    y.closeButton,
    ee
  ]), ei = K.useMemo(() => y.duration || he || ny, [
    y.duration,
    he
  ]), Gs = K.useRef(0), Qn = K.useRef(0), gl = K.useRef(0), ga = K.useRef(null), [ti, kt] = je.split("-"), Nn = K.useMemo(() => R.reduce((xe, Ze, ut) => ut >= Ja ? xe : xe + Ze.height, 0), [
    R,
    Ja
  ]), jt = Lj(), Mc = y.invert || b, Ys = Ct === "loading";
  Qn.current = K.useMemo(() => Ja * ke + Nn, [
    Ja,
    Nn
  ]), K.useEffect(() => {
    Wa.current = ei;
  }, [
    ei
  ]), K.useEffect(() => {
    W(!0);
  }, []), K.useEffect(() => {
    const xe = Zt.current;
    if (xe) {
      const Ze = xe.getBoundingClientRect().height;
      return Fi(Ze), T((ut) => [
        {
          toastId: y.id,
          height: Ze,
          position: y.position
        },
        ...ut
      ]), () => T((ut) => ut.filter((St) => St.toastId !== y.id));
    }
  }, [
    T,
    y.id
  ]), K.useLayoutEffect(() => {
    if (!G) return;
    const xe = Zt.current, Ze = xe.style.height;
    xe.style.height = "auto";
    const ut = xe.getBoundingClientRect().height;
    xe.style.height = Ze, Fi(ut), T((St) => St.find((Ke) => Ke.toastId === y.id) ? St.map((Ke) => Ke.toastId === y.id ? {
      ...Ke,
      height: ut
    } : Ke) : [
      {
        toastId: y.id,
        height: ut,
        position: y.position
      },
      ...St
    ]);
  }, [
    G,
    y.title,
    y.description,
    T,
    y.id,
    y.jsx,
    y.action,
    y.cancel
  ]);
  const _n = K.useCallback(() => {
    le(!0), wt(Qn.current), T((xe) => xe.filter((Ze) => Ze.toastId !== y.id)), setTimeout(() => {
      Y(y);
    }, eS);
  }, [
    y,
    Y,
    T,
    Qn
  ]);
  K.useEffect(() => {
    if (y.promise && Ct === "loading" || y.duration === 1 / 0 || y.type === "loading") return;
    let xe;
    return L || S || jt ? (() => {
      if (gl.current < Gs.current) {
        const St = (/* @__PURE__ */ new Date()).getTime() - Gs.current;
        Wa.current = Wa.current - St;
      }
      gl.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Wa.current !== 1 / 0 && (Gs.current = (/* @__PURE__ */ new Date()).getTime(), xe = setTimeout(() => {
      y.onAutoClose == null || y.onAutoClose.call(y, y), _n();
    }, Wa.current)), () => clearTimeout(xe);
  }, [
    L,
    S,
    y,
    Ct,
    jt,
    _n
  ]), K.useEffect(() => {
    y.delete && (_n(), y.onDismiss == null || y.onDismiss.call(y, y));
  }, [
    _n,
    y.delete
  ]);
  function Bi() {
    var xe;
    if (X?.loading) {
      var Ze;
      return /* @__PURE__ */ K.createElement("div", {
        className: Un(O?.loader, y == null || (Ze = y.classNames) == null ? void 0 : Ze.loader, "sonner-loader"),
        "data-visible": Ct === "loading"
      }, X.loading);
    }
    return /* @__PURE__ */ K.createElement(Dj, {
      className: Un(O?.loader, y == null || (xe = y.classNames) == null ? void 0 : xe.loader),
      visible: Ct === "loading"
    });
  }
  const Vi = y.icon || X?.[Ct] || Rj(Ct);
  var ni, Dn;
  return /* @__PURE__ */ K.createElement("li", {
    tabIndex: 0,
    ref: Zt,
    className: Un(V, Et, O?.toast, y == null || (i = y.classNames) == null ? void 0 : i.toast, O?.default, O?.[Ct], y == null || (l = y.classNames) == null ? void 0 : l[Ct]),
    "data-sonner-toast": "",
    "data-rich-colors": (ni = y.richColors) != null ? ni : ae,
    "data-styled": !(y.jsx || y.unstyled || w),
    "data-mounted": G,
    "data-promise": !!y.promise,
    "data-swiped": Rt,
    "data-removed": J,
    "data-visible": Is,
    "data-y-position": ti,
    "data-x-position": kt,
    "data-index": z,
    "data-front": qs,
    "data-swiping": ve,
    "data-dismissible": pa,
    "data-type": Ct,
    "data-invert": Mc,
    "data-swipe-out": ge,
    "data-swipe-direction": N,
    "data-expanded": !!(L || Se && G),
    "data-testid": y.testId,
    style: {
      "--index": z,
      "--toasts-before": z,
      "--z-index": Q.length - z,
      "--offset": `${J ? ma : Qn.current}px`,
      "--initial-height": Se ? "auto" : `${Ls}px`,
      ...Z,
      ...y.style
    },
    onDragEnd: () => {
      be(!1), $(null), ga.current = null;
    },
    onPointerDown: (xe) => {
      xe.button !== 2 && (Ys || !pa || (Ps.current = /* @__PURE__ */ new Date(), wt(Qn.current), xe.target.setPointerCapture(xe.pointerId), xe.target.tagName !== "BUTTON" && (be(!0), ga.current = {
        x: xe.clientX,
        y: xe.clientY
      })));
    },
    onPointerUp: () => {
      var xe, Ze, ut;
      if (ge || !pa) return;
      ga.current = null;
      const St = Number(((xe = Zt.current) == null ? void 0 : xe.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), xa = Number(((Ze = Zt.current) == null ? void 0 : Ze.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ke = (/* @__PURE__ */ new Date()).getTime() - ((ut = Ps.current) == null ? void 0 : ut.getTime()), _t = me === "x" ? St : xa, ai = Math.abs(_t) / Ke;
      if (Math.abs(_t) >= Jj || ai > 0.11) {
        wt(Qn.current), y.onDismiss == null || y.onDismiss.call(y, y), P(me === "x" ? St > 0 ? "right" : "left" : xa > 0 ? "down" : "up"), _n(), Qt(!0);
        return;
      } else {
        var Dt, Ft;
        (Dt = Zt.current) == null || Dt.style.setProperty("--swipe-amount-x", "0px"), (Ft = Zt.current) == null || Ft.style.setProperty("--swipe-amount-y", "0px");
      }
      At(!1), be(!1), $(null);
    },
    onPointerMove: (xe) => {
      var Ze, ut, St;
      if (!ga.current || !pa || ((Ze = window.getSelection()) == null ? void 0 : Ze.toString().length) > 0) return;
      const Ke = xe.clientY - ga.current.y, _t = xe.clientX - ga.current.x;
      var ai;
      const Dt = (ai = n.swipeDirections) != null ? ai : tS(je);
      !me && (Math.abs(_t) > 1 || Math.abs(Ke) > 1) && $(Math.abs(_t) > Math.abs(Ke) ? "x" : "y");
      let Ft = {
        x: 0,
        y: 0
      };
      const Hi = (Tn) => 1 / (1.5 + Math.abs(Tn) / 20);
      if (me === "y") {
        if (Dt.includes("top") || Dt.includes("bottom"))
          if (Dt.includes("top") && Ke < 0 || Dt.includes("bottom") && Ke > 0)
            Ft.y = Ke;
          else {
            const Tn = Ke * Hi(Ke);
            Ft.y = Math.abs(Tn) < Math.abs(Ke) ? Tn : Ke;
          }
      } else if (me === "x" && (Dt.includes("left") || Dt.includes("right")))
        if (Dt.includes("left") && _t < 0 || Dt.includes("right") && _t > 0)
          Ft.x = _t;
        else {
          const Tn = _t * Hi(_t);
          Ft.x = Math.abs(Tn) < Math.abs(_t) ? Tn : _t;
        }
      (Math.abs(Ft.x) > 0 || Math.abs(Ft.y) > 0) && At(!0), (ut = Zt.current) == null || ut.style.setProperty("--swipe-amount-x", `${Ft.x}px`), (St = Zt.current) == null || St.style.setProperty("--swipe-amount-y", `${Ft.y}px`);
    }
  }, pl && !y.jsx && Ct !== "loading" ? /* @__PURE__ */ K.createElement("button", {
    "aria-label": te,
    "data-disabled": Ys,
    "data-close-button": !0,
    onClick: Ys || !pa ? () => {
    } : () => {
      _n(), y.onDismiss == null || y.onDismiss.call(y, y);
    },
    className: Un(O?.closeButton, y == null || (o = y.classNames) == null ? void 0 : o.closeButton)
  }, (Dn = X?.close) != null ? Dn : Uj) : null, (Ct || y.icon || y.promise) && y.icon !== null && (X?.[Ct] !== null || y.icon) ? /* @__PURE__ */ K.createElement("div", {
    "data-icon": "",
    className: Un(O?.icon, y == null || (d = y.classNames) == null ? void 0 : d.icon)
  }, y.promise || y.type === "loading" && !y.icon ? y.icon || Bi() : null, y.type !== "loading" ? Vi : null) : null, /* @__PURE__ */ K.createElement("div", {
    "data-content": "",
    className: Un(O?.content, y == null || (f = y.classNames) == null ? void 0 : f.content)
  }, /* @__PURE__ */ K.createElement("div", {
    "data-title": "",
    className: Un(O?.title, y == null || (h = y.classNames) == null ? void 0 : h.title)
  }, y.jsx ? y.jsx : typeof y.title == "function" ? y.title() : y.title), y.description ? /* @__PURE__ */ K.createElement("div", {
    "data-description": "",
    className: Un(ie, kc, O?.description, y == null || (p = y.classNames) == null ? void 0 : p.description)
  }, typeof y.description == "function" ? y.description() : y.description) : null), /* @__PURE__ */ K.isValidElement(y.cancel) ? y.cancel : y.cancel && Mo(y.cancel) ? /* @__PURE__ */ K.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: y.cancelButtonStyle || k,
    onClick: (xe) => {
      Mo(y.cancel) && pa && (y.cancel.onClick == null || y.cancel.onClick.call(y.cancel, xe), _n());
    },
    className: Un(O?.cancelButton, y == null || (g = y.classNames) == null ? void 0 : g.cancelButton)
  }, y.cancel.label) : null, /* @__PURE__ */ K.isValidElement(y.action) ? y.action : y.action && Mo(y.action) ? /* @__PURE__ */ K.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: y.actionButtonStyle || ne,
    onClick: (xe) => {
      Mo(y.action) && (y.action.onClick == null || y.action.onClick.call(y.action, xe), !xe.defaultPrevented && _n());
    },
    className: Un(O?.actionButton, y == null || (m = y.classNames) == null ? void 0 : m.actionButton)
  }, y.action.label) : null);
};
function ay() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const n = document.documentElement.getAttribute("dir");
  return n === "auto" || !n ? window.getComputedStyle(document.documentElement).direction : n;
}
function aS(n, i) {
  const l = {};
  return [
    n,
    i
  ].forEach((o, d) => {
    const f = d === 1, h = f ? "--mobile-offset" : "--offset", p = f ? Kj : Xj;
    function g(m) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((b) => {
        l[`${h}-${b}`] = typeof m == "number" ? `${m}px` : m;
      });
    }
    typeof o == "number" || typeof o == "string" ? g(o) : typeof o == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((m) => {
      o[m] === void 0 ? l[`${h}-${m}`] = p : l[`${h}-${m}`] = typeof o[m] == "number" ? `${o[m]}px` : o[m];
    }) : g(p);
  }), l;
}
const iS = /* @__PURE__ */ K.forwardRef(function(i, l) {
  const { id: o, invert: d, position: f = "bottom-right", hotkey: h = [
    "altKey",
    "KeyT"
  ], expand: p, closeButton: g, className: m, offset: b, mobileOffset: y, theme: w = "light", richColors: S, duration: T, style: _, visibleToasts: R = Zj, toastOptions: z, dir: Q = ay(), gap: L = Wj, icons: Y, containerAriaLabel: ae = "Notifications" } = i, [ee, Z] = K.useState([]), k = K.useMemo(() => o ? ee.filter((G) => G.toasterId === o) : ee.filter((G) => !G.toasterId), [
    ee,
    o
  ]), ne = K.useMemo(() => Array.from(new Set([
    f
  ].concat(k.filter((G) => G.position).map((G) => G.position)))), [
    k,
    f
  ]), [V, ie] = K.useState([]), [he, je] = K.useState(!1), [ke, Se] = K.useState(!1), [O, X] = K.useState(w !== "system" ? w : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), te = K.useRef(null), me = h.join("+").replace(/Key/g, "").replace(/Digit/g, ""), $ = K.useRef(null), N = K.useRef(!1), P = K.useCallback((G) => {
    Z((W) => {
      var J;
      return (J = W.find((le) => le.id === G.id)) != null && J.delete || Gt.dismiss(G.id), W.filter(({ id: le }) => le !== G.id);
    });
  }, []);
  return K.useEffect(() => Gt.subscribe((G) => {
    if (G.dismiss) {
      requestAnimationFrame(() => {
        Z((W) => W.map((J) => J.id === G.id ? {
          ...J,
          delete: !0
        } : J));
      });
      return;
    }
    setTimeout(() => {
      zj.flushSync(() => {
        Z((W) => {
          const J = W.findIndex((le) => le.id === G.id);
          return J !== -1 ? [
            ...W.slice(0, J),
            {
              ...W[J],
              ...G
            },
            ...W.slice(J + 1)
          ] : [
            G,
            ...W
          ];
        });
      });
    });
  }), [
    ee
  ]), K.useEffect(() => {
    if (w !== "system") {
      X(w);
      return;
    }
    if (w === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? X("dark") : X("light")), typeof window > "u") return;
    const G = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      G.addEventListener("change", ({ matches: W }) => {
        X(W ? "dark" : "light");
      });
    } catch {
      G.addListener(({ matches: J }) => {
        try {
          X(J ? "dark" : "light");
        } catch (le) {
          console.error(le);
        }
      });
    }
  }, [
    w
  ]), K.useEffect(() => {
    ee.length <= 1 && je(!1);
  }, [
    ee
  ]), K.useEffect(() => {
    const G = (W) => {
      var J;
      if (h.every((be) => W[be] || W.code === be)) {
        var ve;
        je(!0), (ve = te.current) == null || ve.focus();
      }
      W.code === "Escape" && (document.activeElement === te.current || (J = te.current) != null && J.contains(document.activeElement)) && je(!1);
    };
    return document.addEventListener("keydown", G), () => document.removeEventListener("keydown", G);
  }, [
    h
  ]), K.useEffect(() => {
    if (te.current)
      return () => {
        $.current && ($.current.focus({
          preventScroll: !0
        }), $.current = null, N.current = !1);
      };
  }, [
    te.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ K.createElement("section", {
    ref: l,
    "aria-label": `${ae} ${me}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, ne.map((G, W) => {
    var J;
    const [le, ve] = G.split("-");
    return k.length ? /* @__PURE__ */ K.createElement("ol", {
      key: G,
      dir: Q === "auto" ? ay() : Q,
      tabIndex: -1,
      ref: te,
      className: m,
      "data-sonner-toaster": !0,
      "data-sonner-theme": O,
      "data-y-position": le,
      "data-x-position": ve,
      style: {
        "--front-toast-height": `${((J = V[0]) == null ? void 0 : J.height) || 0}px`,
        "--width": `${$j}px`,
        "--gap": `${L}px`,
        ..._,
        ...aS(b, y)
      },
      onBlur: (be) => {
        N.current && !be.currentTarget.contains(be.relatedTarget) && (N.current = !1, $.current && ($.current.focus({
          preventScroll: !0
        }), $.current = null));
      },
      onFocus: (be) => {
        be.target instanceof HTMLElement && be.target.dataset.dismissible === "false" || N.current || (N.current = !0, $.current = be.relatedTarget);
      },
      onMouseEnter: () => je(!0),
      onMouseMove: () => je(!0),
      onMouseLeave: () => {
        ke || je(!1);
      },
      onDragEnd: () => je(!1),
      onPointerDown: (be) => {
        be.target instanceof HTMLElement && be.target.dataset.dismissible === "false" || Se(!0);
      },
      onPointerUp: () => Se(!1)
    }, k.filter((be) => !be.position && W === 0 || be.position === G).map((be, ge) => {
      var Qt, Rt;
      return /* @__PURE__ */ K.createElement(nS, {
        key: be.id,
        icons: Y,
        index: ge,
        toast: be,
        defaultRichColors: S,
        duration: (Qt = z?.duration) != null ? Qt : T,
        className: z?.className,
        descriptionClassName: z?.descriptionClassName,
        invert: d,
        visibleToasts: R,
        closeButton: (Rt = z?.closeButton) != null ? Rt : g,
        interacting: ke,
        position: G,
        style: z?.style,
        unstyled: z?.unstyled,
        classNames: z?.classNames,
        cancelButtonStyle: z?.cancelButtonStyle,
        actionButtonStyle: z?.actionButtonStyle,
        closeButtonAriaLabel: z?.closeButtonAriaLabel,
        removeToast: P,
        toasts: k.filter((At) => At.position == be.position),
        heights: V.filter((At) => At.position == be.position),
        setHeights: ie,
        expandByDefault: p,
        gap: L,
        expanded: he,
        swipeDirections: i.swipeDirections
      });
    })) : null;
  }));
}), sS = ({ ...n }) => {
  const { theme: i = "system" } = kj();
  return /* @__PURE__ */ s.jsx(
    iS,
    {
      theme: i,
      className: "toaster group",
      style: {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)"
      },
      ...n
    }
  );
};
var rS = Object.defineProperty, df = (n, i) => rS(n, "name", { value: i, configurable: !0 });
function kh(n, i) {
  if (typeof n == "function")
    return n(i);
  n != null && (n.current = i);
}
df(kh, "setRef");
function pv(...n) {
  return (i) => {
    let l = !1;
    const o = n.map((d) => {
      const f = kh(d, i);
      return !l && typeof f == "function" && (l = !0), f;
    });
    if (l)
      return () => {
        for (let d = 0; d < o.length; d++) {
          const f = o[d];
          typeof f == "function" ? f() : kh(n[d], null);
        }
      };
  };
}
df(pv, "composeRefs");
function gv(...n) {
  return C.useCallback(pv(...n), n);
}
df(gv, "useComposedRefs");
var lS = Object.defineProperty, wn = (n, i) => lS(n, "name", { value: i, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function oS(n, i) {
  const l = C.createContext(i);
  l.displayName = n + "Context";
  const o = /* @__PURE__ */ wn((f) => {
    const { children: h, ...p } = f, g = C.useMemo(() => p, Object.values(p));
    return /* @__PURE__ */ s.jsx(l.Provider, { value: g, children: h });
  }, "Provider");
  o.displayName = n + "Provider";
  function d(f, h = {}) {
    const { optional: p = !1 } = h, g = C.useContext(l);
    if (g) return g;
    if (i !== void 0) return i;
    if (!p)
      throw new Error(`\`${f}\` must be used within \`${n}\``);
  }
  return wn(d, "useContext"), [o, d];
}
wn(oS, "createContext");
// @__NO_SIDE_EFFECTS__
function hf(n, i = []) {
  let l = [];
  function o(f, h) {
    const p = C.createContext(h);
    p.displayName = f + "Context";
    const g = l.length;
    l = [...l, h];
    const m = /* @__PURE__ */ wn((y) => {
      const { scope: w, children: S, ...T } = y, _ = w?.[n]?.[g] || p, R = C.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ s.jsx(_.Provider, { value: R, children: S });
    }, "Provider");
    m.displayName = f + "Provider";
    function b(y, w, S = {}) {
      const { optional: T = !1 } = S, _ = w?.[n]?.[g] || p, R = C.useContext(_);
      if (R) return R;
      if (h !== void 0) return h;
      if (!T)
        throw new Error(`\`${y}\` must be used within \`${f}\``);
    }
    return wn(b, "useContext"), [m, b];
  }
  wn(o, "createContext");
  const d = /* @__PURE__ */ wn(() => {
    const f = l.map((h) => C.createContext(h));
    return /* @__PURE__ */ wn(function(p) {
      const g = p?.[n] || f;
      return C.useMemo(
        () => ({ [`__scope${n}`]: { ...p, [n]: g } }),
        [p, g]
      );
    }, "useScope");
  }, "createScope");
  return d.scopeName = n, [o, xv(d, ...i)];
}
wn(hf, "createContextScope");
function xv(...n) {
  const i = n[0];
  if (n.length === 1) return i;
  const l = /* @__PURE__ */ wn(() => {
    const o = n.map((d) => ({
      useScope: d(),
      scopeName: d.scopeName
    }));
    return /* @__PURE__ */ wn(function(f) {
      const h = o.reduce((p, { useScope: g, scopeName: m }) => {
        const y = g(f)[`__scope${m}`];
        return { ...p, ...y };
      }, {});
      return C.useMemo(() => ({ [`__scope${i.scopeName}`]: h }), [h]);
    }, "useComposedScopes");
  }, "createScope");
  return l.scopeName = i.scopeName, l;
}
wn(xv, "composeContextScopes");
var cS = Object.defineProperty, Rn = (n, i) => cS(n, "name", { value: i, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function yv(n) {
  const i = C.forwardRef((l, o) => {
    let { children: d, ...f } = l, h = null, p = !1;
    const g = [];
    Mh(d) && typeof zo == "function" && (d = zo(d._payload)), C.Children.forEach(d, (w) => {
      if (jv(w)) {
        p = !0;
        const S = w;
        let T = "child" in S.props ? S.props.child : S.props.children;
        Mh(T) && typeof zo == "function" && (T = zo(T._payload)), h = hS(S, T), g.push(h?.props?.children);
      } else
        g.push(w);
    }), h ? h = C.cloneElement(h, void 0, g) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !p && C.Children.count(d) === 1 && C.isValidElement(d) && (h = d)
    );
    const m = h ? wv(h) : void 0, b = gv(o, m);
    if (!h) {
      if (d || d === 0)
        throw new Error(
          p ? pS(n) : mS(n)
        );
      return d;
    }
    const y = vv(f, h.props ?? {});
    return h.type !== C.Fragment && (y.ref = o ? b : m), C.cloneElement(h, y);
  });
  return i.displayName = `${n}.Slot`, i;
}
Rn(yv, "createSlot");
var uS = /* @__PURE__ */ yv("Slot"), bv = /* @__PURE__ */ Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function dS(n) {
  const i = /* @__PURE__ */ Rn((l) => "child" in l ? l.children(l.child) : l.children, "Slottable");
  return i.displayName = `${n}.Slottable`, i.__radixId = bv, i;
}
Rn(dS, "createSlottable");
var hS = /* @__PURE__ */ Rn((n, i) => {
  if ("child" in n.props) {
    const l = n.props.child;
    return C.isValidElement(l) ? C.cloneElement(l, void 0, n.props.children(l.props.children)) : null;
  }
  return C.isValidElement(i) ? i : null;
}, "getSlottableElementFromSlottable");
function vv(n, i) {
  const l = { ...i };
  for (const o in i) {
    const d = n[o], f = i[o];
    /^on[A-Z]/.test(o) ? d && f ? l[o] = (...p) => {
      const g = f(...p);
      return d(...p), g;
    } : d && (l[o] = d) : o === "style" ? l[o] = { ...d, ...f } : o === "className" && (l[o] = [d, f].filter(Boolean).join(" "));
  }
  return { ...n, ...l };
}
Rn(vv, "mergeProps");
function wv(n) {
  let i = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, l = i && "isReactWarning" in i && i.isReactWarning;
  return l ? n.ref : (i = Object.getOwnPropertyDescriptor(n, "ref")?.get, l = i && "isReactWarning" in i && i.isReactWarning, l ? n.props.ref : n.props.ref || n.ref);
}
Rn(wv, "getElementRef");
function jv(n) {
  return C.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === bv;
}
Rn(jv, "isSlottable");
var fS = /* @__PURE__ */ Symbol.for("react.lazy");
function Mh(n) {
  return n != null && typeof n == "object" && "$$typeof" in n && n.$$typeof === fS && "_payload" in n && Sv(n._payload);
}
Rn(Mh, "isLazyComponent");
function Sv(n) {
  return typeof n == "object" && n !== null && "then" in n;
}
Rn(Sv, "isPromiseLike");
var mS = /* @__PURE__ */ Rn((n) => `${n} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), pS = /* @__PURE__ */ Rn((n) => `${n} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), zo = mv[" use ".trim().toString()], gS = Object.defineProperty, Nv = (n, i) => gS(n, "name", { value: i, configurable: !0 }), Tv = "Popper", [Av, Cv] = /* @__PURE__ */ hf(Tv), [OE, RE] = Av(Tv), xS = "PopperContent", [_E, DE] = Av(xS);
function yS(n) {
  return n !== null;
}
Nv(yS, "isNotNull");
function bS(n) {
  const [i, l = "center"] = n.split("-");
  return [i, l];
}
Nv(bS, "getSideAndAlignFromPlacement");
var vS = Object.defineProperty, _i = (n, i) => vS(n, "name", { value: i, configurable: !0 }), [ff, FE] = /* @__PURE__ */ hf("Tooltip", [
  Cv
]);
Cv();
var wS = "TooltipProvider", jS = 700, [SS, BE] = ff(wS), NS = /* @__PURE__ */ _i((n) => {
  const {
    __scopeTooltip: i,
    delayDuration: l = jS,
    skipDelayDuration: o = 300,
    disableHoverableContent: d = !1,
    children: f
  } = n, h = C.useRef(!0), p = C.useRef(!1), g = C.useRef(0);
  return C.useEffect(() => {
    const m = g.current;
    return () => window.clearTimeout(m);
  }, []), /* @__PURE__ */ s.jsx(
    SS,
    {
      scope: i,
      isOpenDelayedRef: h,
      delayDuration: l,
      onOpen: C.useCallback(() => {
        o <= 0 || (window.clearTimeout(g.current), h.current = !1);
      }, [o]),
      onClose: C.useCallback(() => {
        o <= 0 || (window.clearTimeout(g.current), g.current = window.setTimeout(
          () => h.current = !0,
          o
        ));
      }, [o]),
      isPointerInTransitRef: p,
      onPointerInTransitChange: C.useCallback((m) => {
        p.current = m;
      }, []),
      disableHoverableContent: d,
      children: f
    }
  );
}, "TooltipProvider"), TS = "Tooltip", [VE, HE] = ff(TS), AS = "TooltipPortal", [UE, LE] = ff(AS, {
  forceMount: void 0
});
function CS(n, i) {
  const l = Math.abs(i.top - n.y), o = Math.abs(i.bottom - n.y), d = Math.abs(i.right - n.x), f = Math.abs(i.left - n.x);
  switch (Math.min(l, o, d, f)) {
    case f:
      return "left";
    case d:
      return "right";
    case l:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
_i(CS, "getExitSideFromRect");
function ES(n, i, l = 5) {
  const o = [];
  switch (i) {
    case "top":
      o.push(
        { x: n.x - l, y: n.y + l },
        { x: n.x + l, y: n.y + l }
      );
      break;
    case "bottom":
      o.push(
        { x: n.x - l, y: n.y - l },
        { x: n.x + l, y: n.y - l }
      );
      break;
    case "left":
      o.push(
        { x: n.x + l, y: n.y - l },
        { x: n.x + l, y: n.y + l }
      );
      break;
    case "right":
      o.push(
        { x: n.x - l, y: n.y - l },
        { x: n.x - l, y: n.y + l }
      );
      break;
  }
  return o;
}
_i(ES, "getPaddedExitPoints");
function kS(n) {
  const { top: i, right: l, bottom: o, left: d } = n;
  return [
    { x: d, y: i },
    { x: l, y: i },
    { x: l, y: o },
    { x: d, y: o }
  ];
}
_i(kS, "getPointsFromRect");
function MS(n, i) {
  const { x: l, y: o } = n;
  let d = !1;
  for (let f = 0, h = i.length - 1; f < i.length; h = f++) {
    const p = i[f], g = i[h], m = p.x, b = p.y, y = g.x, w = g.y;
    b > o != w > o && l < (y - m) * (o - b) / (w - b) + m && (d = !d);
  }
  return d;
}
_i(MS, "isPointInPolygon");
function zS(n) {
  const i = n.slice();
  return i.sort((l, o) => l.x < o.x ? -1 : l.x > o.x ? 1 : l.y < o.y ? -1 : l.y > o.y ? 1 : 0), Ev(i);
}
_i(zS, "getHull");
function Ev(n) {
  if (n.length <= 1) return n.slice();
  const i = [];
  for (let o = 0; o < n.length; o++) {
    const d = n[o];
    for (; i.length >= 2; ) {
      const f = i[i.length - 1], h = i[i.length - 2];
      if ((f.x - h.x) * (d.y - h.y) >= (f.y - h.y) * (d.x - h.x)) i.pop();
      else break;
    }
    i.push(d);
  }
  i.pop();
  const l = [];
  for (let o = n.length - 1; o >= 0; o--) {
    const d = n[o];
    for (; l.length >= 2; ) {
      const f = l[l.length - 1], h = l[l.length - 2];
      if ((f.x - h.x) * (d.y - h.y) >= (f.y - h.y) * (d.x - h.x)) l.pop();
      else break;
    }
    l.push(d);
  }
  return l.pop(), i.length === 1 && l.length === 1 && i[0].x === l[0].x && i[0].y === l[0].y ? i : i.concat(l);
}
_i(Ev, "getHullPresorted");
var OS = NS;
function kv(n) {
  var i, l, o = "";
  if (typeof n == "string" || typeof n == "number") o += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var d = n.length;
    for (i = 0; i < d; i++) n[i] && (l = kv(n[i])) && (o && (o += " "), o += l);
  } else for (l in n) n[l] && (o && (o += " "), o += l);
  return o;
}
function Mv() {
  for (var n, i, l = 0, o = "", d = arguments.length; l < d; l++) (n = arguments[l]) && (i = kv(n)) && (o && (o += " "), o += i);
  return o;
}
const RS = (n, i) => {
  const l = new Array(n.length + i.length);
  for (let o = 0; o < n.length; o++)
    l[o] = n[o];
  for (let o = 0; o < i.length; o++)
    l[n.length + o] = i[o];
  return l;
}, _S = (n, i) => ({
  classGroupId: n,
  validator: i
}), zv = (n = /* @__PURE__ */ new Map(), i = null, l) => ({
  nextPart: n,
  validators: i,
  classGroupId: l
}), ac = "-", iy = [], DS = "arbitrary..", FS = (n) => {
  const i = VS(n), {
    conflictingClassGroups: l,
    conflictingClassGroupModifiers: o
  } = n;
  return {
    getClassGroupId: (h) => {
      if (h.startsWith("[") && h.endsWith("]"))
        return BS(h);
      const p = h.split(ac), g = p[0] === "" && p.length > 1 ? 1 : 0;
      return Ov(p, g, i);
    },
    getConflictingClassGroupIds: (h, p) => {
      if (p) {
        const g = o[h], m = l[h];
        return g ? m ? RS(m, g) : g : m || iy;
      }
      return l[h] || iy;
    }
  };
}, Ov = (n, i, l) => {
  if (n.length - i === 0)
    return l.classGroupId;
  const d = n[i], f = l.nextPart.get(d);
  if (f) {
    const m = Ov(n, i + 1, f);
    if (m) return m;
  }
  const h = l.validators;
  if (h === null)
    return;
  const p = i === 0 ? n.join(ac) : n.slice(i).join(ac), g = h.length;
  for (let m = 0; m < g; m++) {
    const b = h[m];
    if (b.validator(p))
      return b.classGroupId;
  }
}, BS = (n) => n.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const i = n.slice(1, -1), l = i.indexOf(":"), o = i.slice(0, l);
  return o ? DS + o : void 0;
})(), VS = (n) => {
  const {
    theme: i,
    classGroups: l
  } = n;
  return HS(l, i);
}, HS = (n, i) => {
  const l = zv();
  for (const o in n) {
    const d = n[o];
    mf(d, l, o, i);
  }
  return l;
}, mf = (n, i, l, o) => {
  const d = n.length;
  for (let f = 0; f < d; f++) {
    const h = n[f];
    US(h, i, l, o);
  }
}, US = (n, i, l, o) => {
  if (typeof n == "string") {
    LS(n, i, l);
    return;
  }
  if (typeof n == "function") {
    PS(n, i, l, o);
    return;
  }
  qS(n, i, l, o);
}, LS = (n, i, l) => {
  const o = n === "" ? i : Rv(i, n);
  o.classGroupId = l;
}, PS = (n, i, l, o) => {
  if (IS(n)) {
    mf(n(o), i, l, o);
    return;
  }
  i.validators === null && (i.validators = []), i.validators.push(_S(l, n));
}, qS = (n, i, l, o) => {
  const d = Object.entries(n), f = d.length;
  for (let h = 0; h < f; h++) {
    const [p, g] = d[h];
    mf(g, Rv(i, p), l, o);
  }
}, Rv = (n, i) => {
  let l = n;
  const o = i.split(ac), d = o.length;
  for (let f = 0; f < d; f++) {
    const h = o[f];
    let p = l.nextPart.get(h);
    p || (p = zv(), l.nextPart.set(h, p)), l = p;
  }
  return l;
}, IS = (n) => "isThemeGetter" in n && n.isThemeGetter === !0, GS = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let i = 0, l = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  const d = (f, h) => {
    l[f] = h, i++, i > n && (i = 0, o = l, l = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(f) {
      let h = l[f];
      if (h !== void 0)
        return h;
      if ((h = o[f]) !== void 0)
        return d(f, h), h;
    },
    set(f, h) {
      f in l ? l[f] = h : d(f, h);
    }
  };
}, zh = "!", sy = ":", YS = [], ry = (n, i, l, o, d) => ({
  modifiers: n,
  hasImportantModifier: i,
  baseClassName: l,
  maybePostfixModifierPosition: o,
  isExternal: d
}), QS = (n) => {
  const {
    prefix: i,
    experimentalParseClassName: l
  } = n;
  let o = (d) => {
    const f = [];
    let h = 0, p = 0, g = 0, m;
    const b = d.length;
    for (let _ = 0; _ < b; _++) {
      const R = d[_];
      if (h === 0 && p === 0) {
        if (R === sy) {
          f.push(d.slice(g, _)), g = _ + 1;
          continue;
        }
        if (R === "/") {
          m = _;
          continue;
        }
      }
      R === "[" ? h++ : R === "]" ? h-- : R === "(" ? p++ : R === ")" && p--;
    }
    const y = f.length === 0 ? d : d.slice(g);
    let w = y, S = !1;
    y.endsWith(zh) ? (w = y.slice(0, -1), S = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      y.startsWith(zh) && (w = y.slice(1), S = !0)
    );
    const T = m && m > g ? m - g : void 0;
    return ry(f, S, w, T);
  };
  if (i) {
    const d = i + sy, f = o;
    o = (h) => h.startsWith(d) ? f(h.slice(d.length)) : ry(YS, !1, h, void 0, !0);
  }
  if (l) {
    const d = o;
    o = (f) => l({
      className: f,
      parseClassName: d
    });
  }
  return o;
}, ZS = (n) => {
  const i = /* @__PURE__ */ new Map();
  return n.orderSensitiveModifiers.forEach((l, o) => {
    i.set(l, 1e6 + o);
  }), (l) => {
    const o = [];
    let d = [];
    for (let f = 0; f < l.length; f++) {
      const h = l[f], p = h[0] === "[", g = i.has(h);
      p || g ? (d.length > 0 && (d.sort(), o.push(...d), d = []), o.push(h)) : d.push(h);
    }
    return d.length > 0 && (d.sort(), o.push(...d)), o;
  };
}, XS = (n) => ({
  cache: GS(n.cacheSize),
  parseClassName: QS(n),
  sortModifiers: ZS(n),
  postfixLookupClassGroupIds: KS(n),
  ...FS(n)
}), KS = (n) => {
  const i = /* @__PURE__ */ Object.create(null), l = n.postfixLookupClassGroups;
  if (l)
    for (let o = 0; o < l.length; o++)
      i[l[o]] = !0;
  return i;
}, $S = /\s+/, WS = (n, i) => {
  const {
    parseClassName: l,
    getClassGroupId: o,
    getConflictingClassGroupIds: d,
    sortModifiers: f,
    postfixLookupClassGroupIds: h
  } = i, p = [], g = n.trim().split($S);
  let m = "";
  for (let b = g.length - 1; b >= 0; b -= 1) {
    const y = g[b], {
      isExternal: w,
      modifiers: S,
      hasImportantModifier: T,
      baseClassName: _,
      maybePostfixModifierPosition: R
    } = l(y);
    if (w) {
      m = y + (m.length > 0 ? " " + m : m);
      continue;
    }
    let z = !!R, Q;
    if (z) {
      const Z = _.substring(0, R);
      Q = o(Z);
      const k = Q && h[Q] ? o(_) : void 0;
      k && k !== Q && (Q = k, z = !1);
    } else
      Q = o(_);
    if (!Q) {
      if (!z) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      if (Q = o(_), !Q) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      z = !1;
    }
    const L = S.length === 0 ? "" : S.length === 1 ? S[0] : f(S).join(":"), Y = T ? L + zh : L, ae = Y + Q;
    if (p.indexOf(ae) > -1)
      continue;
    p.push(ae);
    const ee = d(Q, z);
    for (let Z = 0; Z < ee.length; ++Z) {
      const k = ee[Z];
      p.push(Y + k);
    }
    m = y + (m.length > 0 ? " " + m : m);
  }
  return m;
}, JS = (...n) => {
  let i = 0, l, o, d = "";
  for (; i < n.length; )
    (l = n[i++]) && (o = _v(l)) && (d && (d += " "), d += o);
  return d;
}, _v = (n) => {
  if (typeof n == "string")
    return n;
  let i, l = "";
  for (let o = 0; o < n.length; o++)
    n[o] && (i = _v(n[o])) && (l && (l += " "), l += i);
  return l;
}, eN = (n, ...i) => {
  let l, o, d, f;
  const h = (g) => {
    const m = i.reduce((b, y) => y(b), n());
    return l = XS(m), o = l.cache.get, d = l.cache.set, f = p, p(g);
  }, p = (g) => {
    const m = o(g);
    if (m)
      return m;
    const b = WS(g, l);
    return d(g, b), b;
  };
  return f = h, (...g) => f(JS(...g));
}, tN = [], ot = (n) => {
  const i = (l) => l[n] || tN;
  return i.isThemeGetter = !0, i;
}, Dv = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Fv = /^\((?:(\w[\w-]*):)?(.+)\)$/i, nN = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, aN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, iN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, sN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, rN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, lN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Pa = (n) => nN.test(n), Te = (n) => !!n && !Number.isNaN(Number(n)), Ln = (n) => !!n && Number.isInteger(Number(n)), Qd = (n) => n.endsWith("%") && Te(n.slice(0, -1)), ha = (n) => aN.test(n), Bv = () => !0, oN = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  iN.test(n) && !sN.test(n)
), pf = () => !1, cN = (n) => rN.test(n), uN = (n) => lN.test(n), dN = (n) => !se(n) && !oe(n), hN = (n) => n.startsWith("@container") && (n[10] === "/" && n[11] !== void 0 || n[11] === "s" && n[16] !== void 0 && n.startsWith("-size/", 10) || n[11] === "n" && n[18] !== void 0 && n.startsWith("-normal/", 10)), fN = (n) => Ka(n, Uv, pf), se = (n) => Dv.test(n), wi = (n) => Ka(n, Lv, oN), ly = (n) => Ka(n, wN, Te), mN = (n) => Ka(n, qv, Bv), pN = (n) => Ka(n, Pv, pf), oy = (n) => Ka(n, Vv, pf), gN = (n) => Ka(n, Hv, uN), Oo = (n) => Ka(n, Iv, cN), oe = (n) => Fv.test(n), Vr = (n) => Di(n, Lv), xN = (n) => Di(n, Pv), cy = (n) => Di(n, Vv), yN = (n) => Di(n, Uv), bN = (n) => Di(n, Hv), Ro = (n) => Di(n, Iv, !0), vN = (n) => Di(n, qv, !0), Ka = (n, i, l) => {
  const o = Dv.exec(n);
  return o ? o[1] ? i(o[1]) : l(o[2]) : !1;
}, Di = (n, i, l = !1) => {
  const o = Fv.exec(n);
  return o ? o[1] ? i(o[1]) : l : !1;
}, Vv = (n) => n === "position" || n === "percentage", Hv = (n) => n === "image" || n === "url", Uv = (n) => n === "length" || n === "size" || n === "bg-size", Lv = (n) => n === "length", wN = (n) => n === "number", Pv = (n) => n === "family-name", qv = (n) => n === "number" || n === "weight", Iv = (n) => n === "shadow", jN = () => {
  const n = ot("color"), i = ot("font"), l = ot("text"), o = ot("font-weight"), d = ot("tracking"), f = ot("leading"), h = ot("breakpoint"), p = ot("container"), g = ot("spacing"), m = ot("radius"), b = ot("shadow"), y = ot("inset-shadow"), w = ot("text-shadow"), S = ot("drop-shadow"), T = ot("blur"), _ = ot("perspective"), R = ot("aspect"), z = ot("ease"), Q = ot("animate"), L = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Y = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], ae = () => [...Y(), oe, se], ee = () => ["auto", "hidden", "clip", "visible", "scroll"], Z = () => ["auto", "contain", "none"], k = () => [oe, se, g], ne = () => [Pa, "full", "auto", ...k()], V = () => [Ln, "none", "subgrid", oe, se], ie = () => ["auto", {
    span: ["full", Ln, oe, se]
  }, Ln, oe, se], he = () => [Ln, "auto", oe, se], je = () => ["auto", "min", "max", "fr", oe, se], ke = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], Se = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], O = () => ["auto", ...k()], X = () => [Pa, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...k()], te = () => [Pa, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...k()], me = () => [Pa, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...k()], $ = () => [n, oe, se], N = () => [...Y(), cy, oy, {
    position: [oe, se]
  }], P = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], G = () => ["auto", "cover", "contain", yN, fN, {
    size: [oe, se]
  }], W = () => [Qd, Vr, wi], J = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    m,
    oe,
    se
  ], le = () => ["", Te, Vr, wi], ve = () => ["solid", "dashed", "dotted", "double"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ge = () => [Te, Qd, cy, oy], Qt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    T,
    oe,
    se
  ], Rt = () => ["none", Te, oe, se], At = () => ["none", Te, oe, se], ma = () => [Te, oe, se], wt = () => [Pa, "full", ...k()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [ha],
      breakpoint: [ha],
      color: [Bv],
      container: [ha],
      "drop-shadow": [ha],
      ease: ["in", "out", "in-out"],
      font: [dN],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [ha],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [ha],
      shadow: [ha],
      spacing: ["px", Te],
      text: [ha],
      "text-shadow": [ha],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Pa, se, oe, R]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", oe, se]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [hN],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Te, se, oe, p]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": L()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": L()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: ae()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: ee()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": ee()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": ee()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Z()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Z()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Z()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: ne()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": ne()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": ne()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": ne(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: ne()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": ne(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: ne()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": ne()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": ne()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: ne()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: ne()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: ne()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: ne()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Ln, "auto", oe, se]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Pa, "full", "auto", p, ...k()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Te, Pa, "auto", "initial", "none", se]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Te, oe, se]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Te, oe, se]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Ln, "first", "last", "none", oe, se]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": V()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ie()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": he()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": he()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": V()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ie()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": he()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": he()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": je()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": je()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: k()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": k()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": k()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...ke(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...Se(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...Se()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ke()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...Se(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...Se(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": ke()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...Se(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...Se()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: k()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: k()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: k()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: k()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: k()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: k()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: k()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: k()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: k()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: k()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: k()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: O()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: O()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: O()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: O()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: O()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: O()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: O()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: O()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: O()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: O()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: O()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": k()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": k()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: X()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...te()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...te()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...te()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...me()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...me()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...me()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [p, "screen", ...X()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          p,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...X()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          p,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [h]
          },
          ...X()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...X()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...X()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...X()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", l, Vr, wi]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, vN, mN]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Qd, se]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [xN, pN, i]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [se]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [d, oe, se]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Te, "none", oe, ly]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          f,
          ...k()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe, se]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", oe, se]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: $()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: $()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ve(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Te, "from-font", "auto", oe, wi]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: $()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Te, "auto", oe, se]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [Ln, oe, se]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe, se]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe, se]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: N()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: P()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: G()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Ln, oe, se],
          radial: ["", oe, se],
          conic: [Ln, oe, se]
        }, bN, gN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: $()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: W()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: W()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: W()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: $()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: $()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: $()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: J()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": J()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": J()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": J()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": J()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": J()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": J()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": J()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": J()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": J()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": J()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": J()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": J()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": J()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": J()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: le()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": le()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": le()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": le()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": le()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": le()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": le()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": le()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": le()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": le()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": le()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": le()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": le()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ve(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...ve(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: $()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": $()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": $()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": $()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": $()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": $()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": $()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": $()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": $()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": $()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": $()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: $()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...ve(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Te, oe, se]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Te, Vr, wi]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: $()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          b,
          Ro,
          Oo
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: $()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", y, Ro, Oo]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": $()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: le()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: $()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Te, wi]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": $()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": le()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": $()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", w, Ro, Oo]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": $()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Te, oe, se]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Te]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": ge()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": ge()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": $()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": $()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": ge()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": ge()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": $()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": $()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": ge()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": ge()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": $()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": $()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": ge()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": ge()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": $()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": $()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": ge()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": ge()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": $()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": $()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": ge()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": ge()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": $()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": $()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": ge()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": ge()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": $()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": $()
      }],
      "mask-image-radial": [{
        "mask-radial": [oe, se]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": ge()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": ge()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": $()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": $()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": Y()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Te]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": ge()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": ge()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": $()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": $()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: N()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: P()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: G()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", oe, se]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          se
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Qt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Te, oe, se]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Te, oe, se]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          S,
          Ro,
          Oo
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": $()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Te, oe, se]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Te, oe, se]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Te, oe, se]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Te, oe, se]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Te, oe, se]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          se
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Qt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Te, oe, se]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Te, oe, se]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Te, oe, se]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Te, oe, se]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Te, oe, se]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Te, oe, se]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Te, oe, se]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Te, oe, se]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": k()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": k()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": k()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", oe, se]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Te, "initial", oe, se]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", z, oe, se]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Te, oe, se]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", Q, oe, se]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [_, oe, se]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": ae()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Rt()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Rt()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Rt()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Rt()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: At()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": At()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": At()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": At()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ma()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ma()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ma()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [oe, se, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ae()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: wt()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": wt()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": wt()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": wt()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [Ln, oe, se]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: $()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: $()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe, se]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": $()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": $()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": k()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": k()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe, se]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...$()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Te, Vr, wi, ly]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...$()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, SN = /* @__PURE__ */ eN(jN);
function yc(...n) {
  return SN(Mv(n));
}
function NN({
  delayDuration: n = 0,
  ...i
}) {
  return /* @__PURE__ */ s.jsx(
    OS,
    {
      "data-slot": "tooltip-provider",
      delayDuration: n,
      ...i
    }
  );
}
const uy = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, dy = Mv, TN = (n, i) => (l) => {
  var o;
  if (i?.variants == null) return dy(n, l?.class, l?.className);
  const { variants: d, defaultVariants: f } = i, h = Object.keys(d).map((m) => {
    const b = l?.[m], y = f?.[m];
    if (b === null) return null;
    const w = uy(b) || uy(y);
    return d[m][w];
  }), p = l && Object.entries(l).reduce((m, b) => {
    let [y, w] = b;
    return w === void 0 || (m[y] = w), m;
  }, {}), g = i == null || (o = i.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((m, b) => {
    let { class: y, className: w, ...S } = b;
    return Object.entries(S).every((T) => {
      let [_, R] = T;
      return Array.isArray(R) ? R.includes({
        ...f,
        ...p
      }[_]) : {
        ...f,
        ...p
      }[_] === R;
    }) ? [
      ...m,
      y,
      w
    ] : m;
  }, []);
  return dy(n, h, g, l?.class, l?.className);
}, AN = TN(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-transparent shadow-xs hover:bg-accent dark:bg-transparent dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function CN({
  className: n,
  variant: i,
  size: l,
  asChild: o = !1,
  ...d
}) {
  const f = o ? uS : "button";
  return /* @__PURE__ */ s.jsx(
    f,
    {
      "data-slot": "button",
      className: yc(AN({ variant: i, size: l, className: n })),
      ...d
    }
  );
}
function EN({ className: n, ...i }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card",
      className: yc(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm",
        n
      ),
      ...i
    }
  );
}
function kN({ className: n, ...i }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-content",
      className: yc("px-6", n),
      ...i
    }
  );
}
const MN = (n) => n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Gv = (...n) => n.filter((i, l, o) => !!i && o.indexOf(i) === l).join(" ");
var zN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const ON = C.forwardRef(
  ({
    color: n = "currentColor",
    size: i = 24,
    strokeWidth: l = 2,
    absoluteStrokeWidth: o,
    className: d = "",
    children: f,
    iconNode: h,
    ...p
  }, g) => C.createElement(
    "svg",
    {
      ref: g,
      ...zN,
      width: i,
      height: i,
      stroke: n,
      strokeWidth: o ? Number(l) * 24 / Number(i) : l,
      className: Gv("lucide", d),
      ...p
    },
    [
      ...h.map(([m, b]) => C.createElement(m, b)),
      ...Array.isArray(f) ? f : [f]
    ]
  )
);
const re = (n, i) => {
  const l = C.forwardRef(
    ({ className: o, ...d }, f) => C.createElement(ON, {
      ref: f,
      iconNode: i,
      className: Gv(`lucide-${MN(n)}`, o),
      ...d
    })
  );
  return l.displayName = `${n}`, l;
};
const RN = re("Calculator", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const _N = re("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
const Yv = re("CameraOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
const el = re("Camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
const Ds = re("ChartColumn", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const Qv = re("ChartNoAxesCombined", [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
]);
const Yt = re("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
const tl = re("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
const Qr = re("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
const Zv = re("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
const DN = re("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const Xv = re("Clock3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
const FN = re("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const Oh = re("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
const BN = re("Cpu", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
const gf = re("Crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
const VN = re("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
const HN = re("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const UN = re("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
const LN = re("Files", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
const bc = re("Film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
const PN = re("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const qN = re("Headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
const IN = re("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
const GN = re("House", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
const YN = re("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const QN = re("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
const ZN = re("Layers", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  ["path", { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }],
  ["path", { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }]
]);
const zs = re("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
const Kv = re("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
const XN = re("MapPin", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
const KN = re("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const $N = re("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
const WN = re("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
const JN = re("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
const eT = re("MonitorSmartphone", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
const tT = re("Mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
const nl = re("Package", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7", key: "yx3hmr" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
const Rh = re("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
const nT = re("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
const ic = re("Radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
const aT = re("RefreshCcw", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
const iT = re("Rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
const xf = re("RotateCcw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
const ol = re("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
const sT = re("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const yf = re("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
const $v = re("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const rT = re("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
const hy = re("ShoppingBag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
const Os = re("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
const lT = re("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
const bf = re("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
const sc = re("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
const vf = re("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);
const rc = re("Target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const oT = re("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
const cT = re("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
const uT = re("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const dT = re("Trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
const Wv = re("Truck", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const fy = re("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
const wf = re("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
const Jv = re("VideoOff", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const e0 = re("Video", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
const jf = re("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
const t0 = re("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
function hT(n, i) {
  if (n instanceof RegExp) return { keys: !1, pattern: n };
  var l, o, d, f, h = [], p = "", g = n.split("/");
  for (g[0] || g.shift(); d = g.shift(); )
    l = d[0], l === "*" ? (h.push(l), p += d[1] === "?" ? "(?:/(.*))?" : "/(.*)") : l === ":" ? (o = d.indexOf("?", 1), f = d.indexOf(".", 1), h.push(d.substring(1, ~o ? o : ~f ? f : d.length)), p += ~o && !~f ? "(?:/([^/]+?))?" : "/([^/]+?)", ~f && (p += (~o ? "?" : "") + "\\" + d.substring(f))) : p += "/" + d;
  return {
    keys: h,
    pattern: new RegExp("^" + p + (i ? "(?=$|/)" : "/?$"), "i")
  };
}
var Zd = { exports: {} }, Xd = {};
var my;
function fT() {
  if (my) return Xd;
  my = 1;
  var n = xc();
  function i(y, w) {
    return y === w && (y !== 0 || 1 / y === 1 / w) || y !== y && w !== w;
  }
  var l = typeof Object.is == "function" ? Object.is : i, o = n.useState, d = n.useEffect, f = n.useLayoutEffect, h = n.useDebugValue;
  function p(y, w) {
    var S = w(), T = o({ inst: { value: S, getSnapshot: w } }), _ = T[0].inst, R = T[1];
    return f(
      function() {
        _.value = S, _.getSnapshot = w, g(_) && R({ inst: _ });
      },
      [y, S, w]
    ), d(
      function() {
        return g(_) && R({ inst: _ }), y(function() {
          g(_) && R({ inst: _ });
        });
      },
      [y]
    ), h(S), S;
  }
  function g(y) {
    var w = y.getSnapshot;
    y = y.value;
    try {
      var S = w();
      return !l(y, S);
    } catch {
      return !0;
    }
  }
  function m(y, w) {
    return w();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? m : p;
  return Xd.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : b, Xd;
}
var py;
function mT() {
  return py || (py = 1, Zd.exports = fT()), Zd.exports;
}
var pT = mT();
const gT = mv.useInsertionEffect, xT = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", yT = xT ? C.useLayoutEffect : C.useEffect, bT = gT || yT, n0 = (n) => {
  const i = C.useRef([n, (...l) => i[0](...l)]).current;
  return bT(() => {
    i[0] = n;
  }), i[1];
}, vT = "popstate", Sf = "pushState", Nf = "replaceState", wT = "hashchange", gy = [
  vT,
  Sf,
  Nf,
  wT
], jT = (n) => {
  for (const i of gy)
    addEventListener(i, n);
  return () => {
    for (const i of gy)
      removeEventListener(i, n);
  };
}, a0 = (n, i) => pT.useSyncExternalStore(jT, n, i), xy = () => location.search, ST = ({ ssrSearch: n } = {}) => a0(
  xy,
  // != null checks for both null and undefined, but allows empty string ""
  // This allows proper hydration: server renders with ssrSearch="?foo",
  // client hydrates with just <Router /> and reads from location.search
  n != null ? () => n : xy
), yy = () => location.pathname, NT = ({ ssrPath: n } = {}) => a0(
  yy,
  // != null checks for both null and undefined, but allows empty string ""
  // This allows proper hydration: server renders with ssrPath="/foo",
  // client hydrates with just <Router /> and reads from location.pathname
  n != null ? () => n : yy
), TT = (n, { replace: i = !1, state: l = null } = {}) => history[i ? Nf : Sf](l, "", n), AT = (n = {}) => [NT(n), TT], by = /* @__PURE__ */ Symbol.for("wouter_v3");
if (typeof history < "u" && typeof window[by] > "u") {
  for (const n of [Sf, Nf]) {
    const i = history[n];
    history[n] = function() {
      const l = i.apply(this, arguments), o = new Event(n);
      return o.arguments = arguments, dispatchEvent(o), l;
    };
  }
  Object.defineProperty(window, by, { value: !0 });
}
const CT = (n, i) => i.toLowerCase().indexOf(n.toLowerCase()) ? "~" + i : i.slice(n.length) || "/", i0 = (n = "") => n === "/" ? "" : n, ET = (n, i) => n[0] === "~" ? n.slice(1) : i0(i) + n, kT = (n = "", i) => CT(vy(i0(n)), vy(i)), vy = (n) => {
  try {
    return decodeURI(n);
  } catch {
    return n;
  }
}, s0 = {
  hook: AT,
  searchHook: ST,
  parser: hT,
  base: "",
  // this option is used to override the current location during SSR
  ssrPath: void 0,
  ssrSearch: void 0,
  // optional context to track render state during SSR
  ssrContext: void 0,
  // customizes how `href` props are transformed for <Link />
  hrefs: (n) => n,
  // wraps navigate calls, useful for view transitions
  aroundNav: (n, i, l) => n(i, l)
}, r0 = C.createContext(s0), cl = () => C.useContext(r0), l0 = {}, o0 = C.createContext(l0), MT = () => C.useContext(o0), vc = (n) => {
  const [i, l] = n.hook(n);
  return [
    kT(n.base, i),
    n0(
      (o, d) => n.aroundNav(l, ET(o, n.base), d)
    )
  ];
}, c0 = () => vc(cl()), u0 = (n, i, l, o) => {
  const { pattern: d, keys: f } = i instanceof RegExp ? { keys: !1, pattern: i } : n(i || "*", o), h = d.exec(l) || [], [p, ...g] = h;
  return p !== void 0 ? [
    !0,
    (() => {
      const m = f !== !1 ? Object.fromEntries(f.map((y, w) => [y, g[w]])) : h.groups;
      let b = { ...g };
      return m && Object.assign(b, m), b;
    })(),
    // the third value if only present when parser is in "loose" mode,
    // so that we can extract the base path for nested routes
    ...o ? [p] : []
  ] : [!1, null];
}, zT = ({ children: n, ...i }) => {
  const l = cl(), o = i.hook ? s0 : l;
  let d = o;
  const [f, h = i.ssrSearch ?? ""] = i.ssrPath?.split("?") ?? [];
  f && (i.ssrSearch = h, i.ssrPath = f), i.hrefs = i.hrefs ?? i.hook?.hrefs, i.searchHook = i.searchHook ?? i.hook?.searchHook;
  let p = C.useRef({}), g = p.current, m = g;
  for (let b in o) {
    const y = b === "base" ? (
      /* base is special case, it is appended to the parent's base */
      o[b] + (i[b] ?? "")
    ) : i[b] ?? o[b];
    g === m && y !== m[b] && (p.current = m = { ...m }), m[b] = y, (y !== o[b] || y !== d[b]) && (d = m);
  }
  return C.createElement(r0.Provider, { value: d, children: n });
}, wy = ({ children: n, component: i }, l) => i ? C.createElement(i, { params: l }) : typeof n == "function" ? n(l) : n, OT = (n) => {
  let i = C.useRef(l0);
  const l = i.current;
  return i.current = // Update cache if number of params changed or any value changed
  Object.keys(n).length !== Object.keys(l).length || Object.entries(n).some(([o, d]) => d !== l[o]) ? n : l;
}, Be = ({ path: n, nest: i, match: l, ...o }) => {
  const d = cl(), [f] = vc(d), [h, p, g] = (
    // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    l ?? u0(d.parser, n, f, i)
  ), m = OT({ ...MT(), ...p });
  if (!h) return null;
  const b = g ? C.createElement(zT, { base: g }, wy(o, m)) : wy(o, m);
  return C.createElement(o0.Provider, { value: m, children: b });
}, Ae = C.forwardRef((n, i) => {
  const l = cl(), [o, d] = vc(l), {
    to: f = "",
    href: h = f,
    onClick: p,
    asChild: g,
    children: m,
    className: b,
    /* eslint-disable no-unused-vars */
    replace: y,
    state: w,
    transition: S,
    /* eslint-enable no-unused-vars */
    ...T
  } = n, _ = n0((z) => {
    z.ctrlKey || z.metaKey || z.altKey || z.shiftKey || z.button !== 0 || (p?.(z), z.defaultPrevented || (z.preventDefault(), d(h, n)));
  }), R = l.hrefs(
    h[0] === "~" ? h.slice(1) : l.base + h,
    l
    // pass router as a second argument for convinience
  );
  return g && C.isValidElement(m) ? C.cloneElement(m, { onClick: _, href: R }) : C.createElement("a", {
    ...T,
    onClick: _,
    href: R,
    // `className` can be a function to apply the class if this link is active
    className: b?.call ? b(o === h) : b,
    children: m,
    ref: i
  });
}), d0 = (n) => Array.isArray(n) ? n.flatMap(
  (i) => d0(i && i.type === C.Fragment ? i.props.children : i)
) : [n], RT = ({ children: n, location: i }) => {
  const l = cl(), [o] = vc(l);
  for (const d of d0(n)) {
    let f = 0;
    if (C.isValidElement(d) && // we don't require an element to be of type Route,
    // but we do require it to contain a truthy `path` prop.
    // this allows to use different components that wrap Route
    // inside of a switch, for example <AnimatedRoute />.
    (f = u0(
      l.parser,
      d.props.path,
      i || o,
      d.props.nest
    ))[0])
      return C.cloneElement(d, { match: f });
  }
  return null;
};
function jy() {
  const [, n] = c0(), i = () => {
    n("/");
  };
  return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100", children: /* @__PURE__ */ s.jsx(EN, { className: "w-full max-w-lg mx-4 shadow-lg border-0 bg-white/80 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs(kN, { className: "pt-8 pb-8 text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex justify-center mb-6", children: /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-red-100 rounded-full animate-pulse" }),
      /* @__PURE__ */ s.jsx(DN, { className: "relative h-16 w-16 text-red-500" })
    ] }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-4xl font-bold text-slate-900 mb-2", children: "404" }),
    /* @__PURE__ */ s.jsx("h2", { className: "text-xl font-semibold text-slate-700 mb-4", children: "Page Not Found" }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600 mb-8 leading-relaxed", children: [
      "Sorry, the page you are looking for doesn't exist.",
      /* @__PURE__ */ s.jsx("br", {}),
      "It may have been moved or deleted."
    ] }),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        id: "not-found-button-group",
        className: "flex flex-col sm:flex-row gap-3 justify-center",
        children: /* @__PURE__ */ s.jsxs(
          CN,
          {
            onClick: i,
            className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg",
            children: [
              /* @__PURE__ */ s.jsx(GN, { className: "w-4 h-4 mr-2" }),
              "Go Home"
            ]
          }
        )
      }
    )
  ] }) }) });
}
class _T extends C.Component {
  constructor(i) {
    super(i), this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(i) {
    return { hasError: !0, error: i };
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center min-h-screen p-8 bg-background", children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center w-full max-w-2xl p-8", children: [
      /* @__PURE__ */ s.jsx(
        uT,
        {
          size: 48,
          className: "text-destructive mb-6 flex-shrink-0"
        }
      ),
      /* @__PURE__ */ s.jsx("h2", { className: "text-xl mb-4", children: "An unexpected error occurred." }),
      /* @__PURE__ */ s.jsx("div", { className: "p-4 w-full rounded bg-muted overflow-auto mb-6", children: /* @__PURE__ */ s.jsx("pre", { className: "text-sm text-muted-foreground whitespace-break-spaces", children: this.state.error?.stack }) }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: () => window.location.reload(),
          className: yc(
            "flex items-center gap-2 px-4 py-2 rounded-lg",
            "bg-primary text-primary-foreground",
            "hover:opacity-90 cursor-pointer"
          ),
          children: [
            /* @__PURE__ */ s.jsx(xf, { size: 16 }),
            "Reload Page"
          ]
        }
      )
    ] }) }) : this.props.children;
  }
}
const DT = C.createContext(void 0);
function FT({
  children: n,
  defaultTheme: i = "light",
  switchable: l = !1
}) {
  const [o, d] = C.useState(() => l && localStorage.getItem("theme") || i);
  C.useEffect(() => {
    const h = document.documentElement;
    o === "dark" ? h.classList.add("dark") : h.classList.remove("dark"), l && localStorage.setItem("theme", o);
  }, [o, l]);
  const f = l ? () => {
    d((h) => h === "light" ? "dark" : "light");
  } : void 0;
  return /* @__PURE__ */ s.jsx(DT.Provider, { value: { theme: o, toggleTheme: f, switchable: l }, children: n });
}
const h0 = C.createContext(null);
function _o(n, i) {
  return { amount: (n / 100).toFixed(2), currencyCode: i };
}
function BT(n) {
  const i = n.currency || "USD", l = n.items.map((o) => ({
    lineId: o.key,
    variantId: String(o.variant_id),
    productHandle: o.product_handle || "",
    productTitle: o.product_title,
    variantTitle: o.variant_title || "Default Title",
    quantity: o.quantity,
    unitPrice: _o(o.final_price, i),
    lineTotal: _o(o.final_line_price, i),
    image: o.image || o.featured_image?.url ? { url: o.image || o.featured_image?.url || "", altText: o.product_title } : null
  }));
  return {
    id: n.token || "shopify-cart",
    checkoutUrl: "/checkout",
    itemCount: n.item_count,
    subtotal: _o(n.items_subtotal_price ?? n.total_price, i),
    total: _o(n.total_price, i),
    items: l
  };
}
async function Go(n, i) {
  const l = await fetch(n, {
    credentials: "same-origin",
    ...i,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...i?.headers || {}
    }
  });
  if (!l.ok) {
    const o = await l.text().catch(() => "");
    throw new Error(o || `Shopify cart request failed (${l.status})`);
  }
  return l.json();
}
async function Do() {
  return BT(await Go("/cart.js"));
}
function VT({ children: n }) {
  const [i, l] = C.useState(null), [o, d] = C.useState(!1), [f, h] = C.useState(!1);
  C.useEffect(() => {
    let R = !1;
    return Do().then((z) => {
      R || l(z);
    }).catch((z) => console.warn("[Shopify cart] Unable to hydrate cart", z)), () => {
      R = !0;
    };
  }, []);
  const p = i?.itemCount ?? 0, g = C.useCallback(() => d(!0), []), m = C.useCallback(() => d(!1), []), b = C.useCallback(async (R, z = 1) => {
    h(!0);
    try {
      await Go("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ items: [{ id: R, quantity: z }] })
      }), l(await Do()), d(!0);
    } finally {
      h(!1);
    }
  }, []), y = C.useCallback(async (R, z) => {
    h(!0);
    try {
      await Go("/cart/change.js", {
        method: "POST",
        body: JSON.stringify({ id: R, quantity: Math.max(0, z) })
      }), l(await Do());
    } finally {
      h(!1);
    }
  }, []), w = C.useCallback(
    async (R) => y(R, 0),
    [y]
  ), S = C.useCallback(() => {
    h(!0), Go("/cart/clear.js", { method: "POST", body: "{}" }).then(() => Do()).then(l).finally(() => h(!1));
  }, []), T = C.useCallback(() => {
    window.location.assign("/checkout");
  }, []), _ = C.useMemo(
    () => ({
      cart: i,
      isOpen: o,
      loading: f,
      itemCount: p,
      openCart: g,
      closeCart: m,
      addItem: b,
      updateQuantity: y,
      removeItem: w,
      clearCart: S,
      proceedToCheckout: T
    }),
    [i, o, f, p, g, m, b, y, w, S, T]
  );
  return /* @__PURE__ */ s.jsx(h0.Provider, { value: _, children: n });
}
function ul() {
  const n = C.useContext(h0);
  if (!n) throw new Error("useCart must be used inside CartProvider");
  return n;
}
const Tf = C.createContext({});
function Af(n) {
  const i = C.useRef(null);
  return i.current === null && (i.current = n()), i.current;
}
const HT = typeof window < "u", Cf = HT ? C.useLayoutEffect : C.useEffect, wc = /* @__PURE__ */ C.createContext(null);
function Ef(n, i) {
  n.indexOf(i) === -1 && n.push(i);
}
function lc(n, i) {
  const l = n.indexOf(i);
  l > -1 && n.splice(l, 1);
}
const Yn = (n, i, l) => l > i ? i : l < n ? n : l;
let jc = () => {
};
const Za = {}, f0 = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n), m0 = (n) => typeof n == "object" && n !== null, p0 = (n) => /^0[^.\s]+$/u.test(n);
// @__NO_SIDE_EFFECTS__
function g0(n) {
  let i;
  return () => (i === void 0 && (i = n()), i);
}
const Sn = /* @__NO_SIDE_EFFECTS__ */ (n) => n, dl = (...n) => n.reduce((i, l) => (o) => l(i(o))), al = /* @__NO_SIDE_EFFECTS__ */ (n, i, l) => {
  const o = i - n;
  return o ? (l - n) / o : 1;
};
class kf {
  constructor() {
    this.subscriptions = [];
  }
  add(i) {
    return Ef(this.subscriptions, i), () => lc(this.subscriptions, i);
  }
  notify(i, l, o) {
    const d = this.subscriptions.length;
    if (d)
      if (d === 1)
        this.subscriptions[0](i, l, o);
      else
        for (let f = 0; f < d; f++) {
          const h = this.subscriptions[f];
          h && h(i, l, o);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const an = /* @__NO_SIDE_EFFECTS__ */ (n) => n * 1e3, jn = /* @__NO_SIDE_EFFECTS__ */ (n) => n / 1e3, x0 = /* @__NO_SIDE_EFFECTS__ */ (n, i) => i ? n * (1e3 / i) : 0, y0 = (n, i, l) => (((1 - 3 * l + 3 * i) * n + (3 * l - 6 * i)) * n + 3 * i) * n, UT = 1e-7, LT = 12;
function PT(n, i, l, o, d) {
  let f, h, p = 0;
  do
    h = i + (l - i) / 2, f = y0(h, o, d) - n, f > 0 ? l = h : i = h;
  while (Math.abs(f) > UT && ++p < LT);
  return h;
}
// @__NO_SIDE_EFFECTS__
function hl(n, i, l, o) {
  if (n === i && l === o)
    return Sn;
  const d = (f) => PT(f, 0, 1, n, l);
  return (f) => f === 0 || f === 1 ? f : y0(d(f), i, o);
}
const b0 = /* @__NO_SIDE_EFFECTS__ */ (n) => (i) => i <= 0.5 ? n(2 * i) / 2 : (2 - n(2 * (1 - i))) / 2, v0 = /* @__NO_SIDE_EFFECTS__ */ (n) => (i) => 1 - n(1 - i), w0 = /* @__PURE__ */ hl(0.33, 1.53, 0.69, 0.99), Mf = /* @__PURE__ */ v0(w0), j0 = /* @__PURE__ */ b0(Mf), S0 = (n) => n >= 1 ? 1 : (n *= 2) < 1 ? 0.5 * Mf(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1))), zf = (n) => 1 - Math.sin(Math.acos(n)), N0 = /* @__PURE__ */ v0(zf), T0 = /* @__PURE__ */ b0(zf), qT = /* @__PURE__ */ hl(0.42, 0, 1, 1), IT = /* @__PURE__ */ hl(0, 0, 0.58, 1), A0 = /* @__PURE__ */ hl(0.42, 0, 0.58, 1), GT = /* @__NO_SIDE_EFFECTS__ */ (n) => Array.isArray(n) && typeof n[0] != "number", C0 = /* @__NO_SIDE_EFFECTS__ */ (n) => Array.isArray(n) && typeof n[0] == "number", YT = {
  linear: Sn,
  easeIn: qT,
  easeInOut: A0,
  easeOut: IT,
  circIn: zf,
  circInOut: T0,
  circOut: N0,
  backIn: Mf,
  backInOut: j0,
  backOut: w0,
  anticipate: S0
}, QT = (n) => typeof n == "string", Sy = (n) => {
  if (/* @__PURE__ */ C0(n)) {
    jc(n.length === 4);
    const [i, l, o, d] = n;
    return /* @__PURE__ */ hl(i, l, o, d);
  } else if (QT(n))
    return YT[n];
  return n;
}, Fo = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function ZT(n) {
  let i = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), o = !1, d = !1;
  const f = /* @__PURE__ */ new WeakSet();
  let h = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function p(m) {
    f.has(m) && (g.schedule(m), n()), m(h);
  }
  const g = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (m, b = !1, y = !1) => {
      const S = y && o ? i : l;
      return b && f.add(m), S.add(m), m;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (m) => {
      l.delete(m), f.delete(m);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (m) => {
      if (h = m, o) {
        d = !0;
        return;
      }
      o = !0;
      const b = i;
      i = l, l = b, i.forEach(p), i.clear(), o = !1, d && (d = !1, g.process(m));
    }
  };
  return g;
}
const XT = 40;
function E0(n, i) {
  let l = !1, o = !0;
  const d = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, f = () => l = !0, h = Fo.reduce((L, Y) => (L[Y] = ZT(f), L), {}), { setup: p, read: g, resolveKeyframes: m, preUpdate: b, update: y, preRender: w, render: S, postRender: T } = h, _ = () => {
    const L = Za.useManualTiming, Y = L ? d.timestamp : performance.now();
    l = !1, L || (d.delta = o ? 1e3 / 60 : Math.max(Math.min(Y - d.timestamp, XT), 1)), d.timestamp = Y, d.isProcessing = !0, p.process(d), g.process(d), m.process(d), b.process(d), y.process(d), w.process(d), S.process(d), T.process(d), d.isProcessing = !1, l && i && (o = !1, n(_));
  }, R = () => {
    l = !0, o = !0, d.isProcessing || n(_);
  };
  return { schedule: Fo.reduce((L, Y) => {
    const ae = h[Y];
    return L[Y] = (ee, Z = !1, k = !1) => (l || R(), ae.schedule(ee, Z, k)), L;
  }, {}), cancel: (L) => {
    for (let Y = 0; Y < Fo.length; Y++)
      h[Fo[Y]].cancel(L);
  }, state: d, steps: h };
}
const { schedule: Ge, cancel: Xa, state: bt, steps: Kd } = /* @__PURE__ */ E0(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Sn, !0);
let Yo;
function KT() {
  Yo = void 0;
}
const zt = {
  now: () => (Yo === void 0 && zt.set(bt.isProcessing || Za.useManualTiming ? bt.timestamp : performance.now()), Yo),
  set: (n) => {
    Yo = n, queueMicrotask(KT);
  }
}, k0 = (n) => (i) => typeof i == "string" && i.startsWith(n), M0 = /* @__PURE__ */ k0("--"), $T = /* @__PURE__ */ k0("var(--"), Of = (n) => $T(n) ? WT.test(n.split("/*")[0].trim()) : !1, WT = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function Ny(n) {
  return typeof n != "string" ? !1 : n.split("/*")[0].includes("var(--");
}
const Vs = {
  test: (n) => typeof n == "number",
  parse: parseFloat,
  transform: (n) => n
}, il = {
  ...Vs,
  transform: (n) => Yn(0, 1, n)
}, Bo = {
  ...Vs,
  default: 1
}, Xr = (n) => Math.round(n * 1e5) / 1e5, Rf = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function JT(n) {
  return n == null;
}
const e5 = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, _f = (n, i) => (l) => !!(typeof l == "string" && e5.test(l) && l.startsWith(n) || i && !JT(l) && Object.prototype.hasOwnProperty.call(l, i)), z0 = (n, i, l) => (o) => {
  if (typeof o != "string")
    return o;
  const [d, f, h, p] = o.match(Rf);
  return {
    [n]: parseFloat(d),
    [i]: parseFloat(f),
    [l]: parseFloat(h),
    alpha: p !== void 0 ? parseFloat(p) : 1
  };
}, t5 = (n) => Yn(0, 255, n), $d = {
  ...Vs,
  transform: (n) => Math.round(t5(n))
}, Mi = {
  test: /* @__PURE__ */ _f("rgb", "red"),
  parse: /* @__PURE__ */ z0("red", "green", "blue"),
  transform: ({ red: n, green: i, blue: l, alpha: o = 1 }) => "rgba(" + $d.transform(n) + ", " + $d.transform(i) + ", " + $d.transform(l) + ", " + Xr(il.transform(o)) + ")"
};
function n5(n) {
  let i = "", l = "", o = "", d = "";
  return n.length > 5 ? (i = n.substring(1, 3), l = n.substring(3, 5), o = n.substring(5, 7), d = n.substring(7, 9)) : (i = n.substring(1, 2), l = n.substring(2, 3), o = n.substring(3, 4), d = n.substring(4, 5), i += i, l += l, o += o, d += d), {
    red: parseInt(i, 16),
    green: parseInt(l, 16),
    blue: parseInt(o, 16),
    alpha: d ? parseInt(d, 16) / 255 : 1
  };
}
const _h = {
  test: /* @__PURE__ */ _f("#"),
  parse: n5,
  transform: Mi.transform
}, fl = /* @__NO_SIDE_EFFECTS__ */ (n) => ({
  test: (i) => typeof i == "string" && i.endsWith(n) && i.split(" ").length === 1,
  parse: parseFloat,
  transform: (i) => `${i}${n}`
}), fa = /* @__PURE__ */ fl("deg"), Gn = /* @__PURE__ */ fl("%"), ue = /* @__PURE__ */ fl("px"), a5 = /* @__PURE__ */ fl("vh"), i5 = /* @__PURE__ */ fl("vw"), Ty = {
  ...Gn,
  parse: (n) => Gn.parse(n) / 100,
  transform: (n) => Gn.transform(n * 100)
}, Es = {
  test: /* @__PURE__ */ _f("hsl", "hue"),
  parse: /* @__PURE__ */ z0("hue", "saturation", "lightness"),
  transform: ({ hue: n, saturation: i, lightness: l, alpha: o = 1 }) => "hsla(" + Math.round(n) + ", " + Gn.transform(Xr(i)) + ", " + Gn.transform(Xr(l)) + ", " + Xr(il.transform(o)) + ")"
}, rt = {
  test: (n) => Mi.test(n) || _h.test(n) || Es.test(n),
  parse: (n) => Mi.test(n) ? Mi.parse(n) : Es.test(n) ? Es.parse(n) : _h.parse(n),
  transform: (n) => typeof n == "string" ? n : n.hasOwnProperty("red") ? Mi.transform(n) : Es.transform(n),
  getAnimatableNone: (n) => {
    const i = rt.parse(n);
    return i.alpha = 0, rt.transform(i);
  }
}, s5 = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function r5(n) {
  return isNaN(n) && typeof n == "string" && (n.match(Rf)?.length || 0) + (n.match(s5)?.length || 0) > 0;
}
const O0 = "number", R0 = "color", l5 = "var", o5 = "var(", Ay = "${}", c5 = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Fs(n) {
  const i = n.toString(), l = [], o = {
    color: [],
    number: [],
    var: []
  }, d = [];
  let f = 0;
  const p = i.replace(c5, (g) => (rt.test(g) ? (o.color.push(f), d.push(R0), l.push(rt.parse(g))) : g.startsWith(o5) ? (o.var.push(f), d.push(l5), l.push(g)) : (o.number.push(f), d.push(O0), l.push(parseFloat(g))), ++f, Ay)).split(Ay);
  return { values: l, split: p, indexes: o, types: d };
}
function u5(n) {
  return Fs(n).values;
}
function _0({ split: n, types: i }) {
  const l = n.length;
  return (o) => {
    let d = "";
    for (let f = 0; f < l; f++)
      if (d += n[f], o[f] !== void 0) {
        const h = i[f];
        h === O0 ? d += Xr(o[f]) : h === R0 ? d += rt.transform(o[f]) : d += o[f];
      }
    return d;
  };
}
function d5(n) {
  return _0(Fs(n));
}
const h5 = (n) => typeof n == "number" ? 0 : rt.test(n) ? rt.getAnimatableNone(n) : n, f5 = (n, i) => typeof n == "number" ? i?.trim().endsWith("/") ? n : 0 : h5(n);
function m5(n) {
  const i = Fs(n);
  return _0(i)(i.values.map((o, d) => f5(o, i.split[d])));
}
const On = {
  test: r5,
  parse: u5,
  createTransformer: d5,
  getAnimatableNone: m5
};
function Wd(n, i, l) {
  return l < 0 && (l += 1), l > 1 && (l -= 1), l < 1 / 6 ? n + (i - n) * 6 * l : l < 1 / 2 ? i : l < 2 / 3 ? n + (i - n) * (2 / 3 - l) * 6 : n;
}
function p5({ hue: n, saturation: i, lightness: l, alpha: o }) {
  n /= 360, i /= 100, l /= 100;
  let d = 0, f = 0, h = 0;
  if (!i)
    d = f = h = l;
  else {
    const p = l < 0.5 ? l * (1 + i) : l + i - l * i, g = 2 * l - p;
    d = Wd(g, p, n + 1 / 3), f = Wd(g, p, n), h = Wd(g, p, n - 1 / 3);
  }
  return {
    red: Math.round(d * 255),
    green: Math.round(f * 255),
    blue: Math.round(h * 255),
    alpha: o
  };
}
function oc(n, i) {
  return (l) => l > 0 ? i : n;
}
const Ie = (n, i, l) => n + (i - n) * l, Jd = (n, i, l) => {
  const o = n * n, d = l * (i * i - o) + o;
  return d < 0 ? 0 : Math.sqrt(d);
}, g5 = [_h, Mi, Es], x5 = (n) => g5.find((i) => i.test(n));
function Cy(n) {
  const i = x5(n);
  if (!i)
    return !1;
  let l = i.parse(n);
  return i === Es && (l = p5(l)), l;
}
const Ey = (n, i) => {
  const l = Cy(n), o = Cy(i);
  if (!l || !o)
    return oc(n, i);
  const d = { ...l };
  return (f) => (d.red = Jd(l.red, o.red, f), d.green = Jd(l.green, o.green, f), d.blue = Jd(l.blue, o.blue, f), d.alpha = Ie(l.alpha, o.alpha, f), Mi.transform(d));
}, Dh = /* @__PURE__ */ new Set(["none", "hidden"]);
function y5(n, i) {
  return Dh.has(n) ? (l) => l <= 0 ? n : i : (l) => l >= 1 ? i : n;
}
function b5(n, i) {
  return (l) => Ie(n, i, l);
}
function Df(n) {
  return typeof n == "number" ? b5 : typeof n == "string" ? Of(n) ? oc : rt.test(n) ? Ey : j5 : Array.isArray(n) ? D0 : typeof n == "object" ? rt.test(n) ? Ey : v5 : oc;
}
function D0(n, i) {
  const l = [...n], o = l.length, d = n.map((f, h) => Df(f)(f, i[h]));
  return (f) => {
    for (let h = 0; h < o; h++)
      l[h] = d[h](f);
    return l;
  };
}
function v5(n, i) {
  const l = { ...n, ...i }, o = {};
  for (const d in l)
    n[d] !== void 0 && i[d] !== void 0 && (o[d] = Df(n[d])(n[d], i[d]));
  return (d) => {
    for (const f in o)
      l[f] = o[f](d);
    return l;
  };
}
function w5(n, i) {
  const l = [], o = { color: 0, var: 0, number: 0 };
  for (let d = 0; d < i.values.length; d++) {
    const f = i.types[d], h = n.indexes[f][o[f]], p = n.values[h] ?? 0;
    l[d] = p, o[f]++;
  }
  return l;
}
const j5 = (n, i) => {
  const l = On.createTransformer(i), o = Fs(n), d = Fs(i);
  return o.indexes.var.length === d.indexes.var.length && o.indexes.color.length === d.indexes.color.length && o.indexes.number.length >= d.indexes.number.length ? Dh.has(n) && !d.values.length || Dh.has(i) && !o.values.length ? y5(n, i) : dl(D0(w5(o, d), d.values), l) : oc(n, i);
};
function F0(n, i, l) {
  return typeof n == "number" && typeof i == "number" && typeof l == "number" ? Ie(n, i, l) : Df(n)(n, i);
}
const S5 = (n) => {
  const i = ({ timestamp: l }) => n(l);
  return {
    start: (l = !0) => Ge.update(i, l),
    stop: () => Xa(i),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => bt.isProcessing ? bt.timestamp : zt.now()
  };
}, B0 = (n, i, l = 10) => {
  let o = "";
  const d = Math.max(Math.round(i / l), 2);
  for (let f = 0; f < d; f++)
    o += Math.round(n(f / (d - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${o.substring(0, o.length - 2)})`;
}, cc = 2e4;
function Ff(n) {
  let i = 0;
  const l = 50;
  let o = n.next(i);
  for (; !o.done && i < cc; )
    i += l, o = n.next(i);
  return i >= cc ? 1 / 0 : i;
}
function N5(n, i = 100, l) {
  const o = l({ ...n, keyframes: [0, i] }), d = Math.min(Ff(o), cc);
  return {
    type: "keyframes",
    ease: (f) => o.next(d * f).value / i,
    duration: /* @__PURE__ */ jn(d)
  };
}
const Je = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function Fh(n, i) {
  return n * Math.sqrt(1 - i * i);
}
const T5 = 12;
function A5(n, i, l) {
  let o = l;
  for (let d = 1; d < T5; d++)
    o = o - n(o) / i(o);
  return o;
}
const eh = 1e-3;
function C5({ duration: n = Je.duration, bounce: i = Je.bounce, velocity: l = Je.velocity, mass: o = Je.mass }) {
  let d, f, h = 1 - i;
  h = Yn(Je.minDamping, Je.maxDamping, h), n = Yn(Je.minDuration, Je.maxDuration, /* @__PURE__ */ jn(n)), h < 1 ? (d = (m) => {
    const b = m * h, y = b * n, w = b - l, S = Fh(m, h), T = Math.exp(-y);
    return eh - w / S * T;
  }, f = (m) => {
    const y = m * h * n, w = y * l + l, S = Math.pow(h, 2) * Math.pow(m, 2) * n, T = Math.exp(-y), _ = Fh(Math.pow(m, 2), h);
    return (-d(m) + eh > 0 ? -1 : 1) * ((w - S) * T) / _;
  }) : (d = (m) => {
    const b = Math.exp(-m * n), y = (m - l) * n + 1;
    return -eh + b * y;
  }, f = (m) => {
    const b = Math.exp(-m * n), y = (l - m) * (n * n);
    return b * y;
  });
  const p = 5 / n, g = A5(d, f, p);
  if (n = /* @__PURE__ */ an(n), isNaN(g))
    return {
      stiffness: Je.stiffness,
      damping: Je.damping,
      duration: n
    };
  {
    const m = Math.pow(g, 2) * o;
    return {
      stiffness: m,
      damping: h * 2 * Math.sqrt(o * m),
      duration: n
    };
  }
}
const E5 = ["duration", "bounce"], k5 = ["stiffness", "damping", "mass"];
function ky(n, i) {
  return i.some((l) => n[l] !== void 0);
}
function M5(n) {
  let i = {
    velocity: Je.velocity,
    stiffness: Je.stiffness,
    damping: Je.damping,
    mass: Je.mass,
    isResolvedFromDuration: !1,
    ...n
  };
  if (!ky(n, k5) && ky(n, E5))
    if (i.velocity = 0, n.visualDuration) {
      const l = n.visualDuration, o = 2 * Math.PI / (l * 1.2), d = o * o, f = 2 * Yn(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(d);
      i = {
        ...i,
        mass: Je.mass,
        stiffness: d,
        damping: f
      };
    } else {
      const l = C5({ ...n, velocity: 0 });
      i = {
        ...i,
        ...l,
        mass: Je.mass
      }, i.isResolvedFromDuration = !0;
    }
  return i;
}
function uc(n = Je.visualDuration, i = Je.bounce) {
  const l = typeof n != "object" ? {
    visualDuration: n,
    keyframes: [0, 1],
    bounce: i
  } : n;
  let { restSpeed: o, restDelta: d } = l;
  const f = l.keyframes[0], h = l.keyframes[l.keyframes.length - 1], p = { done: !1, value: f }, { stiffness: g, damping: m, mass: b, duration: y, velocity: w, isResolvedFromDuration: S } = M5({
    ...l,
    velocity: -/* @__PURE__ */ jn(l.velocity || 0)
  }), T = w || 0, _ = m / (2 * Math.sqrt(g * b)), R = h - f, z = /* @__PURE__ */ jn(Math.sqrt(g / b)), Q = Math.abs(R) < 5;
  o || (o = Q ? Je.restSpeed.granular : Je.restSpeed.default), d || (d = Q ? Je.restDelta.granular : Je.restDelta.default);
  let L, Y, ae, ee, Z, k;
  if (_ < 1)
    ae = Fh(z, _), ee = (T + _ * z * R) / ae, L = (V) => {
      const ie = Math.exp(-_ * z * V);
      return h - ie * (ee * Math.sin(ae * V) + R * Math.cos(ae * V));
    }, Z = _ * z * ee + R * ae, k = _ * z * R - ee * ae, Y = (V) => Math.exp(-_ * z * V) * (Z * Math.sin(ae * V) + k * Math.cos(ae * V));
  else if (_ === 1) {
    L = (ie) => h - Math.exp(-z * ie) * (R + (T + z * R) * ie);
    const V = T + z * R;
    Y = (ie) => Math.exp(-z * ie) * (z * V * ie - T);
  } else {
    const V = z * Math.sqrt(_ * _ - 1);
    L = (ke) => {
      const Se = Math.exp(-_ * z * ke), O = Math.min(V * ke, 300);
      return h - Se * ((T + _ * z * R) * Math.sinh(O) + V * R * Math.cosh(O)) / V;
    };
    const ie = (T + _ * z * R) / V, he = _ * z * ie - R * V, je = _ * z * R - ie * V;
    Y = (ke) => {
      const Se = Math.exp(-_ * z * ke), O = Math.min(V * ke, 300);
      return Se * (he * Math.sinh(O) + je * Math.cosh(O));
    };
  }
  const ne = {
    calculatedDuration: S && y || null,
    velocity: (V) => /* @__PURE__ */ an(Y(V)),
    next: (V) => {
      if (!S && _ < 1) {
        const he = Math.exp(-_ * z * V), je = Math.sin(ae * V), ke = Math.cos(ae * V), Se = h - he * (ee * je + R * ke), O = /* @__PURE__ */ an(he * (Z * je + k * ke));
        return p.done = Math.abs(O) <= o && Math.abs(h - Se) <= d, p.value = p.done ? h : Se, p;
      }
      const ie = L(V);
      if (S)
        p.done = V >= y;
      else {
        const he = /* @__PURE__ */ an(Y(V));
        p.done = Math.abs(he) <= o && Math.abs(h - ie) <= d;
      }
      return p.value = p.done ? h : ie, p;
    },
    toString: () => {
      const V = Math.min(Ff(ne), cc), ie = B0((he) => ne.next(V * he).value, V, 30);
      return V + "ms " + ie;
    },
    toTransition: () => {
    }
  };
  return ne;
}
uc.applyToOptions = (n) => {
  const i = N5(n, 100, uc);
  return n.ease = i.ease, n.duration = /* @__PURE__ */ an(i.duration), n.type = "keyframes", n;
};
const z5 = 5;
function V0(n, i, l) {
  const o = Math.max(i - z5, 0);
  return /* @__PURE__ */ x0(l - n(o), i - o);
}
function Bh({ keyframes: n, velocity: i = 0, power: l = 0.8, timeConstant: o = 325, bounceDamping: d = 10, bounceStiffness: f = 500, modifyTarget: h, min: p, max: g, restDelta: m = 0.5, restSpeed: b }) {
  const y = n[0], w = {
    done: !1,
    value: y
  }, S = (k) => p !== void 0 && k < p || g !== void 0 && k > g, T = (k) => p === void 0 ? g : g === void 0 || Math.abs(p - k) < Math.abs(g - k) ? p : g;
  let _ = l * i;
  const R = y + _, z = h === void 0 ? R : h(R);
  z !== R && (_ = z - y);
  const Q = (k) => -_ * Math.exp(-k / o), L = (k) => z + Q(k), Y = (k) => {
    const ne = Q(k), V = L(k);
    w.done = Math.abs(ne) <= m, w.value = w.done ? z : V;
  };
  let ae, ee;
  const Z = (k) => {
    S(w.value) && (ae = k, ee = uc({
      keyframes: [w.value, T(w.value)],
      velocity: V0(L, k, w.value),
      // TODO: This should be passing * 1000
      damping: d,
      stiffness: f,
      restDelta: m,
      restSpeed: b
    }));
  };
  return Z(0), {
    calculatedDuration: null,
    next: (k) => {
      let ne = !1;
      return !ee && ae === void 0 && (ne = !0, Y(k), Z(k)), ae !== void 0 && k >= ae ? ee.next(k - ae) : (!ne && Y(k), w);
    }
  };
}
function O5(n, i, l) {
  const o = [], d = l || Za.mix || F0, f = n.length - 1;
  for (let h = 0; h < f; h++) {
    let p = d(n[h], n[h + 1]);
    if (i) {
      const g = Array.isArray(i) ? i[h] || Sn : i;
      p = dl(g, p);
    }
    o.push(p);
  }
  return o;
}
function R5(n, i, { clamp: l = !0, ease: o, mixer: d } = {}) {
  const f = n.length;
  if (jc(f === i.length), f === 1)
    return () => i[0];
  if (f === 2 && i[0] === i[1])
    return () => i[1];
  const h = n[0] === n[1];
  n[0] > n[f - 1] && (n = [...n].reverse(), i = [...i].reverse());
  const p = O5(i, o, d), g = p.length, m = (b) => {
    if (h && b < n[0])
      return i[0];
    let y = 0;
    if (g > 1)
      for (; y < n.length - 2 && !(b < n[y + 1]); y++)
        ;
    const w = /* @__PURE__ */ al(n[y], n[y + 1], b);
    return p[y](w);
  };
  return l ? (b) => m(Yn(n[0], n[f - 1], b)) : m;
}
function _5(n, i) {
  const l = n[n.length - 1];
  for (let o = 1; o <= i; o++) {
    const d = /* @__PURE__ */ al(0, i, o);
    n.push(Ie(l, 1, d));
  }
}
function D5(n) {
  const i = [0];
  return _5(i, n.length - 1), i;
}
function F5(n, i) {
  return n.map((l) => l * i);
}
function B5(n, i) {
  return n.map(() => i || A0).splice(0, n.length - 1);
}
function Kr({ duration: n = 300, keyframes: i, times: l, ease: o = "easeInOut" }) {
  const d = /* @__PURE__ */ GT(o) ? o.map(Sy) : Sy(o), f = {
    done: !1,
    value: i[0]
  }, h = F5(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    l && l.length === i.length ? l : D5(i),
    n
  ), p = R5(h, i, {
    ease: Array.isArray(d) ? d : B5(i, d)
  });
  return {
    calculatedDuration: n,
    next: (g) => (f.value = p(g), f.done = g >= n, f)
  };
}
const V5 = (n) => n !== null;
function Sc(n, { repeat: i, repeatType: l = "loop" }, o, d = 1) {
  const f = n.filter(V5), p = d < 0 || i && l !== "loop" && i % 2 === 1 ? 0 : f.length - 1;
  return !p || o === void 0 ? f[p] : o;
}
const H5 = {
  decay: Bh,
  inertia: Bh,
  tween: Kr,
  keyframes: Kr,
  spring: uc
};
function H0(n) {
  typeof n.type == "string" && (n.type = H5[n.type]);
}
class Bf {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((i) => {
      this.resolve = i;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(i, l) {
    return this.finished.then(i, l);
  }
}
const U5 = (n) => n / 100;
class dc extends Bf {
  constructor(i) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: l } = this.options;
      l && l.updatedAt !== zt.now() && this.tick(zt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = i, this.initAnimation(), this.play(), i.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: i } = this;
    H0(i);
    const { type: l = Kr, repeat: o = 0, repeatDelay: d = 0, repeatType: f, velocity: h = 0 } = i;
    let { keyframes: p } = i;
    const g = l || Kr;
    g !== Kr && typeof p[0] != "number" && (this.mixKeyframes = dl(U5, F0(p[0], p[1])), p = [0, 100]);
    const m = g({ ...i, keyframes: p });
    f === "mirror" && (this.mirroredGenerator = g({
      ...i,
      keyframes: [...p].reverse(),
      velocity: -h
    })), m.calculatedDuration === null && (m.calculatedDuration = Ff(m));
    const { calculatedDuration: b } = m;
    this.calculatedDuration = b, this.resolvedDuration = b + d, this.totalDuration = this.resolvedDuration * (o + 1) - d, this.generator = m;
  }
  updateTime(i) {
    const l = Math.round(i - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = l;
  }
  tick(i, l = !1) {
    const { generator: o, totalDuration: d, mixKeyframes: f, mirroredGenerator: h, resolvedDuration: p, calculatedDuration: g } = this;
    if (this.startTime === null)
      return o.next(0);
    const { delay: m = 0, keyframes: b, repeat: y, repeatType: w, repeatDelay: S, type: T, onUpdate: _, finalKeyframe: R } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, i) : this.speed < 0 && (this.startTime = Math.min(i - d / this.speed, this.startTime)), l ? this.currentTime = i : this.updateTime(i);
    const z = this.currentTime - m * (this.playbackSpeed >= 0 ? 1 : -1), Q = this.playbackSpeed >= 0 ? z < 0 : z > d;
    this.currentTime = Math.max(z, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = d);
    let L = this.currentTime, Y = o;
    if (y) {
      const k = Math.min(this.currentTime, d) / p;
      let ne = Math.floor(k), V = k % 1;
      !V && k >= 1 && (V = 1), V === 1 && ne--, ne = Math.min(ne, y + 1), ne % 2 && (w === "reverse" ? (V = 1 - V, S && (V -= S / p)) : w === "mirror" && (Y = h)), L = Yn(0, 1, V) * p;
    }
    let ae;
    Q ? (this.delayState.value = b[0], ae = this.delayState) : ae = Y.next(L), f && !Q && (ae.value = f(ae.value));
    let { done: ee } = ae;
    !Q && g !== null && (ee = this.playbackSpeed >= 0 ? this.currentTime >= d : this.currentTime <= 0);
    const Z = this.holdTime === null && (this.state === "finished" || this.state === "running" && ee);
    return Z && T !== Bh && (ae.value = Sc(b, this.options, R, this.speed)), _ && _(ae.value), Z && this.finish(), ae;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(i, l) {
    return this.finished.then(i, l);
  }
  get duration() {
    return /* @__PURE__ */ jn(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: i = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ jn(i);
  }
  get time() {
    return /* @__PURE__ */ jn(this.currentTime);
  }
  set time(i) {
    i = /* @__PURE__ */ an(i), this.currentTime = i, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = i : this.driver && (this.startTime = this.driver.now() - i / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = i, this.tick(i));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const i = this.currentTime;
    if (i <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(i);
    const l = this.generator.next(i).value;
    return V0((o) => this.generator.next(o).value, i, l);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(i) {
    const l = this.playbackSpeed !== i;
    l && this.driver && this.updateTime(zt.now()), this.playbackSpeed = i, l && this.driver && (this.time = /* @__PURE__ */ jn(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: i = S5, startTime: l } = this.options;
    this.driver || (this.driver = i((d) => this.tick(d))), this.options.onPlay?.();
    const o = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = o) : this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime || (this.startTime = l ?? o), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(zt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(i) {
    return this.startTime = 0, this.tick(i, !0);
  }
  attachTimeline(i) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), i.observe(this);
  }
}
function L5(n) {
  for (let i = 1; i < n.length; i++)
    n[i] ?? (n[i] = n[i - 1]);
}
const zi = (n) => n * 180 / Math.PI, Vh = (n) => {
  const i = zi(Math.atan2(n[1], n[0]));
  return Hh(i);
}, P5 = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (n) => (Math.abs(n[0]) + Math.abs(n[3])) / 2,
  rotate: Vh,
  rotateZ: Vh,
  skewX: (n) => zi(Math.atan(n[1])),
  skewY: (n) => zi(Math.atan(n[2])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[2])) / 2
}, Hh = (n) => (n = n % 360, n < 0 && (n += 360), n), My = Vh, zy = (n) => Math.sqrt(n[0] * n[0] + n[1] * n[1]), Oy = (n) => Math.sqrt(n[4] * n[4] + n[5] * n[5]), q5 = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: zy,
  scaleY: Oy,
  scale: (n) => (zy(n) + Oy(n)) / 2,
  rotateX: (n) => Hh(zi(Math.atan2(n[6], n[5]))),
  rotateY: (n) => Hh(zi(Math.atan2(-n[2], n[0]))),
  rotateZ: My,
  rotate: My,
  skewX: (n) => zi(Math.atan(n[4])),
  skewY: (n) => zi(Math.atan(n[1])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[4])) / 2
};
function Uh(n) {
  return n.includes("scale") ? 1 : 0;
}
function Lh(n, i) {
  if (!n || n === "none")
    return Uh(i);
  const l = n.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let o, d;
  if (l)
    o = q5, d = l;
  else {
    const p = n.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    o = P5, d = p;
  }
  if (!d)
    return Uh(i);
  const f = o[i], h = d[1].split(",").map(G5);
  return typeof f == "function" ? f(h) : h[f];
}
const I5 = (n, i) => {
  const { transform: l = "none" } = getComputedStyle(n);
  return Lh(l, i);
};
function G5(n) {
  return parseFloat(n.trim());
}
const Hs = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Us = /* @__PURE__ */ new Set([...Hs, "pathRotation"]), Ry = (n) => n === Vs || n === ue, Y5 = /* @__PURE__ */ new Set(["x", "y", "z"]), Q5 = Hs.filter((n) => !Y5.has(n));
function Z5(n) {
  const i = [];
  return Q5.forEach((l) => {
    const o = n.getValue(l);
    o !== void 0 && (i.push([l, o.get()]), o.set(l.startsWith("scale") ? 1 : 0));
  }), i;
}
const Qa = {
  // Dimensions
  width: ({ x: n }, { paddingLeft: i = "0", paddingRight: l = "0", boxSizing: o }) => {
    const d = n.max - n.min;
    return o === "border-box" ? d : d - parseFloat(i) - parseFloat(l);
  },
  height: ({ y: n }, { paddingTop: i = "0", paddingBottom: l = "0", boxSizing: o }) => {
    const d = n.max - n.min;
    return o === "border-box" ? d : d - parseFloat(i) - parseFloat(l);
  },
  top: (n, { top: i }) => parseFloat(i),
  left: (n, { left: i }) => parseFloat(i),
  bottom: ({ y: n }, { top: i }) => parseFloat(i) + (n.max - n.min),
  right: ({ x: n }, { left: i }) => parseFloat(i) + (n.max - n.min),
  // Transform
  x: (n, { transform: i }) => Lh(i, "x"),
  y: (n, { transform: i }) => Lh(i, "y")
};
Qa.translateX = Qa.x;
Qa.translateY = Qa.y;
const Oi = /* @__PURE__ */ new Set();
let Ph = !1, qh = !1, Ih = !1;
function U0() {
  if (qh) {
    const n = Array.from(Oi).filter((o) => o.needsMeasurement), i = new Set(n.map((o) => o.element)), l = /* @__PURE__ */ new Map();
    i.forEach((o) => {
      const d = Z5(o);
      d.length && (l.set(o, d), o.render());
    }), n.forEach((o) => o.measureInitialState()), i.forEach((o) => {
      o.render();
      const d = l.get(o);
      d && d.forEach(([f, h]) => {
        o.getValue(f)?.set(h);
      });
    }), n.forEach((o) => o.measureEndState()), n.forEach((o) => {
      o.suspendedScrollY !== void 0 && window.scrollTo(0, o.suspendedScrollY);
    });
  }
  qh = !1, Ph = !1, Oi.forEach((n) => n.complete(Ih)), Oi.clear();
}
function L0() {
  Oi.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (qh = !0);
  });
}
function X5() {
  Ih = !0, L0(), U0(), Ih = !1;
}
class Vf {
  constructor(i, l, o, d, f, h = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...i], this.onComplete = l, this.name = o, this.motionValue = d, this.element = f, this.isAsync = h;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Oi.add(this), Ph || (Ph = !0, Ge.read(L0), Ge.resolveKeyframes(U0))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: i, name: l, element: o, motionValue: d } = this;
    if (i[0] === null) {
      const f = d?.get(), h = i[i.length - 1];
      if (f !== void 0)
        i[0] = f;
      else if (o && l) {
        const p = o.readValue(l, h);
        p != null && (i[0] = p);
      }
      i[0] === void 0 && (i[0] = h), d && f === void 0 && d.set(i[0]);
    }
    L5(i);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(i = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, i), Oi.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Oi.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const K5 = (n) => n.startsWith("--");
function P0(n, i, l) {
  K5(i) ? n.style.setProperty(i, l) : n.style[i] = l;
}
const $5 = {};
function q0(n, i) {
  const l = /* @__PURE__ */ g0(n);
  return () => $5[i] ?? l();
}
const W5 = /* @__PURE__ */ q0(() => window.ScrollTimeline !== void 0, "scrollTimeline"), I0 = /* @__PURE__ */ q0(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Zr = ([n, i, l, o]) => `cubic-bezier(${n}, ${i}, ${l}, ${o})`, _y = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Zr([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Zr([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Zr([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Zr([0.33, 1.53, 0.69, 0.99])
};
function G0(n, i) {
  if (n)
    return typeof n == "function" ? I0() ? B0(n, i) : "ease-out" : /* @__PURE__ */ C0(n) ? Zr(n) : Array.isArray(n) ? n.map((l) => G0(l, i) || _y.easeOut) : _y[n];
}
function J5(n, i, l, { delay: o = 0, duration: d = 300, repeat: f = 0, repeatType: h = "loop", ease: p = "easeOut", times: g } = {}, m = void 0) {
  const b = {
    [i]: l
  };
  g && (b.offset = g);
  const y = G0(p, d);
  Array.isArray(y) && (b.easing = y);
  const w = {
    delay: o,
    duration: d,
    easing: Array.isArray(y) ? "linear" : y,
    fill: "both",
    iterations: f + 1,
    direction: h === "reverse" ? "alternate" : "normal"
  };
  return m && (w.pseudoElement = m), n.animate(b, w);
}
function Y0(n) {
  return typeof n == "function" && "applyToOptions" in n;
}
function e3({ type: n, ...i }) {
  return Y0(n) && I0() ? n.applyToOptions(i) : (i.duration ?? (i.duration = 300), i.ease ?? (i.ease = "easeOut"), i);
}
class Q0 extends Bf {
  constructor(i) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !i)
      return;
    const { element: l, name: o, keyframes: d, pseudoElement: f, allowFlatten: h = !1, finalKeyframe: p, onComplete: g } = i;
    this.isPseudoElement = !!f, this.allowFlatten = h, this.options = i, jc(typeof i.type != "string");
    const m = e3(i);
    this.animation = J5(l, o, d, m, f), m.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !f) {
        const b = Sc(d, this.options, p, this.speed);
        this.updateMotionValue && this.updateMotionValue(b), P0(l, o, b), this.animation.cancel();
      }
      g?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: i } = this;
    i === "idle" || i === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const i = this.options?.element;
    !this.isPseudoElement && i?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const i = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ jn(Number(i));
  }
  get iterationDuration() {
    const { delay: i = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ jn(i);
  }
  get time() {
    return /* @__PURE__ */ jn(Number(this.animation.currentTime) || 0);
  }
  set time(i) {
    const l = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ an(i), l && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(i) {
    i < 0 && (this.finishedTime = null), this.animation.playbackRate = i;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(i) {
    this.manualStartTime = this.animation.startTime = i;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: i, rangeStart: l, rangeEnd: o, observe: d }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, i && W5() ? (this.animation.timeline = i, l && (this.animation.rangeStart = l), o && (this.animation.rangeEnd = o), Sn) : d(this);
  }
}
const Z0 = {
  anticipate: S0,
  backInOut: j0,
  circInOut: T0
};
function t3(n) {
  return n in Z0;
}
function n3(n) {
  typeof n.ease == "string" && t3(n.ease) && (n.ease = Z0[n.ease]);
}
const th = 10;
class a3 extends Q0 {
  constructor(i) {
    n3(i), H0(i), super(i), i.startTime !== void 0 && i.autoplay !== !1 && (this.startTime = i.startTime), this.options = i;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(i) {
    const { motionValue: l, onUpdate: o, onComplete: d, element: f, ...h } = this.options;
    if (!l)
      return;
    if (i !== void 0) {
      l.set(i);
      return;
    }
    const p = new dc({
      ...h,
      autoplay: !1
    }), g = Math.max(th, zt.now() - this.startTime), m = Yn(0, th, g - th), b = p.sample(g).value, { name: y } = this.options;
    f && y && P0(f, y, b), l.setWithVelocity(p.sample(Math.max(0, g - m)).value, b, m), p.stop();
  }
}
const Dy = (n, i) => i === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(On.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url("));
function i3(n) {
  const i = n[0];
  if (n.length === 1)
    return !0;
  for (let l = 0; l < n.length; l++)
    if (n[l] !== i)
      return !0;
}
function s3(n, i, l, o) {
  const d = n[0];
  if (d === null)
    return !1;
  if (i === "display" || i === "visibility")
    return !0;
  const f = n[n.length - 1], h = Dy(d, i), p = Dy(f, i);
  return !h || !p ? !1 : i3(n) || (l === "spring" || Y0(l)) && o;
}
function Gh(n) {
  n.duration = 0, n.type = "keyframes";
}
const X0 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), r3 = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function l3(n) {
  for (let i = 0; i < n.length; i++)
    if (typeof n[i] == "string" && r3.test(n[i]))
      return !0;
  return !1;
}
const o3 = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), c3 = /* @__PURE__ */ g0(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function u3(n) {
  const { motionValue: i, name: l, repeatDelay: o, repeatType: d, damping: f, type: h, keyframes: p } = n, g = i?.owner?.current;
  if (!(g instanceof HTMLElement) && !(g instanceof SVGElement))
    return !1;
  const { onUpdate: m, transformTemplate: b } = i.owner.getProps();
  return c3() && l && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (X0.has(l) || o3.has(l) && l3(p)) && (l !== "transform" || !b) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !m && !o && d !== "mirror" && f !== 0 && h !== "inertia";
}
const d3 = 40;
class h3 extends Bf {
  constructor({ autoplay: i = !0, delay: l = 0, type: o = "keyframes", repeat: d = 0, repeatDelay: f = 0, repeatType: h = "loop", keyframes: p, name: g, motionValue: m, element: b, ...y }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = zt.now();
    const w = {
      autoplay: i,
      delay: l,
      type: o,
      repeat: d,
      repeatDelay: f,
      repeatType: h,
      name: g,
      motionValue: m,
      element: b,
      ...y
    }, S = b?.KeyframeResolver || Vf;
    this.keyframeResolver = new S(p, (T, _, R) => this.onKeyframesResolved(T, _, w, !R), g, m, b), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(i, l, o, d) {
    this.keyframeResolver = void 0;
    const { name: f, type: h, velocity: p, delay: g, isHandoff: m, onUpdate: b } = o;
    this.resolvedAt = zt.now();
    let y = !0;
    s3(i, f, h, p) || (y = !1, (Za.instantAnimations || !g) && b?.(Sc(i, o, l)), i[0] = i[i.length - 1], Gh(o), o.repeat = 0);
    const S = {
      startTime: d ? this.resolvedAt ? this.resolvedAt - this.createdAt > d3 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: l,
      ...o,
      keyframes: i
    }, T = y && !m && u3(S), _ = S.motionValue?.owner?.current;
    let R;
    if (T)
      try {
        R = new a3({
          ...S,
          element: _
        });
      } catch {
        R = new dc(S);
      }
    else
      R = new dc(S);
    R.finished.then(() => {
      this.notifyFinished();
    }).catch(Sn), this.pendingTimeline && (this.stopTimeline = R.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = R;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(i, l) {
    return this.finished.finally(i).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), X5()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(i) {
    this.animation.time = i;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(i) {
    this.animation.speed = i;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(i) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(i) : this.pendingTimeline = i, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function K0(n, i, l, o = 0, d = 1) {
  const f = Array.from(n).sort((m, b) => m.sortNodePosition(b)).indexOf(i), h = n.size, p = (h - 1) * o;
  return typeof l == "function" ? l(f, h) : d === 1 ? f * o : p - f * o;
}
const Fy = 30, f3 = (n) => !isNaN(parseFloat(n));
class m3 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(i, l = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (o) => {
      const d = zt.now();
      if (this.updatedAt !== d && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(o), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const f of this.dependents)
          f.dirty();
    }, this.hasAnimated = !1, this.setCurrent(i), this.owner = l.owner;
  }
  setCurrent(i) {
    this.current = i, this.updatedAt = zt.now(), this.canTrackVelocity === null && i !== void 0 && (this.canTrackVelocity = f3(this.current));
  }
  setPrevFrameValue(i = this.current) {
    this.prevFrameValue = i, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(i) {
    return this.on("change", i);
  }
  on(i, l) {
    this.events[i] || (this.events[i] = new kf());
    const o = this.events[i].add(l);
    return i === "change" ? () => {
      o(), Ge.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : o;
  }
  clearListeners() {
    for (const i in this.events)
      this.events[i].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(i, l) {
    this.passiveEffect = i, this.stopPassiveEffect = l;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(i) {
    this.passiveEffect ? this.passiveEffect(i, this.updateAndNotify) : this.updateAndNotify(i);
  }
  setWithVelocity(i, l, o) {
    this.set(l), this.prev = void 0, this.prevFrameValue = i, this.prevUpdatedAt = this.updatedAt - o;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(i, l = !0) {
    this.updateAndNotify(i), this.prev = i, this.prevUpdatedAt = this.prevFrameValue = void 0, l && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(i) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(i);
  }
  removeDependent(i) {
    this.dependents && this.dependents.delete(i);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const i = zt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || i - this.updatedAt > Fy)
      return 0;
    const l = Math.min(this.updatedAt - this.prevUpdatedAt, Fy);
    return /* @__PURE__ */ x0(parseFloat(this.current) - parseFloat(this.prevFrameValue), l);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(i) {
    return this.stop(), new Promise((l) => {
      this.hasAnimated = !0, this.animation = i(l), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Bs(n, i) {
  return new m3(n, i);
}
function $0(n, i) {
  if (n?.inherit && i) {
    const { inherit: l, ...o } = n;
    return { ...i, ...o };
  }
  return n;
}
function Hf(n, i) {
  const l = n?.[i] ?? n?.default ?? n;
  return l !== n ? $0(l, n) : l;
}
const p3 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, g3 = (n) => ({
  type: "spring",
  stiffness: 550,
  damping: n === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), x3 = {
  type: "keyframes",
  duration: 0.8
}, y3 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, b3 = (n, { keyframes: i }) => i.length > 2 ? x3 : Us.has(n) ? n.startsWith("scale") ? g3(i[1]) : p3 : y3, v3 = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function w3(n) {
  for (const i in n)
    if (!v3.has(i))
      return !0;
  return !1;
}
const Uf = (n, i, l, o = {}, d, f) => (h) => {
  const p = Hf(o, n) || {}, g = p.delay || o.delay || 0;
  let { elapsed: m = 0 } = o;
  m = m - /* @__PURE__ */ an(g);
  const b = {
    keyframes: Array.isArray(l) ? l : [null, l],
    ease: "easeOut",
    velocity: i.getVelocity(),
    ...p,
    delay: -m,
    onUpdate: (w) => {
      i.set(w), p.onUpdate && p.onUpdate(w);
    },
    onComplete: () => {
      h(), p.onComplete && p.onComplete();
    },
    name: n,
    motionValue: i,
    element: f ? void 0 : d
  };
  w3(p) || Object.assign(b, b3(n, b)), b.duration && (b.duration = /* @__PURE__ */ an(b.duration)), b.repeatDelay && (b.repeatDelay = /* @__PURE__ */ an(b.repeatDelay)), b.from !== void 0 && (b.keyframes[0] = b.from);
  let y = !1;
  if ((b.type === !1 || b.duration === 0 && !b.repeatDelay) && (Gh(b), b.delay === 0 && (y = !0)), (Za.instantAnimations || Za.skipAnimations || d?.shouldSkipAnimations || p.skipAnimations) && (y = !0, Gh(b), b.delay = 0), b.allowFlatten = !p.type && !p.ease, y && !f && i.get() !== void 0) {
    const w = Sc(b.keyframes, p);
    if (w !== void 0) {
      Ge.update(() => {
        b.onUpdate(w), b.onComplete();
      });
      return;
    }
  }
  return p.isSync ? new dc(b) : new h3(b);
}, j3 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function S3(n) {
  const i = j3.exec(n);
  if (!i)
    return [,];
  const [, l, o, d] = i;
  return [`--${l ?? o}`, d];
}
function W0(n, i, l = 1) {
  const [o, d] = S3(n);
  if (!o)
    return;
  const f = window.getComputedStyle(i).getPropertyValue(o);
  if (f) {
    const h = f.trim();
    return f0(h) ? parseFloat(h) : h;
  }
  return Of(d) ? W0(d, i, l + 1) : d;
}
function By(n) {
  const i = [{}, {}];
  return n?.values.forEach((l, o) => {
    i[0][o] = l.get(), i[1][o] = l.getVelocity();
  }), i;
}
function Lf(n, i, l, o) {
  if (typeof i == "function") {
    const [d, f] = By(o);
    i = i(l !== void 0 ? l : n.custom, d, f);
  }
  if (typeof i == "string" && (i = n.variants && n.variants[i]), typeof i == "function") {
    const [d, f] = By(o);
    i = i(l !== void 0 ? l : n.custom, d, f);
  }
  return i;
}
function Ri(n, i, l) {
  const o = n.getProps();
  return Lf(o, i, l !== void 0 ? l : o.custom, n);
}
const J0 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Hs
]), Yh = (n) => Array.isArray(n);
function N3(n, i, l) {
  n.hasValue(i) ? n.getValue(i).set(l) : n.addValue(i, Bs(l));
}
function T3(n) {
  return Yh(n) ? n[n.length - 1] || 0 : n;
}
function A3(n, i) {
  const l = Ri(n, i);
  let { transitionEnd: o = {}, transition: d = {}, ...f } = l || {};
  f = { ...f, ...o };
  for (const h in f) {
    const p = T3(f[h]);
    N3(n, h, p);
  }
}
const vt = (n) => !!(n && n.getVelocity);
function C3(n) {
  return !!(vt(n) && n.add);
}
function Qh(n, i) {
  const l = n.getValue("willChange");
  if (C3(l))
    return l.add(i);
  if (!l && Za.WillChange) {
    const o = new Za.WillChange("auto");
    n.addValue("willChange", o), o.add(i);
  }
}
function Pf(n) {
  return n.replace(/([A-Z])/g, (i) => `-${i.toLowerCase()}`);
}
const E3 = "framerAppearId", e1 = "data-" + Pf(E3);
function t1(n) {
  return n.props[e1];
}
function k3({ protectedKeys: n, needsAnimating: i }, l) {
  const o = n.hasOwnProperty(l) && i[l] !== !0;
  return i[l] = !1, o;
}
function n1(n, i, { delay: l = 0, transitionOverride: o, type: d } = {}) {
  let { transition: f, transitionEnd: h, ...p } = i;
  const g = n.getDefaultTransition();
  f = f ? $0(f, g) : g;
  const m = f?.reduceMotion, b = f?.skipAnimations;
  o && (f = o);
  const y = [], w = d && n.animationState && n.animationState.getState()[d], S = f?.path;
  S && S.animateVisualElement(n, p, f, l, y);
  for (const T in p) {
    const _ = n.getValue(T, n.latestValues[T] ?? null), R = p[T];
    if (R === void 0 || w && k3(w, T))
      continue;
    const z = {
      delay: l,
      ...Hf(f || {}, T)
    };
    b && (z.skipAnimations = !0);
    const Q = _.get();
    if (Q !== void 0 && !_.isAnimating() && !Array.isArray(R) && R === Q && !z.velocity) {
      Ge.update(() => _.set(R));
      continue;
    }
    let L = !1;
    if (window.MotionHandoffAnimation) {
      const ee = t1(n);
      if (ee) {
        const Z = window.MotionHandoffAnimation(ee, T, Ge);
        Z !== null && (z.startTime = Z, L = !0);
      }
    }
    Qh(n, T);
    const Y = m ?? n.shouldReduceMotion;
    _.start(Uf(T, _, R, Y && J0.has(T) ? { type: !1 } : z, n, L));
    const ae = _.animation;
    ae && y.push(ae);
  }
  if (h) {
    const T = () => Ge.update(() => {
      h && A3(n, h);
    });
    y.length ? Promise.all(y).then(T) : T();
  }
  return y;
}
function Zh(n, i, l = {}) {
  const o = Ri(n, i, l.type === "exit" ? n.presenceContext?.custom : void 0);
  let { transition: d = n.getDefaultTransition() || {} } = o || {};
  l.transitionOverride && (d = l.transitionOverride);
  const f = o ? () => Promise.all(n1(n, o, l)) : () => Promise.resolve(), h = n.variantChildren && n.variantChildren.size ? (g = 0) => {
    const { delayChildren: m = 0, staggerChildren: b, staggerDirection: y } = d;
    return M3(n, i, g, m, b, y, l);
  } : () => Promise.resolve(), { when: p } = d;
  if (p) {
    const [g, m] = p === "beforeChildren" ? [f, h] : [h, f];
    return g().then(() => m());
  } else
    return Promise.all([f(), h(l.delay)]);
}
function M3(n, i, l = 0, o = 0, d = 0, f = 1, h) {
  const p = [];
  for (const g of n.variantChildren)
    g.notify("AnimationStart", i), p.push(Zh(g, i, {
      ...h,
      delay: l + (typeof o == "function" ? 0 : o) + K0(n.variantChildren, g, o, d, f)
    }).then(() => g.notify("AnimationComplete", i)));
  return Promise.all(p);
}
function z3(n, i, l = {}) {
  n.notify("AnimationStart", i);
  let o;
  if (Array.isArray(i)) {
    const d = i.map((f) => Zh(n, f, l));
    o = Promise.all(d);
  } else if (typeof i == "string")
    o = Zh(n, i, l);
  else {
    const d = typeof i == "function" ? Ri(n, i, l.custom) : i;
    o = Promise.all(n1(n, d, l));
  }
  return o.then(() => {
    n.notify("AnimationComplete", i);
  });
}
const O3 = {
  test: (n) => n === "auto",
  parse: (n) => n
}, a1 = (n) => (i) => i.test(n), i1 = [Vs, ue, Gn, fa, i5, a5, O3], Vy = (n) => i1.find(a1(n));
function R3(n) {
  return typeof n == "number" ? n === 0 : n !== null ? n === "none" || n === "0" || p0(n) : !0;
}
const _3 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function D3(n) {
  const [i, l] = n.slice(0, -1).split("(");
  if (i === "drop-shadow")
    return n;
  const [o] = l.match(Rf) || [];
  if (!o)
    return n;
  const d = l.replace(o, "");
  let f = _3.has(i) ? 1 : 0;
  return o !== l && (f *= 100), i + "(" + f + d + ")";
}
const F3 = /\b([a-z-]*)\(.*?\)/gu, Xh = {
  ...On,
  getAnimatableNone: (n) => {
    const i = n.match(F3);
    return i ? i.map(D3).join(" ") : n;
  }
}, Kh = {
  ...On,
  getAnimatableNone: (n) => {
    const i = On.parse(n);
    return On.createTransformer(n)(i.map((o) => typeof o == "number" ? 0 : typeof o == "object" ? { ...o, alpha: 1 } : o));
  }
}, Hy = {
  ...Vs,
  transform: Math.round
}, B3 = {
  rotate: fa,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: fa,
  rotateX: fa,
  rotateY: fa,
  rotateZ: fa,
  scale: Bo,
  scaleX: Bo,
  scaleY: Bo,
  scaleZ: Bo,
  skew: fa,
  skewX: fa,
  skewY: fa,
  distance: ue,
  translateX: ue,
  translateY: ue,
  translateZ: ue,
  x: ue,
  y: ue,
  z: ue,
  perspective: ue,
  transformPerspective: ue,
  opacity: il,
  originX: Ty,
  originY: Ty,
  originZ: ue
}, hc = {
  // Border props
  borderWidth: ue,
  borderTopWidth: ue,
  borderRightWidth: ue,
  borderBottomWidth: ue,
  borderLeftWidth: ue,
  borderRadius: ue,
  borderTopLeftRadius: ue,
  borderTopRightRadius: ue,
  borderBottomRightRadius: ue,
  borderBottomLeftRadius: ue,
  // Positioning props
  width: ue,
  maxWidth: ue,
  height: ue,
  maxHeight: ue,
  top: ue,
  right: ue,
  bottom: ue,
  left: ue,
  inset: ue,
  insetBlock: ue,
  insetBlockStart: ue,
  insetBlockEnd: ue,
  insetInline: ue,
  insetInlineStart: ue,
  insetInlineEnd: ue,
  // Spacing props
  padding: ue,
  paddingTop: ue,
  paddingRight: ue,
  paddingBottom: ue,
  paddingLeft: ue,
  paddingBlock: ue,
  paddingBlockStart: ue,
  paddingBlockEnd: ue,
  paddingInline: ue,
  paddingInlineStart: ue,
  paddingInlineEnd: ue,
  margin: ue,
  marginTop: ue,
  marginRight: ue,
  marginBottom: ue,
  marginLeft: ue,
  marginBlock: ue,
  marginBlockStart: ue,
  marginBlockEnd: ue,
  marginInline: ue,
  marginInlineStart: ue,
  marginInlineEnd: ue,
  // Typography
  fontSize: ue,
  // Misc
  backgroundPositionX: ue,
  backgroundPositionY: ue,
  ...B3,
  zIndex: Hy,
  // SVG
  fillOpacity: il,
  strokeOpacity: il,
  numOctaves: Hy
}, V3 = {
  ...hc,
  // Color props
  color: rt,
  backgroundColor: rt,
  outlineColor: rt,
  fill: rt,
  stroke: rt,
  // Border props
  borderColor: rt,
  borderTopColor: rt,
  borderRightColor: rt,
  borderBottomColor: rt,
  borderLeftColor: rt,
  filter: Xh,
  WebkitFilter: Xh,
  mask: Kh,
  WebkitMask: Kh
}, s1 = (n) => V3[n], H3 = /* @__PURE__ */ new Set([Xh, Kh]);
function r1(n, i) {
  let l = s1(n);
  return H3.has(l) || (l = On), l.getAnimatableNone ? l.getAnimatableNone(i) : void 0;
}
const U3 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function L3(n, i, l) {
  let o = 0, d;
  for (; o < n.length && !d; ) {
    const f = n[o];
    typeof f == "string" && !U3.has(f) && Fs(f).values.length && (d = n[o]), o++;
  }
  if (d && l)
    for (const f of i)
      n[f] = r1(l, d);
}
class P3 extends Vf {
  constructor(i, l, o, d, f) {
    super(i, l, o, d, f, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: i, element: l, name: o } = this;
    if (!l || !l.current)
      return;
    super.readKeyframes();
    for (let b = 0; b < i.length; b++) {
      let y = i[b];
      if (typeof y == "string" && (y = y.trim(), Of(y))) {
        const w = W0(y, l.current);
        w !== void 0 && (i[b] = w), b === i.length - 1 && (this.finalKeyframe = y);
      }
    }
    if (this.resolveNoneKeyframes(), !J0.has(o) || i.length !== 2)
      return;
    const [d, f] = i, h = Vy(d), p = Vy(f), g = Ny(d), m = Ny(f);
    if (g !== m && Qa[o]) {
      this.needsMeasurement = !0;
      return;
    }
    if (h !== p)
      if (Ry(h) && Ry(p))
        for (let b = 0; b < i.length; b++) {
          const y = i[b];
          typeof y == "string" && (i[b] = parseFloat(y));
        }
      else Qa[o] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: i, name: l } = this, o = [];
    for (let d = 0; d < i.length; d++)
      (i[d] === null || R3(i[d])) && o.push(d);
    o.length && L3(i, o, l);
  }
  measureInitialState() {
    const { element: i, unresolvedKeyframes: l, name: o } = this;
    if (!i || !i.current)
      return;
    o === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Qa[o](i.measureViewportBox(), window.getComputedStyle(i.current)), l[0] = this.measuredOrigin;
    const d = l[l.length - 1];
    d !== void 0 && i.getValue(o, d).jump(d, !1);
  }
  measureEndState() {
    const { element: i, name: l, unresolvedKeyframes: o } = this;
    if (!i || !i.current)
      return;
    const d = i.getValue(l);
    d && d.jump(this.measuredOrigin, !1);
    const f = o.length - 1, h = o[f];
    o[f] = Qa[l](i.measureViewportBox(), window.getComputedStyle(i.current)), h !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = h), this.removedTransforms?.length && this.removedTransforms.forEach(([p, g]) => {
      i.getValue(p).set(g);
    }), this.resolveNoneKeyframes();
  }
}
const qf = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function l1(n, i, l) {
  if (n == null)
    return [];
  if (n instanceof EventTarget)
    return [n];
  if (typeof n == "string") {
    let o = document;
    const d = l?.[n] ?? o.querySelectorAll(n);
    return d ? Array.from(d) : [];
  }
  return Array.from(n).filter((o) => o != null);
}
const $h = (n, i) => i && typeof n == "number" ? i.transform(n) : n;
function Qo(n) {
  return m0(n) && "offsetHeight" in n && !("ownerSVGElement" in n);
}
const { schedule: If } = /* @__PURE__ */ E0(queueMicrotask, !1), Mn = {
  x: !1,
  y: !1
};
function o1() {
  return Mn.x || Mn.y;
}
function q3(n) {
  return n === "x" || n === "y" ? Mn[n] ? null : (Mn[n] = !0, () => {
    Mn[n] = !1;
  }) : Mn.x || Mn.y ? null : (Mn.x = Mn.y = !0, () => {
    Mn.x = Mn.y = !1;
  });
}
function c1(n, i) {
  const l = l1(n), o = new AbortController(), d = {
    passive: !0,
    ...i,
    signal: o.signal
  };
  return [l, d, () => o.abort()];
}
function I3(n) {
  return !(n.pointerType === "touch" || o1());
}
function G3(n, i, l = {}) {
  const [o, d, f] = c1(n, l);
  return o.forEach((h) => {
    let p = !1, g = !1, m;
    const b = () => {
      h.removeEventListener("pointerleave", T);
    }, y = (R) => {
      m && (m(R), m = void 0), b();
    }, w = (R) => {
      p = !1, window.removeEventListener("pointerup", w), window.removeEventListener("pointercancel", w), g && (g = !1, y(R));
    }, S = () => {
      p = !0, window.addEventListener("pointerup", w, d), window.addEventListener("pointercancel", w, d);
    }, T = (R) => {
      if (R.pointerType !== "touch") {
        if (p) {
          g = !0;
          return;
        }
        y(R);
      }
    }, _ = (R) => {
      if (!I3(R))
        return;
      g = !1;
      const z = i(h, R);
      typeof z == "function" && (m = z, h.addEventListener("pointerleave", T, d));
    };
    h.addEventListener("pointerenter", _, d), h.addEventListener("pointerdown", S, d);
  }), f;
}
const u1 = (n, i) => i ? n === i ? !0 : u1(n, i.parentElement) : !1, Gf = (n) => n.pointerType === "mouse" ? typeof n.button != "number" || n.button <= 0 : n.isPrimary !== !1, Y3 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Q3(n) {
  return Y3.has(n.tagName) || n.isContentEditable === !0;
}
const Z3 = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function X3(n) {
  return Z3.has(n.tagName) || n.isContentEditable === !0;
}
const Zo = /* @__PURE__ */ new WeakSet();
function Uy(n) {
  return (i) => {
    i.key === "Enter" && n(i);
  };
}
function nh(n, i) {
  n.dispatchEvent(new PointerEvent("pointer" + i, { isPrimary: !0, bubbles: !0 }));
}
const K3 = (n, i) => {
  const l = n.currentTarget;
  if (!l)
    return;
  const o = Uy(() => {
    if (Zo.has(l))
      return;
    nh(l, "down");
    const d = Uy(() => {
      nh(l, "up");
    }), f = () => nh(l, "cancel");
    l.addEventListener("keyup", d, i), l.addEventListener("blur", f, i);
  });
  l.addEventListener("keydown", o, i), l.addEventListener("blur", () => l.removeEventListener("keydown", o), i);
};
function Ly(n) {
  return Gf(n) && !o1();
}
const Py = /* @__PURE__ */ new WeakSet();
function $3(n, i, l = {}) {
  const [o, d, f] = c1(n, l), h = (p) => {
    const g = p.currentTarget;
    if (!Ly(p) || Py.has(p))
      return;
    Zo.add(g), l.stopPropagation && Py.add(p);
    const m = i(g, p), b = { ...d, capture: !0 }, y = (T, _) => {
      window.removeEventListener("pointerup", w, b), window.removeEventListener("pointercancel", S, b), Zo.has(g) && Zo.delete(g), Ly(T) && typeof m == "function" && m(T, { success: _ });
    }, w = (T) => {
      y(T, g === window || g === document || l.useGlobalTarget || u1(g, T.target));
    }, S = (T) => {
      y(T, !1);
    };
    window.addEventListener("pointerup", w, b), window.addEventListener("pointercancel", S, b);
  };
  return o.forEach((p) => {
    (l.useGlobalTarget ? window : p).addEventListener("pointerdown", h, d), Qo(p) && (p.addEventListener("focus", (m) => K3(m, d)), !Q3(p) && !p.hasAttribute("tabindex") && (p.tabIndex = 0));
  }), f;
}
function Yf(n) {
  return m0(n) && "ownerSVGElement" in n;
}
const Xo = /* @__PURE__ */ new WeakMap();
let Ko;
const d1 = (n, i, l) => (o, d) => d && d[0] ? d[0][n + "Size"] : Yf(o) && "getBBox" in o ? o.getBBox()[i] : o[l], W3 = /* @__PURE__ */ d1("inline", "width", "offsetWidth"), J3 = /* @__PURE__ */ d1("block", "height", "offsetHeight");
function e4({ target: n, borderBoxSize: i }) {
  Xo.get(n)?.forEach((l) => {
    l(n, {
      get width() {
        return W3(n, i);
      },
      get height() {
        return J3(n, i);
      }
    });
  });
}
function t4(n) {
  n.forEach(e4);
}
function n4() {
  typeof ResizeObserver > "u" || (Ko = new ResizeObserver(t4));
}
function a4(n, i) {
  Ko || n4();
  const l = l1(n);
  return l.forEach((o) => {
    let d = Xo.get(o);
    d || (d = /* @__PURE__ */ new Set(), Xo.set(o, d)), d.add(i), Ko?.observe(o);
  }), () => {
    l.forEach((o) => {
      const d = Xo.get(o);
      d?.delete(i), d?.size || Ko?.unobserve(o);
    });
  };
}
const $o = /* @__PURE__ */ new Set();
let ks;
function i4() {
  ks = () => {
    const n = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    $o.forEach((i) => i(n));
  }, window.addEventListener("resize", ks);
}
function s4(n) {
  return $o.add(n), ks || i4(), () => {
    $o.delete(n), !$o.size && typeof ks == "function" && (window.removeEventListener("resize", ks), ks = void 0);
  };
}
function qy(n, i) {
  return typeof n == "function" ? s4(n) : a4(n, i);
}
function r4(n) {
  return Yf(n) && n.tagName === "svg";
}
const l4 = [...i1, rt, On], o4 = (n) => l4.find(a1(n)), Iy = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ms = () => ({
  x: Iy(),
  y: Iy()
}), Gy = () => ({ min: 0, max: 0 }), ct = () => ({
  x: Gy(),
  y: Gy()
}), c4 = /* @__PURE__ */ new WeakMap();
function Nc(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function";
}
function sl(n) {
  return typeof n == "string" || Array.isArray(n);
}
const Qf = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Zf = ["initial", ...Qf];
function Tc(n) {
  return Nc(n.animate) || Zf.some((i) => sl(n[i]));
}
function h1(n) {
  return !!(Tc(n) || n.variants);
}
function u4(n, i, l) {
  for (const o in i) {
    const d = i[o], f = l[o];
    if (vt(d))
      n.addValue(o, d);
    else if (vt(f))
      n.addValue(o, Bs(d, { owner: n }));
    else if (f !== d)
      if (n.hasValue(o)) {
        const h = n.getValue(o);
        h.liveStyle === !0 ? h.jump(d) : h.hasAnimated || h.set(d);
      } else {
        const h = n.getStaticValue(o);
        n.addValue(o, Bs(h !== void 0 ? h : d, { owner: n }));
      }
  }
  for (const o in l)
    i[o] === void 0 && n.removeValue(o);
  return i;
}
const Wh = { current: null }, f1 = { current: !1 }, d4 = typeof window < "u";
function h4() {
  if (f1.current = !0, !!d4)
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"), i = () => Wh.current = n.matches;
      n.addEventListener("change", i), i();
    } else
      Wh.current = !1;
}
const Yy = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let fc = {};
function m1(n) {
  fc = n;
}
function f4() {
  return fc;
}
class m4 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(i, l, o) {
    return {};
  }
  constructor({ parent: i, props: l, presenceContext: o, reducedMotionConfig: d, skipAnimations: f, blockInitialAnimation: h, visualState: p }, g = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Vf, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const S = zt.now();
      this.renderScheduledAt < S && (this.renderScheduledAt = S, Ge.render(this.render, !1, !0));
    };
    const { latestValues: m, renderState: b } = p;
    this.latestValues = m, this.baseTarget = { ...m }, this.initialValues = l.initial ? { ...m } : {}, this.renderState = b, this.parent = i, this.props = l, this.presenceContext = o, this.depth = i ? i.depth + 1 : 0, this.reducedMotionConfig = d, this.skipAnimationsConfig = f, this.options = g, this.blockInitialAnimation = !!h, this.isControllingVariants = Tc(l), this.isVariantNode = h1(l), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(i && i.current);
    const { willChange: y, ...w } = this.scrapeMotionValuesFromProps(l, {}, this);
    for (const S in w) {
      const T = w[S];
      m[S] !== void 0 && vt(T) && T.set(m[S]);
    }
  }
  mount(i) {
    if (this.hasBeenMounted)
      for (const l in this.initialValues)
        this.values.get(l)?.jump(this.initialValues[l]), this.latestValues[l] = this.initialValues[l];
    this.current = i, c4.set(i, this), this.projection && !this.projection.instance && this.projection.mount(i), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((l, o) => this.bindToMotionValue(o, l)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (f1.current || h4(), this.shouldReduceMotion = Wh.current), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), Xa(this.notifyUpdate), Xa(this.render), this.valueSubscriptions.forEach((i) => i()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const i in this.events)
      this.events[i].clear();
    for (const i in this.features) {
      const l = this.features[i];
      l && (l.unmount(), l.isMounted = !1);
    }
    this.current = null;
  }
  addChild(i) {
    this.children.add(i), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(i);
  }
  removeChild(i) {
    this.children.delete(i), this.enteringChildren && this.enteringChildren.delete(i);
  }
  bindToMotionValue(i, l) {
    if (this.valueSubscriptions.has(i) && this.valueSubscriptions.get(i)(), l.accelerate && X0.has(i) && this.current instanceof HTMLElement) {
      const { factory: h, keyframes: p, times: g, ease: m, duration: b } = l.accelerate, y = new Q0({
        element: this.current,
        name: i,
        keyframes: p,
        times: g,
        ease: m,
        duration: /* @__PURE__ */ an(b)
      }), w = h(y);
      this.valueSubscriptions.set(i, () => {
        w(), y.cancel();
      });
      return;
    }
    const o = Us.has(i);
    o && this.onBindTransform && this.onBindTransform();
    const d = l.on("change", (h) => {
      this.latestValues[i] = h, this.props.onUpdate && Ge.preRender(this.notifyUpdate), o && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let f;
    typeof window < "u" && window.MotionCheckAppearSync && (f = window.MotionCheckAppearSync(this, i, l)), this.valueSubscriptions.set(i, () => {
      d(), f && f();
    });
  }
  sortNodePosition(i) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== i.type ? 0 : this.sortInstanceNodePosition(this.current, i.current);
  }
  updateFeatures() {
    let i = "animation";
    for (i in fc) {
      const l = fc[i];
      if (!l)
        continue;
      const { isEnabled: o, Feature: d } = l;
      if (!this.features[i] && d && o(this.props) && (this.features[i] = new d(this)), this.features[i]) {
        const f = this.features[i];
        f.isMounted ? f.update() : (f.mount(), f.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ct();
  }
  getStaticValue(i) {
    return this.latestValues[i];
  }
  setStaticValue(i, l) {
    this.latestValues[i] = l;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(i, l) {
    (i.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = i, this.prevPresenceContext = this.presenceContext, this.presenceContext = l;
    for (let o = 0; o < Yy.length; o++) {
      const d = Yy[o];
      this.propEventSubscriptions[d] && (this.propEventSubscriptions[d](), delete this.propEventSubscriptions[d]);
      const f = "on" + d, h = i[f];
      h && (this.propEventSubscriptions[d] = this.on(d, h));
    }
    this.prevMotionValues = u4(this, this.scrapeMotionValuesFromProps(i, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(i) {
    return this.props.variants ? this.props.variants[i] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(i) {
    const l = this.getClosestVariantNode();
    if (l)
      return l.variantChildren && l.variantChildren.add(i), () => l.variantChildren.delete(i);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(i, l) {
    const o = this.values.get(i);
    l !== o && (o && this.removeValue(i), this.bindToMotionValue(i, l), this.values.set(i, l), this.latestValues[i] = l.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(i) {
    this.values.delete(i);
    const l = this.valueSubscriptions.get(i);
    l && (l(), this.valueSubscriptions.delete(i)), delete this.latestValues[i], this.removeValueFromRenderState(i, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(i) {
    return this.values.has(i);
  }
  getValue(i, l) {
    if (this.props.values && this.props.values[i])
      return this.props.values[i];
    let o = this.values.get(i);
    return o === void 0 && l !== void 0 && (o = Bs(l === null ? void 0 : l, { owner: this }), this.addValue(i, o)), o;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(i, l) {
    let o = this.latestValues[i] !== void 0 || !this.current ? this.latestValues[i] : this.getBaseTargetFromProps(this.props, i) ?? this.readValueFromInstance(this.current, i, this.options);
    return o != null && (typeof o == "string" && (f0(o) || p0(o)) ? o = parseFloat(o) : !o4(o) && On.test(l) && (o = r1(i, l)), this.setBaseTarget(i, vt(o) ? o.get() : o)), vt(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(i, l) {
    this.baseTarget[i] = l;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(i) {
    const { initial: l } = this.props;
    let o;
    if (typeof l == "string" || typeof l == "object") {
      const f = Lf(this.props, l, this.presenceContext?.custom);
      f && (o = f[i]);
    }
    if (l && o !== void 0)
      return o;
    const d = this.getBaseTargetFromProps(this.props, i);
    return d !== void 0 && !vt(d) ? d : this.initialValues[i] !== void 0 && o === void 0 ? void 0 : this.baseTarget[i];
  }
  on(i, l) {
    return this.events[i] || (this.events[i] = new kf()), this.events[i].add(l);
  }
  notify(i, ...l) {
    this.events[i] && this.events[i].notify(...l);
  }
  scheduleRenderMicrotask() {
    If.render(this.render);
  }
}
class p1 extends m4 {
  constructor() {
    super(...arguments), this.KeyframeResolver = P3;
  }
  sortInstanceNodePosition(i, l) {
    return i.compareDocumentPosition(l) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(i, l) {
    const o = i.style;
    return o ? o[l] : void 0;
  }
  removeValueFromRenderState(i, { vars: l, style: o }) {
    delete l[i], delete o[i];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: i } = this.props;
    vt(i) && (this.childSubscription = i.on("change", (l) => {
      this.current && (this.current.textContent = `${l}`);
    }));
  }
}
class $a {
  constructor(i) {
    this.isMounted = !1, this.node = i;
  }
  update() {
  }
}
function g1({ top: n, left: i, right: l, bottom: o }) {
  return {
    x: { min: i, max: l },
    y: { min: n, max: o }
  };
}
function p4({ x: n, y: i }) {
  return { top: i.min, right: n.max, bottom: i.max, left: n.min };
}
function g4(n, i) {
  if (!i)
    return n;
  const l = i({ x: n.left, y: n.top }), o = i({ x: n.right, y: n.bottom });
  return {
    top: l.y,
    left: l.x,
    bottom: o.y,
    right: o.x
  };
}
function ah(n) {
  return n === void 0 || n === 1;
}
function Jh({ scale: n, scaleX: i, scaleY: l }) {
  return !ah(n) || !ah(i) || !ah(l);
}
function Ei(n) {
  return Jh(n) || x1(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY;
}
function x1(n) {
  return Qy(n.x) || Qy(n.y);
}
function Qy(n) {
  return n && n !== "0%";
}
function mc(n, i, l) {
  const o = n - l, d = i * o;
  return l + d;
}
function Zy(n, i, l, o, d) {
  return d !== void 0 && (n = mc(n, d, o)), mc(n, l, o) + i;
}
function ef(n, i = 0, l = 1, o, d) {
  n.min = Zy(n.min, i, l, o, d), n.max = Zy(n.max, i, l, o, d);
}
function y1(n, { x: i, y: l }) {
  ef(n.x, i.translate, i.scale, i.originPoint), ef(n.y, l.translate, l.scale, l.originPoint);
}
const Xy = 0.999999999999, Ky = 1.0000000000001;
function x4(n, i, l, o = !1) {
  const d = l.length;
  if (!d)
    return;
  i.x = i.y = 1;
  let f, h;
  for (let p = 0; p < d; p++) {
    f = l[p], h = f.projectionDelta;
    const { visualElement: g } = f.options;
    g && g.props.style && g.props.style.display === "contents" || (o && f.options.layoutScroll && f.scroll && f !== f.root && (In(n.x, -f.scroll.offset.x), In(n.y, -f.scroll.offset.y)), h && (i.x *= h.x.scale, i.y *= h.y.scale, y1(n, h)), o && Ei(f.latestValues) && Wo(n, f.latestValues, f.layout?.layoutBox));
  }
  i.x < Ky && i.x > Xy && (i.x = 1), i.y < Ky && i.y > Xy && (i.y = 1);
}
function In(n, i) {
  n.min += i, n.max += i;
}
function $y(n, i, l, o, d = 0.5) {
  const f = Ie(n.min, n.max, d);
  ef(n, i, l, f, o);
}
function Wy(n, i) {
  return typeof n == "string" ? parseFloat(n) / 100 * (i.max - i.min) : n;
}
function Wo(n, i, l) {
  const o = l ?? n;
  $y(n.x, Wy(i.x, o.x), i.scaleX, i.scale, i.originX), $y(n.y, Wy(i.y, o.y), i.scaleY, i.scale, i.originY);
}
function b1(n, i) {
  return g1(g4(n.getBoundingClientRect(), i));
}
function y4(n, i, l) {
  const o = b1(n, l), { scroll: d } = i;
  return d && (In(o.x, d.offset.x), In(o.y, d.offset.y)), o;
}
const b4 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, v4 = Hs.length;
function w4(n, i, l) {
  let o = "", d = !0;
  for (let h = 0; h < v4; h++) {
    const p = Hs[h], g = n[p];
    if (g === void 0)
      continue;
    let m = !0;
    if (typeof g == "number")
      m = g === (p.startsWith("scale") ? 1 : 0);
    else {
      const b = parseFloat(g);
      m = p.startsWith("scale") ? b === 1 : b === 0;
    }
    if (!m || l) {
      const b = $h(g, hc[p]);
      if (!m) {
        d = !1;
        const y = b4[p] || p;
        o += `${y}(${b}) `;
      }
      l && (i[p] = b);
    }
  }
  const f = n.pathRotation;
  return f && (d = !1, o += `rotate(${$h(f, hc.pathRotation)}) `), o = o.trim(), l ? o = l(i, d ? "" : o) : d && (o = "none"), o;
}
function Xf(n, i, l) {
  const { style: o, vars: d, transformOrigin: f } = n;
  let h = !1, p = !1;
  for (const g in i) {
    const m = i[g];
    if (Us.has(g)) {
      h = !0;
      continue;
    } else if (M0(g)) {
      d[g] = m;
      continue;
    } else {
      const b = $h(m, hc[g]);
      g.startsWith("origin") ? (p = !0, f[g] = b) : o[g] = b;
    }
  }
  if (i.transform || (h || l ? o.transform = w4(i, n.transform, l) : o.transform && (o.transform = "none")), p) {
    const { originX: g = "50%", originY: m = "50%", originZ: b = 0 } = f;
    o.transformOrigin = `${g} ${m} ${b}`;
  }
}
function v1(n, { style: i, vars: l }, o, d) {
  const f = n.style;
  let h;
  for (h in i)
    f[h] = i[h];
  d?.applyProjectionStyles(f, o);
  for (h in l)
    f.setProperty(h, l[h]);
}
function Jy(n, i) {
  return i.max === i.min ? 0 : n / (i.max - i.min) * 100;
}
const Hr = {
  correct: (n, i) => {
    if (!i.target)
      return n;
    if (typeof n == "string")
      if (ue.test(n))
        n = parseFloat(n);
      else
        return n;
    const l = Jy(n, i.target.x), o = Jy(n, i.target.y);
    return `${l}% ${o}%`;
  }
}, j4 = {
  correct: (n, { treeScale: i, projectionDelta: l }) => {
    const o = n, d = On.parse(n);
    if (d.length > 5)
      return o;
    const f = On.createTransformer(n), h = typeof d[0] != "number" ? 1 : 0, p = l.x.scale * i.x, g = l.y.scale * i.y;
    d[0 + h] /= p, d[1 + h] /= g;
    const m = Ie(p, g, 0.5);
    return typeof d[2 + h] == "number" && (d[2 + h] /= m), typeof d[3 + h] == "number" && (d[3 + h] /= m), f(d);
  }
}, tf = {
  borderRadius: {
    ...Hr,
    applyTo: [...qf]
  },
  borderTopLeftRadius: Hr,
  borderTopRightRadius: Hr,
  borderBottomLeftRadius: Hr,
  borderBottomRightRadius: Hr,
  boxShadow: j4
};
function w1(n, { layout: i, layoutId: l }) {
  return Us.has(n) || n.startsWith("origin") || (i || l !== void 0) && (!!tf[n] || n === "opacity");
}
function Kf(n, i, l) {
  const o = n.style, d = i?.style, f = {};
  if (!o)
    return f;
  for (const h in o)
    (vt(o[h]) || d && vt(d[h]) || w1(h, n) || l?.getValue(h)?.liveStyle !== void 0) && (f[h] = o[h]);
  return f;
}
function S4(n) {
  return window.getComputedStyle(n);
}
class N4 extends p1 {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = v1;
  }
  mount(i) {
    jc(!!i.style), super.mount(i);
  }
  readValueFromInstance(i, l) {
    if (Us.has(l))
      return this.projection?.isProjecting ? Uh(l) : I5(i, l);
    {
      const o = S4(i), d = (M0(l) ? o.getPropertyValue(l) : o[l]) || 0;
      return typeof d == "string" ? d.trim() : d;
    }
  }
  measureInstanceViewportBox(i, { transformPagePoint: l }) {
    return b1(i, l);
  }
  build(i, l, o) {
    Xf(i, l, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(i, l, o) {
    return Kf(i, l, o);
  }
}
const T4 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, A4 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function C4(n, i, l = 1, o = 0, d = !0) {
  n.pathLength = 1;
  const f = d ? T4 : A4;
  n[f.offset] = `${-o}`, n[f.array] = `${i} ${l}`;
}
const E4 = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function j1(n, {
  attrX: i,
  attrY: l,
  attrScale: o,
  pathLength: d,
  pathSpacing: f = 1,
  pathOffset: h = 0,
  // This is object creation, which we try to avoid per-frame.
  ...p
}, g, m, b) {
  if (Xf(n, p, m), g) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox);
    return;
  }
  n.attrs = n.style, n.style = {};
  const { attrs: y, style: w } = n;
  y.transform && (w.transform = y.transform, delete y.transform), (w.transform || y.transformOrigin) && (w.transformOrigin = y.transformOrigin ?? "50% 50%", delete y.transformOrigin), w.transform && (w.transformBox = b?.transformBox ?? "fill-box", delete y.transformBox);
  for (const S of E4)
    y[S] !== void 0 && (w[S] = y[S], delete y[S]);
  i !== void 0 && (y.x = i), l !== void 0 && (y.y = l), o !== void 0 && (y.scale = o), d !== void 0 && C4(y, d, f, h, !1);
}
const S1 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), N1 = (n) => typeof n == "string" && n.toLowerCase() === "svg";
function k4(n, i, l, o) {
  v1(n, i, void 0, o);
  for (const d in i.attrs)
    n.setAttribute(S1.has(d) ? d : Pf(d), i.attrs[d]);
}
function T1(n, i, l) {
  const o = Kf(n, i, l);
  for (const d in n)
    if (vt(n[d]) || vt(i[d])) {
      const f = Hs.indexOf(d) !== -1 ? "attr" + d.charAt(0).toUpperCase() + d.substring(1) : d;
      o[f] = n[d];
    }
  return o;
}
class M4 extends p1 {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ct;
  }
  getBaseTargetFromProps(i, l) {
    return i[l];
  }
  readValueFromInstance(i, l) {
    if (Us.has(l)) {
      const o = s1(l);
      return o && o.default || 0;
    }
    return l = S1.has(l) ? l : Pf(l), i.getAttribute(l);
  }
  scrapeMotionValuesFromProps(i, l, o) {
    return T1(i, l, o);
  }
  build(i, l, o) {
    j1(i, l, this.isSVGTag, o.transformTemplate, o.style);
  }
  renderInstance(i, l, o, d) {
    k4(i, l, o, d);
  }
  mount(i) {
    this.isSVGTag = N1(i.tagName), super.mount(i);
  }
}
const z4 = Zf.length;
function A1(n) {
  if (!n)
    return;
  if (!n.isControllingVariants) {
    const l = n.parent ? A1(n.parent) || {} : {};
    return n.props.initial !== void 0 && (l.initial = n.props.initial), l;
  }
  const i = {};
  for (let l = 0; l < z4; l++) {
    const o = Zf[l], d = n.props[o];
    (sl(d) || d === !1) && (i[o] = d);
  }
  return i;
}
function C1(n, i) {
  if (!Array.isArray(i))
    return !1;
  const l = i.length;
  if (l !== n.length)
    return !1;
  for (let o = 0; o < l; o++)
    if (i[o] !== n[o])
      return !1;
  return !0;
}
const O4 = [...Qf].reverse(), R4 = Qf.length;
function _4(n) {
  return (i) => Promise.all(i.map(({ animation: l, options: o }) => z3(n, l, o)));
}
function D4(n) {
  let i = _4(n), l = eb(), o = !0, d = !1;
  const f = (m) => (b, y) => {
    const w = Ri(n, y, m === "exit" ? n.presenceContext?.custom : void 0);
    if (w) {
      const { transition: S, transitionEnd: T, ..._ } = w;
      b = { ...b, ..._, ...T };
    }
    return b;
  };
  function h(m) {
    i = m(n);
  }
  function p(m) {
    const { props: b } = n, y = A1(n.parent) || {}, w = [], S = /* @__PURE__ */ new Set();
    let T = {}, _ = 1 / 0;
    for (let z = 0; z < R4; z++) {
      const Q = O4[z], L = l[Q], Y = b[Q] !== void 0 ? b[Q] : y[Q], ae = sl(Y), ee = Q === m ? L.isActive : null;
      ee === !1 && (_ = z);
      let Z = Y === y[Q] && Y !== b[Q] && ae;
      if (Z && (o || d) && n.manuallyAnimateOnMount && (Z = !1), L.protectedKeys = { ...T }, // If it isn't active and hasn't *just* been set as inactive
      !L.isActive && ee === null || // If we didn't and don't have any defined prop for this animation type
      !Y && !L.prevProp || // Or if the prop doesn't define an animation
      Nc(Y) || typeof Y == "boolean")
        continue;
      if (Q === "exit" && L.isActive && ee !== !0) {
        L.prevResolvedValues && (T = {
          ...T,
          ...L.prevResolvedValues
        });
        continue;
      }
      const k = F4(L.prevProp, Y);
      let ne = k || // If we're making this variant active, we want to always make it active
      Q === m && L.isActive && !Z && ae || // If we removed a higher-priority variant (i is in reverse order)
      z > _ && ae, V = !1;
      const ie = Array.isArray(Y) ? Y : [Y];
      let he = ie.reduce(f(Q), {});
      ee === !1 && (he = {});
      const { prevResolvedValues: je = {} } = L, ke = {
        ...je,
        ...he
      }, Se = (te) => {
        ne = !0, S.has(te) && (V = !0, S.delete(te)), L.needsAnimating[te] = !0;
        const me = n.getValue(te);
        me && (me.liveStyle = !1);
      };
      for (const te in ke) {
        const me = he[te], $ = je[te];
        if (T.hasOwnProperty(te))
          continue;
        let N = !1;
        Yh(me) && Yh($) ? N = !C1(me, $) || k : N = me !== $, N ? me != null ? Se(te) : S.add(te) : me !== void 0 && S.has(te) ? Se(te) : L.protectedKeys[te] = !0;
      }
      L.prevProp = Y, L.prevResolvedValues = he, L.isActive && (T = { ...T, ...he }), (o || d) && n.blockInitialAnimation && (ne = !1);
      const O = Z && k;
      ne && (!O || V) && w.push(...ie.map((te) => {
        const me = { type: Q };
        if (typeof te == "string" && (o || d) && !O && n.manuallyAnimateOnMount && n.parent) {
          const { parent: $ } = n, N = Ri($, te);
          if ($.enteringChildren && N) {
            const { delayChildren: P } = N.transition || {};
            me.delay = K0($.enteringChildren, n, P);
          }
        }
        return {
          animation: te,
          options: me
        };
      }));
    }
    if (S.size) {
      const z = {};
      if (typeof b.initial != "boolean") {
        const Q = Ri(n, Array.isArray(b.initial) ? b.initial[0] : b.initial);
        Q && Q.transition && (z.transition = Q.transition);
      }
      S.forEach((Q) => {
        const L = n.getBaseTarget(Q), Y = n.getValue(Q);
        Y && (Y.liveStyle = !0), z[Q] = L ?? null;
      }), w.push({ animation: z });
    }
    let R = !!w.length;
    return o && (b.initial === !1 || b.initial === b.animate) && !n.manuallyAnimateOnMount && (R = !1), o = !1, d = !1, R ? i(w) : Promise.resolve();
  }
  function g(m, b) {
    if (l[m].isActive === b)
      return Promise.resolve();
    n.variantChildren?.forEach((w) => w.animationState?.setActive(m, b)), l[m].isActive = b;
    const y = p(m);
    for (const w in l)
      l[w].protectedKeys = {};
    return y;
  }
  return {
    animateChanges: p,
    setActive: g,
    setAnimateFunction: h,
    getState: () => l,
    reset: () => {
      l = eb(), d = !0;
    }
  };
}
function F4(n, i) {
  return typeof i == "string" ? i !== n : Array.isArray(i) ? !C1(i, n) : !1;
}
function ji(n = !1) {
  return {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function eb() {
  return {
    animate: ji(!0),
    whileInView: ji(),
    whileHover: ji(),
    whileTap: ji(),
    whileDrag: ji(),
    whileFocus: ji(),
    exit: ji()
  };
}
function nf(n, i) {
  n.min = i.min, n.max = i.max;
}
function kn(n, i) {
  nf(n.x, i.x), nf(n.y, i.y);
}
function tb(n, i) {
  n.translate = i.translate, n.scale = i.scale, n.originPoint = i.originPoint, n.origin = i.origin;
}
const E1 = 1e-4, B4 = 1 - E1, V4 = 1 + E1, k1 = 0.01, H4 = 0 - k1, U4 = 0 + k1;
function Ot(n) {
  return n.max - n.min;
}
function L4(n, i, l) {
  return Math.abs(n - i) <= l;
}
function nb(n, i, l, o = 0.5) {
  n.origin = o, n.originPoint = Ie(i.min, i.max, n.origin), n.scale = Ot(l) / Ot(i), n.translate = Ie(l.min, l.max, n.origin) - n.originPoint, (n.scale >= B4 && n.scale <= V4 || isNaN(n.scale)) && (n.scale = 1), (n.translate >= H4 && n.translate <= U4 || isNaN(n.translate)) && (n.translate = 0);
}
function $r(n, i, l, o) {
  nb(n.x, i.x, l.x, o ? o.originX : void 0), nb(n.y, i.y, l.y, o ? o.originY : void 0);
}
function ab(n, i, l, o = 0) {
  const d = o ? Ie(l.min, l.max, o) : l.min;
  n.min = d + i.min, n.max = n.min + Ot(i);
}
function P4(n, i, l, o) {
  ab(n.x, i.x, l.x, o?.x), ab(n.y, i.y, l.y, o?.y);
}
function ib(n, i, l, o = 0) {
  const d = o ? Ie(l.min, l.max, o) : l.min;
  n.min = i.min - d, n.max = n.min + Ot(i);
}
function pc(n, i, l, o) {
  ib(n.x, i.x, l.x, o?.x), ib(n.y, i.y, l.y, o?.y);
}
function sb(n, i, l, o, d) {
  return n -= i, n = mc(n, 1 / l, o), d !== void 0 && (n = mc(n, 1 / d, o)), n;
}
function q4(n, i = 0, l = 1, o = 0.5, d, f = n, h = n) {
  if (Gn.test(i) && (i = parseFloat(i), i = Ie(h.min, h.max, i / 100) - h.min), typeof i != "number")
    return;
  let p = Ie(f.min, f.max, o);
  n === f && (p -= i), n.min = sb(n.min, i, l, p, d), n.max = sb(n.max, i, l, p, d);
}
function rb(n, i, [l, o, d], f, h) {
  q4(n, i[l], i[o], i[d], i.scale, f, h);
}
const I4 = ["x", "scaleX", "originX"], G4 = ["y", "scaleY", "originY"];
function lb(n, i, l, o) {
  rb(n.x, i, I4, l ? l.x : void 0, o ? o.x : void 0), rb(n.y, i, G4, l ? l.y : void 0, o ? o.y : void 0);
}
function ob(n) {
  return n.translate === 0 && n.scale === 1;
}
function M1(n) {
  return ob(n.x) && ob(n.y);
}
function cb(n, i) {
  return n.min === i.min && n.max === i.max;
}
function Y4(n, i) {
  return cb(n.x, i.x) && cb(n.y, i.y);
}
function ub(n, i) {
  return Math.round(n.min) === Math.round(i.min) && Math.round(n.max) === Math.round(i.max);
}
function z1(n, i) {
  return ub(n.x, i.x) && ub(n.y, i.y);
}
function db(n) {
  return Ot(n.x) / Ot(n.y);
}
function hb(n, i) {
  return n.translate === i.translate && n.scale === i.scale && n.originPoint === i.originPoint;
}
function qn(n) {
  return [n("x"), n("y")];
}
function Q4(n, i, l) {
  let o = "";
  const d = n.x.translate / i.x, f = n.y.translate / i.y, h = l?.z || 0;
  if ((d || f || h) && (o = `translate3d(${d}px, ${f}px, ${h}px) `), (i.x !== 1 || i.y !== 1) && (o += `scale(${1 / i.x}, ${1 / i.y}) `), l) {
    const { transformPerspective: m, rotate: b, pathRotation: y, rotateX: w, rotateY: S, skewX: T, skewY: _ } = l;
    m && (o = `perspective(${m}px) ${o}`), b && (o += `rotate(${b}deg) `), y && (o += `rotate(${y}deg) `), w && (o += `rotateX(${w}deg) `), S && (o += `rotateY(${S}deg) `), T && (o += `skewX(${T}deg) `), _ && (o += `skewY(${_}deg) `);
  }
  const p = n.x.scale * i.x, g = n.y.scale * i.y;
  return (p !== 1 || g !== 1) && (o += `scale(${p}, ${g})`), o || "none";
}
const Z4 = qf.length, fb = (n) => typeof n == "string" ? parseFloat(n) : n, mb = (n) => typeof n == "number" || ue.test(n);
function X4(n, i, l, o, d, f) {
  d ? (n.opacity = Ie(0, l.opacity ?? 1, K4(o)), n.opacityExit = Ie(i.opacity ?? 1, 0, $4(o))) : f && (n.opacity = Ie(i.opacity ?? 1, l.opacity ?? 1, o));
  for (let h = 0; h < Z4; h++) {
    const p = qf[h];
    let g = pb(i, p), m = pb(l, p);
    if (g === void 0 && m === void 0)
      continue;
    g || (g = 0), m || (m = 0), g === 0 || m === 0 || mb(g) === mb(m) ? (n[p] = Math.max(Ie(fb(g), fb(m), o), 0), (Gn.test(m) || Gn.test(g)) && (n[p] += "%")) : n[p] = m;
  }
  (i.rotate || l.rotate) && (n.rotate = Ie(i.rotate || 0, l.rotate || 0, o));
}
function pb(n, i) {
  return n[i] !== void 0 ? n[i] : n.borderRadius;
}
const K4 = /* @__PURE__ */ O1(0, 0.5, N0), $4 = /* @__PURE__ */ O1(0.5, 0.95, Sn);
function O1(n, i, l) {
  return (o) => o < n ? 0 : o > i ? 1 : l(/* @__PURE__ */ al(n, i, o));
}
function W4(n, i, l) {
  const o = vt(n) ? n : Bs(n);
  return o.start(Uf("", o, i, l)), o.animation;
}
function rl(n, i, l, o = { passive: !0 }) {
  return n.addEventListener(i, l, o), () => n.removeEventListener(i, l, o);
}
const J4 = (n, i) => n.depth - i.depth;
class eA {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(i) {
    Ef(this.children, i), this.isDirty = !0;
  }
  remove(i) {
    lc(this.children, i), this.isDirty = !0;
  }
  forEach(i) {
    this.isDirty && this.children.sort(J4), this.isDirty = !1, this.children.forEach(i);
  }
}
function tA(n, i) {
  const l = zt.now(), o = ({ timestamp: d }) => {
    const f = d - l;
    f >= i && (Xa(o), n(f - i));
  };
  return Ge.setup(o, !0), () => Xa(o);
}
function Jo(n) {
  return vt(n) ? n.get() : n;
}
class nA {
  constructor() {
    this.members = [];
  }
  add(i) {
    Ef(this.members, i);
    for (let l = this.members.length - 1; l >= 0; l--) {
      const o = this.members[l];
      if (o === i || o === this.lead || o === this.prevLead)
        continue;
      const d = o.instance;
      (!d || d.isConnected === !1) && !o.snapshot && (lc(this.members, o), o.unmount());
    }
    i.scheduleRender();
  }
  remove(i) {
    if (lc(this.members, i), i === this.prevLead && (this.prevLead = void 0), i === this.lead) {
      const l = this.members[this.members.length - 1];
      l && this.promote(l);
    }
  }
  relegate(i) {
    for (let l = this.members.indexOf(i) - 1; l >= 0; l--) {
      const o = this.members[l];
      if (o.isPresent !== !1 && o.instance?.isConnected !== !1)
        return this.promote(o), !0;
    }
    return !1;
  }
  promote(i, l) {
    const o = this.lead;
    if (i !== o && (this.prevLead = o, this.lead = i, i.show(), o)) {
      o.updateSnapshot(), i.scheduleRender();
      const { layoutDependency: d } = o.options, { layoutDependency: f } = i.options;
      (d === void 0 || d !== f) && (i.resumeFrom = o, l && (o.preserveOpacity = !0), o.snapshot && (i.snapshot = o.snapshot, i.snapshot.latestValues = o.animationValues || o.latestValues), i.root?.isUpdating && (i.isLayoutDirty = !0)), i.options.crossfade === !1 && o.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((i) => {
      i.options.onExitComplete?.(), i.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((i) => i.instance && i.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const ec = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, ih = ["", "X", "Y", "Z"], aA = 1e3;
let iA = 0;
function sh(n, i, l, o) {
  const { latestValues: d } = i;
  d[n] && (l[n] = d[n], i.setStaticValue(n, 0), o && (o[n] = 0));
}
function R1(n) {
  if (n.hasCheckedOptimisedAppear = !0, n.root === n)
    return;
  const { visualElement: i } = n.options;
  if (!i)
    return;
  const l = t1(i);
  if (window.MotionHasOptimisedAnimation(l, "transform")) {
    const { layout: d, layoutId: f } = n.options;
    window.MotionCancelOptimisedAnimation(l, "transform", Ge, !(d || f));
  }
  const { parent: o } = n;
  o && !o.hasCheckedOptimisedAppear && R1(o);
}
function _1({ attachResizeListener: n, defaultParent: i, measureScroll: l, checkIsScrollRoot: o, resetTransform: d }) {
  return class {
    constructor(h = {}, p = i?.()) {
      this.id = iA++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(lA), this.nodes.forEach(fA), this.nodes.forEach(mA), this.nodes.forEach(oA);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = h, this.root = p ? p.root || p : this, this.path = p ? [...p.path, p] : [], this.parent = p, this.depth = p ? p.depth + 1 : 0;
      for (let g = 0; g < this.path.length; g++)
        this.path[g].shouldResetTransform = !0;
      this.root === this && (this.nodes = new eA());
    }
    addEventListener(h, p) {
      return this.eventHandlers.has(h) || this.eventHandlers.set(h, new kf()), this.eventHandlers.get(h).add(p);
    }
    notifyListeners(h, ...p) {
      const g = this.eventHandlers.get(h);
      g && g.notify(...p);
    }
    hasListeners(h) {
      return this.eventHandlers.has(h);
    }
    /**
     * Lifecycles
     */
    mount(h) {
      if (this.instance)
        return;
      this.isSVG = Yf(h) && !r4(h), this.instance = h;
      const { layoutId: p, layout: g, visualElement: m } = this.options;
      if (m && !m.current && m.mount(h), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (g || p) && (this.isLayoutDirty = !0), n) {
        let b, y = 0;
        const w = () => this.root.updateBlockedByResize = !1;
        Ge.read(() => {
          y = window.innerWidth;
        }), n(h, () => {
          const S = window.innerWidth;
          S !== y && (y = S, this.root.updateBlockedByResize = !0, b && b(), b = tA(w, 250), ec.hasAnimatedSinceResize && (ec.hasAnimatedSinceResize = !1, this.nodes.forEach(yb)));
        });
      }
      p && this.root.registerSharedNode(p, this), this.options.animate !== !1 && m && (p || g) && this.addEventListener("didUpdate", ({ delta: b, hasLayoutChanged: y, hasRelativeLayoutChanged: w, layout: S }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const T = this.options.transition || m.getDefaultTransition() || bA, { onLayoutAnimationStart: _, onLayoutAnimationComplete: R } = m.getProps(), z = !this.targetLayout || !z1(this.targetLayout, S), Q = !y && w;
        if (this.options.layoutRoot || this.resumeFrom || Q || y && (z || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const L = {
            ...Hf(T, "layout"),
            onPlay: _,
            onComplete: R
          };
          (m.shouldReduceMotion || this.options.layoutRoot) && (L.delay = 0, L.type = !1), this.startAnimation(L), this.setAnimationOrigin(b, Q, L.path);
        } else
          y || yb(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = S;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const h = this.getStack();
      h && h.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Xa(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(pA), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: h } = this.options;
      return h && h.getProps().transformTemplate;
    }
    willUpdate(h = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && R1(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let b = 0; b < this.path.length; b++) {
        const y = this.path[b];
        y.shouldResetTransform = !0, (typeof y.latestValues.x == "string" || typeof y.latestValues.y == "string") && (y.isLayoutDirty = !0), y.updateScroll("snapshot"), y.options.layoutRoot && y.willUpdate(!1);
      }
      const { layoutId: p, layout: g } = this.options;
      if (p === void 0 && !g)
        return;
      const m = this.getTransformTemplate();
      this.prevTransformTemplateValue = m ? m(this.latestValues, "") : void 0, this.updateSnapshot(), h && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const g = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), g && this.nodes.forEach(uA), this.nodes.forEach(gb);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(xb);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(dA), this.nodes.forEach(hA), this.nodes.forEach(sA), this.nodes.forEach(rA)) : this.nodes.forEach(xb), this.clearAllSnapshots();
      const p = zt.now();
      bt.delta = Yn(0, 1e3 / 60, p - bt.timestamp), bt.timestamp = p, bt.isProcessing = !0, Kd.update.process(bt), Kd.preRender.process(bt), Kd.render.process(bt), bt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, If.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(cA), this.sharedNodes.forEach(gA);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Ge.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Ge.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Ot(this.snapshot.measuredBox.x) && !Ot(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let g = 0; g < this.path.length; g++)
          this.path[g].updateScroll();
      const h = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = ct()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: p } = this.options;
      p && p.notify("LayoutMeasure", this.layout.layoutBox, h ? h.layoutBox : void 0);
    }
    updateScroll(h = "measure") {
      let p = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === h && (p = !1), p && this.instance) {
        const g = o(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: h,
          isRoot: g,
          offset: l(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : g
        };
      }
    }
    resetTransform() {
      if (!d)
        return;
      const h = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, p = this.projectionDelta && !M1(this.projectionDelta), g = this.getTransformTemplate(), m = g ? g(this.latestValues, "") : void 0, b = m !== this.prevTransformTemplateValue;
      h && this.instance && (p || Ei(this.latestValues) || b) && (d(this.instance, m), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(h = !0) {
      const p = this.measurePageBox();
      let g = this.removeElementScroll(p);
      return h && (g = this.removeTransform(g)), vA(g), {
        animationId: this.root.animationId,
        measuredBox: p,
        layoutBox: g,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: h } = this.options;
      if (!h)
        return ct();
      const p = h.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(wA))) {
        const { scroll: m } = this.root;
        m && (In(p.x, m.offset.x), In(p.y, m.offset.y));
      }
      return p;
    }
    removeElementScroll(h) {
      const p = ct();
      if (kn(p, h), this.scroll?.wasRoot)
        return p;
      for (let g = 0; g < this.path.length; g++) {
        const m = this.path[g], { scroll: b, options: y } = m;
        m !== this.root && b && y.layoutScroll && (b.wasRoot && kn(p, h), In(p.x, b.offset.x), In(p.y, b.offset.y));
      }
      return p;
    }
    applyTransform(h, p = !1, g) {
      const m = g || ct();
      kn(m, h);
      for (let b = 0; b < this.path.length; b++) {
        const y = this.path[b];
        !p && y.options.layoutScroll && y.scroll && y !== y.root && (In(m.x, -y.scroll.offset.x), In(m.y, -y.scroll.offset.y)), Ei(y.latestValues) && Wo(m, y.latestValues, y.layout?.layoutBox);
      }
      return Ei(this.latestValues) && Wo(m, this.latestValues, this.layout?.layoutBox), m;
    }
    removeTransform(h) {
      const p = ct();
      kn(p, h);
      for (let g = 0; g < this.path.length; g++) {
        const m = this.path[g];
        if (!Ei(m.latestValues))
          continue;
        let b;
        m.instance && (Jh(m.latestValues) && m.updateSnapshot(), b = ct(), kn(b, m.measurePageBox())), lb(p, m.latestValues, m.snapshot?.layoutBox, b);
      }
      return Ei(this.latestValues) && lb(p, this.latestValues), p;
    }
    setTargetDelta(h) {
      this.targetDelta = h, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(h) {
      this.options = {
        ...this.options,
        ...h,
        crossfade: h.crossfade !== void 0 ? h.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== bt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(h = !1) {
      const p = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = p.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = p.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = p.isSharedProjectionDirty);
      const g = !!this.resumingFrom || this !== p;
      if (!(h || g && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: b, layoutId: y } = this.options;
      if (!this.layout || !(b || y))
        return;
      this.resolvedRelativeTargetAt = bt.timestamp;
      const w = this.getClosestProjectingParent();
      w && this.linkedParentVersion !== w.layoutVersion && !w.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && w && w.layout ? this.createRelativeTarget(w, this.layout.layoutBox, w.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ct(), this.targetWithTransforms = ct()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), P4(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : kn(this.target, this.layout.layoutBox), y1(this.target, this.targetDelta)) : kn(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && w && !!w.resumingFrom == !!this.resumingFrom && !w.options.layoutScroll && w.target && this.animationProgress !== 1 ? this.createRelativeTarget(w, this.target, w.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Jh(this.parent.latestValues) || x1(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(h, p, g) {
      this.relativeParent = h, this.linkedParentVersion = h.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ct(), this.relativeTargetOrigin = ct(), pc(this.relativeTargetOrigin, p, g, this.options.layoutAnchor || void 0), kn(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const h = this.getLead(), p = !!this.resumingFrom || this !== h;
      let g = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (g = !1), p && (this.isSharedProjectionDirty || this.isTransformDirty) && (g = !1), this.resolvedRelativeTargetAt === bt.timestamp && (g = !1), g)
        return;
      const { layout: m, layoutId: b } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(m || b))
        return;
      kn(this.layoutCorrected, this.layout.layoutBox);
      const y = this.treeScale.x, w = this.treeScale.y;
      x4(this.layoutCorrected, this.treeScale, this.path, p), h.layout && !h.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (h.target = h.layout.layoutBox, h.targetWithTransforms = ct());
      const { target: S } = h;
      if (!S) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (tb(this.prevProjectionDelta.x, this.projectionDelta.x), tb(this.prevProjectionDelta.y, this.projectionDelta.y)), $r(this.projectionDelta, this.layoutCorrected, S, this.latestValues), (this.treeScale.x !== y || this.treeScale.y !== w || !hb(this.projectionDelta.x, this.prevProjectionDelta.x) || !hb(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", S));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(h = !0) {
      if (this.options.visualElement?.scheduleRender(), h) {
        const p = this.getStack();
        p && p.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Ms(), this.projectionDelta = Ms(), this.projectionDeltaWithTransform = Ms();
    }
    setAnimationOrigin(h, p = !1, g) {
      const m = this.snapshot, b = m ? m.latestValues : {}, y = { ...this.latestValues }, w = Ms();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !p;
      const S = ct(), T = m ? m.source : void 0, _ = this.layout ? this.layout.source : void 0, R = T !== _, z = this.getStack(), Q = !z || z.members.length <= 1, L = !!(R && !Q && this.options.crossfade === !0 && !this.path.some(yA));
      this.animationProgress = 0;
      let Y;
      const ae = g?.interpolateProjection(h);
      this.mixTargetDelta = (ee) => {
        const Z = ee / 1e3, k = ae?.(Z);
        k ? (w.x.translate = k.x, w.x.scale = Ie(h.x.scale, 1, Z), w.x.origin = h.x.origin, w.x.originPoint = h.x.originPoint, w.y.translate = k.y, w.y.scale = Ie(h.y.scale, 1, Z), w.y.origin = h.y.origin, w.y.originPoint = h.y.originPoint) : (bb(w.x, h.x, Z), bb(w.y, h.y, Z)), this.setTargetDelta(w), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (pc(S, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), xA(this.relativeTarget, this.relativeTargetOrigin, S, Z), Y && Y4(this.relativeTarget, Y) && (this.isProjectionDirty = !1), Y || (Y = ct()), kn(Y, this.relativeTarget)), R && (this.animationValues = y, X4(y, b, this.latestValues, Z, L, Q)), k && k.rotate !== void 0 && (this.animationValues || (this.animationValues = y), this.animationValues.pathRotation = k.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = Z;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(h) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (Xa(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ge.update(() => {
        ec.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Bs(0)), this.motionValue.jump(0, !1), this.currentAnimation = W4(this.motionValue, [0, 1e3], {
          ...h,
          velocity: 0,
          isSync: !0,
          onUpdate: (p) => {
            this.mixTargetDelta(p), h.onUpdate && h.onUpdate(p);
          },
          onComplete: () => {
            h.onComplete && h.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const h = this.getStack();
      h && h.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(aA), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const h = this.getLead();
      let { targetWithTransforms: p, target: g, layout: m, latestValues: b } = h;
      if (!(!p || !g || !m)) {
        if (this !== h && this.layout && m && D1(this.options.animationType, this.layout.layoutBox, m.layoutBox)) {
          g = this.target || ct();
          const y = Ot(this.layout.layoutBox.x);
          g.x.min = h.target.x.min, g.x.max = g.x.min + y;
          const w = Ot(this.layout.layoutBox.y);
          g.y.min = h.target.y.min, g.y.max = g.y.min + w;
        }
        kn(p, g), Wo(p, b), $r(this.projectionDeltaWithTransform, this.layoutCorrected, p, b);
      }
    }
    registerSharedNode(h, p) {
      this.sharedNodes.has(h) || this.sharedNodes.set(h, new nA()), this.sharedNodes.get(h).add(p);
      const m = p.options.initialPromotionConfig;
      p.promote({
        transition: m ? m.transition : void 0,
        preserveFollowOpacity: m && m.shouldPreserveFollowOpacity ? m.shouldPreserveFollowOpacity(p) : void 0
      });
    }
    isLead() {
      const h = this.getStack();
      return h ? h.lead === this : !0;
    }
    getLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: h } = this.options;
      if (h)
        return this.root.sharedNodes.get(h);
    }
    promote({ needsReset: h, transition: p, preserveFollowOpacity: g } = {}) {
      const m = this.getStack();
      m && m.promote(this, g), h && (this.projectionDelta = void 0, this.needsReset = !0), p && this.setOptions({ transition: p });
    }
    relegate() {
      const h = this.getStack();
      return h ? h.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: h } = this.options;
      if (!h)
        return;
      let p = !1;
      const { latestValues: g } = h;
      if ((g.z || g.rotate || g.rotateX || g.rotateY || g.rotateZ || g.skewX || g.skewY) && (p = !0), !p)
        return;
      const m = {};
      g.z && sh("z", h, m, this.animationValues);
      for (let b = 0; b < ih.length; b++)
        sh(`rotate${ih[b]}`, h, m, this.animationValues), sh(`skew${ih[b]}`, h, m, this.animationValues);
      h.render();
      for (const b in m)
        h.setStaticValue(b, m[b]), this.animationValues && (this.animationValues[b] = m[b]);
      h.scheduleRender();
    }
    applyProjectionStyles(h, p) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        h.visibility = "hidden";
        return;
      }
      const g = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, h.visibility = "", h.opacity = "", h.pointerEvents = Jo(p?.pointerEvents) || "", h.transform = g ? g(this.latestValues, "") : "none";
        return;
      }
      const m = this.getLead();
      if (!this.projectionDelta || !this.layout || !m.target) {
        this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Jo(p?.pointerEvents) || ""), this.hasProjected && !Ei(this.latestValues) && (h.transform = g ? g({}, "") : "none", this.hasProjected = !1);
        return;
      }
      h.visibility = "";
      const b = m.animationValues || m.latestValues;
      this.applyTransformsToTarget();
      let y = Q4(this.projectionDeltaWithTransform, this.treeScale, b);
      g && (y = g(b, y)), h.transform = y;
      const { x: w, y: S } = this.projectionDelta;
      h.transformOrigin = `${w.origin * 100}% ${S.origin * 100}% 0`, m.animationValues ? h.opacity = m === this ? b.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : b.opacityExit : h.opacity = m === this ? b.opacity !== void 0 ? b.opacity : "" : b.opacityExit !== void 0 ? b.opacityExit : 0;
      for (const T in tf) {
        if (b[T] === void 0)
          continue;
        const { correct: _, applyTo: R, isCSSVariable: z } = tf[T], Q = y === "none" ? b[T] : _(b[T], m);
        if (R) {
          const L = R.length;
          for (let Y = 0; Y < L; Y++)
            h[R[Y]] = Q;
        } else
          z ? this.options.visualElement.renderState.vars[T] = Q : h[T] = Q;
      }
      this.options.layoutId && (h.pointerEvents = m === this ? Jo(p?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((h) => h.currentAnimation?.stop()), this.root.nodes.forEach(gb), this.root.sharedNodes.clear();
    }
  };
}
function sA(n) {
  n.updateLayout();
}
function rA(n) {
  const i = n.resumeFrom?.snapshot || n.snapshot;
  if (n.isLead() && n.layout && i && n.hasListeners("didUpdate")) {
    const { layoutBox: l, measuredBox: o } = n.layout, { animationType: d } = n.options, f = i.source !== n.layout.source;
    if (d === "size")
      qn((b) => {
        const y = f ? i.measuredBox[b] : i.layoutBox[b], w = Ot(y);
        y.min = l[b].min, y.max = y.min + w;
      });
    else if (d === "x" || d === "y") {
      const b = d === "x" ? "y" : "x";
      nf(f ? i.measuredBox[b] : i.layoutBox[b], l[b]);
    } else D1(d, i.layoutBox, l) && qn((b) => {
      const y = f ? i.measuredBox[b] : i.layoutBox[b], w = Ot(l[b]);
      y.max = y.min + w, n.relativeTarget && !n.currentAnimation && (n.isProjectionDirty = !0, n.relativeTarget[b].max = n.relativeTarget[b].min + w);
    });
    const h = Ms();
    $r(h, l, i.layoutBox);
    const p = Ms();
    f ? $r(p, n.applyTransform(o, !0), i.measuredBox) : $r(p, l, i.layoutBox);
    const g = !M1(h);
    let m = !1;
    if (!n.resumeFrom) {
      const b = n.getClosestProjectingParent();
      if (b && !b.resumeFrom) {
        const { snapshot: y, layout: w } = b;
        if (y && w) {
          const S = n.options.layoutAnchor || void 0, T = ct();
          pc(T, i.layoutBox, y.layoutBox, S);
          const _ = ct();
          pc(_, l, w.layoutBox, S), z1(T, _) || (m = !0), b.options.layoutRoot && (n.relativeTarget = _, n.relativeTargetOrigin = T, n.relativeParent = b);
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: l,
      snapshot: i,
      delta: p,
      layoutDelta: h,
      hasLayoutChanged: g,
      hasRelativeLayoutChanged: m
    });
  } else if (n.isLead()) {
    const { onExitComplete: l } = n.options;
    l && l();
  }
  n.options.transition = void 0;
}
function lA(n) {
  n.parent && (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty), n.isSharedProjectionDirty || (n.isSharedProjectionDirty = !!(n.isProjectionDirty || n.parent.isProjectionDirty || n.parent.isSharedProjectionDirty)), n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty));
}
function oA(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1;
}
function cA(n) {
  n.clearSnapshot();
}
function gb(n) {
  n.clearMeasurements();
}
function uA(n) {
  n.isLayoutDirty = !0, n.updateLayout();
}
function xb(n) {
  n.isLayoutDirty = !1;
}
function dA(n) {
  n.isAnimationBlocked && n.layout && !n.isLayoutDirty && (n.snapshot = n.layout, n.isLayoutDirty = !0);
}
function hA(n) {
  const { visualElement: i } = n.options;
  i && i.getProps().onBeforeLayoutMeasure && i.notify("BeforeLayoutMeasure"), n.resetTransform();
}
function yb(n) {
  n.finishAnimation(), n.targetDelta = n.relativeTarget = n.target = void 0, n.isProjectionDirty = !0;
}
function fA(n) {
  n.resolveTargetDelta();
}
function mA(n) {
  n.calcProjection();
}
function pA(n) {
  n.resetSkewAndRotation();
}
function gA(n) {
  n.removeLeadSnapshot();
}
function bb(n, i, l) {
  n.translate = Ie(i.translate, 0, l), n.scale = Ie(i.scale, 1, l), n.origin = i.origin, n.originPoint = i.originPoint;
}
function vb(n, i, l, o) {
  n.min = Ie(i.min, l.min, o), n.max = Ie(i.max, l.max, o);
}
function xA(n, i, l, o) {
  vb(n.x, i.x, l.x, o), vb(n.y, i.y, l.y, o);
}
function yA(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0;
}
const bA = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, wb = (n) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(n), jb = wb("applewebkit/") && !wb("chrome/") ? Math.round : Sn;
function Sb(n) {
  n.min = jb(n.min), n.max = jb(n.max);
}
function vA(n) {
  Sb(n.x), Sb(n.y);
}
function D1(n, i, l) {
  return n === "position" || n === "preserve-aspect" && !L4(db(i), db(l), 0.2);
}
function wA(n) {
  return n !== n.root && n.scroll?.wasRoot;
}
const jA = _1({
  attachResizeListener: (n, i) => rl(n, "resize", i),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), rh = {
  current: void 0
}, F1 = _1({
  measureScroll: (n) => ({
    x: n.scrollLeft,
    y: n.scrollTop
  }),
  defaultParent: () => {
    if (!rh.current) {
      const n = new jA({});
      n.mount(window), n.setOptions({ layoutScroll: !0 }), rh.current = n;
    }
    return rh.current;
  },
  resetTransform: (n, i) => {
    n.style.transform = i !== void 0 ? i : "none";
  },
  checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed"
}), $f = C.createContext({
  transformPagePoint: (n) => n,
  isStatic: !1,
  reducedMotion: "never"
});
function Nb(n, i) {
  if (typeof n == "function")
    return n(i);
  n != null && (n.current = i);
}
function SA(...n) {
  return (i) => {
    let l = !1;
    const o = n.map((d) => {
      const f = Nb(d, i);
      return !l && typeof f == "function" && (l = !0), f;
    });
    if (l)
      return () => {
        for (let d = 0; d < o.length; d++) {
          const f = o[d];
          typeof f == "function" ? f() : Nb(n[d], null);
        }
      };
  };
}
function NA(...n) {
  return C.useCallback(SA(...n), n);
}
class TA extends C.Component {
  getSnapshotBeforeUpdate(i) {
    const l = this.props.childRef.current;
    if (Qo(l) && i.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const o = l.offsetParent, d = Qo(o) && o.offsetWidth || 0, f = Qo(o) && o.offsetHeight || 0, h = getComputedStyle(l), p = this.props.sizeRef.current;
      p.height = parseFloat(h.height), p.width = parseFloat(h.width), p.top = l.offsetTop, p.left = l.offsetLeft, p.right = d - p.width - p.left, p.bottom = f - p.height - p.top, p.direction = h.direction;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function AA({ children: n, isPresent: i, anchorX: l, anchorY: o, root: d, pop: f }) {
  const h = C.useId(), p = C.useRef(null), g = C.useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    direction: "ltr"
  }), { nonce: m } = C.useContext($f), b = f !== !1 ? n.props?.ref ?? n?.ref : void 0, y = NA(p, b);
  return C.useInsertionEffect(() => {
    const { width: w, height: S, top: T, left: _, right: R, bottom: z, direction: Q } = g.current;
    if (i || f === !1 || !p.current || !w || !S)
      return;
    const L = Q === "rtl", Y = l === "left" ? L ? `right: ${R}` : `left: ${_}` : L ? `left: ${_}` : `right: ${R}`, ae = o === "bottom" ? `bottom: ${z}` : `top: ${T}`;
    p.current.dataset.motionPopId = h;
    const ee = document.createElement("style");
    m && (ee.nonce = m);
    const Z = d ?? document.head;
    return Z.appendChild(ee), ee.sheet && ee.sheet.insertRule(`
          [data-motion-pop-id="${h}"] {
            position: absolute !important;
            width: ${w}px !important;
            height: ${S}px !important;
            ${Y}px !important;
            ${ae}px !important;
          }
        `), () => {
      p.current?.removeAttribute("data-motion-pop-id"), Z.contains(ee) && Z.removeChild(ee);
    };
  }, [i]), s.jsx(TA, { isPresent: i, childRef: p, sizeRef: g, pop: f, children: f === !1 ? n : C.cloneElement(n, { ref: y }) });
}
const CA = ({ children: n, initial: i, isPresent: l, onExitComplete: o, custom: d, presenceAffectsLayout: f, mode: h, anchorX: p, anchorY: g, root: m }) => {
  const b = Af(EA), y = C.useId(), w = C.useRef(l), S = C.useRef(o);
  Cf(() => {
    w.current = l, S.current = o;
  });
  let T = !0, _ = C.useMemo(() => (T = !1, {
    id: y,
    initial: i,
    isPresent: l,
    custom: d,
    onExitComplete: (R) => {
      b.set(R, !0);
      for (const z of b.values())
        if (!z)
          return;
      o && o();
    },
    register: (R) => (b.set(R, !1), () => {
      b.delete(R), !w.current && !b.size && S.current?.();
    })
  }), [l, b, o]);
  return f && T && (_ = { ..._ }), C.useMemo(() => {
    b.forEach((R, z) => b.set(z, !1));
  }, [l]), C.useEffect(() => {
    !l && !b.size && o && o();
  }, [l]), n = s.jsx(AA, { pop: h === "popLayout", isPresent: l, anchorX: p, anchorY: g, root: m, children: n }), s.jsx(wc.Provider, { value: _, children: n });
};
function EA() {
  return /* @__PURE__ */ new Map();
}
function B1(n = !0) {
  const i = C.useContext(wc);
  if (i === null)
    return [!0, null];
  const { isPresent: l, onExitComplete: o, register: d } = i, f = C.useId();
  C.useEffect(() => {
    if (n)
      return d(f);
  }, [n]);
  const h = C.useCallback(() => n && o && o(f), [f, o, n]);
  return !l && o ? [!1, h] : [!0];
}
const Vo = (n) => n.key || "";
function Tb(n) {
  const i = [];
  return C.Children.forEach(n, (l) => {
    C.isValidElement(l) && i.push(l);
  }), i;
}
const Wr = ({ children: n, custom: i, initial: l = !0, onExitComplete: o, presenceAffectsLayout: d = !0, mode: f = "sync", propagate: h = !1, anchorX: p = "left", anchorY: g = "top", root: m }) => {
  const [b, y] = B1(h), w = C.useMemo(() => Tb(n), [n]), S = h && !b ? [] : w.map(Vo), T = C.useRef(!0), _ = C.useRef(w), R = Af(() => /* @__PURE__ */ new Map()), z = C.useRef(/* @__PURE__ */ new Set()), [Q, L] = C.useState(w), [Y, ae] = C.useState(w);
  Cf(() => {
    T.current = !1, _.current = w;
    for (let k = 0; k < Y.length; k++) {
      const ne = Vo(Y[k]);
      S.includes(ne) ? (R.delete(ne), z.current.delete(ne)) : R.get(ne) !== !0 && R.set(ne, !1);
    }
  }, [Y, S.length, S.join("-")]);
  const ee = [];
  if (w !== Q) {
    let k = [...w];
    for (let ne = 0; ne < Y.length; ne++) {
      const V = Y[ne], ie = Vo(V);
      S.includes(ie) || (k.splice(ne, 0, V), ee.push(V));
    }
    return f === "wait" && ee.length && (k = ee), ae(Tb(k)), L(w), null;
  }
  const { forceRender: Z } = C.useContext(Tf);
  return s.jsx(s.Fragment, { children: Y.map((k) => {
    const ne = Vo(k), V = h && !b ? !1 : w === Y || S.includes(ne), ie = () => {
      if (z.current.has(ne))
        return;
      if (R.has(ne))
        z.current.add(ne), R.set(ne, !0);
      else
        return;
      let he = !0;
      R.forEach((je) => {
        je || (he = !1);
      }), he && (Z?.(), ae(_.current), h && y?.(), o && o());
    };
    return s.jsx(CA, { isPresent: V, initial: !T.current || l ? void 0 : !1, custom: i, presenceAffectsLayout: d, mode: f, root: m, onExitComplete: V ? void 0 : ie, anchorX: p, anchorY: g, children: k }, ne);
  }) });
}, V1 = C.createContext({ strict: !1 }), Ab = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Cb = !1;
function kA() {
  if (Cb)
    return;
  const n = {};
  for (const i in Ab)
    n[i] = {
      isEnabled: (l) => Ab[i].some((o) => !!l[o])
    };
  m1(n), Cb = !0;
}
function H1() {
  return kA(), f4();
}
function MA(n) {
  const i = H1();
  for (const l in n)
    i[l] = {
      ...i[l],
      ...n[l]
    };
  m1(i);
}
const zA = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function gc(n) {
  return n.startsWith("while") || n.startsWith("drag") && n !== "draggable" || n.startsWith("layout") || n.startsWith("onTap") || n.startsWith("onPan") || n.startsWith("onLayout") || zA.has(n);
}
let U1 = (n) => !gc(n);
function OA(n) {
  typeof n == "function" && (U1 = (i) => i.startsWith("on") ? !gc(i) : n(i));
}
try {
  OA(require("@emotion/is-prop-valid").default);
} catch {
}
function RA(n, i, l) {
  const o = {};
  for (const d in n)
    d === "values" && typeof n.values == "object" || vt(n[d]) || (U1(d) || l === !0 && gc(d) || !i && !gc(d) || // If trying to use native HTML drag events, forward drag listeners
    n.draggable && d.startsWith("onDrag")) && (o[d] = n[d]);
  return o;
}
const Ac = /* @__PURE__ */ C.createContext({});
function _A(n, i) {
  if (Tc(n)) {
    const { initial: l, animate: o } = n;
    return {
      initial: l === !1 || sl(l) ? l : void 0,
      animate: sl(o) ? o : void 0
    };
  }
  return n.inherit !== !1 ? i : {};
}
function DA(n) {
  const { initial: i, animate: l } = _A(n, C.useContext(Ac));
  return C.useMemo(() => ({ initial: i, animate: l }), [Eb(i), Eb(l)]);
}
function Eb(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}
const Wf = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function L1(n, i, l) {
  for (const o in i)
    !vt(i[o]) && !w1(o, l) && (n[o] = i[o]);
}
function FA({ transformTemplate: n }, i) {
  return C.useMemo(() => {
    const l = Wf();
    return Xf(l, i, n), Object.assign({}, l.vars, l.style);
  }, [i]);
}
function BA(n, i) {
  const l = n.style || {}, o = {};
  return L1(o, l, n), Object.assign(o, FA(n, i)), o;
}
function VA(n, i) {
  const l = {}, o = BA(n, i);
  return n.drag && n.dragListener !== !1 && (l.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`), n.tabIndex === void 0 && (n.onTap || n.onTapStart || n.whileTap) && (l.tabIndex = 0), l.style = o, l;
}
const P1 = () => ({
  ...Wf(),
  attrs: {}
});
function HA(n, i, l, o) {
  const d = C.useMemo(() => {
    const f = P1();
    return j1(f, i, N1(o), n.transformTemplate, n.style), {
      ...f.attrs,
      style: { ...f.style }
    };
  }, [i]);
  if (n.style) {
    const f = {};
    L1(f, n.style, n), d.style = { ...f, ...d.style };
  }
  return d;
}
const UA = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Jf(n) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof n != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    n.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(UA.indexOf(n) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(n))
    )
  );
}
function LA(n, i, l, { latestValues: o }, d, f = !1, h) {
  const g = (h ?? Jf(n) ? HA : VA)(i, o, d, n), m = RA(i, typeof n == "string", f), b = n !== C.Fragment ? { ...m, ...g, ref: l } : {}, { children: y } = i, w = C.useMemo(() => vt(y) ? y.get() : y, [y]);
  return C.createElement(n, {
    ...b,
    children: w
  });
}
function PA({ scrapeMotionValuesFromProps: n, createRenderState: i }, l, o, d) {
  return {
    latestValues: qA(l, o, d, n),
    renderState: i()
  };
}
function qA(n, i, l, o) {
  const d = {}, f = o(n, {});
  for (const w in f)
    d[w] = Jo(f[w]);
  let { initial: h, animate: p } = n;
  const g = Tc(n), m = h1(n);
  i && m && !g && n.inherit !== !1 && (h === void 0 && (h = i.initial), p === void 0 && (p = i.animate));
  let b = l ? l.initial === !1 : !1;
  b = b || h === !1;
  const y = b ? p : h;
  if (y && typeof y != "boolean" && !Nc(y)) {
    const w = Array.isArray(y) ? y : [y];
    for (let S = 0; S < w.length; S++) {
      const T = Lf(n, w[S]);
      if (T) {
        const { transitionEnd: _, transition: R, ...z } = T;
        for (const Q in z) {
          let L = z[Q];
          if (Array.isArray(L)) {
            const Y = b ? L.length - 1 : 0;
            L = L[Y];
          }
          L !== null && (d[Q] = L);
        }
        for (const Q in _)
          d[Q] = _[Q];
      }
    }
  }
  return d;
}
const q1 = (n) => (i, l) => {
  const o = C.useContext(Ac), d = C.useContext(wc), f = () => PA(n, i, o, d);
  return l ? f() : Af(f);
}, IA = /* @__PURE__ */ q1({
  scrapeMotionValuesFromProps: Kf,
  createRenderState: Wf
}), GA = /* @__PURE__ */ q1({
  scrapeMotionValuesFromProps: T1,
  createRenderState: P1
}), YA = /* @__PURE__ */ Symbol.for("motionComponentSymbol");
function QA(n, i, l) {
  const o = C.useRef(l);
  C.useInsertionEffect(() => {
    o.current = l;
  });
  const d = C.useRef(null);
  return C.useCallback((f) => {
    f && n.onMount?.(f), i && (f ? i.mount(f) : i.unmount());
    const h = o.current;
    if (typeof h == "function")
      if (f) {
        const p = h(f);
        typeof p == "function" && (d.current = p);
      } else d.current ? (d.current(), d.current = null) : h(f);
    else h && (h.current = f);
  }, [i]);
}
const I1 = C.createContext({});
function Cs(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function ZA(n, i, l, o, d, f) {
  const { visualElement: h } = C.useContext(Ac), p = C.useContext(V1), g = C.useContext(wc), m = C.useContext($f), b = m.reducedMotion, y = m.skipAnimations, w = C.useRef(null), S = C.useRef(!1);
  o = o || p.renderer, !w.current && o && (w.current = o(n, {
    visualState: i,
    parent: h,
    props: l,
    presenceContext: g,
    blockInitialAnimation: g ? g.initial === !1 : !1,
    reducedMotionConfig: b,
    skipAnimations: y,
    isSVG: f
  }), S.current && w.current && (w.current.manuallyAnimateOnMount = !0));
  const T = w.current, _ = C.useContext(I1);
  T && !T.projection && d && (T.type === "html" || T.type === "svg") && XA(w.current, l, d, _);
  const R = C.useRef(!1);
  C.useInsertionEffect(() => {
    T && R.current && T.update(l, g);
  });
  const z = l[e1], Q = C.useRef(!!z && typeof window < "u" && !window.MotionHandoffIsComplete?.(z) && window.MotionHasOptimisedAnimation?.(z));
  return Cf(() => {
    S.current = !0, T && (R.current = !0, window.MotionIsMounted = !0, T.updateFeatures(), T.scheduleRenderMicrotask(), Q.current && T.animationState && T.animationState.animateChanges());
  }), C.useEffect(() => {
    T && (!Q.current && T.animationState && T.animationState.animateChanges(), Q.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(z);
    }), Q.current = !1), T.enteringChildren = void 0);
  }), T;
}
function XA(n, i, l, o) {
  const { layoutId: d, layout: f, drag: h, dragConstraints: p, layoutScroll: g, layoutRoot: m, layoutAnchor: b, layoutCrossfade: y } = i;
  n.projection = new l(n.latestValues, i["data-framer-portal-id"] ? void 0 : G1(n.parent)), n.projection.setOptions({
    layoutId: d,
    layout: f,
    alwaysMeasureLayout: !!h || p && Cs(p),
    visualElement: n,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof f == "string" ? f : "both",
    initialPromotionConfig: o,
    crossfade: y,
    layoutScroll: g,
    layoutRoot: m,
    layoutAnchor: b
  });
}
function G1(n) {
  if (n)
    return n.options.allowProjection !== !1 ? n.projection : G1(n.parent);
}
function lh(n, { forwardMotionProps: i = !1, type: l } = {}, o, d) {
  o && MA(o);
  const f = l ? l === "svg" : Jf(n), h = f ? GA : IA;
  function p(m, b) {
    let y;
    const w = {
      ...C.useContext($f),
      ...m,
      layoutId: KA(m)
    }, { isStatic: S } = w, T = DA(m), _ = h(m, S);
    if (!S && typeof window < "u") {
      $A();
      const R = WA(w);
      y = R.MeasureLayout, T.visualElement = ZA(n, _, w, d, R.ProjectionNode, f);
    }
    return s.jsxs(Ac.Provider, { value: T, children: [y && T.visualElement ? s.jsx(y, { visualElement: T.visualElement, ...w }) : null, LA(n, m, QA(_, T.visualElement, b), _, S, i, f)] });
  }
  p.displayName = `motion.${typeof n == "string" ? n : `create(${n.displayName ?? n.name ?? ""})`}`;
  const g = C.forwardRef(p);
  return g[YA] = n, g;
}
function KA({ layoutId: n }) {
  const i = C.useContext(Tf).id;
  return i && n !== void 0 ? i + "-" + n : n;
}
function $A(n, i) {
  C.useContext(V1).strict;
}
function WA(n) {
  const i = H1(), { drag: l, layout: o } = i;
  if (!l && !o)
    return {};
  const d = { ...l, ...o };
  return {
    MeasureLayout: l?.isEnabled(n) || o?.isEnabled(n) ? d.MeasureLayout : void 0,
    ProjectionNode: d.ProjectionNode
  };
}
function JA(n, i) {
  if (typeof Proxy > "u")
    return lh;
  const l = /* @__PURE__ */ new Map(), o = (f, h) => lh(f, h, n, i), d = (f, h) => o(f, h);
  return new Proxy(d, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (f, h) => h === "create" ? o : (l.has(h) || l.set(h, lh(h, void 0, n, i)), l.get(h))
  });
}
const e6 = (n, i) => i.isSVG ?? Jf(n) ? new M4(i) : new N4(i, {
  allowProjection: n !== C.Fragment
});
class t6 extends $a {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(i) {
    super(i), i.animationState || (i.animationState = D4(i));
  }
  updateAnimationControlsSubscription() {
    const { animate: i } = this.node.getProps();
    Nc(i) && (this.unmountControls = i.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: i } = this.node.getProps(), { animate: l } = this.node.prevProps || {};
    i !== l && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let n6 = 0;
class a6 extends $a {
  constructor() {
    super(...arguments), this.id = n6++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: i, onExitComplete: l } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || i === o)
      return;
    if (i && o === !1) {
      if (this.isExitComplete) {
        const { initial: f, custom: h } = this.node.getProps();
        if (typeof f == "string" || typeof f == "object" && f !== null && !Array.isArray(f)) {
          const p = Ri(this.node, f, h);
          if (p) {
            const { transition: g, transitionEnd: m, ...b } = p;
            for (const y in b)
              this.node.getValue(y)?.jump(b[y]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const d = this.node.animationState.setActive("exit", !i);
    l && !i && d.then(() => {
      this.isExitComplete = !0, l(this.id);
    });
  }
  mount() {
    const { register: i, onExitComplete: l } = this.node.presenceContext || {};
    l && l(this.id), i && (this.unmount = i(this.id));
  }
  unmount() {
  }
}
const i6 = {
  animation: {
    Feature: t6
  },
  exit: {
    Feature: a6
  }
};
function ml(n) {
  return {
    point: {
      x: n.pageX,
      y: n.pageY
    }
  };
}
const s6 = (n) => (i) => Gf(i) && n(i, ml(i));
function Jr(n, i, l, o) {
  return rl(n, i, s6(l), o);
}
const Y1 = ({ current: n }) => n ? n.ownerDocument.defaultView : null, kb = (n, i) => Math.abs(n - i);
function r6(n, i) {
  const l = kb(n.x, i.x), o = kb(n.y, i.y);
  return Math.sqrt(l ** 2 + o ** 2);
}
const Mb = /* @__PURE__ */ new Set(["auto", "scroll"]);
class Q1 {
  constructor(i, l, { transformPagePoint: o, contextWindow: d = window, dragSnapToOrigin: f = !1, distanceThreshold: h = 3, element: p } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (T) => {
      this.handleScroll(T.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Ho(this.lastRawMoveEventInfo, this.transformPagePoint));
      const T = oh(this.lastMoveEventInfo, this.history), _ = this.startEvent !== null, R = r6(T.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!_ && !R)
        return;
      const { point: z } = T, { timestamp: Q } = bt;
      this.history.push({ ...z, timestamp: Q });
      const { onStart: L, onMove: Y } = this.handlers;
      _ || (L && L(this.lastMoveEvent, T), this.startEvent = this.lastMoveEvent), Y && Y(this.lastMoveEvent, T);
    }, this.handlePointerMove = (T, _) => {
      this.lastMoveEvent = T, this.lastRawMoveEventInfo = _, this.lastMoveEventInfo = Ho(_, this.transformPagePoint), Ge.update(this.updatePoint, !0);
    }, this.handlePointerUp = (T, _) => {
      this.end();
      const { onEnd: R, onSessionEnd: z, resumeAnimation: Q } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && Q && Q(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const L = oh(T.type === "pointercancel" ? this.lastMoveEventInfo : Ho(_, this.transformPagePoint), this.history);
      this.startEvent && R && R(T, L), z && z(T, L);
    }, !Gf(i))
      return;
    this.dragSnapToOrigin = f, this.handlers = l, this.transformPagePoint = o, this.distanceThreshold = h, this.contextWindow = d || window;
    const g = ml(i), m = Ho(g, this.transformPagePoint), { point: b } = m, { timestamp: y } = bt;
    this.history = [{ ...b, timestamp: y }];
    const { onSessionStart: w } = l;
    w && w(i, oh(m, this.history));
    const S = { passive: !0, capture: !0 };
    this.removeListeners = dl(Jr(this.contextWindow, "pointermove", this.handlePointerMove, S), Jr(this.contextWindow, "pointerup", this.handlePointerUp, S), Jr(this.contextWindow, "pointercancel", this.handlePointerUp, S)), p && this.startScrollTracking(p);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(i) {
    let l = i.parentElement;
    for (; l; ) {
      const o = getComputedStyle(l);
      (Mb.has(o.overflowX) || Mb.has(o.overflowY)) && this.scrollPositions.set(l, {
        x: l.scrollLeft,
        y: l.scrollTop
      }), l = l.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(i) {
    const l = this.scrollPositions.get(i);
    if (!l)
      return;
    const o = i === window, d = o ? { x: window.scrollX, y: window.scrollY } : {
      x: i.scrollLeft,
      y: i.scrollTop
    }, f = { x: d.x - l.x, y: d.y - l.y };
    f.x === 0 && f.y === 0 || (o ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += f.x, this.lastMoveEventInfo.point.y += f.y) : this.history.length > 0 && (this.history[0].x -= f.x, this.history[0].y -= f.y), this.scrollPositions.set(i, d), Ge.update(this.updatePoint, !0));
  }
  updateHandlers(i) {
    this.handlers = i;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Xa(this.updatePoint);
  }
}
function Ho(n, i) {
  return i ? { point: i(n.point) } : n;
}
function zb(n, i) {
  return { x: n.x - i.x, y: n.y - i.y };
}
function oh({ point: n }, i) {
  return {
    point: n,
    delta: zb(n, Z1(i)),
    offset: zb(n, l6(i)),
    velocity: o6(i, 0.1)
  };
}
function l6(n) {
  return n[0];
}
function Z1(n) {
  return n[n.length - 1];
}
function o6(n, i) {
  if (n.length < 2)
    return { x: 0, y: 0 };
  let l = n.length - 1, o = null;
  const d = Z1(n);
  for (; l >= 0 && (o = n[l], !(d.timestamp - o.timestamp > /* @__PURE__ */ an(i))); )
    l--;
  if (!o)
    return { x: 0, y: 0 };
  o === n[0] && n.length > 2 && d.timestamp - o.timestamp > /* @__PURE__ */ an(i) * 2 && (o = n[1]);
  const f = /* @__PURE__ */ jn(d.timestamp - o.timestamp);
  if (f === 0)
    return { x: 0, y: 0 };
  const h = {
    x: (d.x - o.x) / f,
    y: (d.y - o.y) / f
  };
  return h.x === 1 / 0 && (h.x = 0), h.y === 1 / 0 && (h.y = 0), h;
}
function c6(n, { min: i, max: l }, o) {
  return i !== void 0 && n < i ? n = o ? Ie(i, n, o.min) : Math.max(n, i) : l !== void 0 && n > l && (n = o ? Ie(l, n, o.max) : Math.min(n, l)), n;
}
function Ob(n, i, l) {
  return {
    min: i !== void 0 ? n.min + i : void 0,
    max: l !== void 0 ? n.max + l - (n.max - n.min) : void 0
  };
}
function u6(n, { top: i, left: l, bottom: o, right: d }) {
  return {
    x: Ob(n.x, l, d),
    y: Ob(n.y, i, o)
  };
}
function Rb(n, i) {
  let l = i.min - n.min, o = i.max - n.max;
  return i.max - i.min < n.max - n.min && ([l, o] = [o, l]), { min: l, max: o };
}
function d6(n, i) {
  return {
    x: Rb(n.x, i.x),
    y: Rb(n.y, i.y)
  };
}
function h6(n, i) {
  let l = 0.5;
  const o = Ot(n), d = Ot(i);
  return d > o ? l = /* @__PURE__ */ al(i.min, i.max - o, n.min) : o > d && (l = /* @__PURE__ */ al(n.min, n.max - d, i.min)), Yn(0, 1, l);
}
function f6(n, i) {
  const l = {};
  return i.min !== void 0 && (l.min = i.min - n.min), i.max !== void 0 && (l.max = i.max - n.min), l;
}
const af = 0.35;
function m6(n = af) {
  return n === !1 ? n = 0 : n === !0 && (n = af), {
    x: _b(n, "left", "right"),
    y: _b(n, "top", "bottom")
  };
}
function _b(n, i, l) {
  return {
    min: Db(n, i),
    max: Db(n, l)
  };
}
function Db(n, i) {
  return typeof n == "number" ? n : n[i] || 0;
}
const p6 = /* @__PURE__ */ new WeakMap();
class g6 {
  constructor(i) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ct(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = i;
  }
  start(i, { snapToCursor: l = !1, distanceThreshold: o } = {}) {
    const { presenceContext: d } = this.visualElement;
    if (d && d.isPresent === !1)
      return;
    const f = (y) => {
      l && this.snapToCursor(ml(y).point), this.stopAnimation();
    }, h = (y, w) => {
      const { drag: S, dragPropagation: T, onDragStart: _ } = this.getProps();
      if (S && !T && (this.openDragLock && this.openDragLock(), this.openDragLock = q3(S), !this.openDragLock))
        return;
      this.latestPointerEvent = y, this.latestPanInfo = w, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), qn((z) => {
        let Q = this.getAxisMotionValue(z).get() || 0;
        if (Gn.test(Q)) {
          const { projection: L } = this.visualElement;
          if (L && L.layout) {
            const Y = L.layout.layoutBox[z];
            Y && (Q = Ot(Y) * (parseFloat(Q) / 100));
          }
        }
        this.originPoint[z] = Q;
      }), _ && Ge.update(() => _(y, w), !1, !0), Qh(this.visualElement, "transform");
      const { animationState: R } = this.visualElement;
      R && R.setActive("whileDrag", !0);
    }, p = (y, w) => {
      this.latestPointerEvent = y, this.latestPanInfo = w;
      const { dragPropagation: S, dragDirectionLock: T, onDirectionLock: _, onDrag: R } = this.getProps();
      if (!S && !this.openDragLock)
        return;
      const { offset: z } = w;
      if (T && this.currentDirection === null) {
        this.currentDirection = y6(z), this.currentDirection !== null && _ && _(this.currentDirection);
        return;
      }
      this.updateAxis("x", w.point, z), this.updateAxis("y", w.point, z), this.visualElement.render(), R && Ge.update(() => R(y, w), !1, !0);
    }, g = (y, w) => {
      this.latestPointerEvent = y, this.latestPanInfo = w, this.stop(y, w), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, m = () => {
      const { dragSnapToOrigin: y } = this.getProps();
      (y || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: b } = this.getProps();
    this.panSession = new Q1(i, {
      onSessionStart: f,
      onStart: h,
      onMove: p,
      onSessionEnd: g,
      resumeAnimation: m
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: b,
      distanceThreshold: o,
      contextWindow: Y1(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(i, l) {
    const o = i || this.latestPointerEvent, d = l || this.latestPanInfo, f = this.isDragging;
    if (this.cancel(), !f || !d || !o)
      return;
    const { velocity: h } = d;
    this.startAnimation(h);
    const { onDragEnd: p } = this.getProps();
    p && Ge.postRender(() => p(o, d));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: i, animationState: l } = this.visualElement;
    i && (i.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: o } = this.getProps();
    !o && this.openDragLock && (this.openDragLock(), this.openDragLock = null), l && l.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(i, l, o) {
    const { drag: d } = this.getProps();
    if (!o || !Uo(i, d, this.currentDirection))
      return;
    const f = this.getAxisMotionValue(i);
    let h = this.originPoint[i] + o[i];
    this.constraints && this.constraints[i] && (h = c6(h, this.constraints[i], this.elastic[i])), f.set(h);
  }
  resolveConstraints() {
    const { dragConstraints: i, dragElastic: l } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, d = this.constraints;
    i && Cs(i) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : i && o ? this.constraints = u6(o.layoutBox, i) : this.constraints = !1, this.elastic = m6(l), d !== this.constraints && !Cs(i) && o && this.constraints && !this.hasMutatedConstraints && qn((f) => {
      this.constraints !== !1 && this.getAxisMotionValue(f) && (this.constraints[f] = f6(o.layoutBox[f], this.constraints[f]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: i, onMeasureDragConstraints: l } = this.getProps();
    if (!i || !Cs(i))
      return !1;
    const o = i.current, { projection: d } = this.visualElement;
    if (!d || !d.layout)
      return !1;
    d.root && (d.root.scroll = void 0, d.root.updateScroll());
    const f = y4(o, d.root, this.visualElement.getTransformPagePoint());
    let h = d6(d.layout.layoutBox, f);
    if (l) {
      const p = l(p4(h));
      this.hasMutatedConstraints = !!p, p && (h = g1(p));
    }
    return h;
  }
  startAnimation(i) {
    const { drag: l, dragMomentum: o, dragElastic: d, dragTransition: f, dragSnapToOrigin: h, onDragTransitionEnd: p } = this.getProps(), g = this.constraints || {}, m = qn((b) => {
      if (!Uo(b, l, this.currentDirection))
        return;
      let y = g && g[b] || {};
      (h === !0 || h === b) && (y = { min: 0, max: 0 });
      const w = d ? 200 : 1e6, S = d ? 40 : 1e7, T = {
        type: "inertia",
        velocity: o ? i[b] : 0,
        bounceStiffness: w,
        bounceDamping: S,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...f,
        ...y
      };
      return this.startAxisValueAnimation(b, T);
    });
    return Promise.all(m).then(p);
  }
  startAxisValueAnimation(i, l) {
    const o = this.getAxisMotionValue(i);
    return Qh(this.visualElement, i), o.start(Uf(i, o, 0, l, this.visualElement, !1));
  }
  stopAnimation() {
    qn((i) => this.getAxisMotionValue(i).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(i) {
    const l = `_drag${i.toUpperCase()}`, d = this.visualElement.getProps()[l];
    return d || this.visualElement.getValue(i, this.visualElement.latestValues[i] ?? 0);
  }
  snapToCursor(i) {
    qn((l) => {
      const { drag: o } = this.getProps();
      if (!Uo(l, o, this.currentDirection))
        return;
      const { projection: d } = this.visualElement, f = this.getAxisMotionValue(l);
      if (d && d.layout) {
        const { min: h, max: p } = d.layout.layoutBox[l], g = f.get() || 0;
        f.set(i[l] - Ie(h, p, 0.5) + g);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: i, dragConstraints: l } = this.getProps(), { projection: o } = this.visualElement;
    if (!Cs(l) || !o || !this.constraints)
      return;
    this.stopAnimation();
    const d = { x: 0, y: 0 };
    qn((h) => {
      const p = this.getAxisMotionValue(h);
      if (p && this.constraints !== !1) {
        const g = p.get();
        d[h] = h6({ min: g, max: g }, this.constraints[h]);
      }
    });
    const { transformTemplate: f } = this.visualElement.getProps();
    this.visualElement.current.style.transform = f ? f({}, "") : "none", o.root && o.root.updateScroll(), o.updateLayout(), this.constraints = !1, this.resolveConstraints(), qn((h) => {
      if (!Uo(h, i, null))
        return;
      const p = this.getAxisMotionValue(h), { min: g, max: m } = this.constraints[h];
      p.set(Ie(g, m, d[h]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    p6.set(this.visualElement, this);
    const i = this.visualElement.current, l = Jr(i, "pointerdown", (m) => {
      const { drag: b, dragListener: y = !0 } = this.getProps(), w = m.target, S = w !== i && X3(w);
      b && y && !S && this.start(m);
    });
    let o;
    const d = () => {
      const { dragConstraints: m } = this.getProps();
      Cs(m) && m.current && (this.constraints = this.resolveRefConstraints(), o || (o = x6(i, m.current, () => this.scalePositionWithinConstraints())));
    }, { projection: f } = this.visualElement, h = f.addEventListener("measure", d);
    f && !f.layout && (f.root && f.root.updateScroll(), f.updateLayout()), Ge.read(d);
    const p = rl(window, "resize", () => this.scalePositionWithinConstraints()), g = f.addEventListener("didUpdate", (({ delta: m, hasLayoutChanged: b }) => {
      this.isDragging && b && (qn((y) => {
        const w = this.getAxisMotionValue(y);
        w && (this.originPoint[y] += m[y].translate, w.set(w.get() + m[y].translate));
      }), this.visualElement.render());
    }));
    return () => {
      p(), l(), h(), g && g(), o && o();
    };
  }
  getProps() {
    const i = this.visualElement.getProps(), { drag: l = !1, dragDirectionLock: o = !1, dragPropagation: d = !1, dragConstraints: f = !1, dragElastic: h = af, dragMomentum: p = !0 } = i;
    return {
      ...i,
      drag: l,
      dragDirectionLock: o,
      dragPropagation: d,
      dragConstraints: f,
      dragElastic: h,
      dragMomentum: p
    };
  }
}
function Fb(n) {
  let i = !0;
  return () => {
    if (i) {
      i = !1;
      return;
    }
    n();
  };
}
function x6(n, i, l) {
  const o = qy(n, Fb(l)), d = qy(i, Fb(l));
  return () => {
    o(), d();
  };
}
function Uo(n, i, l) {
  return (i === !0 || i === n) && (l === null || l === n);
}
function y6(n, i = 10) {
  let l = null;
  return Math.abs(n.y) > i ? l = "y" : Math.abs(n.x) > i && (l = "x"), l;
}
class b6 extends $a {
  constructor(i) {
    super(i), this.removeGroupControls = Sn, this.removeListeners = Sn, this.controls = new g6(i);
  }
  mount() {
    const { dragControls: i } = this.node.getProps();
    i && (this.removeGroupControls = i.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Sn;
  }
  update() {
    const { dragControls: i } = this.node.getProps(), { dragControls: l } = this.node.prevProps || {};
    i !== l && (this.removeGroupControls(), i && (this.removeGroupControls = i.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const ch = (n) => (i, l) => {
  n && Ge.update(() => n(i, l), !1, !0);
};
class v6 extends $a {
  constructor() {
    super(...arguments), this.removePointerDownListener = Sn;
  }
  onPointerDown(i) {
    this.session = new Q1(i, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Y1(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: i, onPanStart: l, onPan: o, onPanEnd: d } = this.node.getProps();
    return {
      onSessionStart: ch(i),
      onStart: ch(l),
      onMove: ch(o),
      onEnd: (f, h) => {
        delete this.session, d && Ge.postRender(() => d(f, h));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Jr(this.node.current, "pointerdown", (i) => this.onPointerDown(i));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let uh = !1;
class w6 extends C.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: i, layoutGroup: l, switchLayoutGroup: o, layoutId: d } = this.props, { projection: f } = i;
    f && (l.group && l.group.add(f), o && o.register && d && o.register(f), uh && f.root.didUpdate(), f.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), f.setOptions({
      ...f.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), ec.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(i) {
    const { layoutDependency: l, visualElement: o, drag: d, isPresent: f } = this.props, { projection: h } = o;
    return h && (h.isPresent = f, i.layoutDependency !== l && h.setOptions({
      ...h.options,
      layoutDependency: l
    }), uh = !0, d || i.layoutDependency !== l || l === void 0 || i.isPresent !== f ? h.willUpdate() : this.safeToRemove(), i.isPresent !== f && (f ? h.promote() : h.relegate() || Ge.postRender(() => {
      const p = h.getStack();
      (!p || !p.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: i, layoutAnchor: l } = this.props, { projection: o } = i;
    o && (o.options.layoutAnchor = l, o.root.didUpdate(), If.postRender(() => {
      !o.currentAnimation && o.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: i, layoutGroup: l, switchLayoutGroup: o } = this.props, { projection: d } = i;
    uh = !0, d && (d.scheduleCheckAfterUnmount(), l && l.group && l.group.remove(d), o && o.deregister && o.deregister(d));
  }
  safeToRemove() {
    const { safeToRemove: i } = this.props;
    i && i();
  }
  render() {
    return null;
  }
}
function X1(n) {
  const [i, l] = B1(), o = C.useContext(Tf);
  return s.jsx(w6, { ...n, layoutGroup: o, switchLayoutGroup: C.useContext(I1), isPresent: i, safeToRemove: l });
}
const j6 = {
  pan: {
    Feature: v6
  },
  drag: {
    Feature: b6,
    ProjectionNode: F1,
    MeasureLayout: X1
  }
};
function Bb(n, i, l) {
  const { props: o } = n;
  n.animationState && o.whileHover && n.animationState.setActive("whileHover", l === "Start");
  const d = "onHover" + l, f = o[d];
  f && Ge.postRender(() => f(i, ml(i)));
}
class S6 extends $a {
  mount() {
    const { current: i } = this.node;
    i && (this.unmount = G3(i, (l, o) => (Bb(this.node, o, "Start"), (d) => Bb(this.node, d, "End"))));
  }
  unmount() {
  }
}
class N6 extends $a {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let i = !1;
    try {
      i = this.node.current.matches(":focus-visible");
    } catch {
      i = !0;
    }
    !i || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = dl(rl(this.node.current, "focus", () => this.onFocus()), rl(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Vb(n, i, l) {
  const { props: o } = n;
  if (n.current instanceof HTMLButtonElement && n.current.disabled)
    return;
  n.animationState && o.whileTap && n.animationState.setActive("whileTap", l === "Start");
  const d = "onTap" + (l === "End" ? "" : l), f = o[d];
  f && Ge.postRender(() => f(i, ml(i)));
}
class T6 extends $a {
  mount() {
    const { current: i } = this.node;
    if (!i)
      return;
    const { globalTapTarget: l, propagate: o } = this.node.props;
    this.unmount = $3(i, (d, f) => (Vb(this.node, f, "Start"), (h, { success: p }) => Vb(this.node, h, p ? "End" : "Cancel")), {
      useGlobalTarget: l,
      stopPropagation: o?.tap === !1
    });
  }
  unmount() {
  }
}
const sf = /* @__PURE__ */ new WeakMap(), dh = /* @__PURE__ */ new WeakMap(), A6 = (n) => {
  const i = sf.get(n.target);
  i && i(n);
}, C6 = (n) => {
  n.forEach(A6);
};
function E6({ root: n, ...i }) {
  const l = n || document;
  dh.has(l) || dh.set(l, {});
  const o = dh.get(l), d = JSON.stringify(i);
  return o[d] || (o[d] = new IntersectionObserver(C6, { root: n, ...i })), o[d];
}
function k6(n, i, l) {
  const o = E6(i);
  return sf.set(n, l), o.observe(n), () => {
    sf.delete(n), o.unobserve(n);
  };
}
const M6 = {
  some: 0,
  all: 1
};
class z6 extends $a {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: i = {} } = this.node.getProps(), { root: l, margin: o, amount: d = "some", once: f } = i, h = {
      root: l ? l.current : void 0,
      rootMargin: o,
      threshold: typeof d == "number" ? d : M6[d]
    }, p = (g) => {
      const { isIntersecting: m } = g;
      if (this.isInView === m || (this.isInView = m, f && !m && this.hasEnteredView))
        return;
      m && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", m);
      const { onViewportEnter: b, onViewportLeave: y } = this.node.getProps(), w = m ? b : y;
      w && w(g);
    };
    this.stopObserver = k6(this.node.current, h, p);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: i, prevProps: l } = this.node;
    ["amount", "margin", "root"].some(O6(i, l)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function O6({ viewport: n = {} }, { viewport: i = {} } = {}) {
  return (l) => n[l] !== i[l];
}
const R6 = {
  inView: {
    Feature: z6
  },
  tap: {
    Feature: T6
  },
  focus: {
    Feature: N6
  },
  hover: {
    Feature: S6
  }
}, _6 = {
  layout: {
    ProjectionNode: F1,
    MeasureLayout: X1
  }
}, D6 = {
  ...i6,
  ...R6,
  ...j6,
  ..._6
}, E = /* @__PURE__ */ JA(D6, e6);
function F6() {
  const {
    cart: n,
    isOpen: i,
    loading: l,
    itemCount: o,
    closeCart: d,
    updateQuantity: f,
    removeItem: h,
    proceedToCheckout: p
  } = ul();
  return /* @__PURE__ */ s.jsx(Wr, { children: i && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      E.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.2 },
        className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50",
        onClick: d
      }
    ),
    /* @__PURE__ */ s.jsxs(
      E.div,
      {
        initial: { x: "100%" },
        animate: { x: 0 },
        exit: { x: "100%" },
        transition: { type: "spring", damping: 25, stiffness: 300 },
        className: "fixed right-0 top-0 h-full w-full max-w-md bg-[#111] border-l border-white/10 z-50 flex flex-col",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-6 border-b border-white/10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ s.jsx(hy, { size: 20, className: "text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsxs("h2", { className: "text-white font-semibold text-lg", children: [
                "Your Cart (",
                o,
                ")"
              ] })
            ] }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: d,
                className: "p-2 rounded-lg hover:bg-white/5 transition-colors",
                children: /* @__PURE__ */ s.jsx(jf, { size: 20, className: "text-white/60" })
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "flex-1 overflow-y-auto p-6", children: !n || n.items.length === 0 ? /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center justify-center h-full text-center", children: [
            /* @__PURE__ */ s.jsx(hy, { size: 48, className: "text-white/10 mb-4" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm", children: "Your cart is empty" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs mt-1", children: "Add items from our product pages" })
          ] }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-4", children: n.items.map((g) => /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: "flex gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                g.image && /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 rounded-lg overflow-hidden bg-white/5 flex-shrink-0", children: /* @__PURE__ */ s.jsx(
                  "img",
                  {
                    src: g.image.url,
                    alt: g.productTitle,
                    className: "w-full h-full object-cover"
                  }
                ) }),
                /* @__PURE__ */ s.jsxs("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ s.jsx("h3", { className: "text-white text-sm font-medium truncate", children: g.productTitle }),
                  g.variantTitle !== "Default Title" && /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: g.variantTitle }),
                  /* @__PURE__ */ s.jsxs("p", { className: "text-[#FF6B35] text-sm font-semibold mt-1", children: [
                    "$",
                    parseFloat(g.unitPrice.amount).toFixed(2)
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 mt-2", children: [
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => f(g.lineId, g.quantity - 1),
                        disabled: l,
                        className: "w-6 h-6 rounded bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(JN, { size: 12, className: "text-white/60" })
                      }
                    ),
                    /* @__PURE__ */ s.jsx("span", { className: "text-white text-sm w-6 text-center", children: g.quantity }),
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => f(g.lineId, g.quantity + 1),
                        disabled: l,
                        className: "w-6 h-6 rounded bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(nT, { size: 12, className: "text-white/60" })
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => h(g.lineId),
                        disabled: l,
                        className: "ml-auto p-1 rounded hover:bg-red-500/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(oT, { size: 14, className: "text-red-400/60" })
                      }
                    )
                  ] })
                ] })
              ]
            },
            g.lineId
          )) }) }),
          n && n.items.length > 0 && /* @__PURE__ */ s.jsxs("div", { className: "p-6 border-t border-white/10 space-y-4", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between items-center", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/60 text-sm", children: "Subtotal" }),
              /* @__PURE__ */ s.jsxs("span", { className: "text-white font-semibold", children: [
                "$",
                parseFloat(n.subtotal.amount).toFixed(2),
                " ",
                n.subtotal.currencyCode
              ] })
            ] }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: p,
                disabled: l,
                className: "w-full py-4 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2",
                children: l ? /* @__PURE__ */ s.jsx(zs, { size: 18, className: "animate-spin" }) : "Checkout with Shopify"
              }
            ),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs text-center", children: "Secure checkout powered by Shopify" })
          ] })
        ]
      }
    )
  ] }) });
}
var hh, Hb;
function B6() {
  if (Hb) return hh;
  Hb = 1;
  var n = typeof Element < "u", i = typeof Map == "function", l = typeof Set == "function", o = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function d(f, h) {
    if (f === h) return !0;
    if (f && h && typeof f == "object" && typeof h == "object") {
      if (f.constructor !== h.constructor) return !1;
      var p, g, m;
      if (Array.isArray(f)) {
        if (p = f.length, p != h.length) return !1;
        for (g = p; g-- !== 0; )
          if (!d(f[g], h[g])) return !1;
        return !0;
      }
      var b;
      if (i && f instanceof Map && h instanceof Map) {
        if (f.size !== h.size) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!h.has(g.value[0])) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!d(g.value[1], h.get(g.value[0]))) return !1;
        return !0;
      }
      if (l && f instanceof Set && h instanceof Set) {
        if (f.size !== h.size) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!h.has(g.value[0])) return !1;
        return !0;
      }
      if (o && ArrayBuffer.isView(f) && ArrayBuffer.isView(h)) {
        if (p = f.length, p != h.length) return !1;
        for (g = p; g-- !== 0; )
          if (f[g] !== h[g]) return !1;
        return !0;
      }
      if (f.constructor === RegExp) return f.source === h.source && f.flags === h.flags;
      if (f.valueOf !== Object.prototype.valueOf && typeof f.valueOf == "function" && typeof h.valueOf == "function") return f.valueOf() === h.valueOf();
      if (f.toString !== Object.prototype.toString && typeof f.toString == "function" && typeof h.toString == "function") return f.toString() === h.toString();
      if (m = Object.keys(f), p = m.length, p !== Object.keys(h).length) return !1;
      for (g = p; g-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(h, m[g])) return !1;
      if (n && f instanceof Element) return !1;
      for (g = p; g-- !== 0; )
        if (!((m[g] === "_owner" || m[g] === "__v" || m[g] === "__o") && f.$$typeof) && !d(f[m[g]], h[m[g]]))
          return !1;
      return !0;
    }
    return f !== f && h !== h;
  }
  return hh = function(h, p) {
    try {
      return d(h, p);
    } catch (g) {
      if ((g.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw g;
    }
  }, hh;
}
var V6 = B6();
const H6 = /* @__PURE__ */ ll(V6);
var fh, Ub;
function U6() {
  if (Ub) return fh;
  Ub = 1;
  var n = function(i, l, o, d, f, h, p, g) {
    if (!i) {
      var m;
      if (l === void 0)
        m = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var b = [o, d, f, h, p, g], y = 0;
        m = new Error(
          l.replace(/%s/g, function() {
            return b[y++];
          })
        ), m.name = "Invariant Violation";
      }
      throw m.framesToPop = 1, m;
    }
  };
  return fh = n, fh;
}
var L6 = U6();
const Lb = /* @__PURE__ */ ll(L6);
var mh, Pb;
function P6() {
  return Pb || (Pb = 1, mh = function(i, l, o, d) {
    var f = o ? o.call(d, i, l) : void 0;
    if (f !== void 0)
      return !!f;
    if (i === l)
      return !0;
    if (typeof i != "object" || !i || typeof l != "object" || !l)
      return !1;
    var h = Object.keys(i), p = Object.keys(l);
    if (h.length !== p.length)
      return !1;
    for (var g = Object.prototype.hasOwnProperty.bind(l), m = 0; m < h.length; m++) {
      var b = h[m];
      if (!g(b))
        return !1;
      var y = i[b], w = l[b];
      if (f = o ? o.call(d, y, w, b) : void 0, f === !1 || f === void 0 && y !== w)
        return !1;
    }
    return !0;
  }), mh;
}
var q6 = P6();
const I6 = /* @__PURE__ */ ll(q6);
var K1 = /* @__PURE__ */ ((n) => (n.BASE = "base", n.BODY = "body", n.HEAD = "head", n.HTML = "html", n.LINK = "link", n.META = "meta", n.NOSCRIPT = "noscript", n.SCRIPT = "script", n.STYLE = "style", n.TITLE = "title", n.FRAGMENT = "Symbol(react.fragment)", n))(K1 || {}), ph = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, qb = Object.values(K1), Cc = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, $1 = Object.entries(Cc).reduce(
  (n, [i, l]) => (n[l] = i, n),
  {}
), zn = "data-rh", Rs = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, _s = (n, i) => {
  for (let l = n.length - 1; l >= 0; l -= 1) {
    const o = n[l];
    if (Object.prototype.hasOwnProperty.call(o, i))
      return o[i];
  }
  return null;
}, G6 = (n) => {
  let i = _s(
    n,
    "title"
    /* TITLE */
  );
  const l = _s(n, Rs.TITLE_TEMPLATE);
  if (Array.isArray(i) && (i = i.join("")), l && i)
    return l.replace(/%s/g, () => i);
  const o = _s(n, Rs.DEFAULT_TITLE);
  return i || o || void 0;
}, Y6 = (n) => _s(n, Rs.ON_CHANGE_CLIENT_STATE) || (() => {
}), gh = (n, i) => i.filter((l) => typeof l[n] < "u").map((l) => l[n]).reduce((l, o) => ({ ...l, ...o }), {}), Q6 = (n, i) => i.filter((l) => typeof l.base < "u").map((l) => l.base).reverse().reduce((l, o) => {
  if (!l.length) {
    const d = Object.keys(o);
    for (let f = 0; f < d.length; f += 1) {
      const p = d[f].toLowerCase();
      if (n.indexOf(p) !== -1 && o[p])
        return l.concat(o);
    }
  }
  return l;
}, []), Z6 = (n) => console && typeof console.warn == "function" && console.warn(n), Ur = (n, i, l) => {
  const o = {};
  return l.filter((d) => Array.isArray(d[n]) ? !0 : (typeof d[n] < "u" && Z6(
    `Helmet: ${n} should be of type "Array". Instead found type "${typeof d[n]}"`
  ), !1)).map((d) => d[n]).reverse().reduce((d, f) => {
    const h = {};
    f.filter((g) => {
      let m;
      const b = Object.keys(g);
      for (let w = 0; w < b.length; w += 1) {
        const S = b[w], T = S.toLowerCase();
        i.indexOf(T) !== -1 && !(m === "rel" && g[m].toLowerCase() === "canonical") && !(T === "rel" && g[T].toLowerCase() === "stylesheet") && (m = T), i.indexOf(S) !== -1 && (S === "innerHTML" || S === "cssText" || S === "itemprop") && (m = S);
      }
      if (!m || !g[m])
        return !1;
      const y = g[m].toLowerCase();
      return o[m] || (o[m] = {}), h[m] || (h[m] = {}), o[m][y] ? !1 : (h[m][y] = !0, !0);
    }).reverse().forEach((g) => d.push(g));
    const p = Object.keys(h);
    for (let g = 0; g < p.length; g += 1) {
      const m = p[g], b = {
        ...o[m],
        ...h[m]
      };
      o[m] = b;
    }
    return d;
  }, []).reverse();
}, X6 = (n, i) => {
  if (Array.isArray(n) && n.length) {
    for (let l = 0; l < n.length; l += 1)
      if (n[l][i])
        return !0;
  }
  return !1;
}, K6 = (n) => ({
  baseTag: Q6([
    "href"
    /* HREF */
  ], n),
  bodyAttributes: gh("bodyAttributes", n),
  defer: _s(n, Rs.DEFER),
  encode: _s(n, Rs.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: gh("htmlAttributes", n),
  linkTags: Ur(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    n
  ),
  metaTags: Ur(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    n
  ),
  noscriptTags: Ur("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], n),
  onChangeClientState: Y6(n),
  scriptTags: Ur(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    n
  ),
  styleTags: Ur("style", [
    "cssText"
    /* CSS_TEXT */
  ], n),
  title: G6(n),
  titleAttributes: gh("titleAttributes", n),
  prioritizeSeoTags: X6(n, Rs.PRIORITIZE_SEO_TAGS)
}), W1 = (n) => Array.isArray(n) ? n.join("") : n, $6 = (n, i) => {
  const l = Object.keys(n);
  for (let o = 0; o < l.length; o += 1)
    if (i[l[o]] && i[l[o]].includes(n[l[o]]))
      return !0;
  return !1;
}, xh = (n, i) => Array.isArray(n) ? n.reduce(
  (l, o) => ($6(o, i) ? l.priority.push(o) : l.default.push(o), l),
  { priority: [], default: [] }
) : { default: n, priority: [] }, Ib = (n, i) => ({
  ...n,
  [i]: void 0
}), W6 = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], rf = (n, i = !0) => i === !1 ? String(n) : String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), J1 = (n) => Object.keys(n).reduce((i, l) => {
  const o = typeof n[l] < "u" ? `${l}="${n[l]}"` : `${l}`;
  return i ? `${i} ${o}` : o;
}, ""), J6 = (n, i, l, o) => {
  const d = J1(l), f = W1(i);
  return d ? `<${n} ${zn}="true" ${d}>${rf(
    f,
    o
  )}</${n}>` : `<${n} ${zn}="true">${rf(
    f,
    o
  )}</${n}>`;
}, eC = (n, i, l = !0) => i.reduce((o, d) => {
  const f = d, h = Object.keys(f).filter(
    (m) => !(m === "innerHTML" || m === "cssText")
  ).reduce((m, b) => {
    const y = typeof f[b] > "u" ? b : `${b}="${rf(f[b], l)}"`;
    return m ? `${m} ${y}` : y;
  }, ""), p = f.innerHTML || f.cssText || "", g = W6.indexOf(n) === -1;
  return `${o}<${n} ${zn}="true" ${h}${g ? "/>" : `>${p}</${n}>`}`;
}, ""), ew = (n, i = {}) => Object.keys(n).reduce((l, o) => {
  const d = Cc[o];
  return l[d || o] = n[o], l;
}, i), tC = (n, i, l) => {
  const o = {
    key: i,
    [zn]: !0
  }, d = ew(l, o);
  return [K.createElement("title", d, i)];
}, tc = (n, i) => i.map((l, o) => {
  const d = {
    key: o,
    [zn]: !0
  };
  return Object.keys(l).forEach((f) => {
    const p = Cc[f] || f;
    if (p === "innerHTML" || p === "cssText") {
      const g = l.innerHTML || l.cssText;
      d.dangerouslySetInnerHTML = { __html: g };
    } else
      d[p] = l[f];
  }), K.createElement(n, d);
}), vn = (n, i, l = !0) => {
  switch (n) {
    case "title":
      return {
        toComponent: () => tC(n, i.title, i.titleAttributes),
        toString: () => J6(n, i.title, i.titleAttributes, l)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => ew(i),
        toString: () => J1(i)
      };
    default:
      return {
        toComponent: () => tc(n, i),
        toString: () => eC(n, i, l)
      };
  }
}, nC = ({ metaTags: n, linkTags: i, scriptTags: l, encode: o }) => {
  const d = xh(n, ph.meta), f = xh(i, ph.link), h = xh(l, ph.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...tc("meta", d.priority),
        ...tc("link", f.priority),
        ...tc("script", h.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${vn("meta", d.priority, o)} ${vn(
          "link",
          f.priority,
          o
        )} ${vn("script", h.priority, o)}`
      )
    },
    metaTags: d.default,
    linkTags: f.default,
    scriptTags: h.default
  };
}, aC = (n) => {
  const {
    baseTag: i,
    bodyAttributes: l,
    encode: o = !0,
    htmlAttributes: d,
    noscriptTags: f,
    styleTags: h,
    title: p = "",
    titleAttributes: g,
    prioritizeSeoTags: m
  } = n;
  let { linkTags: b, metaTags: y, scriptTags: w } = n, S = {
    toComponent: () => [],
    toString: () => ""
  };
  return m && ({ priorityMethods: S, linkTags: b, metaTags: y, scriptTags: w } = nC(n)), {
    priority: S,
    base: vn("base", i, o),
    bodyAttributes: vn("bodyAttributes", l, o),
    htmlAttributes: vn("htmlAttributes", d, o),
    link: vn("link", b, o),
    meta: vn("meta", y, o),
    noscript: vn("noscript", f, o),
    script: vn("script", w, o),
    style: vn("style", h, o),
    title: vn("title", { title: p, titleAttributes: g }, o)
  };
}, lf = aC, Lo = [], em = !!(typeof window < "u" && window.document && window.document.createElement), of = class {
  instances = [];
  canUseDOM = em;
  context;
  value = {
    setHelmet: (n) => {
      this.context.helmet = n;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? Lo : this.instances,
      add: (n) => {
        (this.canUseDOM ? Lo : this.instances).push(n);
      },
      remove: (n) => {
        const i = (this.canUseDOM ? Lo : this.instances).indexOf(n);
        (this.canUseDOM ? Lo : this.instances).splice(i, 1);
      }
    }
  };
  constructor(n, i) {
    this.context = n, this.canUseDOM = i || !1, i || (n.helmet = lf({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, iC = parseInt(K.version.split(".")[0], 10), cf = iC >= 19, sC = {}, tw = K.createContext(sC), nw = class aw extends C.Component {
  static canUseDOM = em;
  helmetData;
  constructor(i) {
    super(i), cf ? this.helmetData = null : this.helmetData = new of(this.props.context || {}, aw.canUseDOM);
  }
  render() {
    return cf ? /* @__PURE__ */ K.createElement(K.Fragment, null, this.props.children) : /* @__PURE__ */ K.createElement(tw.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, Ns = (n, i) => {
  const l = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), o = l.querySelectorAll(`${n}[${zn}]`), d = [].slice.call(o), f = [];
  let h;
  return i && i.length && i.forEach((p) => {
    const g = document.createElement(n);
    for (const m in p)
      if (Object.prototype.hasOwnProperty.call(p, m))
        if (m === "innerHTML")
          g.innerHTML = p.innerHTML;
        else if (m === "cssText") {
          const b = p.cssText;
          g.appendChild(document.createTextNode(b));
        } else {
          const b = m, y = typeof p[b] > "u" ? "" : p[b];
          g.setAttribute(m, y);
        }
    g.setAttribute(zn, "true"), d.some((m, b) => (h = b, g.isEqualNode(m))) ? d.splice(h, 1) : f.push(g);
  }), d.forEach((p) => p.parentNode?.removeChild(p)), f.forEach((p) => l.appendChild(p)), {
    oldTags: d,
    newTags: f
  };
}, uf = (n, i) => {
  const l = document.getElementsByTagName(n)[0];
  if (!l)
    return;
  const o = l.getAttribute(zn), d = o ? o.split(",") : [], f = [...d], h = Object.keys(i);
  for (const p of h) {
    const g = i[p] || "";
    l.getAttribute(p) !== g && l.setAttribute(p, g), d.indexOf(p) === -1 && d.push(p);
    const m = f.indexOf(p);
    m !== -1 && f.splice(m, 1);
  }
  for (let p = f.length - 1; p >= 0; p -= 1)
    l.removeAttribute(f[p]);
  d.length === f.length ? l.removeAttribute(zn) : l.getAttribute(zn) !== h.join(",") && l.setAttribute(zn, h.join(","));
}, rC = (n, i) => {
  typeof n < "u" && document.title !== n && (document.title = W1(n)), uf("title", i);
}, Gb = (n, i) => {
  const {
    baseTag: l,
    bodyAttributes: o,
    htmlAttributes: d,
    linkTags: f,
    metaTags: h,
    noscriptTags: p,
    onChangeClientState: g,
    scriptTags: m,
    styleTags: b,
    title: y,
    titleAttributes: w
  } = n;
  uf("body", o), uf("html", d), rC(y, w);
  const S = {
    baseTag: Ns("base", l),
    linkTags: Ns("link", f),
    metaTags: Ns("meta", h),
    noscriptTags: Ns("noscript", p),
    scriptTags: Ns("script", m),
    styleTags: Ns("style", b)
  }, T = {}, _ = {};
  Object.keys(S).forEach((R) => {
    const { newTags: z, oldTags: Q } = S[R];
    z.length && (T[R] = z), Q.length && (_[R] = S[R].oldTags);
  }), i && i(), g(n, T, _);
}, Lr = null, lC = (n) => {
  Lr && cancelAnimationFrame(Lr), n.defer ? Lr = requestAnimationFrame(() => {
    Gb(n, () => {
      Lr = null;
    });
  }) : (Gb(n), Lr = null);
}, oC = lC, Yb = class extends C.Component {
  rendered = !1;
  shouldComponentUpdate(n) {
    return !I6(n, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: n } = this.props.context;
    n.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: n, setHelmet: i } = this.props.context;
    let l = null;
    const o = K6(
      n.get().map((d) => {
        const { context: f, ...h } = d.props;
        return h;
      })
    );
    nw.canUseDOM ? oC(o) : lf && (l = lf(o)), i(l);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: n } = this.props.context;
    n.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, nc = [], Qb = (n) => {
  const i = {};
  for (const l of Object.keys(n))
    i[$1[l] || l] = n[l];
  return i;
}, Si = (n) => {
  const i = {};
  for (const l of Object.keys(n)) {
    const o = Cc[l];
    i[o || l] = n[l];
  }
  return i;
}, Zb = (n, i) => {
  if (!em)
    return;
  const l = document.getElementsByTagName(n)[0];
  if (!l)
    return;
  const o = "data-rh-managed", d = l.getAttribute(o), f = d ? d.split(",") : [], h = Object.keys(i);
  for (const p of f)
    h.includes(p) || l.removeAttribute(p);
  for (const p of h) {
    const g = i[p];
    g == null || g === !1 ? l.removeAttribute(p) : g === !0 ? l.setAttribute(p, "") : l.setAttribute(p, String(g));
  }
  h.length > 0 ? l.setAttribute(o, h.join(",")) : l.removeAttribute(o);
}, yh = () => {
  const n = {}, i = {};
  for (const l of nc) {
    const { htmlAttributes: o, bodyAttributes: d } = l.props;
    o && Object.assign(n, Qb(o)), d && Object.assign(i, Qb(d));
  }
  Zb("html", n), Zb("body", i);
}, cC = class extends C.Component {
  componentDidMount() {
    nc.push(this), yh();
  }
  componentDidUpdate() {
    yh();
  }
  componentWillUnmount() {
    const n = nc.indexOf(this);
    n !== -1 && nc.splice(n, 1), yh();
  }
  resolveTitle() {
    const { title: n, titleTemplate: i, defaultTitle: l } = this.props;
    return n && i ? i.replace(/%s/g, () => Array.isArray(n) ? n.join("") : n) : n || l || void 0;
  }
  renderTitle() {
    const n = this.resolveTitle();
    if (n === void 0)
      return null;
    const i = this.props.titleAttributes || {};
    return K.createElement("title", Si(i), n);
  }
  renderBase() {
    const { base: n } = this.props;
    return n ? K.createElement("base", Si(n)) : null;
  }
  renderMeta() {
    const { meta: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map(
      (i, l) => K.createElement("meta", {
        key: l,
        ...Si(i)
      })
    );
  }
  renderLink() {
    const { link: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map(
      (i, l) => K.createElement("link", {
        key: l,
        ...Si(i)
      })
    );
  }
  renderScript() {
    const { script: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { innerHTML: o, ...d } = i, f = Si(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), K.createElement("script", { key: l, ...f });
    });
  }
  renderStyle() {
    const { style: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { cssText: o, ...d } = i, f = Si(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), K.createElement("style", { key: l, ...f });
    });
  }
  renderNoscript() {
    const { noscript: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { innerHTML: o, ...d } = i, f = Si(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), K.createElement("noscript", { key: l, ...f });
    });
  }
  render() {
    return K.createElement(
      K.Fragment,
      null,
      this.renderTitle(),
      this.renderBase(),
      this.renderMeta(),
      this.renderLink(),
      this.renderScript(),
      this.renderStyle(),
      this.renderNoscript()
    );
  }
}, uC = class extends C.Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(n) {
    return !H6(Ib(this.props, "helmetData"), Ib(n, "helmetData"));
  }
  mapNestedChildrenToProps(n, i) {
    if (!i)
      return null;
    switch (n.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: i
        };
      case "style":
        return {
          cssText: i
        };
      default:
        throw new Error(
          `<${n.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(n, i, l, o) {
    return {
      ...i,
      [n.type]: [
        ...i[n.type] || [],
        {
          ...l,
          ...this.mapNestedChildrenToProps(n, o)
        }
      ]
    };
  }
  mapObjectTypeChildren(n, i, l, o) {
    switch (n.type) {
      case "title":
        return {
          ...i,
          [n.type]: o,
          titleAttributes: { ...l }
        };
      case "body":
        return {
          ...i,
          bodyAttributes: { ...l }
        };
      case "html":
        return {
          ...i,
          htmlAttributes: { ...l }
        };
      default:
        return {
          ...i,
          [n.type]: { ...l }
        };
    }
  }
  mapArrayTypeChildrenToProps(n, i) {
    let l = { ...i };
    return Object.keys(n).forEach((o) => {
      l = {
        ...l,
        [o]: n[o]
      };
    }), l;
  }
  warnOnInvalidChildren(n, i) {
    return Lb(
      qb.some((l) => n.type === l),
      typeof n.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${qb.join(
        ", "
      )} are allowed. Helmet does not support rendering <${n.type}> elements. Refer to our API for more information.`
    ), Lb(
      !i || typeof i == "string" || Array.isArray(i) && !i.some((l) => typeof l != "string"),
      `Helmet expects a string as a child of <${n.type}>. Did you forget to wrap your children in braces? ( <${n.type}>{\`\`}</${n.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(n, i) {
    let l = {};
    return K.Children.forEach(n, (o) => {
      if (!o || !o.props)
        return;
      const { children: d, ...f } = o.props, h = Object.keys(f).reduce((g, m) => (g[$1[m] || m] = f[m], g), {});
      let { type: p } = o;
      switch (typeof p == "symbol" ? p = p.toString() : this.warnOnInvalidChildren(o, d), p) {
        case "Symbol(react.fragment)":
          i = this.mapChildrenToProps(d, i);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          l = this.flattenArrayTypeChildren(
            o,
            l,
            h,
            d
          );
          break;
        default:
          i = this.mapObjectTypeChildren(o, i, h, d);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(l, i);
  }
  render() {
    const { children: n, ...i } = this.props;
    let l = { ...i }, { helmetData: o } = i;
    if (n && (l = this.mapChildrenToProps(n, l)), o && !(o instanceof of)) {
      const d = o;
      o = new of(d.context, !0), delete l.helmetData;
    }
    return cf ? /* @__PURE__ */ K.createElement(cC, { ...l }) : o ? /* @__PURE__ */ K.createElement(Yb, { ...l, context: o.value }) : /* @__PURE__ */ K.createElement(tw.Consumer, null, (d) => /* @__PURE__ */ K.createElement(Yb, { ...l, context: d }));
  }
};
const dC = C.lazy(() => Promise.resolve().then(() => AC)), hC = C.lazy(() => Promise.resolve().then(() => MC)), fC = C.lazy(() => Promise.resolve().then(() => _C)), Xb = C.lazy(() => Promise.resolve().then(() => UC)), Kb = C.lazy(() => Promise.resolve().then(() => YC)), $b = C.lazy(() => Promise.resolve().then(() => KC)), Wb = C.lazy(() => Promise.resolve().then(() => JC)), Jb = C.lazy(() => Promise.resolve().then(() => aE)), bh = C.lazy(() => Promise.resolve().then(() => lE)), ev = C.lazy(() => Promise.resolve().then(() => hE)), tv = C.lazy(() => Promise.resolve().then(() => gE)), nv = C.lazy(() => Promise.resolve().then(() => bE)), av = C.lazy(() => Promise.resolve().then(() => wE)), iv = C.lazy(() => Promise.resolve().then(() => SE)), sv = C.lazy(() => Promise.resolve().then(() => TE)), rv = C.lazy(() => Promise.resolve().then(() => zE));
function mC() {
  return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen flex items-center justify-center bg-[#0a0a0a]", children: /* @__PURE__ */ s.jsx("div", { className: "w-8 h-8 border-2 border-[#FF6B35] border-t-transparent rounded-full animate-spin" }) });
}
function pC() {
  const n = window.__SHOOTZ_PRODUCT__, i = window.__SHOOTZ_PRODUCTS__?.tripod;
  return !!(n && i && n.id === i.id || n?.handle === "shootzinsight-r1-professional-tripod" || window.location.pathname.includes("shootzinsight-r1-professional-tripod")) ? /* @__PURE__ */ s.jsx(fC, {}) : /* @__PURE__ */ s.jsx(hC, {});
}
function gC() {
  return /* @__PURE__ */ s.jsx(C.Suspense, { fallback: /* @__PURE__ */ s.jsx(mC, {}), children: /* @__PURE__ */ s.jsxs(RT, { children: [
    /* @__PURE__ */ s.jsx(Be, { path: "/", component: dC }),
    /* @__PURE__ */ s.jsx(Be, { path: "/products/:handle", component: pC }),
    /* @__PURE__ */ s.jsx(Be, { path: "/sports/basketball", component: Xb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/basketball", component: Xb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/users/parents", component: Kb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/parents", component: Kb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/users/coaches", component: $b }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/coaches", component: $b }),
    /* @__PURE__ */ s.jsx(Be, { path: "/users/players", component: Jb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/players", component: Jb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/users/clubs", component: Wb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/clubs", component: Wb }),
    /* @__PURE__ */ s.jsx(Be, { path: "/about", component: bh }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/about", component: bh }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/about-us", component: bh }),
    /* @__PURE__ */ s.jsx(Be, { path: "/help/guide", component: ev }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/user-guide", component: ev }),
    /* @__PURE__ */ s.jsx(Be, { path: "/help/faq", component: tv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/faq", component: tv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/help/contact", component: nv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/contact", component: nv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/privacy", component: av }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/privacy-policy", component: av }),
    /* @__PURE__ */ s.jsx(Be, { path: "/terms", component: iv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/terms-of-service", component: iv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/refund", component: sv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/refund-policy", component: sv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pricing", component: rv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/pages/pricing", component: rv }),
    /* @__PURE__ */ s.jsx(Be, { path: "/404", component: jy }),
    /* @__PURE__ */ s.jsx(Be, { component: jy })
  ] }) });
}
function xC() {
  return /* @__PURE__ */ s.jsx(_T, { children: /* @__PURE__ */ s.jsx(nw, { children: /* @__PURE__ */ s.jsx(FT, { defaultTheme: "dark", children: /* @__PURE__ */ s.jsx(VT, { children: /* @__PURE__ */ s.jsxs(NN, { children: [
    /* @__PURE__ */ s.jsx(sS, {}),
    /* @__PURE__ */ s.jsx(gC, {}),
    /* @__PURE__ */ s.jsx(F6, {})
  ] }) }) }) }) });
}
const lv = document.getElementById("root");
lv && Tj.createRoot(lv).render(/* @__PURE__ */ s.jsx(xC, {}));
const yC = window.__SHOOTZ_CONFIG__?.logoUrl || "/shootzinsight-logo-light.png", ov = [
  {
    label: "Products",
    groups: [
      { links: [
        { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", label: "ShootzInsight Q1" }
      ] }
    ]
  },
  {
    label: "Accessories",
    groups: [
      { links: [
        { href: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod", label: "ShootzInsight R1 Tripod" }
      ] }
    ]
  },
  {
    label: "Sports & Users",
    groups: [
      { title: "Sports", links: [{ href: "/pages/basketball", label: "Basketball" }] },
      {
        title: "Users",
        links: [
          { href: "/pages/parents", label: "Parents" },
          { href: "/pages/coaches", label: "Coaches" },
          { href: "/pages/players", label: "Players" },
          { href: "/pages/clubs", label: "Clubs & Leagues" }
        ]
      }
    ]
  },
  {
    label: "Explore",
    groups: [
      { links: [
        { href: "/pages/about-us", label: "About Us" }
      ] }
    ]
  },
  { label: "Pricing & Plans", href: "/pricing" },
  {
    label: "Help Center",
    groups: [
      {
        links: [
          { href: "/pages/user-guide", label: "User Guide" },
          { href: "/pages/faq", label: "FAQ" },
          { href: "/pages/contact", label: "Contact Us" }
        ]
      }
    ]
  }
];
function cv(n) {
  return "groups" in n;
}
function bC() {
  const { openCart: n, itemCount: i } = ul();
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: n,
      className: "relative p-2 rounded-lg hover:bg-white/5 transition-colors",
      "aria-label": "Open cart",
      children: [
        /* @__PURE__ */ s.jsx(Os, { size: 20, className: "text-white/80" }),
        i > 0 && /* @__PURE__ */ s.jsx("span", { className: "absolute -top-0.5 -right-0.5 w-4 h-4 bg-[#FF6B35] text-white text-[10px] font-bold rounded-full flex items-center justify-center", children: i > 9 ? "9+" : i })
      ]
    }
  );
}
function sn() {
  const [n, i] = C.useState(!1), [l, o] = C.useState(null), [d, f] = C.useState(null), [h] = c0(), p = C.useRef(null), g = (b) => {
    p.current && clearTimeout(p.current), o(b);
  }, m = () => {
    p.current = setTimeout(() => o(null), 150);
  };
  return C.useEffect(() => {
    i(!1), o(null);
  }, [h]), /* @__PURE__ */ s.jsxs("nav", { className: "fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/5", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto flex items-center justify-between h-16 lg:h-[72px]", children: [
      /* @__PURE__ */ s.jsx(Ae, { href: "/", className: "flex items-center gap-2.5 shrink-0", children: /* @__PURE__ */ s.jsx("img", { src: yC, alt: "ShootzInsight", className: "h-10 w-auto max-w-[210px] object-contain invert" }) }),
      /* @__PURE__ */ s.jsx("div", { className: "hidden lg:flex items-center gap-1", children: ov.map((b) => cv(b) ? /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: "relative",
          onMouseEnter: () => g(b.label),
          onMouseLeave: m,
          children: [
            /* @__PURE__ */ s.jsxs(
              "button",
              {
                className: `flex items-center gap-1 px-4 py-2 text-sm font-medium transition-colors hover:text-[#FF6B35] ${l === b.label ? "text-[#FF6B35]" : "text-white/80"}`,
                children: [
                  b.label,
                  /* @__PURE__ */ s.jsx(
                    tl,
                    {
                      size: 14,
                      className: `transition-transform duration-200 ${l === b.label ? "rotate-180" : ""}`
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx(Wr, { children: l === b.label && /* @__PURE__ */ s.jsx(
              E.div,
              {
                initial: { opacity: 0, y: 8 },
                animate: { opacity: 1, y: 0 },
                exit: { opacity: 0, y: 8 },
                transition: { duration: 0.18, ease: [0.23, 1, 0.32, 1] },
                className: "absolute top-full left-0 mt-1 min-w-[200px] bg-[#141414] border border-white/10 rounded-xl shadow-2xl overflow-hidden",
                children: /* @__PURE__ */ s.jsx("div", { className: "p-3", children: b.groups.map((y, w) => /* @__PURE__ */ s.jsxs("div", { children: [
                  y.title && /* @__PURE__ */ s.jsx("p", { className: "px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40", children: y.title }),
                  y.links.map((S) => /* @__PURE__ */ s.jsx(
                    Ae,
                    {
                      href: S.href,
                      className: `block px-3 py-2 text-sm rounded-lg transition-colors hover:bg-white/5 hover:text-[#FF6B35] ${h === S.href ? "text-[#FF6B35]" : "text-white/70"}`,
                      children: S.label
                    },
                    S.href
                  ))
                ] }, w)) })
              }
            ) })
          ]
        },
        b.label
      ) : /* @__PURE__ */ s.jsx(
        Ae,
        {
          href: b.href,
          className: `px-4 py-2 text-sm font-medium transition-colors hover:text-[#FF6B35] ${h === b.href ? "text-[#FF6B35]" : "text-white/80"}`,
          children: b.label
        },
        b.label
      )) }),
      /* @__PURE__ */ s.jsxs("div", { className: "hidden lg:flex items-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          "a",
          {
            href: window.__SHOOTZ_CONFIG__?.accountUrl || "/account",
            className: "p-2 rounded-lg hover:bg-white/5 transition-colors",
            "aria-label": "My Account",
            title: "My Account",
            children: /* @__PURE__ */ s.jsx(fy, { size: 20, className: "text-white/80" })
          }
        ),
        /* @__PURE__ */ s.jsx(bC, {}),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
            className: "flex h-11 w-[120px] items-center justify-center bg-[#FF6B35] text-white text-xs font-semibold rounded-lg hover:bg-[#D94F22] transition-all active:scale-[0.97]",
            children: "Buy Q1 - $199"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: "lg:hidden text-white p-2",
          onClick: () => i(!n),
          "aria-label": "Toggle menu",
          children: n ? /* @__PURE__ */ s.jsx(jf, { size: 24 }) : /* @__PURE__ */ s.jsx($N, { size: 24 })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(Wr, { children: n && /* @__PURE__ */ s.jsx(
      E.div,
      {
        initial: { opacity: 0, height: 0 },
        animate: { opacity: 1, height: "auto" },
        exit: { opacity: 0, height: 0 },
        transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] },
        className: "lg:hidden bg-[#0a0a0a]/98 backdrop-blur-xl border-b border-white/5 overflow-hidden",
        children: /* @__PURE__ */ s.jsxs("div", { className: "container py-4 flex flex-col gap-1", children: [
          ov.map((b) => {
            if (!cv(b))
              return /* @__PURE__ */ s.jsx(
                Ae,
                {
                  href: b.href,
                  className: "py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors",
                  onClick: () => i(!1),
                  children: b.label
                },
                b.label
              );
            const y = d === b.label;
            return /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs(
                "button",
                {
                  className: "w-full flex items-center justify-between py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors",
                  onClick: () => f(y ? null : b.label),
                  children: [
                    b.label,
                    /* @__PURE__ */ s.jsx(
                      tl,
                      {
                        size: 16,
                        className: `transition-transform duration-200 ${y ? "rotate-180" : ""}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ s.jsx(Wr, { children: y && /* @__PURE__ */ s.jsx(
                E.div,
                {
                  initial: { opacity: 0, height: 0 },
                  animate: { opacity: 1, height: "auto" },
                  exit: { opacity: 0, height: 0 },
                  className: "overflow-hidden",
                  children: /* @__PURE__ */ s.jsx("div", { className: "pl-4 pb-2", children: b.groups.map((w, S) => /* @__PURE__ */ s.jsxs("div", { children: [
                    w.title && /* @__PURE__ */ s.jsx("p", { className: "px-2 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40", children: w.title }),
                    w.links.map((T) => /* @__PURE__ */ s.jsx(
                      Ae,
                      {
                        href: T.href,
                        className: "block px-2 py-2 text-sm text-white/60 hover:text-[#FF6B35] transition-colors",
                        onClick: () => i(!1),
                        children: T.label
                      },
                      T.href
                    ))
                  ] }, S)) })
                }
              ) })
            ] }, b.label);
          }),
          /* @__PURE__ */ s.jsxs(
            "a",
            {
              href: window.__SHOOTZ_CONFIG__?.accountUrl || "/account",
              className: "py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors flex items-center gap-2",
              children: [
                /* @__PURE__ */ s.jsx(fy, { size: 18 }),
                " My Account"
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(
            Ae,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
              className: "mt-3 px-5 py-3 bg-[#FF6B35] text-white text-sm font-semibold rounded-lg text-center",
              onClick: () => i(!1),
              children: "Buy Q1 - $199"
            }
          )
        ] })
      }
    ) })
  ] });
}
const vC = window.__SHOOTZ_CONFIG__?.logoUrl || "/shootzinsight-logo-light.png", wC = {
  Products: [
    { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", label: "ShootzInsight Q1" },
    { href: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod", label: "R1 Tripod" },
    { href: "/pricing", label: "Pricing & Plans" }
  ],
  Support: [
    { href: "/pages/user-guide", label: "User Guide" },
    { href: "/pages/faq", label: "FAQ" },
    { href: "/pages/refund-policy", label: "Shipping & Returns" },
    { href: "/pages/contact", label: "Contact Us" }
  ],
  Resources: [
    { href: "/pages/faq#accuracy-test-methodology", label: "Accuracy & Test Methodology" },
    { href: "/pricing#credits-billing", label: "Credits & Billing" },
    { href: "/pages/basketball", label: "Basketball" },
    { href: "/pages/about-us", label: "Our Story" }
  ],
  Company: [
    { href: "/pages/parents", label: "Parents" },
    { href: "/pages/players", label: "Players" },
    { href: "/pages/coaches", label: "Coaches" },
    { href: "/pages/clubs", label: "Clubs & Leagues" }
  ]
}, jC = [
  { icon: Wv, title: "Free Shipping", detail: "Available in the US" },
  { icon: aT, title: "15-Day Returns", detail: "Hassle-free returns" },
  { icon: $v, title: "Secure Payments", detail: "Protected checkout" },
  { icon: qN, title: "Customer Support", detail: "Help when you need it" }
];
function rn() {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("section", { id: "newsletter", className: "border-y border-white/[0.08] bg-[#202020]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto grid gap-8 py-10 md:grid-cols-[0.8fr_1.2fr] md:items-center md:py-12", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-2xl font-bold text-white md:text-3xl", children: "Don't Miss the Action" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm text-white/50", children: "Get product updates, game-film tips, and ShootzInsight news." })
      ] }),
      /* @__PURE__ */ s.jsxs("form", { method: "post", action: "/contact#newsletter", acceptCharset: "UTF-8", className: "flex flex-col gap-3 sm:flex-row", children: [
        /* @__PURE__ */ s.jsx("input", { type: "hidden", name: "form_type", value: "customer" }),
        /* @__PURE__ */ s.jsx("input", { type: "hidden", name: "contact[tags]", value: "newsletter" }),
        /* @__PURE__ */ s.jsx("label", { htmlFor: "footer-email", className: "sr-only", children: "Email address" }),
        /* @__PURE__ */ s.jsxs("div", { className: "relative flex-1", children: [
          /* @__PURE__ */ s.jsx(Kv, { size: 18, className: "pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-white/35" }),
          /* @__PURE__ */ s.jsx("input", { id: "footer-email", name: "contact[email]", type: "email", autoComplete: "email", required: !0, placeholder: "Enter your email", className: "h-12 w-full rounded-lg border border-white/15 bg-[#151515] pl-12 pr-4 text-sm text-white outline-none placeholder:text-white/35 focus:border-[#FF6B35]" })
        ] }),
        /* @__PURE__ */ s.jsx("button", { type: "submit", className: "h-12 rounded-lg bg-[#FF6B35] px-7 text-sm font-semibold text-white transition-colors hover:bg-[#D94F22]", children: "Subscribe" })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("footer", { className: "bg-[#0d0d0d]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto py-14 md:py-16", children: [
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-6 border-b border-white/[0.08] pb-10 sm:grid-cols-2 lg:grid-cols-4", children: jC.map((n) => {
        const i = n.icon;
        return /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-4", children: [
          /* @__PURE__ */ s.jsx(i, { size: 24, className: "shrink-0 text-[#FF6B35]", "aria-hidden": "true" }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold text-white", children: n.title }),
            /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/40", children: n.detail })
          ] })
        ] }, n.title);
      }) }),
      /* @__PURE__ */ s.jsxs("div", { className: "grid gap-10 py-12 md:grid-cols-2 lg:grid-cols-6", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "lg:col-span-2", children: [
          /* @__PURE__ */ s.jsx(Ae, { href: "/", className: "inline-flex", children: /* @__PURE__ */ s.jsx("img", { src: vC, alt: "ShootzInsight", className: "h-11 w-auto max-w-[220px] object-contain invert" }) }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-5 max-w-sm text-sm leading-relaxed text-white/50", children: "Q1 is built for basketball today and uses your iPhone to record. Soccer, tennis and badminton are planned for late 2026." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-[#FF6B35]", children: "iPhone app coming soon" })
        ] }),
        Object.entries(wC).map(([n, i]) => /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-white", children: n }),
          /* @__PURE__ */ s.jsx("ul", { className: "mt-5 space-y-3", children: i.map((l) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(Ae, { href: l.href, className: "text-sm text-white/45 transition-colors hover:text-[#FF6B35]", children: l.label }) }, l.href)) })
        ] }, n))
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-4 border-t border-white/[0.08] pt-7 text-xs text-white/30 md:flex-row md:items-center md:justify-between", children: [
        /* @__PURE__ */ s.jsxs("p", { children: [
          "© ",
          (/* @__PURE__ */ new Date()).getFullYear(),
          " ShootzInsight. All rights reserved."
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex flex-wrap gap-x-6 gap-y-3", children: [
          /* @__PURE__ */ s.jsx(Ae, { href: "/pages/privacy-policy", className: "hover:text-white/60", children: "Privacy" }),
          /* @__PURE__ */ s.jsx(Ae, { href: "/pages/terms-of-service", className: "hover:text-white/60", children: "Terms" }),
          /* @__PURE__ */ s.jsx(Ae, { href: "/pages/refund-policy", className: "hover:text-white/60", children: "Returns" })
        ] })
      ] })
    ] }) })
  ] });
}
const Ni = {
  siteName: "ShootzInsight",
  title: "ShootzInsight - Know Your Game",
  description: "AI-powered basketball recording system. AI Moments, Game Analytics, and One-Tap Highlights — delivered seconds after the buzzer. Know your game.",
  image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp",
  baseUrl: typeof window < "u" ? window.location.origin : ""
};
function ln({
  title: n,
  description: i,
  keywords: l,
  image: o,
  url: d
}) {
  const f = n ? `${n} | ${Ni.siteName}` : Ni.title, h = i || Ni.description, p = o || Ni.image, g = d ? `${Ni.baseUrl}${d}` : Ni.baseUrl;
  return /* @__PURE__ */ s.jsxs(uC, { children: [
    /* @__PURE__ */ s.jsx("title", { children: f }),
    /* @__PURE__ */ s.jsx("meta", { name: "description", content: h }),
    l && /* @__PURE__ */ s.jsx("meta", { name: "keywords", content: l }),
    /* @__PURE__ */ s.jsx("link", { rel: "canonical", href: g }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:type", content: "website" }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:site_name", content: Ni.siteName }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:title", content: f }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:description", content: h }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:image", content: p }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:url", content: g }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:card", content: "summary_large_image" }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:title", content: f }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:description", content: h }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:image", content: p })
  ] });
}
const It = window.__SHOOTZ_CONFIG__?.media, SC = window.__SHOOTZ_CONFIG__?.heroUrl || It?.homeRecord || "/q1-pricing.png", NC = "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/feature_game_analytics-9wEawaZenTiVzuxVtfHT3C.webp", Oe = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
}, yn = {
  visible: { transition: { staggerChildren: 0.15 } }
};
function vh({ icon: n, title: i, description: l, accentColor: o = "#FF6B35" }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[color:var(--accent)]/20 transition-all group", style: { "--accent": o }, children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg flex items-center justify-center mb-4", style: { backgroundColor: `${o}15` }, children: /* @__PURE__ */ s.jsx(n, { size: 20, style: { color: o } }) }),
    /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-2", children: i }),
    /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: l })
  ] });
}
function TC() {
  const [n, i] = C.useState(null);
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { description: "AI-powered basketball recording system. Mount your phone, record every play, browse made-basket moments, create one-tap highlights, and review real shooting data. Know your game.", keywords: "basketball recording system, AI sports tracking, automatic highlights, scoring moments, sports video analysis", url: "/" }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative min-h-screen flex items-center justify-center overflow-hidden", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
        /* @__PURE__ */ s.jsx("img", { src: SC, alt: "", className: "w-full h-full object-cover opacity-40" }),
        /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/60 via-[#0a0a0a]/30 to-[#0a0a0a]" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "relative z-10 container mx-auto text-center pt-20",
          initial: "hidden",
          animate: "visible",
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(
              E.p,
              {
                variants: Oe,
                className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-4",
                children: "Q1 + iPhone + Basketball AI"
              }
            ),
            /* @__PURE__ */ s.jsx(
              E.h1,
              {
                variants: Oe,
                className: "font-[family-name:var(--font-display)] text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-[0.95] tracking-tight",
                children: "KNOW YOUR GAME."
              }
            ),
            /* @__PURE__ */ s.jsx(
              E.p,
              {
                variants: Oe,
                className: "mt-6 text-white/60 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed",
                children: "ShootzInsight Q1 works with your iPhone to record full-court basketball. After processing, made-basket clips are organized for review, selected plays become highlights, and shooting numbers link back to film."
              }
            ),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "mt-10 flex flex-col sm:flex-row items-center justify-center gap-4", children: [
              /* @__PURE__ */ s.jsx(
                Ae,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
                  className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg glow-orange hover:scale-105 transition-transform text-base",
                  children: "Buy Q1 - $199"
                }
              ),
              /* @__PURE__ */ s.jsxs(
                Ae,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
                  className: "px-8 py-4 border border-white/20 text-white font-medium rounded-lg hover:border-[#FF6B35]/50 hover:text-[#FF6B35] transition-all text-base flex items-center gap-2",
                  children: [
                    /* @__PURE__ */ s.jsx(Rh, { size: 18 }),
                    " Watch the 30-sec Scoring Moments Demo"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx(
              E.div,
              {
                variants: Oe,
                className: "mt-16 grid grid-cols-2 gap-6 max-w-2xl mx-auto sm:grid-cols-4 sm:gap-8",
                children: [
                  { value: "20,000", label: "Court Test Environments*" },
                  { value: "FREE", label: "Scoring Moments" },
                  { value: "FREE", label: "Live Streaming" },
                  { value: "800", label: "AI Credits Included" }
                ].map((l) => /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
                  /* @__PURE__ */ s.jsx("p", { className: "font-[family-name:var(--font-mono)] text-2xl md:text-3xl font-bold text-[#FF6B35]", children: l.value }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-1", children: l.label })
                ] }, l.label))
              }
            ),
            /* @__PURE__ */ s.jsxs(
              E.div,
              {
                variants: Oe,
                className: "mt-10 flex flex-wrap items-center justify-center gap-6 text-white/50 text-sm",
                children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "Free AI Moments" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "15-Day Money-Back" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "1-Year Warranty" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "Free Shipping (US)" })
                  ] })
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce", children: /* @__PURE__ */ s.jsx("div", { className: "w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center pt-2", children: /* @__PURE__ */ s.jsx("div", { className: "w-1.5 h-3 bg-[#FF6B35] rounded-full" }) }) })
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "border-b border-white/[0.07] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-12 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "From Buzzer to Box Score" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "One connected result chain" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-5 md:grid-cols-2 lg:grid-cols-4", children: [
        { step: "01", title: "Record", desc: "Set up Q1 with your iPhone and record the basketball game hands-free.", image: It?.homeRecord },
        { step: "02", title: "Detect", desc: "Made-basket moments are identified and clipped automatically after processing.", image: It?.aiMoments },
        { step: "03", title: "Understand", desc: "Review points, FG%, and 3PT / 2PT / FT breakdowns linked to video.", image: It?.gameAnalytics },
        { step: "04", title: "Share", desc: "Turn selected plays into a share-ready highlight.", image: It?.oneTapHighlight }
      ].map((l) => /* @__PURE__ */ s.jsxs("article", { className: "overflow-hidden rounded-lg border border-white/10 bg-white/[0.02]", children: [
        l.image && /* @__PURE__ */ s.jsx("img", { src: l.image, alt: `ShootzInsight ${l.title.toLowerCase()} workflow example`, loading: "lazy", className: "aspect-[14/9] w-full object-cover" }),
        /* @__PURE__ */ s.jsxs("div", { className: "p-5", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold text-[#FF6B35]", children: l.step }),
          /* @__PURE__ */ s.jsx("h3", { className: "mt-2 text-lg font-semibold text-white", children: l.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm leading-relaxed text-white/50", children: l.desc }),
          l.step !== "01" && l.image && /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => i({ src: l.image, title: `${l.title} example` }), className: "mt-4 inline-flex text-xs font-semibold text-[#FF6B35] hover:text-[#FF8A5C]", children: "View an example" })
        ] })
      ] }, l.title)) }),
      /* @__PURE__ */ s.jsx("p", { className: "mt-5 text-xs text-white/35", children: "*Based on internal testing. Results may vary by venue, lighting, iPhone placement and game conditions." })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 1" }),
            /* @__PURE__ */ s.jsx(E.h2, { variants: Oe, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "RECORD" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "Set up in 30 seconds. Capture every play automatically. Sit back and enjoy the game." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "mb-16 rounded-2xl overflow-hidden border border-white/5 aspect-[21/9] bg-white/[0.01]",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Oe,
          children: It?.homeRecord ? /* @__PURE__ */ s.jsx("img", { src: It.homeRecord, alt: "ShootzInsight Q1 recording a basketball game", className: "w-full h-full object-cover" }) : /* @__PURE__ */ s.jsx("div", { className: "h-full flex items-center justify-center text-center", children: /* @__PURE__ */ s.jsx(el, { size: 48, className: "text-[#FF6B35]/30 mx-auto mb-3" }) })
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "grid md:grid-cols-3 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.div, { variants: Oe, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: el,
                title: "Full-Court AI Tracking",
                description: "Hands-free tracking helps keep fast breaks and off-ball action in frame — no manual panning required."
              }
            ) }),
            /* @__PURE__ */ s.jsx(E.div, { variants: Oe, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: rc,
                title: "Never Miss a Play",
                description: "Our AI-powered follow-cam keeps every play in focus throughout the match. Relive every moment in a true broadcast-style experience in the ShootzInsight App."
              }
            ) }),
            /* @__PURE__ */ s.jsx(E.div, { variants: Oe, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: ic,
                title: "Free Live Streaming",
                description: "Stream to YouTube, Facebook, or any RTMP destination — free and unlimited. Share the game with family and fans who can't be there in person."
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Oe,
          children: /* @__PURE__ */ s.jsxs(
            Ae,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Qr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative bg-gradient-to-b from-[#0a0a0a] to-[#0a0f14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-[#22c55e] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 2" }),
            /* @__PURE__ */ s.jsx(E.h2, { variants: Oe, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "ANALYZE" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "AI does the retrieval work, so parents and players can start with the plays that matter." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "mb-20",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#22c55e]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(t0, { size: 20, className: "text-[#22c55e]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-green-500/10 text-green-400 text-xs font-semibold px-3 py-1 rounded-full", children: "FREE FOREVER" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "AI MOMENTS" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Made-basket clips found automatically" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Q1 records the whole game and organizes made baskets into a browsable Moments library — threes, twos, and free throws included." })
              ] }),
              /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: It?.aiMoments && /* @__PURE__ */ s.jsx("img", { src: It.aiMoments, alt: "ShootzInsight AI Moments interface", className: "w-full h-full object-cover", loading: "lazy" }) })
            ] }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Browse clips faster" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Review thumbnail previews instead of scrubbing through hours of film. Select the scoring plays worth keeping." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Automatic scoring clips" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Threes, twos, and free throws are captured and organized after processing. No manual tagging required." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsx("div", { className: "order-2 lg:order-1 rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-[#070707] flex items-center justify-center", children: /* @__PURE__ */ s.jsx(
                "img",
                {
                  src: It?.gameAnalytics || window.__SHOOTZ_CONFIG__?.analyticsImageUrl || NC,
                  alt: "ShootzInsight game analytics dashboard",
                  className: "w-full h-full object-contain",
                  loading: "lazy"
                }
              ) }),
              /* @__PURE__ */ s.jsxs("div", { className: "order-1 lg:order-2", children: [
                /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-3 mb-4", children: /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#eab308]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Ds, { size: 20, className: "text-[#eab308]" }) }) }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "GAME ANALYTICS" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Real numbers linked to film" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "See the 2PT / 3PT / FT breakdown and FG% behind each game — then jump back to the clip behind the number." })
              ] })
            ] }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid md:grid-cols-3 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Scoring fundamentals" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "The 2PT / 3PT / FT split and FG% stay connected to their source video. Tap a number, watch that play." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Linked film review" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Keep each shooting number tied to its source play, so review starts from evidence rather than memory." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "More insights coming soon" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Rebounds, assists and additional player and team data dimensions are planned for future updates." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Oe,
          children: /* @__PURE__ */ s.jsxs(
            Ae,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Qr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative bg-gradient-to-b from-[#0a0f14] to-[#0a0a0a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 3" }),
            /* @__PURE__ */ s.jsx(E.h2, { variants: Oe, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "SHARE" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "From selected plays to social-ready output in one tap — with live streaming for everyone who cannot be there." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "mb-20",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(e0, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-semibold px-3 py-1 rounded-full font-[family-name:var(--font-mono)]", children: "ONE-TAP" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "ONE-TAP HIGHLIGHT" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Selected plays into a shareable reel" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "One tap turns your selected Moments into a cinematic Highlight — landscape to vertical, slow-mo on the clutch plays, music synced to the beat." })
              ] }),
              /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: It?.oneTapHighlight && /* @__PURE__ */ s.jsx("img", { src: It.oneTapHighlight, alt: "ShootzInsight one-tap player highlights", className: "w-full h-full object-cover", loading: "lazy" }) })
            ] }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Clip-first editing" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Start from clips already surfaced by Scoring Moments, then choose exactly the plays you want to include." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Export where it matters" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Export the finished reel for TikTok, Instagram, YouTube Shorts, or private conversations with coaches and recruiters." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsx("div", { className: "order-2 lg:order-1 rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: It?.liveStreaming && /* @__PURE__ */ s.jsx("img", { src: It.liveStreaming, alt: "ShootzInsight live streaming interface", className: "w-full h-full object-cover", loading: "lazy" }) }),
              /* @__PURE__ */ s.jsxs("div", { className: "order-1 lg:order-2", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(ic, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-green-500/10 text-green-400 text-xs font-semibold px-3 py-1 rounded-full", children: "FREE" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "SHOOTZINSIGHT LIVE" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Stream the action in real time" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Nothing beats watching live sports. Share every win, every loss, every moment as they happen. Stream to Facebook, YouTube, and more — instantly connecting with your fans where they already are." })
              ] })
            ] }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Livestream to social media" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Livestream your matches on Facebook, YouTube, and more, instantly connecting with your fans where they already are. One tap to go live — no extra equipment needed." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Keep track of score and time" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Add score and time displays to your streams in just a few clicks, giving your audience the full match overview for a true live sports broadcast feel." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Oe,
          children: /* @__PURE__ */ s.jsxs(
            Ae,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Qr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0f0f1a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Built For Everyone" }),
            /* @__PURE__ */ s.jsx(E.h2, { variants: Oe, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: "WHO IS IT FOR?" })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: yn,
          children: [
            { icon: rc, title: "Parents", desc: "Find your child's made-basket moments and share the plays that matter.", href: "/pages/parents" },
            { icon: Ds, title: "Coaches", desc: "Review points, FG%, and shooting breakdowns with every result linked to film.", href: "/pages/coaches" },
            { icon: sc, title: "Clubs", desc: "Build a repeatable recording and scoring-clip workflow across your program.", href: "/pages/clubs" },
            { icon: Rh, title: "Players", desc: "Find scoring clips, review linked stats, and create a share-ready highlight.", href: "/pages/players" }
          ].map((l) => /* @__PURE__ */ s.jsx(E.div, { variants: Oe, children: /* @__PURE__ */ s.jsx(Ae, { href: l.href, className: "block group", children: /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/30 transition-all h-full", children: [
            /* @__PURE__ */ s.jsx(l.icon, { size: 28, className: "text-[#FF6B35] mb-4 group-hover:scale-110 transition-transform" }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-semibold text-white mb-2", children: l.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: l.desc }),
            /* @__PURE__ */ s.jsxs("div", { className: "mt-4 flex items-center gap-1 text-[#FF6B35] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity", children: [
              "Learn more ",
              /* @__PURE__ */ s.jsx(Qr, { size: 14 })
            ] })
          ] }) }) }, l.title))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-10 max-w-3xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#55D681]", children: "No subscription required to start" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "Start Recording Without a Subscription" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-base leading-relaxed text-white/50", children: "Every Q1 includes 800 bonus credits - enough for one Full Game Analysis of a video up to 80 minutes." })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "overflow-x-auto rounded-lg border border-white/10", children: /* @__PURE__ */ s.jsxs("table", { className: "w-full min-w-[680px] border-collapse text-left text-sm", children: [
        /* @__PURE__ */ s.jsx("thead", { className: "bg-white/[0.04] text-white", children: /* @__PURE__ */ s.jsxs("tr", { children: [
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Feature" }),
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Q1 included" }),
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Shootz Cloud credits" })
        ] }) }),
        /* @__PURE__ */ s.jsx("tbody", { className: "divide-y divide-white/[0.07] text-white/55", children: [
          ["Full-court tracking", !0, !1],
          ["Full-game recording, download and local storage", !0, !1],
          ["AI Moments / made-basket clips", !0, !1],
          ["Live streaming + scoreboard", !0, !1],
          ["Cloud game analysis", "800 bonus credits to start", !0],
          ["Highlight reel creation", "800 bonus credits to start", !0],
          ["One-Tap Highlight reel", "800 bonus credits to start", !0]
        ].map(([l, o, d]) => /* @__PURE__ */ s.jsxs("tr", { children: [
          /* @__PURE__ */ s.jsx("td", { className: "p-4 text-white/75", children: l }),
          /* @__PURE__ */ s.jsx("td", { className: "p-4", children: o === !0 ? /* @__PURE__ */ s.jsx(Yt, { size: 18, className: "text-[#55D681]" }) : o }),
          /* @__PURE__ */ s.jsx("td", { className: "p-4", children: d ? /* @__PURE__ */ s.jsx(Yt, { size: 18, className: "text-[#FF6B35]" }) : "" })
        ] }, String(l))) })
      ] }) })
    ] }) }),
    /* @__PURE__ */ s.jsxs("section", { className: "py-24 relative overflow-hidden", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-r from-[#FF6B35]/5 to-[#FFD700]/5" }),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "container mx-auto text-center relative z-10",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: yn,
          children: [
            /* @__PURE__ */ s.jsx(E.h2, { variants: Oe, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-6", children: "READY TO KNOW YOUR GAME?" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Oe, className: "text-white/60 text-lg max-w-xl mx-auto mb-10", children: "AI Moments are free forever. Premium features unlock in the ShootzInsight App. Get started with Q1 — starting at $199 with free shipping, 15-day money-back guarantee, and 1-year warranty." }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Oe, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
              /* @__PURE__ */ s.jsx(
                Ae,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
                  className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg glow-orange hover:scale-105 transition-transform text-base",
                  children: "View Product"
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ae,
                {
                  href: "/pages/user-guide",
                  className: "px-8 py-4 border border-white/20 text-white font-medium rounded-lg hover:border-[#FF6B35]/50 transition-all text-base",
                  children: "How It Works"
                }
              )
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(rn, {}),
    n && /* @__PURE__ */ s.jsx("div", { role: "dialog", "aria-modal": "true", "aria-label": n.title, className: "fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm", onClick: () => i(null), children: /* @__PURE__ */ s.jsxs("div", { className: "relative w-full max-w-5xl", onClick: (l) => l.stopPropagation(), children: [
      /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => i(null), "aria-label": "Close example", className: "absolute right-3 top-3 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/70 text-white hover:border-[#FF6B35]/70", children: /* @__PURE__ */ s.jsx(jf, { size: 20 }) }),
      /* @__PURE__ */ s.jsx("img", { src: n.src, alt: n.title, className: "max-h-[85vh] w-full rounded-lg border border-white/10 bg-[#111318] object-contain" })
    ] }) })
  ] });
}
const AC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TC
}, Symbol.toStringTag, { value: "Module" })), qa = window.__SHOOTZ_CONFIG__?.media?.q1Gallery?.length ? window.__SHOOTZ_CONFIG__.media.q1Gallery : [
  "https://cdn.shopify.com/s/files/1/0720/0168/3530/files/UpsMejoSJxIpnZiw.png?v=1784347644",
  "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp"
], bn = window.__SHOOTZ_CONFIG__?.media, uv = [
  {
    id: "q1",
    name: "Q1 Only",
    subtitle: "ShootzInsight Q1 AI Tracking System",
    price: 199,
    originalPrice: 199,
    items: ["ShootzInsight Q1 Unit", "Phone Mount Clamp", "RC1 Remote Control", "USB-C Cable"],
    badge: null
  },
  {
    id: "bundle",
    name: "Q1 + R1 Bundle",
    subtitle: "Q1 + R1 Professional Tripod",
    price: 249,
    originalPrice: 249,
    items: ["ShootzInsight Q1 Unit", "Phone Mount Clamp", "RC1 Remote Control", "R1 Professional Tripod (200cm)", "USB-C Cable"],
    badge: null
  }
], dv = [
  { label: "AI processing", value: "Q1 and the ShootzInsight iPhone App work together; no standalone AI Processor specification published" },
  { label: "Runtime", value: "Approx. 13 hours balanced and stationary without AI tracking; approx. 4 hours with AI tracking and fill light" },
  { label: "Battery", value: "7.4V / 1400mAh" },
  { label: "Charging", value: "Approx. 2.5 hours, 5V-2A" },
  { label: "Controllable angles", value: "Heading -120° to 210°; Roll -195° to 135°; Pitch -35° to 45°" },
  { label: "Expanded size", value: "127 × 65 × 312 mm" },
  { label: "Folded size", value: "98 × 44 × 160.5 mm" },
  { label: "Gimbal weight", value: "420g ±5g" },
  { label: "Magnetic tracking module", value: "13.6g" },
  { label: "Working temperature", value: "-10°C to 45°C / 14°F to 113°F" },
  { label: "Compatibility", value: "iPhone only at launch; exact models and minimum iOS version will be listed with the App Store release" }
], CC = [
  {
    q: "What's included with the ShootzInsight Q1?",
    a: "Every Q1 comes with the RC1 Bluetooth remote control (with score +/- buttons), a USB-C charging cable, and a carry pouch. The R1 tripod is available in bundle options."
  },
  {
    q: "Is AI Moments really free?",
    a: "Yes. Q1 records the game and organizes made-basket clips into your free Scoring Moments library. You can browse and select plays without a subscription."
  },
  {
    q: "How do One-Tap Highlight and Game Analytics work?",
    a: "Both use Shootz Cloud credits in the ShootzInsight app. Highlight creation turns selected Moments into a finished vertical reel. Game Analytics currently supports shooting metrics — 2PT / 3PT / FT breakdowns and FG% — linked to video."
  },
  {
    q: "What makes ShootzInsight different from other sports recording systems?",
    a: "Q1 does not stop at recording. It turns full-game film into a browsable Scoring Moments library, supports one-tap Highlight creation from selected clips, and provides real shooting numbers with linked video — all while preserving the complete game film."
  },
  {
    q: "What phones are compatible?",
    a: "Q1 is iPhone-only at launch. Exact compatible models and the minimum iOS version will be published with the App Store release."
  },
  {
    q: "How long does setup take?",
    a: "Under 30 seconds. Mount Q1 on a tripod, clamp your phone, open the ShootzInsight App, connect via Bluetooth, select basketball mode, and hit record."
  },
  {
    q: "What sports does Q1 support?",
    a: "Q1 is built for basketball today. Soccer, tennis and badminton are planned for late 2026."
  },
  {
    q: "Can I use Q1 without a subscription?",
    a: "Absolutely. Q1 auto-tracks the full court and generates free AI Moments with no subscription. Recording quality depends on your phone. Subscribe only when you want One-Tap Highlights or Game Analytics."
  },
  {
    q: "How does the landscape-to-portrait conversion work?",
    a: "Our AI analyzes the action in each clip and intelligently reframes the horizontal recording into a vertical format optimized for TikTok, Instagram Reels, and Shorts — keeping the key action centered without manual cropping."
  },
  {
    q: "What is the shipping policy?",
    a: "We offer free standard shipping within the United States (5-7 business days). Expedited shipping (2-3 business days) is available for $9.99. International shipping is available to select countries — rates are calculated at checkout."
  },
  {
    q: "What is the return policy?",
    a: "We offer a 15-day money-back guarantee. If you're not satisfied with your ShootzInsight Q1, return it within 15 days of delivery in its original packaging for a full refund. Return shipping is free for US customers."
  },
  {
    q: "What does the warranty cover?",
    a: "ShootzInsight Q1 comes with a 1-year limited warranty covering manufacturing defects and hardware malfunctions under normal use. This includes the tracking motor, Bluetooth module, and phone clamp mechanism. Accidental damage and water damage are not covered."
  }
], ki = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};
function EC({ q: n, a: i }) {
  const [l, o] = C.useState(!1);
  return /* @__PURE__ */ s.jsxs("div", { className: "border-b border-white/10", children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        onClick: () => o(!l),
        className: "w-full flex items-center justify-between py-5 text-left",
        children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium pr-4", children: n }),
          l ? /* @__PURE__ */ s.jsx(Zv, { size: 18, className: "text-white/40 shrink-0" }) : /* @__PURE__ */ s.jsx(tl, { size: 18, className: "text-white/40 shrink-0" })
        ]
      }
    ),
    l && /* @__PURE__ */ s.jsx("div", { className: "pb-5 text-white/60 text-sm leading-relaxed", children: i })
  ] });
}
function Ti({
  title: n,
  subtitle: i,
  description: l,
  bullets: o,
  imagePlaceholder: d,
  imageAlt: f,
  imageSrc: h,
  reversed: p,
  accentColor: g = "#FF6B35"
}) {
  return /* @__PURE__ */ s.jsx(E.div, { variants: ki, className: "mb-20 last:mb-0", children: /* @__PURE__ */ s.jsxs("div", { className: "grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ", children: [
    /* @__PURE__ */ s.jsxs("div", { className: p ? "order-1 lg:order-2" : "order-1", children: [
      i && /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold tracking-widest uppercase mb-3", style: { color: g }, children: i }),
      /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-3xl font-bold text-white mb-4", children: n }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-base leading-relaxed mb-5", children: l }),
      o && o.length > 0 && /* @__PURE__ */ s.jsx("ul", { className: "space-y-2.5", children: o.map((m) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-3 text-white/70 text-sm", children: [
        /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
        m
      ] }, m)) })
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: `aspect-[4/3] rounded-2xl overflow-hidden bg-white/[0.02] border border-white/10 flex items-center justify-center ${p ? "order-2 lg:order-1" : "order-2"}`, children: h ? /* @__PURE__ */ s.jsx("img", { src: h, alt: f, className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center p-8", children: [
      /* @__PURE__ */ s.jsx(YN, { size: 40, className: "mx-auto mb-3 opacity-30", style: { color: g } }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-sm", children: d }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs mt-1", children: f })
    ] }) })
  ] }) });
}
function kC() {
  const n = window.__SHOOTZ_PRODUCTS__, i = window.__SHOOTZ_PRODUCT__, l = n?.q1 ?? (i?.handle !== "shootzinsight-q1-r1-bundle" ? i : null), o = n?.bundle ?? (i?.handle === "shootzinsight-q1-r1-bundle" ? i : null), d = i && o && i.id === o.id ? "bundle" : "q1", [f, h] = C.useState(d), [p, g] = C.useState(null), [m, b] = C.useState("overview"), [y, w] = C.useState(0), [S, T] = C.useState(!1), { addItem: _, loading: R } = ul(), z = f === "bundle" ? o : l, Q = z?.images.length ? z.images.map((V) => V.url) : qa, L = z?.variants.find((V) => V.id === p) ?? z?.variants.find((V) => V.availableForSale) ?? z?.variants[0], Y = !!(z && z.variants.length > 1), ae = z?.options[0]?.name ?? "Option", ee = ae.toLowerCase() === "color", Z = C.useMemo(() => {
    const V = uv.find((je) => je.id === f);
    if (!L) return V;
    const ie = Number.parseFloat(L.price.amount), he = L.compareAtPrice ? Number.parseFloat(L.compareAtPrice.amount) : V.originalPrice;
    return {
      ...V,
      price: Number.isFinite(ie) ? ie : V.price,
      originalPrice: Number.isFinite(he) ? he : V.originalPrice
    };
  }, [f, L]), k = async () => {
    L?.availableForSale && await _(L.id, 1);
  }, ne = [
    { id: "overview", label: "Overview" },
    { id: "specs", label: "Specs" },
    { id: "faq", label: "FAQs" }
  ];
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(
      ln,
      {
        title: "Buy ShootzInsight Q1 - AI Sports Recording System",
        description: "ShootzInsight Q1 records full-court basketball, finds made-basket moments, creates one-tap highlights, and shows real shooting data linked to video. Starting at $199.",
        keywords: "buy ShootzInsight Q1, AI sports recording system, basketball tracking, auto tracking, game moments, Highlight",
        url: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal"
      }
    ),
    /* @__PURE__ */ s.jsx("section", { id: "q1-purchase", className: "scroll-mt-24 pt-16 pb-12 md:pt-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs("div", { className: "grid min-w-0 gap-6 lg:grid-cols-2 lg:gap-16 items-start", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "order-1 w-full min-w-0 lg:sticky lg:top-24 lg:order-1", children: [
        /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.03] border border-white/10 mb-4", children: /* @__PURE__ */ s.jsx(
          "img",
          {
            src: Q[y] || Q[0],
            alt: y === 0 ? "Basketball game recorded by ShootzInsight Q1" : "ShootzInsight Q1",
            className: "h-full w-full object-contain p-4 sm:p-8"
          }
        ) }),
        /* @__PURE__ */ s.jsx("div", { className: "flex max-w-full gap-3 overflow-x-auto pb-1", children: Q.map((V, ie) => /* @__PURE__ */ s.jsx(
          "button",
          {
            onClick: () => w(ie),
            className: `w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${y === ie ? "border-[#FF6B35]" : "border-white/10 hover:border-white/30"}`,
            children: /* @__PURE__ */ s.jsx("img", { src: V, alt: "", className: "w-full h-full object-cover" })
          },
          ie
        )) })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "order-2 space-y-8 lg:order-2", children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] text-sm font-semibold tracking-widest uppercase mb-2", children: z?.title ?? "SHOOTZINSIGHT Q1 · AI BASKETBALL RECORDER" }),
          /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold leading-[0.95] text-white mb-3 md:text-5xl", children: "KNOW YOUR GAME." }),
          /* @__PURE__ */ s.jsxs("p", { className: "mb-4 text-sm font-medium text-[#55D681]", children: [
            "iPhone-only at launch · ",
            L?.availableForSale ? "In Stock" : "Sold Out"
          ] }),
          z?.descriptionHtml ? /* @__PURE__ */ s.jsx(
            "div",
            {
              className: "mb-4 text-sm leading-relaxed text-white/60 [&_br]:block [&_li]:ml-4 [&_li]:list-disc [&_p]:mb-2 [&_p:last-child]:mb-0",
              dangerouslySetInnerHTML: { __html: z.descriptionHtml }
            }
          ) : /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm leading-relaxed mb-4", children: "Record every game. Find your scoring moments. Create highlights and see your game in numbers — automatically." }),
          /* @__PURE__ */ s.jsxs("ul", { className: "space-y-2.5 text-white/70 text-sm", children: [
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Free Scoring Moments — browse made-basket clips without scrubbing full film"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " One-Tap Highlight — landscape-to-vertical, slow-mo, beat-synced music"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Game Numbers — 2PT / 3PT / FT breakdown and FG%"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Full-Court AI Tracking & Free Live Streaming"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " RC1 Remote included"
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 inline-flex items-center gap-2 rounded-full border border-[#55D681]/25 bg-[#55D681]/10 px-3 py-1.5", children: [
            /* @__PURE__ */ s.jsx(sc, { size: 13, className: "text-[#55D681]" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold text-[#55D681]", children: "800 AI credits included" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsxs("p", { className: "text-white font-semibold mb-3 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(nl, { size: 16, className: "text-[#FF6B35]" }),
            " Choose Your Setup"
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: uv.map((V) => {
            const ie = V.id === "bundle" ? o : l, he = ie?.variants.find((X) => X.availableForSale) ?? ie?.variants[0], je = !ie || !he?.availableForSale, ke = he ? Number.parseFloat(he.price.amount) : V.price, Se = he?.compareAtPrice ? Number.parseFloat(he.compareAtPrice.amount) : V.originalPrice, O = Se > ke ? `SAVE $${(Se - ke).toFixed(0)}` : V.badge;
            return /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => {
                  je || (h(V.id), g(null), w(0));
                },
                disabled: je,
                className: `w-full text-left p-4 rounded-xl border transition-all ${je ? "border-white/5 bg-white/[0.01] opacity-50 cursor-not-allowed" : f === V.id ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-white/10 bg-white/[0.02] hover:border-white/20"}`,
                children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ s.jsx("div", { className: `w-4 h-4 rounded-full border-2 flex items-center justify-center ${f === V.id ? "border-[#FF6B35]" : "border-white/30"}`, children: f === V.id && /* @__PURE__ */ s.jsx("div", { className: "w-2 h-2 rounded-full bg-[#FF6B35]" }) }),
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: V.name }),
                      O && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-[#FF6B35]", children: O }),
                      je && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white/60 bg-white/10 rounded-full", children: ie ? "SOLD OUT" : "NOT CONFIGURED" }),
                      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: ie?.title ?? V.subtitle })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "text-right", children: [
                    /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold", children: [
                      "$",
                      ke.toFixed(2)
                    ] }),
                    Se > ke && /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-sm line-through ml-2", children: [
                      "$",
                      Se.toFixed(2)
                    ] })
                  ] })
                ] })
              },
              V.id
            );
          }) })
        ] }),
        Y && /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsxs("p", { className: "text-white font-semibold mb-3 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(ZN, { size: 16, className: "text-[#FF6B35]" }),
            " Choose ",
            ae
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-3", children: z.variants.map((V) => {
            const ie = L?.id === V.id, he = V.selectedOptions.map((Se) => Se.value).join(" / "), je = he.toLowerCase(), ke = je === "black" ? "#0a0a0a" : je === "white" ? "#f5f5f5" : "#7a7a7a";
            return /* @__PURE__ */ s.jsxs(
              "button",
              {
                type: "button",
                onClick: () => g(V.id),
                disabled: !V.availableForSale,
                "aria-pressed": ie,
                className: `flex min-w-0 items-center gap-3 rounded-xl border px-4 py-3 text-left transition-all ${ie ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-white/10 bg-white/[0.02] hover:border-white/25"} disabled:cursor-not-allowed disabled:opacity-40`,
                children: [
                  ee && /* @__PURE__ */ s.jsx(
                    "span",
                    {
                      className: "h-5 w-5 shrink-0 rounded-full border border-white/25",
                      style: { backgroundColor: ke },
                      "aria-hidden": "true"
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: "min-w-0 flex-1 truncate text-sm font-medium text-white", children: he }),
                  ie && /* @__PURE__ */ s.jsx(Yt, { size: 15, className: "shrink-0 text-[#FF6B35]" })
                ]
              },
              V.id
            );
          }) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "p-5 rounded-xl bg-white/[0.03] border border-white/10 space-y-3", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
            /* @__PURE__ */ s.jsx("span", { className: "text-white/60", children: Z.name }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white font-medium", children: [
              "$",
              Z.price.toFixed(2)
            ] })
          ] }),
          Z.originalPrice > Z.price && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
            /* @__PURE__ */ s.jsxs("span", { className: "text-green-400 text-xs", children: [
              "You save $",
              (Z.originalPrice - Z.price).toFixed(2)
            ] }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-xs line-through", children: [
              "$",
              Z.originalPrice.toFixed(2)
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "border-t border-white/10 pt-3 flex justify-between items-center", children: [
            /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold", children: "Total" }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold text-2xl", children: [
              "$",
              Z.price.toFixed(2)
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: k,
              disabled: !L?.availableForSale || R,
              className: "w-full py-4 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 mt-2",
              children: [
                R ? /* @__PURE__ */ s.jsx(zs, { size: 20, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(Os, { size: 20 }),
                z ? L?.availableForSale ? `Add to Cart — $${Z.price.toFixed(2)}` : "Sold Out" : "Configure product in Shopify"
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-2 pt-1 sm:grid-cols-4", children: [
            { icon: Wv, label: "Free US Shipping" },
            { icon: xf, label: "Free US Returns" },
            { icon: Yt, label: "15-Day Money-Back" },
            { icon: $v, label: "1-Year Warranty" }
          ].map((V) => /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center gap-1 rounded-lg bg-white/[0.02] px-2 py-2 text-center", children: [
            /* @__PURE__ */ s.jsx(V.icon, { size: 15, className: "text-white/60" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[11px] font-medium leading-tight text-white/50", children: V.label })
          ] }, V.label)) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm font-medium mb-2", children: "What's in the box:" }),
          /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap gap-2", children: Z.items.map((V) => /* @__PURE__ */ s.jsx("span", { className: "px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/10 text-white/60 text-xs", children: V }, V)) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "rounded-xl border border-white/10 overflow-hidden", children: [
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: () => T(!S),
              className: "w-full flex items-center justify-between p-4 bg-white/[0.03] hover:bg-white/[0.05] transition-colors",
              children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ s.jsx(Oh, { size: 18, className: "text-[#FF6B35]" }),
                  /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold text-sm", children: "Start Free. Upgrade When You Need More." })
                ] }),
                S ? /* @__PURE__ */ s.jsx(Zv, { size: 16, className: "text-white/40" }) : /* @__PURE__ */ s.jsx(tl, { size: 16, className: "text-white/40" })
              ]
            }
          ),
          S && /* @__PURE__ */ s.jsxs("div", { className: "p-4 space-y-4 border-t border-white/10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 px-3 py-2 rounded-lg bg-[#FF6B35]/10 border border-[#FF6B35]/20", children: [
              /* @__PURE__ */ s.jsx(vf, { size: 14, className: "text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] text-xs font-semibold", children: "Purchase includes 800 free credits to get started!" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm leading-relaxed", children: "Q1 works standalone. Recording and Scoring Moments are included free. Your 800 AI credits let you try premium cloud features such as finished Highlight creation and deeper game analysis." }),
            /* @__PURE__ */ s.jsxs("p", { className: "text-white/40 text-[11px] text-center leading-relaxed", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/60 font-medium", children: "Q1 works standalone." }),
              " AI Moments are free forever. Subscription is optional for advanced cloud features."
            ] })
          ] })
        ] })
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-t border-white/10 sticky top-[64px] z-30 bg-[#0a0a0a]/95 backdrop-blur-sm", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx("div", { className: "flex overflow-x-auto", children: ne.map((V) => /* @__PURE__ */ s.jsx(
      "button",
      {
        onClick: () => b(V.id),
        className: `px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-all ${m === V.id ? "border-[#FF6B35] text-[#FF6B35]" : "border-transparent text-white/50 hover:text-white/70"}`,
        children: V.label
      },
      V.id
    )) }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-5xl", children: [
      m === "overview" && /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", animate: "visible", variants: { visible: { transition: { staggerChildren: 0.1 } } }, children: [
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mb-20 text-center", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: [
            "WHAT SHOOTZINSIGHT Q1 IS ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "BUILT FOR" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 max-w-2xl mx-auto mb-12", children: "More than a tracker: full-game recording, browsable Scoring Moments, shareable Highlights, and limited real shooting numbers." }),
          /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-3 gap-6 max-w-3xl mx-auto", children: [
            { step: "1", label: "RECORD", desc: "Full-court AI tracking captures the game automatically." },
            { step: "2", label: "ANALYZE", desc: "Scoring Moments and limited game numbers are organized after processing." },
            { step: "3", label: "SHARE", desc: "Create and export vertical Highlights from selected plays." }
          ].map((V, ie) => /* @__PURE__ */ s.jsxs("div", { className: "relative p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
            /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-full bg-[#FF6B35]/10 border border-[#FF6B35]/30 flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-bold text-lg", children: V.step }) }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-white mb-2", children: V.label }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: V.desc }),
            ie < 2 && /* @__PURE__ */ s.jsx("div", { className: "hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-white/10" })
          ] }, V.step)) })
        ] }),
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mb-8 mt-8", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Record" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "CAPTURE ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "EVERY GAME" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "Mount Q1, open the app, and let AI tracking keep the action in frame from tip-off to the last buzzer." })
        ] }),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "AI AUTO-TRACKING",
            title: "Capture Every Game",
            description: "Mount Q1 with your iPhone and record hands-free while Q1 follows the basketball action across the full court.",
            bullets: [
              "Hands-free tracking for indoor and outdoor courts",
              "Smooth pan and tilt — no jerky movements",
              "Built for youth games, school teams, and clubs"
            ],
            imagePlaceholder: "[Full-Court Tracking Demo]",
            imageAlt: "Show: Wide shot of basketball court with tracking overlay showing system movement path",
            imageSrc: bn?.fullCourtTracking || qa[0],
            reversed: !0
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "REMOTE MONITORING",
            title: "See What Q1 Sees",
            description: "Check framing, start and stop recording, and monitor status from courtside.",
            bullets: [
              "Real-time live preview on your phone",
              "Start/stop recording remotely",
              "Monitor battery, storage, and connection status",
              "RC1 remote for quick physical control"
            ],
            imagePlaceholder: "[Monitor & Control Interface]",
            imageAlt: "Real ShootzInsight phone screen showing the recorded live feed and recording controls",
            imageSrc: bn?.monitorControl || qa[0]
          }
        ),
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mb-8 mt-24", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Analyze" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "FIND THE PLAYS THAT ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "MATTER" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "After the game, made-basket Moments are organized so you do not have to rewind through the whole recording." })
        ] }),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "SCORING MOMENTS — FREE WITH Q1",
            title: "Your Player's Scoring Moments",
            description: "Q1 records the whole game and detects made baskets into a browsable Moments library. Review thumbnails quickly, choose the plays you want, and leave the gym with clips worth keeping.",
            bullets: [
              "Free forever with Q1",
              "Made-basket Moments organized automatically",
              "Thumbnail-first browsing instead of manual scrubbing",
              "Easy selection for Highlight creation"
            ],
            imagePlaceholder: "[AI Moments Interface Screenshot]",
            imageAlt: "ShootzInsight app showing Scoring Moment thumbnails after a basketball game",
            imageSrc: bn?.aiMoments || qa[0],
            accentColor: "#22c55e"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "GAME ANALYTICS",
            title: "See Your Game in Numbers",
            description: "Review the scoring fundamentals behind each game, then jump back to the clip behind the number.",
            bullets: [
              "2PT / 3PT / FT shooting breakdown",
              "Field-goal percentage (FG%)",
              "Every stat linked to its video clip — tap to jump to that play",
              "More Game Insights Are Coming"
            ],
            imagePlaceholder: "[Game Analytics Dashboard Screenshot]",
            imageAlt: "Game analytics view showing approved 2PT, 3PT, free throw, and field-goal percentage data linked to video",
            imageSrc: bn?.gameAnalytics || qa[0],
            reversed: !0,
            accentColor: "#eab308"
          }
        ),
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mb-8 mt-24", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Share" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "SHARE YOUR ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "HIGHLIGHTS" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "From selected Moments to social-ready output — one tap creates your Highlight." })
        ] }),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "ONE-TAP HIGHLIGHT",
            title: "Your Highlights. One Tap.",
            description: "Choose the Moments you want and generate a cinematic vertical highlight — reframed from landscape game footage with music and transitions.",
            bullets: [
              "Smart landscape-to-vertical reframe — AI keeps the action centered",
              "Slow-mo on key plays, beat-synced music",
              "Dynamic transitions & cinematic effects",
              "Export for TikTok, Instagram Reels, YouTube Shorts, and recruiting conversations"
            ],
            imagePlaceholder: "[One-Tap Highlight Interface Screenshot]",
            imageAlt: "Landscape basketball footage converted into a vertical highlight reel in the ShootzInsight app",
            imageSrc: bn?.oneTapHighlight || qa[0],
            accentColor: "#FF6B35"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "FREE LIVE STREAMING",
            title: "Stream Every Game. Free.",
            description: "Share the game with fans who cannot be there. Stream while recording — free and unlimited.",
            bullets: [
              "One-tap streaming to YouTube, Facebook, and custom RTMP",
              "Free and unlimited — no monthly fees",
              "Useful for AAU, clubs, training facilities, and tournaments",
              "Share a link instantly"
            ],
            imagePlaceholder: "[Live Streaming Interface]",
            imageAlt: "Show: App streaming UI with YouTube/Facebook icons and live viewer count",
            imageSrc: bn?.liveStreaming || qa[0],
            reversed: !0
          }
        ),
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mt-24 mb-20", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-12 text-center", children: [
            "READY IN ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "30 SECONDS" })
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-3 gap-8", children: [
            { step: "1", title: "Mount & Power On", desc: "Place Q1 on any tripod (or the R1), mount your phone, power on, and open the ShootzInsight App.", img: bn?.setupInstall },
            { step: "2", title: "Connect & Select", desc: "Auto-connect via Bluetooth. Select basketball mode and confirm the court view.", img: bn?.setupConnect },
            { step: "3", title: "Hit Record", desc: "Tap record. Q1 handles tracking, recording, and made-basket detection automatically.", img: bn?.setupRecord }
          ].map((V) => /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "aspect-[4/3] rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 flex items-center justify-center mb-5", children: V.img ? /* @__PURE__ */ s.jsx("img", { src: V.img, alt: `${V.title} setup`, className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs", children: "[Setup step 3 photo]" }) }),
            /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 rounded-full bg-[#FF6B35]/10 border border-[#FF6B35]/30 flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-bold text-xl", children: V.step }) }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: V.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: V.desc })
          ] }, V.step)) })
        ] }),
        /* @__PURE__ */ s.jsxs(E.div, { variants: ki, className: "mb-20", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-12 text-center", children: [
            "WHAT'S ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "INCLUDED" })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "grid md:grid-cols-2 gap-10 items-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.02] border border-white/10 flex items-center justify-center", children: bn?.inTheBox ? /* @__PURE__ */ s.jsx("img", { src: bn.inTheBox, alt: "What's included with ShootzInsight Q1", className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsx(nl, { size: 48, className: "text-[#FF6B35]/30" }) }),
            /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
              [
                { name: "ShootzInsight Q1 Unit", desc: "AI-powered recording system with full-court tracking" },
                { name: "RC1 Remote Control", desc: "Bluetooth remote with record start/stop and score +/- buttons" },
                { name: "USB-C Charging Cable", desc: "Fast charging cable for Q1" },
                { name: "Carry Pouch", desc: "Protective carrying pouch for transport" },
                { name: "Quick Start Guide", desc: "Get recording in under 30 seconds" }
              ].map((V) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx(Yt, { size: 16, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
                /* @__PURE__ */ s.jsxs("div", { children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-white font-medium text-sm", children: V.name }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs", children: V.desc })
                ] })
              ] }, V.name)),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-4 pl-4", children: "* R1 Professional Tripod included with the Q1 + R1 Bundle" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(
          Ti,
          {
            subtitle: "INCLUDED WITH EVERY Q1",
            title: "Control from Courtside",
            description: "Start, stop, and control recording without touching your phone. The RC1 connects via Bluetooth and includes dedicated score +/- buttons — so the scoreboard is always synced with your footage for accurate AI analysis.",
            bullets: [
              "One-press record start/stop",
              "Score +/- buttons for live game tracking",
              "Bluetooth connection with responsive controls",
              "Compact clip-on design — attach to clipboard or pocket"
            ],
            imagePlaceholder: "[RC1 Remote Control Photo]",
            imageAlt: "Show: Close-up of RC1 remote with buttons labeled",
            imageSrc: bn?.remoteControl || qa[0],
            reversed: !0
          }
        )
      ] }),
      m === "specs" && /* @__PURE__ */ s.jsxs(E.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, children: [
        /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white mb-8 text-center", children: [
          "TECHNICAL ",
          /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "SPECIFICATIONS" })
        ] }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-center text-sm mb-8", children: "ShootzInsight Q1 AI Tracking System — recording resolution depends on your phone" }),
        /* @__PURE__ */ s.jsx("div", { className: "max-w-2xl mx-auto", children: /* @__PURE__ */ s.jsx("table", { className: "w-full", children: /* @__PURE__ */ s.jsx("tbody", { children: dv.map((V, ie) => /* @__PURE__ */ s.jsxs("tr", { className: ie < dv.length - 1 ? "border-b border-white/5" : "", children: [
          /* @__PURE__ */ s.jsx("td", { className: "py-4 text-white/50 text-sm", children: V.label }),
          /* @__PURE__ */ s.jsx("td", { className: "py-4 text-white text-sm font-medium text-right", children: V.value })
        ] }, V.label)) }) }) }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-16 max-w-2xl mx-auto", children: [
          /* @__PURE__ */ s.jsxs("h3", { className: "font-[family-name:var(--font-display)] text-2xl font-bold text-white mb-6 text-center", children: [
            "R1 PROFESSIONAL ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "TRIPOD" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center text-sm mb-6", children: "Included with the Q1 + R1 Bundle" }),
          /* @__PURE__ */ s.jsx("table", { className: "w-full", children: /* @__PURE__ */ s.jsx("tbody", { children: [
            { label: "Max Height", value: "200 cm (6.56 ft)" },
            { label: "Min Height", value: "0.6m (2 ft)" },
            { label: "Material", value: "Carbon fiber + aluminum alloy" },
            { label: "Weight", value: "1.8 kg (3.97 lbs)" },
            { label: "Load Capacity", value: "5 kg (11 lbs)" },
            { label: "Folded Length", value: "58 cm (22.8 in)" },
            { label: "Mount", value: '1/4" universal screw' }
          ].map((V, ie) => /* @__PURE__ */ s.jsxs("tr", { className: ie < 6 ? "border-b border-white/5" : "", children: [
            /* @__PURE__ */ s.jsx("td", { className: "py-3 text-white/50 text-sm", children: V.label }),
            /* @__PURE__ */ s.jsx("td", { className: "py-3 text-white text-sm font-medium text-right", children: V.value })
          ] }, V.label)) }) })
        ] })
      ] }),
      m === "faq" && /* @__PURE__ */ s.jsxs(E.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, children: [
        /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white mb-8 text-center", children: [
          "FREQUENTLY ASKED ",
          /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "QUESTIONS" })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "max-w-3xl mx-auto", children: CC.map((V) => /* @__PURE__ */ s.jsx(EC, { q: V.q, a: V.a }, V.q)) })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-t border-white/10 py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-5xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "rounded-2xl border border-white/10 bg-white/[0.02] p-6 md:p-8", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "mx-auto mb-4 inline-flex items-center gap-2 rounded-full border border-[#55D681]/25 bg-[#55D681]/10 px-3 py-1.5", children: [
            /* @__PURE__ */ s.jsx(sc, { size: 14, className: "text-[#55D681]" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold text-[#55D681]", children: "800 AI credits included" })
          ] }),
          /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white mb-4 md:text-4xl", children: "START FREE. UPGRADE WHEN YOU NEED MORE." }),
          /* @__PURE__ */ s.jsx("p", { className: "mx-auto max-w-2xl text-white/60 leading-relaxed", children: "Q1 works standalone. Recording and Scoring Moments are included free. 800 AI credits let you try premium cloud features such as finished Highlight creation and deeper game analysis." })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "mt-8 grid gap-4 sm:grid-cols-3", children: [
          { label: "Buy Q1", desc: "Includes recording and free Scoring Moments." },
          { label: "Use credits", desc: "Try premium cloud features when needed." },
          { label: "Upgrade later", desc: "Only if your workflow needs more volume." }
        ].map((V) => /* @__PURE__ */ s.jsxs("div", { className: "p-4 text-center rounded-xl border border-white/5 bg-white/[0.02]", children: [
          /* @__PURE__ */ s.jsx("p", { className: "font-semibold text-white", children: V.label }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-sm text-white/50", children: V.desc })
        ] }, V.label)) })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "mt-14 text-center", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-4 md:text-6xl", children: "KNOW YOUR GAME." }),
        /* @__PURE__ */ s.jsx("p", { className: "mx-auto max-w-xl text-white/60", children: "Record every game. Find your scoring moments. Create your highlights." }),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            onClick: k,
            disabled: !L?.availableForSale || R,
            className: "mx-auto mt-8 flex items-center justify-center gap-3 rounded-xl bg-[#FF6B35] px-8 py-4 text-lg font-bold text-white transition-all hover:bg-[#FF6B35]/90 active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-50",
            children: [
              R ? /* @__PURE__ */ s.jsx(zs, { size: 20, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(Os, { size: 20 }),
              "Buy ",
              Z.name,
              " — $",
              Z.price.toFixed(0)
            ]
          }
        ),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-5 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-white/50", children: [
          /* @__PURE__ */ s.jsx("span", { children: "Free US Shipping" }),
          /* @__PURE__ */ s.jsx("span", { children: "15-Day Money-Back Guarantee" }),
          /* @__PURE__ */ s.jsx("span", { children: "1-Year Warranty" })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold text-lg", children: [
          "$",
          Z.price.toFixed(2)
        ] }),
        /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-xs", children: Z.name })
      ] }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: k,
          disabled: !L?.availableForSale || R,
          className: "px-6 py-3 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2",
          children: [
            R ? /* @__PURE__ */ s.jsx(zs, { size: 18, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(Os, { size: 18 }),
            "Add to Cart"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "h-[72px] md:hidden" })
  ] });
}
const MC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kC
}, Symbol.toStringTag, { value: "Module" }));
function zC({
  product: n,
  galleryImages: i = [],
  eyebrow: l,
  fallbackTitle: o = "ShootzInsight Q1",
  descriptionFallback: d,
  bullets: f = [],
  trustText: h = "Free shipping • 15-day returns • 1-year warranty",
  boxItems: p,
  accentColor: g = "#FF6B35",
  selectedVariantId: m,
  onVariantChange: b
}) {
  const { addItem: y, loading: w } = ul(), [S, T] = C.useState(0), [_, R] = C.useState(null), z = m !== void 0 ? m : _, Q = (k) => {
    b ? b(k) : R(k);
  }, L = C.useMemo(
    () => i.length ? i.map((k) => ({
      url: k,
      alt: n?.title ?? o
    })) : n?.images.length ? n.images.map((k) => ({ url: k.url, alt: k.altText })) : [],
    [o, i, n]
  ), Y = C.useMemo(() => {
    if (n?.variants?.length)
      return n.variants.find((k) => k.id === z) ?? n.variants.find((k) => k.availableForSale) ?? n.variants[0];
  }, [n, z]), ae = !!(n && n.variants.length > 1), ee = C.useMemo(() => {
    if (!Y) return null;
    const k = Number.parseFloat(Y.price.amount), ne = Y.compareAtPrice ? Number.parseFloat(Y.compareAtPrice.amount) : null;
    return {
      amount: Number.isFinite(k) ? k : 0,
      compareAt: ne !== null && Number.isFinite(ne) ? ne : null
    };
  }, [Y]), Z = async () => {
    Y?.availableForSale && await y(Y.id, 1);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "grid min-w-0 lg:grid-cols-2 gap-10 lg:gap-16 items-start", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "w-full min-w-0 lg:sticky lg:top-24", children: [
      /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.03] border border-white/10 mb-4", children: L.length > 0 ? /* @__PURE__ */ s.jsx(
        "img",
        {
          src: L[S]?.url ?? L[0]?.url,
          alt: L[S]?.alt ?? n?.title ?? o,
          className: "w-full max-w-full h-full object-contain p-8"
        }
      ) : /* @__PURE__ */ s.jsx("div", { className: "w-full h-full flex items-center justify-center", children: /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
        /* @__PURE__ */ s.jsx(nl, { size: 48, className: "mx-auto mb-3 opacity-30", style: { color: g } }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-sm", children: "Product Image" })
      ] }) }) }),
      L.length > 1 && /* @__PURE__ */ s.jsx("div", { className: "flex gap-3", children: L.map((k, ne) => /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: () => T(ne),
          className: `w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${S === ne ? "border-[#FF6B35]" : "border-white/10 hover:border-white/30"}`,
          children: /* @__PURE__ */ s.jsx("img", { src: k.url, alt: "", className: "w-full h-full object-cover" })
        },
        ne
      )) })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-8", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        l && /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] text-sm font-semibold tracking-widest uppercase mb-2", children: l }),
        /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-3", children: n?.title || o }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
          /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-1", children: [1, 2, 3, 4, 5].map((k) => /* @__PURE__ */ s.jsx(vf, { size: 14, className: "text-[#FFD700] fill-[#FFD700]" }, k)) }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white/50 text-sm", children: n ? Y?.availableForSale ? "In Stock" : "Sold Out" : "Not configured" })
        ] }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm leading-relaxed mb-4", children: n?.description || d }),
        f.length > 0 && /* @__PURE__ */ s.jsx("ul", { className: "space-y-2.5 text-white/70 text-sm", children: f.map((k) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
          /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
          " ",
          k
        ] }, k)) })
      ] }),
      ae && n && /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsxs("p", { className: "text-white font-semibold mb-3 flex items-center gap-2", children: [
          /* @__PURE__ */ s.jsx(nl, { size: 16, style: { color: g } }),
          " Choose Your Option"
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: n.variants.map((k) => {
          const ne = Y?.id === k.id, V = k.compareAtPrice && Number.parseFloat(k.compareAtPrice.amount) > Number.parseFloat(k.price.amount) ? Number.parseFloat(k.compareAtPrice.amount) - Number.parseFloat(k.price.amount) : null;
          return /* @__PURE__ */ s.jsx(
            "button",
            {
              onClick: () => {
                k.availableForSale && Q(k.id);
              },
              disabled: !k.availableForSale,
              className: `w-full text-left p-4 rounded-xl border transition-all ${k.availableForSale ? ne ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-white/10 bg-white/[0.02] hover:border-white/20" : "border-white/5 bg-white/[0.01] opacity-50 cursor-not-allowed"}`,
              children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: `w-4 h-4 rounded-full border-2 flex items-center justify-center ${ne ? "border-[#FF6B35]" : "border-white/30"}`,
                      children: ne && /* @__PURE__ */ s.jsx("div", { className: "w-2 h-2 rounded-full bg-[#FF6B35]" })
                    }
                  ),
                  /* @__PURE__ */ s.jsxs("div", { children: [
                    /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: k.title }),
                    V !== null && /* @__PURE__ */ s.jsxs("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-[#FF6B35]", children: [
                      "SAVE $",
                      V.toFixed(0)
                    ] }),
                    !k.availableForSale && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white/60 bg-white/10 rounded-full", children: "SOLD OUT" }),
                    /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: k.selectedOptions.map((ie) => `${ie.name}: ${ie.value}`).join(" · ") })
                  ] })
                ] }),
                /* @__PURE__ */ s.jsxs("div", { className: "text-right", children: [
                  /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold", children: [
                    "$",
                    Number.parseFloat(k.price.amount).toFixed(2)
                  ] }),
                  V !== null && /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-sm line-through ml-2", children: [
                    "$",
                    Number.parseFloat(k.compareAtPrice.amount).toFixed(2)
                  ] })
                ] })
              ] })
            },
            k.id
          );
        }) })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "p-5 rounded-xl bg-white/[0.03] border border-white/10 space-y-3", children: [
        ae && Y && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white/60", children: Y.title }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: ee ? `$${ee.amount.toFixed(2)}` : "—" })
        ] }),
        ae && ee?.compareAt !== null && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
          /* @__PURE__ */ s.jsxs("span", { className: "text-green-400 text-xs", children: [
            "You save $",
            ((ee?.compareAt ?? 0) - (ee?.amount ?? 0)).toFixed(2)
          ] }),
          /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-xs line-through", children: [
            "$",
            (ee?.compareAt ?? 0).toFixed(2)
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "border-t border-white/10 pt-3 flex justify-between items-center", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold", children: "Total" }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-bold text-2xl", children: ee ? `$${ee.amount.toFixed(2)}` : "—" })
        ] }),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            onClick: Z,
            disabled: !Y?.availableForSale || w,
            className: "w-full py-4 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 mt-2",
            children: [
              w ? /* @__PURE__ */ s.jsx(zs, { size: 20, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(Os, { size: 20 }),
              n ? Y?.availableForSale ? `Add to Cart — ${ee ? `$${ee.amount.toFixed(2)}` : ""}` : "Sold Out" : "Configure product in Shopify"
            ]
          }
        ),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs text-center", children: h })
      ] }),
      p && p.length > 0 && /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm font-medium mb-2", children: "What's in the box:" }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-2.5", children: p.map((k) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 p-3 rounded-xl bg-white/[0.02] border border-white/5", children: [
          /* @__PURE__ */ s.jsx(Yt, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-medium text-sm", children: k.name }),
            k.desc && /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs", children: k.desc })
          ] })
        ] }, k.name)) })
      ] })
    ] })
  ] });
}
const Ai = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
}, Po = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } }, OC = [
  {
    icon: KN,
    title: "Adjustable Height",
    desc: "Extends from 60cm to 200cm. Find the perfect angle whether you're courtside, in the bleachers, or on the sideline."
  },
  {
    icon: rT,
    title: "Rock-Solid Stability",
    desc: "Anti-vibration base with weighted center column. Your Q1 stays steady even when the crowd goes wild."
  },
  {
    icon: xf,
    title: "360° Ball Head",
    desc: "Smooth pan and tilt adjustment. Lock into position with a single twist. Quick-release plate for fast setup."
  },
  {
    icon: tT,
    title: "Built for Outdoors",
    desc: "Aluminum alloy construction, weather-resistant finish. Handles rain, dust, and extreme temperatures from -10°C to 50°C."
  }
], hv = [
  { label: "Model", value: "ShootzInsight R1" },
  { label: "Material", value: "Aerospace-grade Aluminum Alloy" },
  { label: "Min Height", value: "60 cm (23.6 in)" },
  { label: "Max Height", value: "200 cm (78.7 in)" },
  { label: "Folded Length", value: "48 cm (18.9 in)" },
  { label: "Weight", value: "1.2 kg (2.6 lbs)" },
  { label: "Max Load", value: "5 kg (11 lbs)" },
  { label: "Leg Sections", value: "4" },
  { label: "Compatibility", value: 'ShootzInsight Q1, standard 1/4" mount' },
  { label: "Color", value: "Matte Black" }
];
function RC() {
  const n = window.__SHOOTZ_PRODUCTS__?.tripod ?? window.__SHOOTZ_PRODUCT__, i = window.__SHOOTZ_CONFIG__?.media?.r1Gallery ?? [], [l, o] = C.useState(null), { addItem: d, loading: f } = ul(), h = C.useMemo(() => {
    if (n?.variants?.length)
      return n.variants.find((m) => m.id === l) ?? n.variants.find((m) => m.availableForSale) ?? n.variants[0];
  }, [n, l]), p = h ? `$${Number.parseFloat(h.price.amount).toFixed(2)}` : null, g = async () => {
    h?.availableForSale && await d(h.id, 1);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(
      ln,
      {
        title: n?.title || "ShootzInsight R1 Tripod - Purpose-Built Sports Mount",
        description: n?.description || "The purpose-built mount for your ShootzInsight Q1. Adjustable height, rock-solid stability, and 30-second setup. Designed for courts, fields, and gyms.",
        keywords: "ShootzInsight R1, sports tripod, Q1 mount, basketball recording tripod",
        url: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod"
      }
    ),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[80px] pb-12", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      zC,
      {
        product: n,
        galleryImages: i,
        eyebrow: "ACCESSORY",
        fallbackTitle: "ShootzInsight R1 Tripod",
        descriptionFallback: "The purpose-built mount for your ShootzInsight Q1. Set up in seconds, capture every angle. Designed for courts, fields, and gyms.",
        bullets: [
          "Adjustable height — 60cm to 200cm for any courtside angle",
          "Rock-solid anti-vibration base for steady AI tracking",
          "360° ball head with quick-release plate",
          "Weather-resistant, built for outdoor courts"
        ],
        boxItems: [
          { name: "ShootzInsight R1 Tripod", desc: "Aluminum alloy, extends to 200cm" },
          { name: "Quick-Release Plate", desc: "One-click Q1 mounting" },
          { name: "Carry Bag", desc: "Padded storage for transport" },
          { name: "Quick Start Guide", desc: "Setup in 30 seconds" }
        ],
        selectedVariantId: l,
        onVariantChange: o
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-4xl", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-14",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: [
            /* @__PURE__ */ s.jsxs(E.h2, { variants: Ai, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: [
              "ENGINEERED FOR ",
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME DAY" })
            ] }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Ai, className: "text-white/50 mt-3 max-w-lg mx-auto", children: "Not just any tripod. R1 is designed specifically for sports recording environments." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: OC.map((m) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: Ai,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(m.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: m.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: m.desc })
              ]
            },
            m.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-4xl", children: [
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "text-center mb-14",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: /* @__PURE__ */ s.jsxs(E.h2, { variants: Ai, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: [
            "SETUP IN ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "30 SECONDS" })
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid md:grid-cols-3 gap-8",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: [
            { step: "1", title: "Extend & Lock", desc: "Pull legs to desired height. Flip-lock clamps secure each section instantly." },
            { step: "2", title: "Mount Q1", desc: "Slide Q1 onto the quick-release plate. One click and it's locked in place." },
            { step: "3", title: "Aim & Record", desc: "Adjust the ball head to frame the court. Tighten the lock knob. You're live." }
          ].map((m) => /* @__PURE__ */ s.jsxs(E.div, { variants: Ai, className: "text-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 rounded-full bg-[#FF6B35] text-white font-bold text-lg flex items-center justify-center mx-auto mb-4", children: m.step }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-lg font-semibold text-white mb-2", children: m.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: m.desc })
          ] }, m.step))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-3xl", children: [
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "text-center mb-10",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ai,
          children: /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "SPECIFICATIONS" })
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "rounded-xl border border-white/10 overflow-hidden",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ai,
          children: hv.map((m, b) => /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: `flex justify-between items-center px-6 py-4 ${b < hv.length - 1 ? "border-b border-white/5" : ""}`,
              children: [
                /* @__PURE__ */ s.jsx("span", { className: "text-white/50 text-sm", children: m.label }),
                /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium text-sm", children: m.value })
              ]
            },
            m.label
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ s.jsx("span", { className: "text-white font-bold text-lg", children: p || "—" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-xs", children: n?.title || "R1 Tripod" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: g,
          disabled: !h?.availableForSale || f,
          className: "px-6 py-3 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2",
          children: [
            f ? /* @__PURE__ */ s.jsx(zs, { size: 18, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(Os, { size: 18 }),
            "Add to Cart"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "h-[72px] md:hidden" })
  ] });
}
const _C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: RC
}, Symbol.toStringTag, { value: "Module" })), DC = "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp", Tt = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ia = { visible: { transition: { staggerChildren: 0.1 } } }, FC = [
  {
    icon: gf,
    title: "Ball & Player Tracking",
    desc: "Our AI simultaneously tracks ball movement and player positions, keeping the action centered and smooth — even during fast breaks."
  },
  {
    icon: HN,
    title: "Court-Aware Framing",
    desc: "Intelligent framing adapts to basketball court geometry. Wide shots for half-court sets, tight follow for drives and transitions."
  },
  {
    icon: rc,
    title: "Made-Basket Detection",
    desc: "After processing, AI identifies threes, twos and free throws into Moments for each scoring play."
  },
  {
    icon: cT,
    title: "Fast-Paced Action",
    desc: "AI-powered tracking is built to keep pace with transition plays and fast breaks across the full court."
  }
], BC = [
  {
    icon: ol,
    title: "AI Moments",
    badge: "FREE",
    desc: "AI organizes made baskets into a browsable library. Review thumbnail previews and select the clips you want to keep or turn into a highlight."
  },
  {
    icon: bc,
    title: "One-Tap Highlight",
    badge: "PREMIUM",
    desc: "One tap turns your Moments into a Highlight — landscape to vertical, slow-mo on key plays, music synced to the beat. Your recruiting tape, done."
  },
  {
    icon: Ds,
    title: "Game Analytics",
    badge: "PREMIUM",
    desc: "Review FG% and the 3PT / 2PT / FT split — with results linked to their source clips. More insights are planned for future updates."
  }
], VC = [
  { label: "Field Goal Percentage", desc: "Shooting efficiency connected to game film" },
  { label: "3PT / 2PT / FT Split", desc: "Scoring categories made clear at a glance" },
  { label: "Linked Clips", desc: "Jump from the number to the play behind it" },
  { label: "More Insights", desc: "Additional player and team dimensions are coming soon" }
];
function HC() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "Basketball - AI Recording for Every Game", description: "Capture basketball games with AI auto-tracking, browse made-basket moments, create one-tap highlights, and review shooting data linked to film.", keywords: "basketball recording system, basketball highlights, basketball analytics, youth basketball recording", url: "/pages/basketball" }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative pt-[72px] min-h-[85vh] flex items-center overflow-hidden", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
        /* @__PURE__ */ s.jsx("img", { src: DC, alt: "", className: "w-full h-full object-cover opacity-30" }),
        /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/50 via-[#0a0a0a]/30 to-[#0a0a0a]" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "container mx-auto relative z-10 py-20",
          initial: "hidden",
          animate: "visible",
          variants: Ia,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Basketball" }),
            /* @__PURE__ */ s.jsxs(E.h1, { variants: Tt, className: "font-[family-name:var(--font-display)] text-5xl md:text-7xl font-bold text-white leading-[1.05]", children: [
              "EVERY SHOT.",
              /* @__PURE__ */ s.jsx("br", {}),
              "EVERY PLAY.",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME INTELLIGENCE." })
            ] }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-white/60 text-lg md:text-xl max-w-2xl leading-relaxed mt-6 mb-10", children: "ShootzInsight is built for basketball. AI keeps the action on film, made-basket Moments surface key scoring plays, and shooting numbers link back to evidence." }),
            /* @__PURE__ */ s.jsxs(E.div, { variants: Tt, className: "flex flex-wrap gap-4", children: [
              /* @__PURE__ */ s.jsx(Ae, { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]", children: "Get ShootzInsight Q1" }),
              /* @__PURE__ */ s.jsx("a", { href: "#analytics", className: "px-8 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all", children: "See Analytics Demo" })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: [
            /* @__PURE__ */ s.jsxs(E.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: [
              "AI BUILT FOR",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "BASKETBALL" })
            ] }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-white/50 mt-4 max-w-2xl mx-auto text-lg", children: "Our Sports Video AI is trained specifically on basketball — understanding court geometry, player movement patterns, and game events in real-time." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: FC.map((n) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: Tt,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: [
            /* @__PURE__ */ s.jsxs(E.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: [
              "FROM RAW FOOTAGE TO",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME INTELLIGENCE" })
            ] }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-white/50 mt-4 max-w-xl mx-auto", children: "Three workflows work together — turning hours of footage into browsable moments, finished reels, and limited shooting data." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid md:grid-cols-3 gap-8",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: BC.map((n) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: Tt,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-all",
              children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(n.icon, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] text-xs font-bold uppercase tracking-wider bg-[#FF6B35]/10 px-2 py-1 rounded", children: n.badge })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-white mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { id: "analytics", className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: [
            /* @__PURE__ */ s.jsx(E.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "SHOOTING DATA LINKED TO FILM" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-white/50 mt-3 max-w-lg mx-auto", children: "Start review with real scoring fundamentals instead of scrubbing through the entire recording." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ia,
          children: VC.map((n) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: Tt,
              className: "p-6 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-[#FF6B35] font-semibold mb-1", children: n.label }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm", children: n.desc })
              ]
            },
            n.label
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ia, children: [
      /* @__PURE__ */ s.jsx(E.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "ELEVATE YOUR GAME." }),
      /* @__PURE__ */ s.jsx(E.p, { variants: Tt, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "From pickup games to competitive leagues — ShootzInsight turns every session into an opportunity to improve." }),
      /* @__PURE__ */ s.jsxs(E.div, { variants: Tt, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Buy ShootzInsight Q1 — $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/coaches",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "For Coaches"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const UC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HC
}, Symbol.toStringTag, { value: "Module" })), Pr = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, LC = { visible: { transition: { staggerChildren: 0.1 } } };
function PC({
  eyebrow: n,
  title: i,
  accentTitle: l,
  description: o,
  imageSrc: d,
  imageAlt: f,
  contentSide: h = "left",
  objectPosition: p = "center",
  primaryLabel: g,
  primaryHref: m,
  secondaryLabel: b,
  secondaryHref: y,
  note: w
}) {
  const S = h === "right";
  return /* @__PURE__ */ s.jsxs("section", { className: "relative flex min-h-[620px] items-end overflow-hidden border-b border-white/5 pt-[72px] sm:min-h-[680px] lg:min-h-[720px]", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
      d && /* @__PURE__ */ s.jsx(
        "img",
        {
          src: d,
          alt: f,
          className: "h-full w-full object-cover",
          style: { objectPosition: p }
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-[#0a0a0a]/25" }),
      /* @__PURE__ */ s.jsx(
        "div",
        {
          className: `absolute inset-0 ${S ? "bg-gradient-to-l from-[#0a0a0a]/95 via-[#0a0a0a]/65 to-[#0a0a0a]/10" : "bg-gradient-to-r from-[#0a0a0a]/95 via-[#0a0a0a]/65 to-[#0a0a0a]/10"}`
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/35" })
    ] }),
    /* @__PURE__ */ s.jsx(
      E.div,
      {
        className: "container relative z-10 mx-auto pb-16 pt-28 sm:pb-20",
        initial: "hidden",
        animate: "visible",
        variants: LC,
        children: /* @__PURE__ */ s.jsxs("div", { className: `max-w-2xl ${S ? "ml-auto" : ""}`, children: [
          /* @__PURE__ */ s.jsx(E.p, { variants: Pr, className: "mb-4 text-sm font-semibold uppercase tracking-widest text-[#FF6B35]", children: n }),
          /* @__PURE__ */ s.jsxs(E.h1, { variants: Pr, className: "font-[family-name:var(--font-display)] text-4xl font-bold leading-[1.1] text-white md:text-6xl", children: [
            i,
            l && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: l })
            ] })
          ] }),
          /* @__PURE__ */ s.jsx(E.p, { variants: Pr, className: "mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg", children: o }),
          /* @__PURE__ */ s.jsxs(E.div, { variants: Pr, className: "mt-8 flex flex-col gap-3 sm:flex-row", children: [
            /* @__PURE__ */ s.jsx("a", { href: m, className: "inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-7 text-sm font-semibold text-white hover:bg-[#D94F22]", children: g }),
            /* @__PURE__ */ s.jsx("a", { href: y, className: "inline-flex min-h-12 items-center justify-center rounded-lg border border-white/25 bg-black/15 px-7 text-sm font-semibold text-white backdrop-blur-sm hover:border-[#FF6B35]/70", children: b })
          ] }),
          w && /* @__PURE__ */ s.jsx(E.p, { variants: Pr, className: "mt-4 text-xs text-white/45", children: w })
        ] })
      }
    )
  ] });
}
const qo = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, wh = { visible: { transition: { staggerChildren: 0.08 } } };
function Ec({ config: n }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#080808]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { ...n.seo }),
    /* @__PURE__ */ s.jsx(PC, { ...n.hero }),
    /* @__PURE__ */ s.jsx("section", { className: "border-b border-white/[0.07] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs(E.div, { className: "container mx-auto max-w-6xl", initial: "hidden", whileInView: "visible", viewport: { once: !0, margin: "-80px" }, variants: wh, children: [
      /* @__PURE__ */ s.jsxs(E.div, { variants: qo, className: "mb-10 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "The challenge" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: n.painTitle }),
        n.painIntro && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-base leading-relaxed text-white/55", children: n.painIntro })
      ] }),
      /* @__PURE__ */ s.jsx(E.div, { variants: wh, className: `grid gap-4 ${n.painPoints.length === 3 ? "md:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-4"}`, children: n.painPoints.map((i) => {
        const l = i.icon;
        return /* @__PURE__ */ s.jsxs(E.article, { variants: qo, className: "border-t border-white/15 px-1 py-6", children: [
          /* @__PURE__ */ s.jsx(l, { size: 30, className: "mb-5 text-[#FF6B35]", "aria-hidden": "true" }),
          /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-white", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm leading-relaxed text-white/50", children: i.description })
        ] }, i.title);
      }) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { id: "scoring-moments", className: "py-20 md:py-28", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-14 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "How ShootzInsight helps" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "From full-game film to the plays that matter" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "space-y-20 md:space-y-28", children: n.features.map((i, l) => /* @__PURE__ */ s.jsxs(E.article, { initial: "hidden", whileInView: "visible", viewport: { once: !0, margin: "-80px" }, variants: wh, className: "grid items-center gap-8 lg:grid-cols-2 lg:gap-16", children: [
        /* @__PURE__ */ s.jsxs(E.div, { variants: qo, className: l % 2 === 1 ? "lg:order-2" : "", children: [
          /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: i.eyebrow }),
          /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-5 text-base leading-relaxed text-white/60", children: i.description }),
          i.note && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-xs leading-relaxed text-white/35", children: i.note })
        ] }),
        /* @__PURE__ */ s.jsx(E.div, { variants: qo, className: l % 2 === 1 ? "lg:order-1" : "", children: i.image ? /* @__PURE__ */ s.jsx("img", { src: i.image, alt: i.imageAlt, loading: "lazy", className: "aspect-[3/2] w-full rounded-lg border border-white/10 object-cover" }) : /* @__PURE__ */ s.jsx("div", { className: "flex aspect-[3/2] items-center justify-center rounded-lg border border-white/10 bg-[#111318] px-8 text-center text-sm text-white/35", children: i.imageAlt }) })
      ] }, i.title)) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.scenariosTitle }),
      /* @__PURE__ */ s.jsx("div", { className: `mt-10 grid gap-px overflow-hidden rounded-lg border border-white/10 bg-white/10 ${n.scenarios.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`, children: n.scenarios.map((i) => /* @__PURE__ */ s.jsxs("article", { className: "bg-[#111318] p-7 md:p-9", children: [
        /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-white", children: i.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-3 text-sm leading-relaxed text-white/50", children: i.description })
      ] }, i.title)) })
    ] }) }),
    n.choices && n.choicesTitle && /* @__PURE__ */ s.jsx("section", { className: "py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.choicesTitle }),
        n.choicesIntro && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-white/50", children: n.choicesIntro })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "mt-10 grid gap-5 md:grid-cols-2", children: n.choices.map((i) => /* @__PURE__ */ s.jsxs(Ae, { href: i.href, className: `group flex min-h-64 flex-col justify-between rounded-lg border p-7 transition-colors md:p-9 ${i.featured ? "border-[#FF6B35]/70 bg-[#FF6B35]/[0.06]" : "border-white/10 bg-white/[0.02] hover:border-white/25"}`, children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold text-[#55D681]", children: "800 bonus credits included" }),
          /* @__PURE__ */ s.jsx("h3", { className: "mt-4 text-2xl font-bold text-white", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-3 max-w-md text-sm leading-relaxed text-white/50", children: i.description })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-8 flex items-end justify-between gap-4", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-3xl font-bold text-white", children: i.price }),
          /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-1 text-sm font-semibold text-[#FF6B35]", children: [
            "Choose setup ",
            /* @__PURE__ */ s.jsx(Qr, { size: 16 })
          ] })
        ] })
      ] }, i.title)) })
    ] }) }),
    n.consultation && /* @__PURE__ */ s.jsx("section", { className: "py-20 md:py-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs("div", { className: "grid gap-10 border-y border-white/10 py-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.consultation.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-4 max-w-2xl text-base leading-relaxed text-white/55", children: n.consultation.description })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("ul", { className: "space-y-3", children: n.consultation.items.map((i) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-center gap-3 text-sm text-white/65", children: [
          /* @__PURE__ */ s.jsx(Yt, { size: 16, className: "text-[#55D681]" }),
          i
        ] }, i)) }),
        /* @__PURE__ */ s.jsx(Ae, { href: n.consultation.ctaHref, className: "mt-7 inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-6 text-sm font-semibold text-white hover:bg-[#D94F22]", children: n.consultation.ctaLabel })
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative overflow-hidden border-t border-white/[0.07] py-24 md:py-32", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-[radial-gradient(circle_at_80%_50%,rgba(255,107,53,0.12),transparent_38%)]" }),
      /* @__PURE__ */ s.jsxs("div", { className: "container relative mx-auto max-w-5xl text-center", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white md:text-6xl", children: n.finalCta.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/55 md:text-lg", children: n.finalCta.description }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row", children: [
          /* @__PURE__ */ s.jsx(Ae, { href: n.finalCta.primaryHref, className: "inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-8 text-sm font-semibold text-white hover:bg-[#D94F22]", children: n.finalCta.primaryLabel }),
          n.finalCta.secondaryLabel && n.finalCta.secondaryHref && /* @__PURE__ */ s.jsx(Ae, { href: n.finalCta.secondaryHref, className: "inline-flex min-h-12 items-center justify-center rounded-lg border border-white/20 px-8 text-sm font-semibold text-white hover:border-[#FF6B35]/60", children: n.finalCta.secondaryLabel })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const qr = window.__SHOOTZ_CONFIG__?.media, jh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", qC = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", IC = {
  seo: { title: "For Parents - Capture the Game. Cheer Freely.", description: "Record youth basketball with your iPhone and Q1, find automatic scoring clips, and share the moments that matter.", keywords: "AI basketball camera, automatic scoring clips, youth basketball recording, player highlights", url: "/pages/parents" },
  hero: { eyebrow: "For Parents", title: "Capture the Game. Cheer Freely.", description: "Set up your iPhone with ShootzInsight Q1 and enjoy the game. Q1 follows the full court and organizes made-basket clips so you can find and share the moments that matter.", imageSrc: qr?.userParents, imageAlt: "Parents watching their child play basketball from the stands", contentSide: "right", objectPosition: "38% center", primaryLabel: "Shop Q1 - $199", primaryHref: jh, secondaryLabel: "Watch the Parent Demo", secondaryHref: "#scoring-moments", note: "Basketball today. More sports planned for late 2026." },
  painTitle: "Enjoy the game. Keep the moments.",
  painPoints: [
    { icon: el, title: "No more holding your phone", description: "Keep your eyes on the game." },
    { icon: sT, title: "No more scrubbing", description: "Jump to scoring moments instead of searching hours of video." },
    { icon: yf, title: "No more missed shares", description: "Find a play and send it to family in a few taps." }
  ],
  features: [
    { eyebrow: "Full-court tracking", title: "Keep the Game in Frame While You Cheer", description: "Set up Q1 with your iPhone and record the basketball game hands-free. Basketball-specific tracking helps keep live action in frame while results vary by venue, lighting and placement.", image: qr?.fullCourtTracking, imageAlt: "ShootzInsight Q1 tracking a full basketball court with an iPhone" },
    { eyebrow: "Made-basket detection", title: "Find Your Child's Scoring Moments Faster", description: "After processing, ShootzInsight identifies made baskets and creates scoring clips. Browse the visual thumbnails to find and open the exact play instead of searching through the full game.", image: qr?.aiMoments, imageAlt: "ShootzInsight iPhone app showing automatic basketball scoring clips" },
    { eyebrow: "Highlights", title: "Share the Moment, Not the Whole Game", description: "Select the plays you want to keep, create a share-ready highlight, and send it to grandparents, teammates or social media. Advanced highlight creation uses Shootz Cloud credits.", image: qr?.socialSharing || qr?.oneTapHighlight, imageAlt: "ShootzInsight app sharing a selected basketball highlight" }
  ],
  scenariosTitle: "A simpler game-day workflow",
  scenarios: [
    { title: "Before the game", description: "Mount your iPhone on Q1 at half court and connect the ShootzInsight app." },
    { title: "During the game", description: "Watch and cheer while Q1 keeps the basketball action in frame." },
    { title: "After the game", description: "Browse made-basket clips, choose the plays you want, and share the highlight." }
  ],
  choicesTitle: "Choose the Setup for Your Family",
  choicesIntro: "Both options include 800 bonus credits for premium processing.",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For families with a compatible tripod.", href: jh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - a ready-to-record setup for game day.", href: qC, featured: !0 }
  ],
  finalCta: { title: "Keep the game. Keep the memory.", description: "Record the game, find made-basket moments, and share the plays your family will talk about.", primaryLabel: "Shop Q1 - $199", primaryHref: jh }
};
function GC() {
  return /* @__PURE__ */ s.jsx(Ec, { config: IC });
}
const YC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: GC
}, Symbol.toStringTag, { value: "Module" })), Ir = window.__SHOOTZ_CONFIG__?.media, Sh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", QC = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", ZC = {
  seo: { title: "For Coaches - Review the Game, Not the Camera.", description: "Capture consistent basketball film, start review with automatic scoring clips, and connect shooting data to video.", keywords: "AI basketball camera, automatic scoring clips, basketball game analytics, coaching film review", url: "/pages/coaches" },
  hero: { eyebrow: "For Coaches", title: "Review the Game, Not the Camera.", description: "Capture consistent basketball film with your iPhone and Q1. After processing, start with made-basket moments and review player and team shooting data linked to video.", imageSrc: Ir?.userCoaches, imageAlt: "Basketball coach talking with players during a game", primaryLabel: "Shop Q1 for Your Team", primaryHref: Sh, secondaryLabel: "Request a Team Demo", secondaryHref: "/pages/contact", note: "Built for basketball coaches." },
  painTitle: "Coaching Is Already Demanding Enough",
  painPoints: [
    { icon: Yv, title: "No dedicated camera operator", description: "Your staff should be able to focus on the team." },
    { icon: Jv, title: "Inconsistent handheld footage", description: "Film is harder to review when the action leaves the frame." },
    { icon: Xv, title: "Too much scrubbing", description: "Finding a few scoring plays should not take hours." },
    { icon: Qv, title: "Stats take time to organize", description: "Review is faster when the number and the play stay connected." }
  ],
  features: [
    { eyebrow: "Game Analytics", title: "Data-Driven Feedback, Linked to Film", description: "Get points, FG%, and a 3PT / 2PT / FT breakdown from your game film. Each result is connected to the play so you can review the number and the video together.", image: Ir?.gameAnalytics, imageAlt: "Basketball shooting data linked to game video in ShootzInsight" },
    { eyebrow: "Full-game film", title: "See the Possessions Around the Ball", description: "Record the basketball game with Q1 and your iPhone, then use the film to review spacing, transitions and off-ball movement.", image: Ir?.fullCourtTracking, imageAlt: "Full-court basketball film recorded by ShootzInsight Q1" },
    { eyebrow: "Player moments", title: "Give Players a Clear Starting Point", description: "Use scoring moments and player highlight reels to start individual feedback. Select the plays you need, then share targeted clips instead of sending the whole game.", image: Ir?.aiMoments, imageAlt: "ShootzInsight automatic scoring clips for player feedback" },
    { eyebrow: "Faster review", title: "Start Review with the Scoring Plays", description: "Start with automatically created scoring clips, select the moments you need, and create clips for team review using your Cloud credits.", image: Ir?.oneTapHighlight, imageAlt: "Selected scoring clips prepared for basketball team review" }
  ],
  scenariosTitle: "A repeatable film-review workflow",
  scenarios: [
    { title: "Record", description: "Set up Q1 with an iPhone at half court and capture consistent full-game film." },
    { title: "Review", description: "Start with made-basket moments and shooting data linked to the source video." },
    { title: "Share", description: "Select the clips each player or group needs for the next session." }
  ],
  choicesTitle: "Equip your team",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For teams that already have a compatible tripod.", href: Sh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - a ready-to-record setup.", href: QC, featured: !0 }
  ],
  consultation: { title: "Need more than one setup?", description: "Tell us how many teams, venues and games you record. We will discuss a workflow and pricing based on your actual program needs.", items: ["Team demo", "Volume pricing discussion", "Recording workflow review"], ctaLabel: "Request Team Pricing", ctaHref: "/pages/contact" },
  finalCta: { title: "Start review with better film.", description: "Capture the game consistently, find scoring moments faster, and keep every shooting number connected to video.", primaryLabel: "Shop Q1 for Your Team", primaryHref: Sh, secondaryLabel: "Request a Team Demo", secondaryHref: "/pages/contact" }
};
function XC() {
  return /* @__PURE__ */ s.jsx(Ec, { config: ZC });
}
const KC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XC
}, Symbol.toStringTag, { value: "Module" })), Gr = window.__SHOOTZ_CONFIG__?.media, $C = {
  seo: { title: "For Clubs & Leagues - A Repeatable Basketball Video Workflow", description: "Give basketball teams a consistent way to record games, find scoring moments, and create shareable content.", keywords: "AI basketball camera, club basketball video, automatic scoring clips, basketball program content", url: "/pages/clubs" },
  hero: { eyebrow: "For Clubs & Leagues", title: "A Better Starting Point for Basketball Programs.", description: "Give your teams a consistent way to record games, find scoring moments and create shareable content. Start with Q1 for basketball today; talk to us about program needs as your organization grows.", imageSrc: Gr?.userClubs, imageAlt: "Youth basketball club team together on the court", primaryLabel: "Request Club Pricing", primaryHref: "/pages/contact", secondaryLabel: "Book a Program Demo", secondaryHref: "/pages/contact", note: "Consultation is based on your number of teams, games and venues." },
  painTitle: "Managing Game Video Across Teams Is Hard",
  painPoints: [
    { icon: Jv, title: "Different recording quality", description: "Every team needs a repeatable way to capture the game." },
    { icon: LN, title: "No consistent scoring clips", description: "Staff should be able to start review from the same kind of result." },
    { icon: lT, title: "Too much manual review", description: "Searching full-game files does not scale across a program." },
    { icon: yf, title: "Content is hard to share", description: "Families and teams need selected plays, not another raw file." }
  ],
  features: [
    { eyebrow: "Consistent scoring moments", title: "Start with the Same Scoring-Moment Workflow", description: "Use Q1 to capture basketball games and automatically identify made baskets. Your staff can start reviews with scoring clips instead of searching through full-game files.", image: Gr?.aiMoments, imageAlt: "Automatic basketball scoring clips in the ShootzInsight app" },
    { eyebrow: "Full-game film", title: "A Repeatable Game-Recording Workflow", description: "Set up an iPhone and Q1 at each game, then keep the full recording available for coaches, families and players.", image: Gr?.fullCourtTracking, imageAlt: "ShootzInsight Q1 recording full-court basketball with an iPhone" },
    { eyebrow: "Program content", title: "Turn Selected Plays into Program Content", description: "Create player highlights and share selected plays with families, teams and your community. Cloud processing uses credits; contact us for a program workflow.", image: Gr?.oneTapHighlight, imageAlt: "Basketball highlight assembled from selected ShootzInsight clips" },
    { eyebrow: "Live sharing", title: "Help Families Follow the Game", description: "Use ShootzInsight Live to share games through supported streaming destinations. Confirm your venue network and streaming setup before a tournament.", image: Gr?.liveStreaming, imageAlt: "ShootzInsight Live streaming interface for a basketball game" }
  ],
  scenariosTitle: "Start with a workflow your teams can repeat",
  scenarios: [
    { title: "Set up", description: "Place an iPhone and Q1 at the game using the same courtside setup." },
    { title: "Process", description: "Keep the full recording and begin review with made-basket clips." },
    { title: "Distribute", description: "Share selected film and content with the people who need it." }
  ],
  consultation: { title: "Plan the right program workflow", description: "We will confirm what can be supported for your organization before making a deployment promise.", items: ["Program onboarding", "Shared content workflow", "Volume pricing discussion"], ctaLabel: "Request Club Pricing", ctaHref: "/pages/contact" },
  finalCta: { title: "Build a more consistent game-video workflow.", description: "Tell us how many teams, games and venues you support, and what outputs your program needs.", primaryLabel: "Request Club Pricing", primaryHref: "/pages/contact", secondaryLabel: "Book a Program Demo", secondaryHref: "/pages/contact" }
};
function WC() {
  return /* @__PURE__ */ s.jsx(Ec, { config: $C });
}
const JC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WC
}, Symbol.toStringTag, { value: "Module" })), Yr = window.__SHOOTZ_CONFIG__?.media, Nh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", eE = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", tE = {
  seo: { title: "For Players - See Your Game. Build Your Next Level.", description: "Find automatic basketball scoring clips, review shooting data linked to film, and create highlights from selected plays with ShootzInsight Q1.", keywords: "AI basketball camera, automatic scoring clips, basketball analytics, highlights", url: "/pages/players" },
  hero: { eyebrow: "For Players", title: "See Your Game. Build Your Next Level.", description: "Get the full game on film, start from your scoring moments, and turn selected plays into highlights you can share with teammates, coaches and recruiters.", imageSrc: Yr?.userPlayers, imageAlt: "Basketball player making a pass during a game", primaryLabel: "Start with Q1 - $199", primaryHref: Nh, secondaryLabel: "See How It Works", secondaryHref: "#scoring-moments", note: "Q1 works with your iPhone and is built for basketball today." },
  painTitle: "Can You Find Your Plays?",
  painPoints: [
    { icon: Yv, title: "No one filming", description: "Your game should not depend on someone holding a phone." },
    { icon: Xv, title: "Hours of footage", description: "The play you need can be buried in a full-game recording." },
    { icon: Qv, title: "No clear game data", description: "Numbers are more useful when they link back to the play." },
    { icon: ol, title: "Editing takes too long", description: "Building a useful reel should start with clips already found." }
  ],
  features: [
    { eyebrow: "Made-basket detection", title: "Your Scoring Moments, Already Found", description: "ShootzInsight detects made baskets into scoring clips after processing. Browse the visual thumbnails, open the exact clip, and save the plays you want to build on.", image: Yr?.aiMoments, imageAlt: "ShootzInsight app displaying automatic basketball scoring moments" },
    { eyebrow: "Uses credits", title: "One Tap to a Share-Ready Highlight", description: "Choose your clips and create a polished highlight with the ShootzInsight app. Highlight creation uses credits; Q1 includes 800 credits to get started.", image: Yr?.oneTapHighlight, imageAlt: "ShootzInsight app creating a basketball highlight from selected clips" },
    { eyebrow: "Game Analytics", title: "Stats Connected to the Plays", description: "Review points, FG%, and the 3PT / 2PT / FT breakdown - then tap a number to jump to the video behind it.", image: Yr?.gameAnalytics, imageAlt: "ShootzInsight basketball game analytics linked to video", note: "Video Data Analysis uses Shootz Cloud credits." },
    { eyebrow: "Full-court tracking", title: "Play. Q1 Keeps the Game in Frame.", description: "Set up your iPhone with Q1 and play without asking someone to hold the camera. ShootzInsight is built for basketball today, with more sports planned for late 2026.", image: Yr?.fullCourtTracking, imageAlt: "Full-court basketball action recorded by ShootzInsight Q1" }
  ],
  scenariosTitle: "Use Q1 for training and game day",
  scenarios: [
    { title: "Training", description: "Record a drill or scrimmage, then review the film with your coach." },
    { title: "Game Day", description: "Capture the full game and start post-game review with automatic scoring clips." }
  ],
  choicesTitle: "Choose your setup",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For players who already have a compatible tripod.", href: Nh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - ready for practice or game day.", href: eE, featured: !0 }
  ],
  finalCta: { title: "Your game deserves to be seen.", description: "Record the full game, find the scoring plays, and build the highlight you want to share.", primaryLabel: "Start with Q1 - $199", primaryHref: Nh, secondaryLabel: "See a Real Game Demo", secondaryHref: "/pages/basketball" }
};
function nE() {
  return /* @__PURE__ */ s.jsx(Ec, { config: tE });
}
const aE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nE
}, Symbol.toStringTag, { value: "Module" })), ft = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ga = { visible: { transition: { staggerChildren: 0.1 } } }, iE = [
  { value: "2024", label: "Founded" },
  { value: "AI", label: "Core Technology" },
  { value: "10+", label: "Sports Supported" },
  { value: "Global", label: "Vision" }
], sE = [
  {
    icon: BN,
    title: "AI-First Engineering",
    desc: "Built on proprietary sports video AI models trained on thousands of hours of game footage. Our technology understands the game — not just the pixels."
  },
  {
    icon: rc,
    title: "Athlete-Centered Design",
    desc: "Every feature is designed with athletes, coaches, and families in mind. We build tools that serve the game, not the other way around."
  },
  {
    icon: PN,
    title: "Global Accessibility",
    desc: "Professional-level game intelligence shouldn't be reserved for elite programs. We're making it accessible to every court, every community, worldwide."
  },
  {
    icon: iT,
    title: "Continuous Innovation",
    desc: "Our AI gets smarter with every game processed. New features ship monthly based on direct feedback from our community of coaches, parents, and players."
  }
];
function rE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "About Us - Our Story", description: "ShootzInsight was born from a simple belief: every athlete deserves to see their game the way the pros do. Meet the team behind the AI sports recording revolution.", keywords: "ShootzInsight about, sports AI company, basketball technology", url: "/about" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ga,
        children: [
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Our Story" }),
          /* @__PURE__ */ s.jsxs(E.h1, { variants: ft, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "WE BELIEVE EVERY",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME MATTERS" })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "max-w-3xl",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ga,
        children: [
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed mb-6", children: "ShootzInsight was born from a simple observation: professional sports teams have entire departments dedicated to video analysis, highlight creation, and performance data. Youth athletes, weekend warriors, and community programs have nothing." }),
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed mb-6", children: "Founded by a team of AI engineers and basketball enthusiasts in China, we set out to bridge that gap. Our mission: bring NBA-level game intelligence to every court through the power of AI — at a price anyone can afford." }),
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed", children: "Today, ShootzInsight combines hardware innovation with deep learning to deliver automatic game recording, free Scoring Moments, One-Tap Highlights, and shooting analytics linked to game film — all from a system that anyone can set up in about 30 seconds." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      E.div,
      {
        className: "grid grid-cols-2 md:grid-cols-4 gap-6",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ga,
        children: iE.map((n) => /* @__PURE__ */ s.jsxs(
          E.div,
          {
            variants: ft,
            className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 text-center",
            children: [
              /* @__PURE__ */ s.jsx("p", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-[#FF6B35] mb-1", children: n.value }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm", children: n.label })
            ]
          },
          n.label
        ))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "max-w-3xl mx-auto text-center",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ga,
        children: [
          /* @__PURE__ */ s.jsx(E.div, { variants: ft, className: "flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(IN, { size: 28, className: "text-[#FF6B35]" }) }),
          /* @__PURE__ */ s.jsx(E.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-6", children: "OUR MISSION" }),
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed", children: "To democratize sports intelligence. Every player — regardless of their level, budget, or location — deserves access to the same quality of game analysis and content creation tools that professional teams use. Through AI, we're making that possible." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: /* @__PURE__ */ s.jsx(E.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "WHAT DRIVES US" })
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: sE.map((n) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: ft,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "max-w-3xl mx-auto text-center",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ga,
        children: [
          /* @__PURE__ */ s.jsx(E.div, { variants: ft, className: "flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(wf, { size: 28, className: "text-[#FF6B35]" }) }),
          /* @__PURE__ */ s.jsx(E.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-6", children: "OUR TEAM" }),
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed mb-4", children: "We're a team of AI researchers, computer vision engineers, and sports enthusiasts based in China with a global outlook. Our backgrounds span deep learning, video processing, sports analytics, and product design." }),
          /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed", children: "United by a shared passion for sports and technology, we're building the future of game intelligence — one algorithm at a time." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ga, children: [
      /* @__PURE__ */ s.jsx(E.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "JOIN THE MOVEMENT" }),
      /* @__PURE__ */ s.jsx(E.p, { variants: ft, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Be part of the revolution in sports video intelligence. Whether you're a parent, coach, player, or club — we built this for you." }),
      /* @__PURE__ */ s.jsxs(E.div, { variants: ft, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Get Started — $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/contact",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "Contact Us"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const lE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rE
}, Symbol.toStringTag, { value: "Module" })), Pn = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Io = { visible: { transition: { staggerChildren: 0.08 } } }, iw = [
  {
    id: "setup",
    title: "Quick Setup",
    desc: "Mount ShootzInsight Q1 on any tripod, clamp your phone, power on, and connect via Bluetooth in under 30 seconds.",
    icon: el,
    videoDuration: "1:30"
  },
  {
    id: "tracking",
    title: "Full-Court AI Tracking",
    desc: "How AI tracking helps follow basketball action across the full court with smooth movement.",
    icon: gf,
    videoDuration: "2:00"
  },
  {
    id: "remote",
    title: "RC1 Remote Control",
    desc: "Pair the Bluetooth remote to start/stop recording, switch modes, and control score overlay.",
    icon: eT,
    videoDuration: "1:15"
  },
  {
    id: "monitor",
    title: "Live Monitor & Framing",
    desc: "Use your phone as a real-time monitor to check framing and adjust the angle during the game.",
    icon: bf,
    videoDuration: "1:00"
  },
  {
    id: "landscape-portrait",
    title: "Landscape & Portrait Mode",
    desc: "Switch between horizontal (full-court) and vertical (single-player) recording modes.",
    icon: e0,
    videoDuration: "0:45"
  }
], oE = [
  {
    id: "moments",
    title: "AI Moments",
    desc: "How the AI automatically detects every made basket (threes, twos, free throws) and creates 10-second Moments clips.",
    icon: t0,
    videoDuration: "2:30"
  },
  {
    id: "find-yourself",
    title: "Find Your Moments",
    desc: "Browse snapshot previews around scoring plays to locate the clips you want to review or share.",
    icon: wf,
    videoDuration: "1:45"
  },
  {
    id: "analytics",
    title: "Shooting Data Dashboard",
    desc: "Review FG% and the 3PT / 2PT / FT breakdown, with results linked to their source video clips.",
    icon: Ds,
    videoDuration: "3:00"
  }
], cE = [
  {
    id: "highlight",
    title: "One-Tap Highlight",
    desc: "Select Moments, then generate a share-ready vertical Highlight reel with transitions, music sync, and slow-mo.",
    icon: bc,
    videoDuration: "2:00"
  },
  {
    id: "smart-reframe",
    title: "Smart Reframe (Landscape → Vertical)",
    desc: "AI intelligently crops and zooms your horizontal footage into vertical format optimized for TikTok and Reels.",
    icon: ol,
    videoDuration: "1:30"
  },
  {
    id: "live-stream",
    title: "ShootzInsight Live",
    desc: "Stream your game in real-time to YouTube, Facebook, or any RTMP platform directly from the app.",
    icon: ic,
    videoDuration: "2:30"
  },
  {
    id: "score-overlay",
    title: "Live Score Overlay",
    desc: "Add real-time score display to your stream or recording using the RC1 remote's +/- buttons.",
    icon: dT,
    videoDuration: "1:00"
  },
  {
    id: "share-social",
    title: "Share to Social Media",
    desc: "Export and share your Highlights directly to Instagram, TikTok, YouTube, or download for later.",
    icon: yf,
    videoDuration: "0:45"
  }
], Th = [
  { key: "record", label: "Record", tutorials: iw },
  { key: "analyze", label: "Analyze", tutorials: oE },
  { key: "share", label: "Share", tutorials: cE }
];
function uE({ tutorial: n }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "aspect-video w-full rounded-xl bg-white/[0.03] border border-white/10 flex flex-col items-center justify-center gap-3 group hover:border-[#FF6B35]/30 transition-colors cursor-pointer", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 rounded-full bg-[#FF6B35]/10 flex items-center justify-center group-hover:bg-[#FF6B35]/20 transition-colors", children: /* @__PURE__ */ s.jsx(Rh, { size: 28, className: "text-[#FF6B35] ml-1" }) }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-white/40 text-sm", children: [
      n.title,
      " Tutorial"
    ] }),
    n.videoDuration && /* @__PURE__ */ s.jsx("span", { className: "text-white/20 text-xs", children: n.videoDuration })
  ] });
}
function dE() {
  const [n, i] = C.useState("record"), [l, o] = C.useState(iw[0].id), d = Th.find((p) => p.key === n), f = d.tutorials.find((p) => p.id === l) || d.tutorials[0], h = (p) => {
    i(p);
    const g = Th.find((m) => m.key === p).tutorials[0];
    o(g.id);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(
      ln,
      {
        title: "How to Use - Tutorial Center",
        description: "Explore ShootzInsight product manuals, video tutorials, App setup and features. From unboxing to your first Highlight in under 5 minutes.",
        keywords: "ShootzInsight tutorial, how to use, setup guide, AI sports recording system guide",
        url: "/pages/user-guide"
      }
    ),
    /* @__PURE__ */ s.jsxs("section", { className: "pt-[72px] relative overflow-hidden", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#FF6B35]/5 via-transparent to-transparent" }),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "container mx-auto pt-20 pb-16 relative z-10",
          initial: "hidden",
          animate: "visible",
          variants: Io,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: Pn, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
            /* @__PURE__ */ s.jsxs(E.h1, { variants: Pn, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
              "HOW TO USE",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "SHOOTZINSIGHT" })
            ] }),
            /* @__PURE__ */ s.jsxs(E.p, { variants: Pn, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: [
              "Explore product manuals, video tutorials, App setup and features.",
              /* @__PURE__ */ s.jsx("br", {}),
              "From unboxing to your first Highlight — everything you need in under 5 minutes."
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs("div", { className: "grid md:grid-cols-2 gap-8", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col items-center text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Pn,
          children: [
            /* @__PURE__ */ s.jsx(UN, { size: 40, className: "text-[#FF6B35] mb-4" }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: "User Manual" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm mb-6 max-w-xs", children: "Download the complete ShootzInsight Q1 product manual for detailed setup instructions and specifications." }),
            /* @__PURE__ */ s.jsxs(
              "a",
              {
                href: "#",
                className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
                children: [
                  /* @__PURE__ */ s.jsx(VN, { size: 18 }),
                  "Download PDF"
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-3", children: "PDF • Coming Soon" })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col items-center text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Pn,
          children: [
            /* @__PURE__ */ s.jsx(bf, { size: 40, className: "text-[#FF6B35] mb-4" }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: "App Download" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm mb-6 max-w-xs", children: "Download the ShootzInsight app to connect your Q1, view Moments, generate Highlights, and access Analytics." }),
            /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row gap-3", children: [
              /* @__PURE__ */ s.jsxs(
                "a",
                {
                  href: "#",
                  className: "inline-flex items-center gap-2 px-5 py-3 bg-white/10 border border-white/20 text-white font-medium rounded-lg hover:bg-white/15 transition-all",
                  children: [
                    /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 24 24", className: "w-5 h-5 fill-current", children: /* @__PURE__ */ s.jsx("path", { d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" }) }),
                    "App Store"
                  ]
                }
              ),
              /* @__PURE__ */ s.jsx("span", { className: "inline-flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 text-white/45 font-medium rounded-lg", children: "iPhone app coming soon" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-3", children: "Links coming soon" })
          ]
        }
      )
    ] }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Io,
          children: [
            /* @__PURE__ */ s.jsx(E.h2, { variants: Pn, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: "APP TUTORIALS" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Pn, className: "text-white/50 mt-3 text-lg", children: "Step-by-step video guides for every feature." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center gap-1 mb-10", children: Th.map((p) => /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: () => h(p.key),
          className: `px-8 py-3 rounded-lg font-semibold text-sm transition-all ${n === p.key ? "bg-[#FF6B35] text-white" : "bg-white/5 text-white/50 hover:text-white hover:bg-white/10"}`,
          children: p.label
        },
        p.key
      )) }),
      /* @__PURE__ */ s.jsx(Wr, { mode: "wait", children: /* @__PURE__ */ s.jsxs(
        E.div,
        {
          initial: { opacity: 0, y: 10 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: -10 },
          transition: { duration: 0.25 },
          children: [
            /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap items-center justify-center gap-3 mb-12", children: d.tutorials.map((p) => /* @__PURE__ */ s.jsxs(
              "button",
              {
                onClick: () => o(p.id),
                className: `inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all ${l === p.id ? "bg-white text-[#0a0a0a]" : "bg-white/5 text-white/60 hover:bg-white/10 hover:text-white border border-white/10"}`,
                children: [
                  /* @__PURE__ */ s.jsx(p.icon, { size: 16 }),
                  p.title
                ]
              },
              p.id
            )) }),
            /* @__PURE__ */ s.jsxs("div", { className: "max-w-4xl mx-auto", children: [
              /* @__PURE__ */ s.jsx(uE, { tutorial: f }),
              /* @__PURE__ */ s.jsxs("div", { className: "mt-6 text-center", children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: f.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-base max-w-2xl mx-auto", children: f.desc })
              ] })
            ] })
          ]
        },
        n
      ) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "text-center mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Io,
          children: [
            /* @__PURE__ */ s.jsx(E.h2, { variants: Pn, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "PRO TIPS" }),
            /* @__PURE__ */ s.jsx(E.p, { variants: Pn, className: "text-white/50 mt-3", children: "Get the best results from your ShootzInsight Q1." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        E.div,
        {
          className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Io,
          children: [
            {
              title: "Best Position",
              desc: "Place at half-court, elevated 8-12 feet if possible. Higher angles improve AI tracking accuracy."
            },
            {
              title: "Lighting",
              desc: "Works indoors and outdoors. Avoid shooting directly into strong backlighting for best results."
            },
            {
              title: "Battery Life",
              desc: "Records up to 3 hours per charge. Bring a USB-C power bank for tournament days."
            },
            {
              title: "Storage",
              desc: "Footage records to your phone. Transfer games to cloud via the app after each session."
            }
          ].map((p) => /* @__PURE__ */ s.jsxs(
            E.div,
            {
              variants: Pn,
              className: "p-6 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-[#FF6B35] font-semibold text-sm mb-2", children: p.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: p.desc })
              ]
            },
            p.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl text-center mb-8", children: "Buy on the ShootzInsight Store" }),
      /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap items-center justify-center gap-8 mb-10", children: [
        { icon: "🚚", label: "Free Shipping" },
        { icon: "↩️", label: "15-Day Hassle-Free Return" },
        { icon: "🔒", label: "Secure Payments" },
        { icon: "🌍", label: "Global Customer Support" }
      ].map((p) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 text-white/60 text-sm", children: [
        /* @__PURE__ */ s.jsx("span", { className: "text-lg", children: p.icon }),
        /* @__PURE__ */ s.jsx("span", { children: p.label })
      ] }, p.label)) }),
      /* @__PURE__ */ s.jsx("div", { className: "text-center", children: /* @__PURE__ */ s.jsx(
        Ae,
        {
          href: "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
          className: "inline-flex items-center gap-2 px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
          children: "Shop Now"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16 bg-gradient-to-b from-[#0d0d14] to-[#0a0a0a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto text-center", children: [
      /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-2xl md:text-3xl font-bold text-white mb-4", children: "NEED MORE HELP?" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Check our FAQ or reach out to our support team." }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/faq",
            className: "px-10 py-4 bg-white/5 border border-white/20 text-white font-semibold rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "View FAQ"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/contact",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "Contact Support"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const hE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dE
}, Symbol.toStringTag, { value: "Module" })), Ci = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ah = { visible: { transition: { staggerChildren: 0.08 } } }, fE = [
  {
    category: "Product & Hardware",
    questions: [
      {
        q: "What is ShootzInsight Q1?",
        a: "ShootzInsight Q1 is an AI-powered basketball recording system. Mount your phone on the Q1, and it automatically tracks and records games. It combines smart hardware (3-axis AI tracking) with software for free Scoring Moments, optional cloud features, and shooting analytics."
      },
      {
        q: "What sports does it support?",
        a: "Q1 is built for basketball today. Soccer, tennis and badminton are planned for late 2026."
      },
      {
        q: "How long does the battery last?",
        a: "Q1 runs for approximately 13 hours when balanced and stationary without AI tracking, or approximately 4 hours with AI tracking and the fill light in use."
      },
      {
        q: "What's the video resolution?",
        a: "Recording quality depends on your iPhone. Exact supported models and recording options will be published with the App Store release."
      },
      {
        q: "Where is the footage stored?",
        a: "Footage is recorded directly to your phone's storage. Transfer to cloud via the ShootzInsight App for AI processing."
      }
    ]
  },
  {
    category: "AI Features",
    questions: [
      {
        q: "What is AI Moments?",
        a: "AI Moments is our free feature that automatically detects made baskets and organizes them into a browsable clip library. After each game, you can review thumbnails and select the plays worth keeping. No subscription needed."
      },
      {
        q: "How does One-Tap Highlight work?",
        a: "Select clips from AI Moments, choose a music track and style, then tap Generate. The app creates a cinematic vertical highlight video with transitions and music — ready to export or share."
      },
      {
        q: "What does Game Analytics include?",
        a: "Game Analytics currently supports 2PT, 3PT, free throw, and field-goal percentage metrics, with results linked to their source video clips. More player and team dimensions are planned."
      },
      {
        q: "Do I need a subscription to use ShootzInsight Q1?",
        a: "No. Q1 works out of the box for full-court recording and free made-basket Moments. Optional Shootz Cloud credits unlock features like finished Highlight reels and deeper game analysis."
      },
      {
        q: "How much is the subscription?",
        a: "Shootz Cloud offers three plans (annual pricing): Lite at $9.6/month (120 credits/month), Plus at $88.8/month (1,200 credits/month), and Max at $196.2/month (3,600 credits/month). Monthly billing is also available at slightly higher rates. All plans are managed through the ShootzInsight App."
      },
      {
        q: "How do credits work?",
        a: "Credits are used for premium cloud features such as cloud game analysis, highlight clipping, and highlight reel creation. Pricing varies by feature and service volume. Purchasing Q1 includes 800 credits to get started; current rates are shown on the Pricing page or in the app when available."
      },
      {
        q: "Can I subscribe on this website?",
        a: "Subscriptions will be managed through the ShootzInsight iPhone app. The App Store listing is still under review, so subscriptions cannot yet be started from this website."
      },
      {
        q: "Can I cancel my subscription anytime?",
        a: "Yes, cancel anytime in the app with no cancellation fees. Your credits remain active until the end of your current billing period. You'll still have full access to free features (recording and AI Moments) after cancellation."
      },
      {
        q: "What if I buy the Q1 but don't subscribe?",
        a: "You get hardware features including AI auto-tracking, full-court recording, live streaming, RC1 remote control, and free made-basket Moments. The 800 included credits let you try premium features. Cloud AI features require credits or an active subscription after those initial credits are used."
      }
    ]
  },
  {
    category: "Setup & Usage",
    questions: [
      {
        q: "How long does setup take?",
        a: "Under 30 seconds. Mount Q1 on a tripod, clamp your phone, open the app, connect via Bluetooth, and press record. That's it."
      },
      {
        q: "Where should I position ShootzInsight Q1?",
        a: "At half-court, elevated 8-12 feet if possible. The higher and more centered, the better the AI tracking performs."
      },
      {
        q: "Does it work indoors and outdoors?",
        a: "Yes. ShootzInsight Q1 works in both environments. For outdoor use, avoid positioning directly facing strong sunlight."
      },
      {
        q: "Do I need WiFi during the game?",
        a: "No. Recording and AI tracking work offline. WiFi is only needed to transfer footage and generate reels/analytics."
      }
    ]
  },
  {
    category: "Accuracy & Test Methodology",
    questions: [
      {
        q: "How reliable are AI tracking and Moments?",
        a: "AI tracking and made-basket detection are validated across varied courts before release. Venue, lighting, iPhone placement and game conditions can affect results, so we publish limitations rather than promising perfect performance."
      },
      {
        q: "What does 20,000 basketball-court environments mean?",
        a: "This is the current product-team description of the data coverage used in internal evaluation. A detailed methodology page will document the statistical unit, test phones, indoor and outdoor mix, accuracy definitions and failure cases before broader claims are published."
      }
    ]
  }
];
function mE({ q: n, a: i }) {
  const [l, o] = C.useState(!1);
  return /* @__PURE__ */ s.jsxs("div", { className: "border-b border-white/5", children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        onClick: () => o(!l),
        className: "w-full flex items-center justify-between py-5 text-left",
        children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium pr-4", children: n }),
          /* @__PURE__ */ s.jsx(
            tl,
            {
              size: 18,
              className: `text-[#FF6B35] shrink-0 transition-transform duration-200 ${l ? "rotate-180" : ""}`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: `overflow-hidden transition-all duration-200 ${l ? "max-h-96 pb-5" : "max-h-0"}`,
        children: /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: i })
      }
    )
  ] });
}
function pE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "FAQ - Frequently Asked Questions", description: "Find answers to common questions about ShootzInsight Q1, AI features, setup, compatibility, and technical support.", keywords: "ShootzInsight FAQ, sports recording system questions, AI sports FAQ", url: "/pages/faq" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ah,
        children: [
          /* @__PURE__ */ s.jsx(E.p, { variants: Ci, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
          /* @__PURE__ */ s.jsxs(E.h1, { variants: Ci, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "FREQUENTLY ASKED",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "QUESTIONS" })
          ] }),
          /* @__PURE__ */ s.jsx(E.p, { variants: Ci, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: "Everything you need to know about ShootzInsight, from hardware setup to AI features and pricing." })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      E.div,
      {
        className: "max-w-3xl mx-auto space-y-12",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ah,
        children: fE.map((n) => /* @__PURE__ */ s.jsxs(E.div, { id: n.category === "Accuracy & Test Methodology" ? "accuracy-test-methodology" : void 0, variants: Ci, children: [
          /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-[#FF6B35] mb-4", children: n.category }),
          /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl bg-white/[0.02] border border-white/5 px-6", children: n.questions.map((i) => /* @__PURE__ */ s.jsx(mE, { q: i.q, a: i.a }, i.q)) })
        ] }, n.category))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ah, children: [
      /* @__PURE__ */ s.jsx(E.h2, { variants: Ci, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "STILL HAVE QUESTIONS?" }),
      /* @__PURE__ */ s.jsx(E.p, { variants: Ci, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Our support team is here to help. Reach out anytime." }),
      /* @__PURE__ */ s.jsxs(E.div, { variants: Ci, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/contact",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Contact Support"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/user-guide",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "User Guide"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const gE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pE
}, Symbol.toStringTag, { value: "Module" })), Ts = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ch = { visible: { transition: { staggerChildren: 0.1 } } }, xE = [
  {
    icon: Kv,
    title: "Customer Support",
    desc: "For product questions, technical issues, and account help.",
    detail: "support@shootzinsight.com"
  },
  {
    icon: WN,
    title: "Business & Partnerships",
    desc: "For bulk orders, club partnerships, and media inquiries.",
    detail: "business@shootzinsight.com"
  },
  {
    icon: FN,
    title: "Business Hours",
    desc: "Our support team is available during business hours.",
    detail: "Mon - Fri, 9:00 AM - 6:00 PM (EST)"
  },
  {
    icon: XN,
    title: "Headquarters",
    desc: "ShootzInsight (Qiuxiu Sports Technology Co., Ltd.)",
    detail: "Shenzhen, China"
  }
];
function yE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "Contact Us", description: "Get in touch with the ShootzInsight team. Technical support, sales inquiries, partnership opportunities, and feedback.", keywords: "ShootzInsight contact, support, customer service", url: "/pages/contact" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ch,
        children: [
          /* @__PURE__ */ s.jsx(E.p, { variants: Ts, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
          /* @__PURE__ */ s.jsxs(E.h1, { variants: Ts, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "GET IN",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "TOUCH" })
          ] }),
          /* @__PURE__ */ s.jsx(E.p, { variants: Ts, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: "Have a question, need support, or want to explore a partnership? We'd love to hear from you." })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      E.div,
      {
        className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ch,
        children: xE.map((n) => /* @__PURE__ */ s.jsxs(
          E.div,
          {
            variants: Ts,
            className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5",
            children: [
              /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
              /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-1", children: n.title }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-3", children: n.desc }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/70 text-sm font-medium", children: n.detail })
            ]
          },
          n.title
        ))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ch, children: [
      /* @__PURE__ */ s.jsx(E.h2, { variants: Ts, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "LOOKING FOR SOMETHING ELSE?" }),
      /* @__PURE__ */ s.jsxs(E.div, { variants: Ts, className: "flex flex-col sm:flex-row items-center justify-center gap-4 mt-8", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/faq",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "View FAQ"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/user-guide",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "User Guide"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const bE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yE
}, Symbol.toStringTag, { value: "Module" }));
function vE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "Privacy Policy", description: "ShootzInsight Privacy Policy — how we collect, use, and protect your personal information.", url: "/pages/privacy-policy" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Privacy Policy" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("p", { children: 'ShootzInsight operates this website and related services, including the ShootzInsight mobile application and Shootz Cloud platform, in order to provide you with AI-powered sports recording, analysis, and highlight generation services (the "Services"). Our e-commerce is powered by Shopify, which enables us to sell products to you. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase through the Services or otherwise communicate with us.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please read this Privacy Policy carefully. By using and accessing any of the Services, you acknowledge that you have read this Privacy Policy and understand the collection, use, and disclosure of your information as described herein. If there is a conflict between our Terms of Service and this Privacy Policy, this Privacy Policy controls with respect to the collection, processing, and disclosure of your personal information." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Personal Information We Collect" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may collect the following categories of personal information depending on how you interact with the Services:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Contact details" }),
              " — your name, address, billing address, shipping address, phone number, and email address."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Financial information" }),
              " — credit card, debit card, and financial account numbers, payment card information, transaction details, and payment confirmation."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Account information" }),
              " — your username, password, preferences, subscription plan, and credit balance."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Transaction information" }),
              " — items you view, add to cart, purchase, return, or cancel, subscription history, and credit usage records."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Communications" }),
              " — information you include in communications with us, such as customer support inquiries."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Device information" }),
              " — information about your device, browser, network connection, IP address, and other unique identifiers."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Usage information" }),
              " — how and when you interact with or navigate the Services, including AI analysis requests, video uploads, and feature usage."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Video content" }),
              " — sports videos you upload for AI processing. These are processed solely to deliver the requested services."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Personal Information Sources" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may collect personal information from the following sources:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Directly from you" }),
              " — when you create an account, make a purchase, upload videos, subscribe to Shootz Cloud, or communicate with us."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Automatically through the Services" }),
              " — from your device when you use our products or services, through cookies and similar technologies."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "From our service providers" }),
              " — including payment processors (Shopify Payments), analytics providers, and cloud infrastructure partners."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "From our partners" }),
              " — such as Shopify (e-commerce platform) and the ShootzInsight iPhone app distribution platform."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How We Use Your Personal Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "Depending on how you interact with us, we may use personal information for the following purposes:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Provide, tailor, and improve the Services" }),
              " — process payments, fulfill orders, deliver AI analysis results, manage your subscription and credits, arrange shipping, facilitate returns and exchanges, and improve our AI algorithms and user experience."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Marketing and advertising" }),
              " — send marketing and promotional communications by email (with your consent), show relevant advertisements, and inform you of new features or products."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Security and fraud prevention" }),
              " — authenticate your account, provide a secure payment experience, detect and investigate fraudulent or malicious activity, and secure our services."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Communication" }),
              " — provide customer support, respond to inquiries, send order and subscription notifications, and maintain our business relationship with you."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Legal compliance" }),
              " — comply with applicable law, respond to valid legal process, investigate potential violations of our terms, and enforce our policies."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Video Content & AI Processing" }),
          /* @__PURE__ */ s.jsx("p", { children: "When you upload sports videos for AI analysis through the Shootz Cloud service, your video content is processed on our secure servers to generate highlights, analytics, and player tracking data. We retain your uploaded videos and generated content for the duration of your active subscription. You may delete your videos and associated data at any time through the ShootzInsight app." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not use your video content to train AI models without your explicit consent. We do not share your video content with third parties for marketing purposes. Video recordings remain on your device until you explicitly upload them for AI processing." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How We Disclose Personal Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may disclose your personal information to third parties in the following circumstances:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "With Shopify, payment processors, cloud service providers, and other vendors who perform services on our behalf (e.g., IT management, payment processing, data analytics, customer support, cloud storage, fulfillment and shipping)." }),
            /* @__PURE__ */ s.jsx("li", { children: "With business and marketing partners to provide marketing services and advertise to you. Our business partners will use your information in accordance with their own privacy notices." }),
            /* @__PURE__ */ s.jsx("li", { children: "When you direct, request, or otherwise consent to disclosure, such as sharing highlights on social media platforms." }),
            /* @__PURE__ */ s.jsx("li", { children: "With our affiliates or within our corporate group." }),
            /* @__PURE__ */ s.jsx("li", { children: "In connection with a business transaction such as a merger, to comply with applicable legal obligations, to enforce our terms of service, and to protect the Services, our rights, and the rights of our users." })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not sell your personal information." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Cookies & Tracking Technologies" }),
          /* @__PURE__ */ s.jsx("p", { children: "We use cookies and similar technologies to recognize your browser, remember your preferences, understand how you use our Services, and improve your experience. A cookie is a small amount of information that is downloaded to your device when you visit our website. We use the following types of cookies:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Essential cookies" }),
              " — required for the website to function properly (shopping cart, authentication)."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Analytics cookies" }),
              " — help us understand how visitors interact with our website."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Marketing cookies" }),
              " — used to deliver relevant advertisements and track campaign effectiveness."
            ] })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You can control cookie preferences through your browser settings. Disabling cookies may limit certain features of the Services." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Children's Privacy" }),
          /* @__PURE__ */ s.jsx("p", { children: "Our Services are not directed to children under 13. We do not knowingly collect personal information directly from children under 13. Our Service may capture video of minors during sports activities — such video recordings are managed by the account holder (parent, coach, or organization) who is responsible for obtaining appropriate consent." }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "If a parent or guardian becomes aware that their child has provided us with personal information without their consent, please contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " and we will delete such information. For users between 13 and 18, parental or guardian consent is required to use our cloud subscription services."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Data Security" }),
          /* @__PURE__ */ s.jsx("p", { children: "We implement industry-standard security measures to protect your personal information, including encryption of data in transit (TLS 1.3) and at rest, secure cloud infrastructure, access controls, and regular security audits. However, no method of transmission over the Internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Your Data Rights" }),
          /* @__PURE__ */ s.jsx("p", { children: "Depending on your jurisdiction, you may have the right to:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Access the personal information we hold about you." }),
            /* @__PURE__ */ s.jsx("li", { children: "Request correction of inaccurate data." }),
            /* @__PURE__ */ s.jsx("li", { children: "Request deletion of your personal data." }),
            /* @__PURE__ */ s.jsx("li", { children: "Opt out of marketing communications." }),
            /* @__PURE__ */ s.jsx("li", { children: "Data portability — export your data in a machine-readable format." }),
            /* @__PURE__ */ s.jsx("li", { children: "Object to or restrict certain processing of your data." })
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "To exercise these rights, contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            ". You can also manage your account settings and delete your data directly through the ShootzInsight app. We will respond to your request within 30 days."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "European Union — 14-Day Cooling Off Period" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you are located in the European Union, you have the right to withdraw consent for data processing within 14 days. For digital services (Shootz Cloud subscriptions), this right may be waived once the service has been accessed and credits have been used, as permitted under EU consumer protection regulations." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "International Data Transfers" }),
          /* @__PURE__ */ s.jsx("p", { children: "Your information may be transferred to and processed in countries other than your country of residence, including the United States and China, where our servers and team are located. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy and applicable law, including standard contractual clauses where required." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Changes to This Privacy Policy" }),
          /* @__PURE__ */ s.jsx("p", { children: 'We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. We will notify you of material changes by posting the updated policy on this page with a new "Last updated" date. Your continued use of the Services after any changes constitutes acceptance of the updated Privacy Policy.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Contact Us" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you have questions or concerns about this Privacy Policy or our data practices, please contact us:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Customer Support: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Address: Shenzhen, Guangdong, China" })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const wE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vE
}, Symbol.toStringTag, { value: "Module" }));
function jE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "Terms of Service", description: "ShootzInsight Terms of Service — the rules and guidelines for using our products and services.", url: "/pages/terms-of-service" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Terms of Service" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Overview" }),
          /* @__PURE__ */ s.jsx("p", { children: 'This website is operated by ShootzInsight. Throughout the site, the terms "we," "us," and "our" refer to ShootzInsight. ShootzInsight offers this website, including all information, tools, and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and notices stated here.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'By visiting our site and/or purchasing something from us, you engage in our "Service" and agree to be bound by the following terms and conditions ("Terms of Service," "Terms"), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change, or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 1 — Online Store Terms" }),
          /* @__PURE__ */ s.jsx("p", { children: "By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws). You must not transmit any worms or viruses or any code of a destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your Services." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 2 — General Conditions" }),
          /* @__PURE__ */ s.jsx("p", { children: "We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (not including credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 3 — Description of Service" }),
          /* @__PURE__ */ s.jsx("p", { children: "ShootzInsight provides an AI-powered sports recording system consisting of hardware (the ShootzInsight Q1 tracking mount) and software (the ShootzInsight mobile application with AI Moments, One-Tap Highlight, and Game Analytics features). The hardware requires a compatible smartphone to function as the recording device." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Premium AI features are available through the Shootz Cloud subscription service, managed through the ShootzInsight iPhone application. Subscription terms, pricing, credit allocations, and renewal policies are presented at the time of purchase within the app." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 4 — Modifications to the Service and Prices" }),
          /* @__PURE__ */ s.jsx("p", { children: "Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension, or discontinuance of the Service." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 5 — Products or Services" }),
          /* @__PURE__ */ s.jsx("p", { children: "Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Refund Policy." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate. We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region, or jurisdiction. All descriptions of products or product pricing are subject to change at any time without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected. AI results may vary by venue, lighting, iPhone placement, motion conditions and other factors, and we do not guarantee perfect performance." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 6 — Accuracy of Billing and Account Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 7 — User Content" }),
          /* @__PURE__ */ s.jsx("p", { children: "You retain all ownership rights to video content you record and upload. By uploading content for AI processing, you grant us a limited license to process, analyze, and store the content solely for the purpose of providing the Service. We do not claim ownership of your content and will not use it for purposes other than delivering the Service without your explicit consent." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials (collectively, "comments"), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate, and otherwise use in any medium any comments that you forward to us.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 8 — Subscription & Credits" }),
          /* @__PURE__ */ s.jsx("p", { children: "Premium AI features are accessed through the Shootz Cloud subscription, managed exclusively through the ShootzInsight mobile application. Credits are allocated monthly based on your subscription tier and reset at the beginning of each billing cycle. Unused credits do not carry over to the next billing period." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'Credit top-up purchases ("Boost Packs") are available to active subscribers only. Top-up credits do not expire and remain valid as long as your account is active. Subscription cancellation does not forfeit remaining top-up credits.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We reserve the right to modify credit allocations, pricing, and feature availability with reasonable notice to subscribers." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 9 — Third-Party Links" }),
          /* @__PURE__ */ s.jsx("p", { children: "Certain content, products, and services available via our Service may include materials from third parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third parties." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 10 — Acceptable Use" }),
          /* @__PURE__ */ s.jsx("p", { children: "In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "For any unlawful purpose or to solicit others to perform unlawful acts" }),
            /* @__PURE__ */ s.jsx("li", { children: "To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances" }),
            /* @__PURE__ */ s.jsx("li", { children: "To infringe upon or violate our intellectual property rights or the intellectual property rights of others" }),
            /* @__PURE__ */ s.jsx("li", { children: "To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate" }),
            /* @__PURE__ */ s.jsx("li", { children: "To submit false or misleading information" }),
            /* @__PURE__ */ s.jsx("li", { children: "To upload or transmit viruses or any other type of malicious code" }),
            /* @__PURE__ */ s.jsx("li", { children: "To collect or track the personal information of others" }),
            /* @__PURE__ */ s.jsx("li", { children: "To record individuals without their knowledge or consent where required by law" }),
            /* @__PURE__ */ s.jsx("li", { children: "To reverse engineer, decompile, or disassemble any part of the Service" }),
            /* @__PURE__ */ s.jsx("li", { children: "To interfere with or circumvent the security features of the Service" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We reserve the right to terminate your use of the Service for violating any of the prohibited uses." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 11 — Disclaimer of Warranties; Limitation of Liability" }),
          /* @__PURE__ */ s.jsx("p", { children: "We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are provided "as is" and "as available" for your use, without any representation, warranties, or conditions of any kind, either express or implied.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "In no case shall ShootzInsight, our directors, officers, employees, affiliates, agents, contractors, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation, lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages. Our total liability shall not exceed the amount you paid for the Service in the 12 months preceding the claim." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 12 — Indemnification" }),
          /* @__PURE__ */ s.jsx("p", { children: "You agree to indemnify, defend, and hold harmless ShootzInsight and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, and employees, harmless from any claim or demand, including reasonable attorneys' fees, made by any third-party due to or arising out of your breach of these Terms of Service or your violation of any law or the rights of a third-party." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 13 — Severability" }),
          /* @__PURE__ */ s.jsx("p", { children: "In the event that any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service. Such determination shall not affect the validity and enforceability of any other remaining provisions." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 14 — Termination" }),
          /* @__PURE__ */ s.jsx("p", { children: "The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof)." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Upon termination, your right to use the Service ceases immediately. You may export your data before termination by contacting support." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 15 — Entire Agreement" }),
          /* @__PURE__ */ s.jsx("p", { children: "The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision. These Terms of Service and any policies or operating rules posted by us on this site or in respect to the Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications, and proposals, whether oral or written, between you and us." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 16 — Governing Law" }),
          /* @__PURE__ */ s.jsx("p", { children: "These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of the People's Republic of China. For international customers, any disputes shall be resolved through arbitration in Shenzhen, Guangdong Province, China, unless local consumer protection laws in your jurisdiction provide otherwise." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 17 — Changes to Terms of Service" }),
          /* @__PURE__ */ s.jsx("p", { children: "You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at our sole discretion, to update, change, or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 18 — Contact Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "Questions about the Terms of Service should be sent to us at:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Email: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Address: Shenzhen, Guangdong, China" })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const SE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jE
}, Symbol.toStringTag, { value: "Module" }));
function NE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(ln, { title: "Refund Policy", description: "ShootzInsight Refund Policy — our commitment to your satisfaction with 15-day money-back guarantee.", url: "/pages/refund-policy" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Refund Policy" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-[#FF6B35]/5 border border-[#FF6B35]/20 text-center mb-12", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] font-[family-name:var(--font-display)] text-2xl font-bold mb-2", children: "15-Day Money-Back Guarantee" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/60", children: "Not satisfied? Return within 30 days for a full refund. No questions asked." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Returns" }),
          /* @__PURE__ */ s.jsx("p", { children: "Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can't offer you a refund or exchange. To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers, or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Additional non-returnable items:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-2 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Gift cards" }),
            /* @__PURE__ */ s.jsx("li", { children: "Downloadable software products" }),
            /* @__PURE__ */ s.jsx("li", { children: "Some health and personal care items" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "To complete your return, we require a receipt or proof of purchase. Please do not send your purchase back to the manufacturer." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "There are certain situations where only partial refunds are granted (if applicable): any item not in its original condition, is damaged or missing parts for reasons not due to our error; any item that is returned more than 30 days after delivery." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Hardware Returns — ShootzInsight Q1" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "15-Day Return Window:" }),
            " You may return your ShootzInsight Q1 within 15 days of delivery for a full refund."
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Condition:" }),
            " The product must be returned in its original packaging with all included accessories (RC1 remote, charging cable, carry pouch). Minor signs of use are acceptable — we understand you need to try it to know if it's right for you."
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Return Shipping:" }),
            " Free return shipping for customers in the United States. International customers are responsible for return shipping costs."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Refunds (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within 5-7 business days." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Late or Missing Refunds (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you haven't received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted." }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "Next contact your bank. There is often some processing time before a refund is posted. If you've done all of this and you still have not received your refund yet, please contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            "."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Sale Items (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "Only regular priced items may be refunded, unfortunately sale items cannot be refunded." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Exchanges (if applicable)" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            "We only replace items if they are defective or damaged. If you need to exchange it for the same item, send us an email at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " and send your item to our return address."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Damaged or Defective Products" }),
          /* @__PURE__ */ s.jsx("p", { children: "If your ShootzInsight Q1 arrives damaged or defective, contact us within 48 hours of delivery. We will provide a prepaid return label and ship a replacement immediately, or issue a full refund — your choice." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please include photos of the damage when contacting support to expedite the process." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Subscription Refunds" }),
          /* @__PURE__ */ s.jsx("p", { children: "Shootz Cloud subscriptions will be managed through the ShootzInsight iPhone app. Subscription refund policies will be governed by the app's published purchase terms when the App Store release is available." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'Credit top-up purchases ("Boost Packs") are non-refundable once credits have been used. Unused top-up credits may be eligible for a refund within 7 days of purchase — contact us for assistance.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Warranty Claims" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "1-Year Limited Warranty:" }),
            " ShootzInsight Q1 is covered by a 1-year limited warranty from the date of purchase."
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "What's Covered:" }) }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Manufacturing defects in materials and workmanship" }),
            /* @__PURE__ */ s.jsx("li", { children: "Motor or tracking mechanism failure under normal use" }),
            /* @__PURE__ */ s.jsx("li", { children: "Bluetooth connectivity hardware failure" }),
            /* @__PURE__ */ s.jsx("li", { children: "Phone clamp mechanism defects" }),
            /* @__PURE__ */ s.jsx("li", { children: "Battery defects (capacity drops below 50% within warranty period)" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "What's Not Covered:" }) }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Accidental damage (drops, impacts, crushing)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Water or liquid damage beyond rated IP protection" }),
            /* @__PURE__ */ s.jsx("li", { children: "Unauthorized modifications or repairs" }),
            /* @__PURE__ */ s.jsx("li", { children: "Normal wear and tear (cosmetic scratches, rubber grip aging)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Damage from use with incompatible devices or accessories" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Shipping" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            "To return your product, please email us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " to receive return instructions and a shipping label (US customers)."
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You will be responsible for paying for your own shipping costs for returning your item if you are located outside the United States. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund (international orders only)." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Depending on where you live, the time it may take for your exchanged product to reach you may vary. If you are shipping an item over $75, you should consider using a trackable shipping service or purchasing shipping insurance. We don't guarantee that we will receive your returned item." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How to Request a Return or Warranty Claim" }),
          /* @__PURE__ */ s.jsxs("ol", { className: "list-decimal pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              "Email us at ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
              " with your order number"
            ] }),
            /* @__PURE__ */ s.jsx("li", { children: "Describe the issue (include photos if applicable)" }),
            /* @__PURE__ */ s.jsx("li", { children: "We'll respond within 24 hours with return instructions or a warranty determination" }),
            /* @__PURE__ */ s.jsx("li", { children: "Ship the product back using the provided label (US) or at your cost (international)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Receive your refund or replacement within 5-7 business days of receipt" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Exceptions" }),
          /* @__PURE__ */ s.jsx("p", { children: "Products purchased through unauthorized resellers are not eligible for returns or warranty service. Please purchase only from shootzinsight.com or authorized retail partners." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Contact" }),
          /* @__PURE__ */ s.jsx("p", { children: "For return or warranty questions:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight Customer Support" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Email: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Response time: Within 24 hours (business days)" }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const TE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NE
}, Symbol.toStringTag, { value: "Module" })), nn = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ya = { visible: { transition: { staggerChildren: 0.1 } } }, AE = [
  {
    name: "Lite",
    monthly: 17.4,
    annual: 115.2,
    annualMonthly: 9.6,
    annualSaving: 93.6,
    credits: "120",
    description: "For clipping and reel creation.",
    popular: !1
  },
  {
    name: "Plus",
    monthly: 160.8,
    annual: 1065.6,
    annualMonthly: 88.8,
    annualSaving: 864,
    credits: "1,200",
    description: "For teams processing games regularly.",
    popular: !0
  },
  {
    name: "Max",
    monthly: 349.2,
    annual: 2354.4,
    annualMonthly: 196.2,
    annualSaving: 1836,
    credits: "3,600",
    description: "For high-volume teams, clubs, and programs.",
    popular: !1
  }
], CE = [
  {
    icon: Ds,
    title: "Video Data Analysis",
    rate: "From 500 credits",
    description: "Includes game clipping, a shooting breakdown, and clips linked to their source video.",
    detail: "The first 50 minutes cost 500 credits. Each minute beyond 50 costs 10 additional credits."
  },
  {
    icon: ol,
    title: "Highlight Clip Analysis",
    rate: "5 credits / minute",
    description: "Clipping only — turn uploaded game footage into individual highlight clips.",
    detail: "Usage is calculated from the duration of the uploaded source video."
  },
  {
    icon: bc,
    title: "Highlight Reel Creation",
    rate: "2 credits / clip",
    description: "Create a finished highlight reel from your selected clips.",
    detail: "Each clip used in the final reel consumes 2 credits."
  }
], EE = [
  {
    icon: gf,
    title: "Full-Court AI Tracking",
    badge: "Free",
    description: "Hands-free tracking helps keep fast breaks and off-ball action in frame across the full court — no manual panning required."
  },
  {
    icon: sc,
    title: "AI Moments",
    badge: "Free Forever",
    description: "Made baskets are detected into an organized clip library, ready to review before you pack up your gear bag."
  },
  {
    icon: wf,
    title: "Find Yourself",
    badge: "Free",
    description: "After the game, browse snapshot thumbnails of scoring plays to locate the clips you want more quickly than scrubbing the whole recording."
  },
  {
    icon: ic,
    title: "Live Stream + Scoreboard",
    badge: "Free",
    description: "Go live on YouTube, Facebook, or any RTMP destination — free and unlimited. Use the included RC1 remote to update the score overlay in real time."
  }
], kE = [
  {
    icon: Ds,
    title: "Game Analytics",
    description: "Review the 2PT / 3PT / FT breakdown and FG% from full-game film, with results connected to the plays they came from."
  },
  {
    icon: ol,
    title: "AI Clipping (Cloud)",
    description: "Upload any game film — from your Q1, a phone recording, or another camera system — and AI pulls every made basket and scoring play into individual clips, ready to review or share."
  },
  {
    icon: bc,
    title: "One-Tap Highlight",
    description: "Pick your best clips and let AI build a polished highlight reel — smart reframing to vertical, slow-mo on the money plays, and beat-synced music. One tap, done."
  }
];
function As(n) {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: n % 1 === 0 ? 0 : 1,
    maximumFractionDigits: 1
  });
}
function ME() {
  const [n, i] = C.useState("annual"), [l, o] = C.useState("analysis"), [d, f] = C.useState(50), [h, p] = C.useState(800), g = window.__SHOOTZ_CONFIG__?.media?.pricingQ1 || "/q1-pricing.png", m = l === "analysis" ? 500 + Math.max(0, Math.ceil(d) - 50) * 10 : l === "clipping" ? Math.ceil(d) * 5 : Math.ceil(d) * 2;
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(sn, {}),
    /* @__PURE__ */ s.jsx(
      ln,
      {
        title: "Pricing — Hardware & Cloud Plans",
        description: "Compare ShootzInsight hardware and optional Shootz Cloud plans. Choose monthly or annual billing and see exactly how AI processing credits are used.",
        keywords: "ShootzInsight pricing, basketball recording system price, AI sports subscription, Shootz Cloud plans",
        url: "/pricing"
      }
    ),
    /* @__PURE__ */ s.jsxs("section", { className: "relative overflow-hidden pt-32 pb-14 text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute left-1/2 top-0 h-[420px] w-[760px] -translate-x-1/2 rounded-full bg-[#FF6B35]/[0.07] blur-[140px]" }),
      /* @__PURE__ */ s.jsxs(
        E.div,
        {
          className: "container relative mx-auto",
          initial: "hidden",
          animate: "visible",
          variants: Ya,
          children: [
            /* @__PURE__ */ s.jsx(E.p, { variants: nn, className: "mb-3 text-sm uppercase tracking-[0.22em] text-[#FF6B35] font-[family-name:var(--font-mono)]", children: "Simple, Transparent Pricing" }),
            /* @__PURE__ */ s.jsx(E.h1, { variants: nn, className: "mb-5 text-4xl font-bold text-white md:text-6xl font-[family-name:var(--font-display)]", children: "Hardware First. Cloud When You Need It." }),
            /* @__PURE__ */ s.jsx(E.p, { variants: nn, className: "mx-auto max-w-2xl text-base leading-relaxed text-white/50 md:text-lg", children: "Record, track, save and use AI Moments with Q1. Add credits when you want data analysis or finished highlights." })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsxs(E.div, { variants: nn, className: "mb-5 flex flex-col justify-between gap-2 sm:flex-row sm:items-end", children: [
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs("div", { className: "mb-2 flex items-center gap-2 text-[#FF6B35]", children: [
                /* @__PURE__ */ s.jsx(nl, { size: 17 }),
                /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold uppercase tracking-[0.18em]", children: "Hardware" })
              ] }),
              /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "One-Time Purchase" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/40", children: "No subscription required to record, track, or use AI Moments." })
          ] }),
          /* @__PURE__ */ s.jsx(E.div, { variants: Ya, className: "grid gap-6 md:grid-cols-2", children: [
            { name: "Q1", price: "$199", description: "For customers who already have a compatible tripod.", href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal", featured: !1 },
            { name: "Q1 + R1 Bundle", price: "$249", description: "Q1 plus the R1 tripod - the ready-to-record setup.", href: window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", featured: !0 }
          ].map((b) => /* @__PURE__ */ s.jsxs(E.article, { variants: nn, className: `overflow-hidden rounded-2xl border ${b.featured ? "border-[#FF6B35]/60 bg-[#FF6B35]/[0.05]" : "border-white/10 bg-white/[0.025]"}`, children: [
            /* @__PURE__ */ s.jsx("div", { className: "overflow-hidden border-b border-white/10 bg-white/[0.96]", children: /* @__PURE__ */ s.jsx(
              "img",
              {
                src: g,
                alt: `${b.name} AI basketball recording setup`,
                className: "block aspect-[16/9] w-full object-cover object-center"
              }
            ) }),
            /* @__PURE__ */ s.jsxs("div", { className: "p-6 md:p-8", children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.16em] text-[#55D681]", children: "800 bonus credits included" }),
              /* @__PURE__ */ s.jsx("h3", { className: "mt-3 text-2xl font-bold text-white font-[family-name:var(--font-display)]", children: b.name }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-3 min-h-10 text-sm leading-relaxed text-white/50", children: b.description }),
              /* @__PURE__ */ s.jsxs("div", { className: "mt-7 flex items-center justify-between gap-5", children: [
                /* @__PURE__ */ s.jsxs("div", { children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-xs text-white/35", children: "One-time purchase" }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-4xl font-bold text-white", children: b.price })
                ] }),
                /* @__PURE__ */ s.jsxs(
                  Ae,
                  {
                    href: b.href,
                    className: "inline-flex items-center justify-center gap-2 rounded-xl bg-[#FF6B35] px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#FF6B35]/90",
                    children: [
                      /* @__PURE__ */ s.jsx(el, { size: 16 }),
                      " View setup"
                    ]
                  }
                )
              ] })
            ] })
          ] }, b.name)) }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex flex-wrap items-baseline gap-3", children: [
              /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-white font-[family-name:var(--font-display)]", children: "Included With Q1" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-sm text-white/35", children: "Core AI features. No subscription required." })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-4", children: EE.map((b) => {
              const y = b.icon;
              return /* @__PURE__ */ s.jsxs("article", { className: "relative rounded-xl border border-white/[0.08] bg-white/[0.025] p-4", children: [
                /* @__PURE__ */ s.jsx("span", { className: "absolute right-3 top-3 rounded-md bg-green-400/15 px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-green-300", children: b.badge }),
                /* @__PURE__ */ s.jsx(y, { size: 19, className: "mb-4 text-[#FF6B35]" }),
                /* @__PURE__ */ s.jsx("h4", { className: "pr-14 text-sm font-semibold text-white", children: b.title }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs leading-relaxed text-white/45", children: b.description })
              ] }, b.title);
            }) })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex flex-wrap items-baseline gap-3", children: [
              /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-white font-[family-name:var(--font-display)]", children: "Shootz Cloud — Works With Any Game Film" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-sm text-white/35", children: "Go deeper when you need it. Upload game film from any source." })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "grid gap-3 md:grid-cols-3", children: kE.map((b) => {
              const y = b.icon;
              return /* @__PURE__ */ s.jsxs("article", { className: "rounded-xl border border-white/[0.08] bg-black/20 p-5", children: [
                /* @__PURE__ */ s.jsx(y, { size: 19, className: "mb-4 text-[#FF6B35]" }),
                /* @__PURE__ */ s.jsx("h4", { className: "text-sm font-semibold text-white", children: b.title }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs leading-relaxed text-white/45", children: b.description })
              ] }, b.title);
            }) })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.06] bg-white/[0.015] py-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsxs(E.div, { variants: nn, className: "mb-8 flex flex-col justify-between gap-6 lg:flex-row lg:items-end", children: [
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs("div", { className: "mb-2 flex items-center gap-2 text-[#FF6B35]", children: [
                /* @__PURE__ */ s.jsx(Oh, { size: 17 }),
                /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold uppercase tracking-[0.18em]", children: "Software Subscription" })
              ] }),
              /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "Choose Your Monthly Credit Level" }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-2 max-w-2xl text-sm leading-relaxed text-white/45", children: "Credits are issued every month and used for premium video processing services." })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "inline-flex w-fit rounded-xl border border-white/10 bg-black/30 p-1", children: [
              /* @__PURE__ */ s.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => i("monthly"),
                  className: `rounded-lg px-4 py-2.5 text-xs font-semibold transition-all ${n === "monthly" ? "bg-white/10 text-white shadow-sm" : "text-white/40 hover:text-white/70"}`,
                  children: "Pay Monthly"
                }
              ),
              /* @__PURE__ */ s.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => i("annual"),
                  className: `rounded-lg px-4 py-2.5 text-xs font-semibold transition-all ${n === "annual" ? "bg-[#FF6B35] text-white shadow-sm" : "text-white/40 hover:text-white/70"}`,
                  children: "Pay Annually"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s.jsx(E.div, { variants: Ya, className: "grid gap-6 md:grid-cols-3", children: AE.map((b) => {
            const y = n === "monthly" ? b.monthly : b.annualMonthly;
            return /* @__PURE__ */ s.jsxs(
              E.article,
              {
                variants: nn,
                className: `relative flex flex-col rounded-2xl border p-6 ${b.popular ? "border-[#FF6B35]/50 bg-gradient-to-b from-[#FF6B35]/[0.09] to-white/[0.025] shadow-[0_18px_60px_rgba(255,107,53,0.08)]" : "border-white/10 bg-white/[0.025]"}`,
                children: [
                  b.popular && /* @__PURE__ */ s.jsx("div", { className: "absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#FF6B35] px-3 py-1 text-[10px] font-bold tracking-wider text-white", children: "MOST POPULAR" }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex items-start justify-between gap-4", children: [
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsx("h3", { className: `text-xl font-bold ${b.popular ? "text-[#FF8A5C]" : "text-white"}`, children: b.name }),
                      /* @__PURE__ */ s.jsx("p", { className: "mt-1 min-h-10 text-xs leading-relaxed text-white/40", children: b.description })
                    ] }),
                    /* @__PURE__ */ s.jsx(vf, { size: 18, className: b.popular ? "fill-[#FF6B35] text-[#FF6B35]" : "text-white/20" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5", children: [
                    /* @__PURE__ */ s.jsxs("div", { className: "flex items-end gap-1", children: [
                      /* @__PURE__ */ s.jsxs("span", { className: "text-3xl font-bold text-white", children: [
                        "$",
                        As(y)
                      ] }),
                      /* @__PURE__ */ s.jsx("span", { className: "pb-1 text-sm text-white/40", children: "/ month" })
                    ] }),
                    /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/35", children: n === "monthly" ? "Billed every month" : `$${As(b.annual)} billed once per year` })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5 rounded-xl border border-[#FF6B35]/20 bg-[#FF6B35]/[0.07] p-4", children: [
                    /* @__PURE__ */ s.jsx("p", { className: "text-xs uppercase tracking-wider text-[#FF8A5C]", children: "Credits issued monthly" }),
                    /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-2xl font-bold text-white", children: b.credits })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-6 space-y-2.5 text-xs", children: [
                    /* @__PURE__ */ s.jsxs("div", { className: `flex items-center justify-between rounded-lg px-3 py-2.5 ${n === "monthly" ? "bg-white/[0.07]" : "bg-white/[0.025]"}`, children: [
                      /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Monthly billing" }),
                      /* @__PURE__ */ s.jsxs("span", { className: "font-medium text-white", children: [
                        "$",
                        As(b.monthly),
                        "/mo"
                      ] })
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: `rounded-lg px-3 py-2.5 ${n === "annual" ? "bg-white/[0.07]" : "bg-white/[0.025]"}`, children: [
                      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                        /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Annual billing" }),
                        /* @__PURE__ */ s.jsxs("span", { className: "font-medium text-white", children: [
                          "$",
                          As(b.annual),
                          "/yr"
                        ] })
                      ] }),
                      /* @__PURE__ */ s.jsxs("div", { className: "mt-1.5 flex items-center justify-between", children: [
                        /* @__PURE__ */ s.jsx("span", { className: "text-white/30", children: "Equivalent monthly rate" }),
                        /* @__PURE__ */ s.jsxs("span", { className: "text-green-400", children: [
                          "$",
                          As(b.annualMonthly),
                          "/mo"
                        ] })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-6 flex items-center gap-2 text-xs text-green-400/80", children: [
                    /* @__PURE__ */ s.jsx(_N, { size: 13 }),
                    "Save $",
                    As(b.annualSaving),
                    " per year with annual billing"
                  ] }),
                  /* @__PURE__ */ s.jsxs(
                    "button",
                    {
                      type: "button",
                      disabled: !0,
                      className: `mt-auto flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-xl py-3.5 text-sm font-semibold opacity-70 ${b.popular ? "bg-[#FF6B35] text-white hover:bg-[#FF6B35]/90" : "border border-white/10 bg-white/[0.06] text-white/80 hover:bg-white/[0.1]"}`,
                      children: [
                        /* @__PURE__ */ s.jsx(bf, { size: 15 }),
                        "iPhone app coming soon"
                      ]
                    }
                  )
                ]
              },
              b.name
            );
          }) })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { id: "credits-billing", className: "py-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      E.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsxs(E.div, { variants: nn, className: "mb-8 text-center", children: [
            /* @__PURE__ */ s.jsx("p", { className: "mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Credit Usage" }),
            /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "Know Exactly What Each Service Costs" })
          ] }),
          /* @__PURE__ */ s.jsx(E.div, { variants: Ya, className: "grid gap-5 md:grid-cols-3", children: CE.map((b) => {
            const y = b.icon;
            return /* @__PURE__ */ s.jsxs(E.article, { variants: nn, className: "rounded-2xl border border-white/10 bg-white/[0.025] p-6", children: [
              /* @__PURE__ */ s.jsx("div", { className: "mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-[#FF6B35]/10", children: /* @__PURE__ */ s.jsx(y, { size: 20, className: "text-[#FF6B35]" }) }),
              /* @__PURE__ */ s.jsx("h3", { className: "text-base font-semibold text-white", children: b.title }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xl font-bold text-[#FF8A5C]", children: b.rate }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-sm leading-relaxed text-white/55", children: b.description }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-3 border-t border-white/[0.07] pt-3 text-xs leading-relaxed text-white/35", children: b.detail })
            ] }, b.title);
          }) }),
          /* @__PURE__ */ s.jsxs(E.div, { variants: nn, className: "mt-6 grid gap-4 lg:grid-cols-[1.2fr_0.8fr]", children: [
            /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl border border-amber-400/20 bg-amber-400/[0.06] p-5", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3", children: [
              /* @__PURE__ */ s.jsx(QN, { size: 19, className: "mt-0.5 shrink-0 text-amber-300" }),
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-amber-100", children: "Short video notice" }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-1.5 text-xs leading-relaxed text-amber-100/60", children: "Uploading a video shorter than 15 minutes? The app will ask you to confirm before processing because any video up to 50 minutes still uses the 500-credit minimum." })
              ] })
            ] }) }),
            /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl border border-white/10 bg-white/[0.025] p-5", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3", children: [
              /* @__PURE__ */ s.jsx(Oh, { size: 19, className: "mt-0.5 shrink-0 text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-white", children: "Billing-cycle rules" }),
                /* @__PURE__ */ s.jsxs("ul", { className: "mt-2 space-y-1.5 text-xs leading-relaxed text-white/45", children: [
                  /* @__PURE__ */ s.jsx("li", { children: "• Partial minutes are rounded up to one full minute." }),
                  /* @__PURE__ */ s.jsx("li", { children: "• Subscription credits are issued automatically each month." }),
                  /* @__PURE__ */ s.jsx("li", { children: "• Credits reset at the next subscription cycle and do not roll over." })
                ] })
              ] })
            ] }) })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-9 flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(RN, { size: 22, className: "text-[#FF6B35]" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Credits Calculator" }),
          /* @__PURE__ */ s.jsx("h2", { className: "mt-1 text-3xl font-bold text-white font-[family-name:var(--font-display)]", children: "Estimate your processing cost" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "grid gap-8 lg:grid-cols-[1.1fr_0.9fr]", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "grid gap-5 sm:grid-cols-2", children: [
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60", children: [
            "Service",
            /* @__PURE__ */ s.jsxs("select", { value: l, onChange: (b) => o(b.target.value), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]", children: [
              /* @__PURE__ */ s.jsx("option", { value: "analysis", children: "Full data analysis" }),
              /* @__PURE__ */ s.jsx("option", { value: "clipping", children: "Clipping only" }),
              /* @__PURE__ */ s.jsx("option", { value: "reel", children: "Highlight reel" })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60", children: [
            l === "reel" ? "Number of clips" : "Video length (minutes)",
            /* @__PURE__ */ s.jsx("input", { type: "number", min: "1", value: d, onChange: (b) => f(Math.max(1, Number(b.target.value) || 1)), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]" })
          ] }),
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60 sm:col-span-2", children: [
            "Available credits",
            /* @__PURE__ */ s.jsx("input", { type: "number", min: "0", value: h, onChange: (b) => p(Math.max(0, Number(b.target.value) || 0)), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]" })
          ] }),
          l === "analysis" && d < 15 && /* @__PURE__ */ s.jsx("p", { className: "rounded-lg border border-amber-400/20 bg-amber-400/[0.06] p-4 text-sm leading-relaxed text-amber-100/70 sm:col-span-2", children: "This video is under 15 minutes. Full data analysis still uses the 500-credit minimum." })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "rounded-lg border border-white/10 bg-[#080808] p-7", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/45", children: "Estimated cost" }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-5xl font-bold text-white", children: m }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/40", children: "credits" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-7 border-t border-white/10 pt-5", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Current balance" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-white", children: h })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "mt-3 flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Balance after processing" }),
              /* @__PURE__ */ s.jsx("span", { className: h >= m ? "text-[#55D681]" : "text-amber-300", children: h - m })
            ] }),
            l === "reel" && /* @__PURE__ */ s.jsxs("div", { className: "mt-3 flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Clips in reel" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-white", children: Math.ceil(d) })
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "mt-6 flex flex-wrap gap-3 text-xs text-white/40", children: [
        /* @__PURE__ */ s.jsx("span", { children: "50 min analysis = 500 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "60 min analysis = 600 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "24 min clipping = 120 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "20-clip reel = 40 credits" })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-9 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Subscribers Only" }),
        /* @__PURE__ */ s.jsx("h2", { className: "mt-2 text-3xl font-bold text-white font-[family-name:var(--font-display)]", children: "Permanent Top-Up Credits" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-3 text-sm leading-relaxed text-white/50", children: "Top-up credits do not reset. An active subscription is required to purchase them." })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-4 sm:grid-cols-2 lg:grid-cols-4", children: [
        { credits: "100", price: "$10", unit: "$0.10 / credit" },
        { credits: "500", price: "$45", unit: "$0.09 / credit" },
        { credits: "2,500", price: "$199", unit: "$0.080 / credit" },
        { credits: "5,000", price: "$349", unit: "$0.070 / credit" }
      ].map((b) => /* @__PURE__ */ s.jsxs("article", { className: "rounded-lg border border-white/10 bg-white/[0.025] p-6", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-2xl font-bold text-white", children: b.credits }),
        /* @__PURE__ */ s.jsx("p", { className: "text-xs text-white/40", children: "permanent credits" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-6 text-3xl font-bold text-[#FF6B35]", children: b.price }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/35", children: b.unit }),
        /* @__PURE__ */ s.jsx("button", { type: "button", disabled: !0, className: "mt-6 h-11 w-full cursor-not-allowed rounded-lg border border-white/10 bg-white/[0.04] text-xs font-semibold text-white/35", children: "Subscribe to unlock top-ups" })
      ] }, b.credits)) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-3xl text-center", children: /* @__PURE__ */ s.jsxs(E.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ya, children: [
      /* @__PURE__ */ s.jsx(E.h3, { variants: nn, className: "mb-3 text-xl font-semibold text-white", children: "Questions about pricing?" }),
      /* @__PURE__ */ s.jsx(E.p, { variants: nn, className: "mb-6 text-sm leading-relaxed text-white/50", children: "The Q1 works without a subscription. Shootz Cloud plans are optional and managed through the ShootzInsight App." }),
      /* @__PURE__ */ s.jsxs(E.div, { variants: nn, className: "flex flex-col items-center justify-center gap-4 sm:flex-row", children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/shootzq1-intelligent-basketball-game-ai-gimbal",
            className: "rounded-lg bg-[#FF6B35] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#FF6B35]/90",
            children: "Shop Q1 — From $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            href: "/pages/faq",
            className: "rounded-lg border border-white/10 bg-white/[0.06] px-6 py-3 text-sm font-medium text-white/70 transition-colors hover:bg-white/[0.1]",
            children: "View Full FAQ"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(rn, {})
  ] });
}
const zE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ME
}, Symbol.toStringTag, { value: "Module" }));
